import CSV from "./Content/images/file-types/csv.png";
import EXCEL from "./Content/images/file-types/excel.png";
import IMG from "./Content/images/file-types/img.png";
import PDF from "./Content/images/file-types/pdf.png";
import PPT from "./Content/images/file-types/ppt.png";
import TEXT from "./Content/images/file-types/txt.png";
import WORD from "./Content/images/file-types/word.png";
import INVALID from "./Content/images/file-types/invalid.png";
import Axios from "./Axios/ActivityAxios";
import { Urls } from "./Urls";
import { RestrictedDomains } from "./RestrictedDomains";
import { FaUsersViewfinder } from "react-icons/fa6";
import { SlGraph } from "react-icons/sl";
// import { PiAirTrafficControl } from "react-icons/pi";
import { MdSettingsSuggest } from "react-icons/md";

export { Urls, LOGO_BASE_URL } from "./Urls";
export {
  STORAGE_ACCOUNT,
  GOOGLE_ID,
  MIXPANEL_TOKEN,
  APP_NAME,
  DECRYPTION_KEY_HEX,
  ENVIRONMENT,
  FIREBASE_CONFIG,
  NODE_ENV,
  PUBLIC_URL,
  IS_PROD
} from "./config/env.config";

// const newval='ContractClosureDocuments'
export const Constants = {
  dhandanowAccessList: ["IND001769", "IND001771", "IND001763"],
  RoutePaths: {
    GeneralInformation: "/generalInfo",
    BusinessProfile: "/businessProfile",
    OperationsOverview: "/operationsOverview",
    CustomerDetails: "/customerDetails",
    ContractClosureInfo: "/contract",
    PreviewProfile: "/MyProfile",
    BusinessEnquiries: "/enquiries",
    Dashboard: "/dashboard",
  },
  restrictedDomains: RestrictedDomains,
  services: {
    dhandanow: {
      basic: {
        lane_count: 2,
      },
      standard: {
        lane_count: 10,
      },
      premium: {
        lane_count: 25,
      },
    },
  },

  ImageUploadMaxSize: 20,
  FileUploadMaxSize: 20,
  OnlyNumberRegEx: "^[0-9]+$",
  EmailRegEx: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
  EnterKey: "Enter",

  ContractAttachments: [
    {
      blob_url: "",
      file_name: "",
      name: "Partnership Deed",
      uploaded_on: "",
    },
    {
      blob_url: "",
      file_name: "",
      name: "Certificate of Incorporation(COI)",
      uploaded_on: "",
    },
    {
      blob_url: "",
      file_name: "",
      name: "Cancelled Cheque",
      uploaded_on: "",
    },
    {
      blob_url: "",
      file_name: "",
      name: "Board Resolution",
      uploaded_on: "",
    },
    {
      blob_url: "",
      file_name: "",
      name: "Others",
      uploaded_on: "",
    },
  ],
  CompanyTypes: [
    {
      label: "PVT LTD",
      value: "PVT LTD",
    },
    {
      label: "Proprietorship",
      value: "Proprietorship",
    },
    {
      label: "LTD",
      value: "LTD",
    },
    {
      label: "Public",
      value: "Public",
    },

    {
      label: "Partnership",
      value: "Partnership",
    },
  ],
  CompanyAct: [
    { label: "1956", value: "1956" },
    {
      label: "2013",
      value: "2013",
    },
  ],

  FileHandlerActions: {
    Upload: "upload",
    Download: "download",
  },

  FinancialYears: [
    { label: "2025-2026", value: "2025-2026" },
    { label: "2024-2025", value: "2024-2025" },
    { label: "2023-2024", value: "2023-2024" },
    { label: "2022-2023", value: "2022-2023" },
    { label: "2021-2022", value: "2021-2022" },
    { label: "2020-2021", value: "2020-2021" },
    { label: "2019-2020", value: "2019-2020" },
    { label: "2018-2019", value: "2018-2019" },
    { label: "2017-2018", value: "2017-2018" },
    { label: "2016-2017", value: "2016-2017" },
    { label: "2015-2016", value: "2015-2016" },
    { label: "2014-2015", value: "2014-2015" },
    { label: "2013-2014", value: "2013-2014" },
    { label: "2012-2013", value: "2012-2013" },
    { label: "2011-2012", value: "2011-2012" },
    { label: "2010-2011", value: "2010-2011" },
    { label: "2009-2010", value: "2009-2010" },
    { label: "2008-2009", value: "2008-2009" },
    { label: "2007-2008", value: "2007-2008" },
    { label: "2006-2007", value: "2006-2007" },
    { label: "2005-2006", value: "2005-2006" },
    { label: "2004-2005", value: "2004-2005" },
    { label: "2003-2004", value: "2003-2004" },
    { label: "2002-2003", value: "2002-2003" },
  ],

  LoginCarouselItems: [
    {
      title: "Get Discovered",
      description:
        "Connect with new customers, including Fortune 500 companies and global leaders. Receive business inquiries from companies in your lanes, matching your preferred truck types.",
      cssName: "user",
      icon : <FaUsersViewfinder size={80}/>,
    },
    {
      title: "Track Your Performance",
      description:
        "Get feedback from customers and grow your reputation on LoRRI – The Trusted Platform for Transporters. Use your ratings to attract more business and build a strong industry presence.",
      cssName: "chart-line",
      icon : <SlGraph size={80}/>,
    },
    {
      title: "Take Control of Your Brand Presence",
      description:
        "Create a standout LoRRI profile with details about your branches, fleet, and lanes. Help customers make informed decisions, leading to more business opportunities for you.",
      cssName: "cogs",
      icon : <MdSettingsSuggest size={80}/>,
    },
  ],

  Countries: [
    {
      name: "India",
      code: "+91",
      abbr: "in",
    },
  ],

  AreaOfOperation: [
    { label: "East", value: "East" },
    { label: "West", value: "West" },
    { label: "North", value: "North" },
    { label: "South", value: "South" },
    { label: "North-East", value: "North-East" },
    { label: "Central", value: "Central" },
    { label: "Pan-India", value: "Pan-India" },
    { label: "Global", value: "Global" },
  ],

  TransportationModes: [
    {
      name: "Road",
      values: [
        "Full Truck Load (FTL)",
        "Less than Truck Load (LTL)",
        "Courier/Parcel",
        "Tanker",
        "Reefer",
        "Over Dimensional Cargo (ODC)",
        "Trailer",
        "Bulker",
      ],
    },
    {
      name: "Rail",
      values: [],
    },
    {
      name: "Ocean",
      values: [],
    },
    {
      name: "Air",
      values: [],
    },
  ],

  FileTypes: [
    {
      extension: "doc",
      icon: WORD,
    },
    {
      extension: "docx",
      icon: WORD,
    },
    {
      extension: "pdf",
      icon: PDF,
    },
    {
      extension: "xls",
      icon: EXCEL,
    },
    {
      extension: "xlsx",
      icon: EXCEL,
    },
    {
      extension: "ppt",
      icon: PPT,
    },
    {
      extension: "pptx",
      icon: PPT,
    },
    {
      extension: "csv",
      icon: CSV,
    },
    {
      extension: "txt",
      icon: TEXT,
    },
    {
      extension: "png",
      icon: IMG,
    },
    {
      extension: "invalid",
      icon: INVALID,
    },
  ],

  NewContact: {
    name: "",
    designation: "",
    contact_number: "",
    email: "",
    poc: "",
  },

  NewCustomerReference: {
    name: "",
    designation: "",
    company: "",
    contact_number: "",
    email: "",
    requestRating_timestamp: "",
  },

  NewExistingCustomer: {
    customerName: "",
    origin: "",
    destination: "",
    truckType: "",
    ftl_ltl: "",
    freight: "",
  },

  NewShipmentTrackingMethod: {
    methods_used: "",
    details_of_method: "",
    service_provider: "",
  },

  TMSTrackingMethod: {
    service_providers: "",
    years: "",
  },

  NewTruckTypeOrAsset: {
    type: "",
    self_owned: "",
    avg_fleet_age: "",
    planned_increase: "",
    attached_vehicles: "",
    vendors: "",
    isCustom: true,
  },

  NewRow: {
    location: "",
    truck_type: "",
    number_trucks: "",
    destination: "",
  },

  acceptable_terms: {
    payment_terms: "upto 30 days",
    cargo_insured: "0",
    loading_unloading_charges: "1",
    detention_charges:
      "Rs.1000 on first day after 24 hrs of cvehicle arrival. ",
    other_terms: "fuel clause should be for a cumulative charge of Rs.2",
  },

  PaymentTerms: [
    { value: "Upto 30 days", label: "Upto 30 days" },
    { value: "30-45 days", label: "30-45 days" },
    { value: "45-60 days", label: "45-60 days" },
    { value: "Can be discussed", label: "Can be discussed" },
  ],

  BooleanOptions: [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
    { value: "can be discussed", label: "Can be discussed" },
  ],

  IndustriesServedOptions: [
    {
      name: "Agricultural Products",
      percentage: null,
    },
    {
      name: "Automobile",
      percentage: null,
    },
    {
      name: "Brewing",
      percentage: null,
    },
    {
      name: "Building Material",
      percentage: null,
    },
    {
      name: "Cement",
      percentage: null,
    },
    {
      name: "Ceramics",
      percentage: null,
    },
    {
      name: "Chemical",
      percentage: null,
    },
    {
      name: "Construction",
      percentage: null,
    },
    {
      name: "Ecommerce",
      percentage: null,
    },
    {
      name: "Electricals",
      percentage: null,
    },
    {
      name: "Electronics",
      percentage: null,
    },
    {
      name: "Engineering Services",
      percentage: null,
    },
    {
      name: "Fashion and Clothing",
      percentage: null,
    },
    {
      name: "Fmcd",
      percentage: null,
    },
    {
      name: "Fmcg",
      percentage: null,
    },
    {
      name: "Glass",
      percentage: null,
    },
    {
      name: "Healthcare",
      percentage: null,
    },
    {
      name: "Industrial Automation",
      percentage: null,
    },
    {
      name: "Infrastructure",
      percentage: null,
    },
    {
      name: "Logistics",
      percentage: null,
    },
    {
      name: "Luggage",
      percentage: null,
    },
    {
      name: "Manufacturing",
      percentage: null,
    },
    {
      name: "Manufacturing Execution System",
      percentage: null,
    },
    {
      name: "Metals and Mining",
      percentage: null,
    },
    {
      name: "Oil and Gas",
      percentage: null,
    },
    {
      name: "Packaging",
      percentage: null,
    },
    {
      name: "Paints",
      percentage: null,
    },
    {
      name: "Paper",
      percentage: null,
    },
    {
      name: "Pharmaceutical",
      percentage: null,
    },
    {
      name: "Plastics",
      percentage: null,
    },
    {
      name: "Printing and Minting",
      percentage: null,
    },
    {
      name: "Raw Material",
      percentage: null,
    },
    {
      name: "Steel",
      percentage: null,
    },
    {
      name: "Technology",
      percentage: null,
    },
    {
      name: "Telecom",
      percentage: null,
    },
    {
      name: "Textile",
      percentage: null,
    },
    {
      name: "Tyre",
      percentage: null,
    },
  ],

  ValueAddedServices: [
    "Transit Insurance",
    "Proof of Delivery (POD)",
    "Draft on Delivery (DOD)",
    "Delivery against consignee copy (DACC)",
    "Customized MIS",
    "Other",
  ],

  BusinessDomains: [
    "Primary Transportation",
    "Secondary Transportation",
    "Warehousing Services",
  ],

  LicenseList: ["Cat 4", "Cat 5", "Cat 9"],

  dhandanow: {
    standard: {
      lane_count: 10,
      access_type: "standard",
    },
    premium: {
      lane_count: 25,
      access_type: "premium",
    },
  },

  BankOptions: [
    {
      label: "Allahabad Bank",
      value: "Allahabad Bank",
    },
    {
      label: "Andhra Bank",
      value: "Andhra Bank",
    },
    {
      label: "Bank of Baroda",
      value: "Bank of Baroda",
    },
    {
      label: "Bank of India",
      value: "Bank of India",
    },
    {
      label: "Bank of Maharashtra",
      value: "Bank of Maharashtra",
    },
    {
      label: "Canara Bank",
      value: "Canara Bank",
    },
    {
      label: "Central Bank of India",
      value: "Central Bank of India",
    },
    {
      label: "Corporation Bank",
      value: "Corporation Bank",
    },
    {
      label: "Dena Bank",
      value: "Dena Bank",
    },
    {
      label: "IDBI Bank Ltd",
      value: "IDBI Bank Ltd",
    },
    {
      label: "Indian Bank",
      value: "Indian Bank",
    },
    {
      label: "Indian Overseas Bank",
      value: "Indian Overseas Bank",
    },
    {
      label: "Oriental Bank of Commerce",
      value: "Oriental Bank of Commerce",
    },
    {
      label: "Punjab & Sind Bank",
      value: "Punjab & Sind Bank",
    },
    {
      label: "Punjab National Bank",
      value: "Punjab National Bank",
    },
    {
      label: "State Bank of India",
      value: "State Bank of India",
    },
    {
      label: "Syndicate Bank",
      value: "Syndicate Bank",
    },
    {
      label: "UCO Bank",
      value: "UCO Bank",
    },
    {
      label: "Union Bank of India",
      value: "Union Bank of India",
    },
    {
      label: "United Bank of India",
      value: "United Bank of India",
    },
    {
      label: "Vijaya Bank",
      value: "Vijaya Bank",
    },
    {
      label: "Axis Bank Ltd.",
      value: "Axis Bank Ltd.",
    },
    {
      label: "Bandhan Bank",
      value: "Bandhan Bank",
    },
    {
      label: "Catholic Syrian Bank Ltd.",
      value: "Catholic Syrian Bank Ltd.",
    },
    {
      label: "City Union Bank Ltd.",
      value: "City Union Bank Ltd.",
    },
    {
      label: "Development Credit Bank Ltd.",
      value: "Development Credit Bank Ltd.",
    },
    {
      label: "Dhanlaxmi Bank Ltd.",
      value: "Dhanlaxmi Bank Ltd.",
    },
    {
      label: "Federal Bank Ltd.",
      value: "Federal Bank Ltd.",
    },
    {
      label: "HDFC Bank Ltd.",
      value: "HDFC Bank Ltd.",
    },
    {
      label: "ICICI Bank Ltd.",
      value: "ICICI Bank Ltd.",
    },
    {
      label: "IDFC Bank Ltd.",
      value: "IDFC Bank Ltd.",
    },
    {
      label: "IndusInd Bank Ltd.",
      value: "IndusInd Bank Ltd.",
    },
    {
      label: "Jammu & Kashmir Bank Ltd.",
      value: "Jammu & Kashmir Bank Ltd.",
    },
    {
      label: "Karnataka Bank Ltd.",
      value: "Karnataka Bank Ltd.",
    },
    {
      label: "Karur Vysya Bank Ltd.",
      value: "Karur Vysya Bank Ltd.",
    },
    {
      label: "Kotak Mahindra Bank Ltd.",
      value: "Kotak Mahindra Bank Ltd.",
    },
    {
      label: "Lakshmi Vilas Bank Ltd.",
      value: "Lakshmi Vilas Bank Ltd.",
    },
    {
      label: "Nainital Bank Ltd.",
      value: "Nainital Bank Ltd.",
    },
    {
      label: "Ratnakar Bank Ltd.",
      value: "Ratnakar Bank Ltd.",
    },
    {
      label: "South Indian Bank Ltd.",
      value: "South Indian Bank Ltd.",
    },

    {
      label: "Tamilnad Mercantile Bank Ltd.",
      value: "Tamilnad Mercantile Bank Ltd.",
    },
    {
      label: "Yes Bank Ltd.",
      value: "Yes Bank Ltd.",
    },
  ],

  Company_data: [
    {
      field_type: "company",
      name: "20 Microns ",
      field_id: "COM000001",
      website: "https://www.20microns.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/20 MICRONS LIMITED.jpg",
      company_id: "COM000001",
      company_name: "20 Microns ",
      industry: "CHEMICAL",
      display_name: "20 Microns ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "3M India ",
      field_id: "COM001062",
      website: "https://www.3mindia.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/3M INDIA LIMITED.png",
      company_id: "COM001062",
      company_name: "3M India ",
      industry: "",
      display_name: "3M India ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "A O Smith India Water Products  ",
      field_id: "COM000002",
      website: "https://www.aosmithindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/A O SMITH INDIA WATER PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM000002",
      company_name: "A O Smith India Water Products  ",
      industry: "FMCD",
      display_name: "A O Smith India Water Products  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "A R Life Sciences  ",
      field_id: "COM001333",
      website: "https://www.arlifesciences.com/",
      group: "",
      logo: "",
      company_id: "COM001333",
      company_name: "A R Life Sciences  ",
      industry: "",
      display_name: "A R Life Sciences  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "AAA Roller Flour Mills  ",
      field_id: "COM000003",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AAA ROLLER FLOUR MILLS PRIVATE LIMITED.jpg",
      company_id: "COM000003",
      company_name: "AAA Roller Flour Mills  ",
      industry: "FMCG",
      display_name: "AAA Roller Flour Mills  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aaacorp Exim   ",
      field_id: "COM000004",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000004",
      company_name: "Aaacorp Exim   ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Aaacorp Exim   ",
    },
    {
      field_type: "company",
      name: "Aadarsh Prints",
      field_id: "COM001334",
      website: "https://aadarsh.com",
      group: "",
      logo: "",
      company_id: "COM001334",
      company_name: "Aadarsh Prints",
      industry: "",
      display_name: "Aadarsh Prints",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aaditya Finechem  ",
      field_id: "COM000005",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000005",
      company_name: "Aaditya Finechem  ",
      industry: "CHEMICAL",
      display_name: "Aaditya Finechem  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aarneel Technocraft  ",
      field_id: "COM000006",
      website: "https://www.aarneel.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AARNEEL TECHNOCRAFT PRIVATE LIMITED.jpg",
      company_id: "COM000006",
      company_name: "Aarneel Technocraft  ",
      industry: "BUILDING MATERIAL",
      display_name: "Aarneel Technocraft  ",
    },
    {
      field_type: "company",
      name: "Aarti Industries ",
      field_id: "COM000007",
      website: "https://www.aarti-industries.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AARTI INDUSTRIES LIMITED.png",
      company_id: "COM000007",
      company_name: "Aarti Industries ",
      industry: "CHEMICAL",
      display_name: "Aarti Industries ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aarti Steels ",
      field_id: "COM001335",
      website: "http://www.aartisteelsltd.com/",
      group: "",
      logo: "",
      company_id: "COM001335",
      company_name: "Aarti Steels ",
      industry: "",
      display_name: "Aarti Steels ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "AB Sugars ",
      field_id: "COM001336",
      website: "http://www.absugars.com/about_us.aspx",
      group: "",
      logo: "",
      company_id: "COM001336",
      company_name: "AB Sugars ",
      industry: "",
      display_name: "AB Sugars ",
    },
    {
      field_type: "company",
      name: "ABB",
      field_id: "COM000009",
      website: "https://new.abb.com/indian-subcontinent",
      group: "",
      logo: "",
      company_id: "COM000009",
      company_name: "ABB",
      industry: "MANUFACTURING",
      display_name: "ABB",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Abbott",
      field_id: "COM000010",
      website: "https://www.abbott.com",
      group: "Abbott Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ABBOTT INDIA LIMITED.png",
      company_id: "COM000010",
      company_name: "Abbott",
      industry: "HEALTHCARE",
      display_name: "Abbott",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "ABG Cement ",
      field_id: "COM001337",
      website: "http://www.abgcement.com/",
      group: "ABG GROUP",
      logo: "",
      company_id: "COM001337",
      company_name: "ABG Cement ",
      industry: "",
      display_name: "ABG Cement ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Abirami Soap Works ",
      field_id: "COM000744",
      website: "https://www.powersoaps.com/about-us/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Abirami soap works LLP.gif",
      company_id: "COM000744",
      company_name: "Abirami Soap Works ",
      industry: "FMCG",
      display_name: "Abirami Soap Works ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "ACC",
      field_id: "COM000012",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ACC LIMITED.png",
      company_id: "COM000012",
      company_name: "ACC",
      industry: "CEMENT",
      display_name: "ACC",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Acciona",
      field_id: "COM000013",
      website: "https://www.acciona.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ACCIONA.jpg",
      company_id: "COM000013",
      company_name: "Acciona",
      industry: "CONGLOMERATE",
      display_name: "Acciona",
    },
    {
      field_type: "company",
      name: "Accutech Power",
      field_id: "COM000049",
      website: "http://accutech.co.in/",
      group: "",
      logo: "",
      company_id: "COM000049",
      company_name: "Accutech Power",
      industry: "",
      display_name: "Accutech Power",
    },
    {
      field_type: "company",
      name: "Ace Manufacturing",
      field_id: "COM001338",
      website: "https://www.acemicromatic.net/ams/",
      group: "Ace Micromatic Group",
      logo: "",
      company_id: "COM001338",
      company_name: "Ace Manufacturing",
      industry: "",
      display_name: "Ace Manufacturing",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "ACG Associated Capsules",
      field_id: "COM000014",
      website: "https://www.acg-world.com/#",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ACG%20PHARMA%C2%A0TECHNOLOGIES%20PRIVATE%20LIMITED.jpg",
      company_id: "COM000014",
      company_name: "ACG Associated Capsules",
      display_name: "ACG Associated Capsules",
      sector: "Pharmaceutical",
      page_display_status: true,
      industry: "Pharmaceutical",
    },
    {
      field_type: "company",
      name: "ACME",
      field_id: "COM001120",
      website: "http://www.acmeindustries.in",
      group: "",
      logo: "",
      company_id: "COM001120",
      company_name: "ACME",
      industry: "",
      display_name: "ACME",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Action Construction Equipment ",
      field_id: "COM001182",
      website: "https://www.ace-cranes.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ACTION CRANE EQUIPMENTS LIMITED.png",
      company_id: "COM001182",
      company_name: "Action Construction Equipment ",
      industry: "",
      display_name: "Action Construction Equipment ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Adama India  ",
      field_id: "COM000015",
      website: "https://www.adama.com/india/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ADAMA INDIA PRIVATE LIMITED.png",
      company_id: "COM000015",
      company_name: "Adama India  ",
      industry: "CHEMICAL",
      display_name: "Adama India  ",
    },
    {
      field_type: "company",
      name: "Adani Enterprises ",
      field_id: "COM001183",
      website: "https://www.adanienterprises.com/",
      group: "",
      logo: "",
      company_id: "COM001183",
      company_name: "Adani Enterprises ",
      industry: "",
      display_name: "Adani Enterprises ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Adani",
      field_id: "COM000016",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ADANI GROUP.png",
      company_id: "COM000016",
      company_name: "Adani",
      industry: "CONGLOMERATE",
      display_name: "Adani",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Adhunik Cement ",
      field_id: "COM000017",
      website: "https://www.dalmiacement.com/adhunik-cement.html",
      group: "Dalmia Cement Bharat Limited",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ADHUNIK CEMENT LIMITED.jpg",
      company_id: "COM000017",
      company_name: "Adhunik Cement ",
      industry: "CEMENT",
      display_name: "Adhunik Cement ",
    },
    {
      field_type: "company",
      name: "Adhunik Group",
      field_id: "COM001339",
      website: "https://www.adhunikgroup.com",
      group: "",
      logo: "",
      company_id: "COM001339",
      company_name: "Adhunik Group",
      industry: "",
      display_name: "Adhunik Group",
    },
    {
      field_type: "company",
      name: "Adidas",
      field_id: "COM001184",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001184",
      company_name: "Adidas",
      industry: "",
      display_name: "Adidas",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aditya Birla Chemicals",
      field_id: "COM001185",
      website: "http://www.adityabirlachemicals.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Aditya Birla Chemicals India Limited.gif",
      company_id: "COM001185",
      company_name: "Aditya Birla Chemicals",
      industry: "",
      display_name: "Aditya Birla Chemicals",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aditya Birla Fashion And Retail",
      field_id: "COM001186",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ADITYA BIRLA FASHION AND RETAIL LIMITED.png",
      company_id: "COM001186",
      company_name: "Aditya Birla Fashion And Retail",
      industry: "",
      display_name: "Aditya Birla Fashion And Retail",
    },
    {
      field_type: "company",
      name: "Aditya Birla",
      field_id: "COM001064",
      website: "https://www.adityabirla.com/",
      group: "Aditya Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ADITYA BIRLA MANAGEMENT CORPORATION PRIVATE LIMITED.jpg",
      company_id: "COM001064",
      company_name: "Aditya Birla",
      industry: "",
      display_name: "Aditya Birla",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Ador Welding ",
      field_id: "COM001340",
      website: "http://www.adorwelding.com",
      group: "",
      logo: "",
      company_id: "COM001340",
      company_name: "Ador Welding ",
      industry: "",
      display_name: "Ador Welding ",
    },
    {
      field_type: "company",
      name: "Advanced Glass",
      field_id: "COM000020",
      website: "http://www.advancedglass.net",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ADVANCED GLASS INDUSTRIES.jpg",
      company_id: "COM000020",
      company_name: "Advanced Glass",
      industry: "GLASS",
      display_name: "Advanced Glass",
    },
    {
      field_type: "company",
      name: "Aeroflex",
      field_id: "COM001341",
      website: "http://www.aeroflexindia.com",
      group: "",
      logo: "",
      company_id: "COM001341",
      company_name: "Aeroflex",
      industry: "",
      display_name: "Aeroflex",
    },
    {
      field_type: "company",
      name: "Agarwal Rubber ",
      field_id: "COM001187",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001187",
      company_name: "Agarwal Rubber ",
      industry: "",
      display_name: "Agarwal Rubber ",
    },
    {
      field_type: "company",
      name: "AGC",
      field_id: "COM000019",
      website: "https://www.agc.com/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AGC INC.jpg",
      company_id: "COM000019",
      company_name: "AGC",
      industry: "GLASS",
      display_name: "AGC",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aglo Packagings  ",
      field_id: "COM000021",
      website: "https://www.aglopackagings.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AGLO PACKAGING PRIVATE LIMITED.jpg",
      company_id: "COM000021",
      company_name: "Aglo Packagings  ",
      industry: "PACKAGING",
      display_name: "Aglo Packagings  ",
    },
    {
      field_type: "company",
      name: "Aglowmed ",
      field_id: "COM000022",
      website: "http://www.aglowmed.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AGLOWMED LIMITED.jpg",
      company_id: "COM000022",
      company_name: "Aglowmed ",
      industry: "PHARMACEUTICAL",
      display_name: "Aglowmed ",
    },
    {
      field_type: "company",
      name: "Agrotech",
      field_id: "COM000023",
      website: "http://www.atfoods.com/",
      group: "CONAGRA FOODS",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AGRO TECH FOODS LIMITED.png",
      company_id: "COM000023",
      company_name: "Agrotech",
      display_name: "Agrotech",
      sector: "Agricultural Products",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Ahlcon Parenterals",
      field_id: "COM001342",
      website: "http://www.ahlconindia.com/",
      group: "",
      logo: "",
      company_id: "COM001342",
      company_name: "Ahlcon Parenterals",
      industry: "",
      display_name: "Ahlcon Parenterals",
    },
    {
      field_type: "company",
      name: "Ahmednagar Alloys  ",
      field_id: "COM001188",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001188",
      company_name: "Ahmednagar Alloys  ",
      industry: "",
      display_name: "Ahmednagar Alloys  ",
    },
    {
      field_type: "company",
      name: "Aim Filtertech  ",
      field_id: "COM000024",
      website: "http://aimfiltration.com/",
      group: "",
      logo: "",
      company_id: "COM000024",
      company_name: "Aim Filtertech  ",
      industry: "CONGLOMERATE",
      display_name: "Aim Filtertech  ",
    },
    {
      field_type: "company",
      name: "Air India",
      field_id: "COM001189",
      website: "http://www.airindia.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AIR INDIA LIMITED.png",
      company_id: "COM001189",
      company_name: "Air India",
      industry: "",
      display_name: "Air India",
    },
    {
      field_type: "company",
      name: "Ajanta Pharma ",
      field_id: "COM001343",
      website: "http://www.ajantapharma.com/index.aspx",
      group: "",
      logo: "",
      company_id: "COM001343",
      company_name: "Ajanta Pharma ",
      industry: "",
      display_name: "Ajanta Pharma ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Ajay Chemical",
      field_id: "COM000027",
      website: "https://ajaychem.weebly.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AJAY CHEMICAL.jpg",
      company_id: "COM000027",
      company_name: "Ajay Chemical",
      industry: "CHEMICAL",
      display_name: "Ajay Chemical",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Akar Tools ",
      field_id: "COM001344",
      website: "https://www.akartoolsltd.com/about-us.html",
      group: "",
      logo: "",
      company_id: "COM001344",
      company_name: "Akar Tools ",
      industry: "",
      display_name: "Akar Tools ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Akorn ",
      field_id: "COM001345",
      website: "http://www.akorn.com/",
      group: "",
      logo: "",
      company_id: "COM001345",
      company_name: "Akorn ",
      industry: "",
      display_name: "Akorn ",
    },
    {
      field_type: "company",
      name: "Akums Drugs And Pharmaceuticals  ",
      field_id: "COM000029",
      website: "http://www.akums.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AKUMS DRUGS AND PHARMACEUTICALS LIMITED.png",
      company_id: "COM000029",
      company_name: "Akums Drugs And Pharmaceuticals  ",
      industry: "PHARMACEUTICAL",
      display_name: "Akums Drugs And Pharmaceuticals  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Akzonobel",
      field_id: "COM000030",
      website: "https://akzonobel.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Akzo Nobel N V.jpg",
      company_id: "COM000030",
      company_name: "Akzonobel",
      industry: "PAINTS",
      display_name: "Akzonobel",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Al Nafees Frozen Food Exports  ",
      field_id: "COM001191",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001191",
      company_name: "Al Nafees Frozen Food Exports  ",
      industry: "",
      display_name: "Al Nafees Frozen Food Exports  ",
    },
    {
      field_type: "company",
      name: "Albert David ",
      field_id: "COM000031",
      website: "http://www.albertdavidindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALBERT DAVID LIMITED.png",
      company_id: "COM000031",
      company_name: "Albert David ",
      industry: "PHARMACEUTICAL",
      display_name: "Albert David ",
    },
    {
      field_type: "company",
      name: "Alcon Cement",
      field_id: "COM001346",
      website: "http://www.alcongoa.com/details.php?id=2",
      group: "ANIL COUNTO ENTERPRISES",
      logo: "",
      company_id: "COM001346",
      company_name: "Alcon Cement",
      industry: "",
      display_name: "Alcon Cement",
    },
    {
      field_type: "company",
      name: "Alembic Pharma",
      field_id: "COM000032",
      website: "https://www.alembicpharmaceuticals.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALEMBIC PHARMACEUTICALS LIMITED.png",
      company_id: "COM000032",
      company_name: "Alembic Pharma",
      display_name: "Alembic Pharma",
      sector: "Pharmaceutical",
      page_display_status: false,
      industry: "Pharmaceutical",
    },
    {
      field_type: "company",
      name: "Alfa Laval",
      field_id: "COM000033",
      website: "https://www.alfalaval.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALFA LAVAL.jpg",
      company_id: "COM000033",
      company_name: "Alfa Laval",
      industry: "CONGLOMERATE",
      display_name: "Alfa Laval",
    },
    {
      field_type: "company",
      name: "Align Components  ",
      field_id: "COM001347",
      website: "http://www.aligngroup.co.in",
      group: "Align Group",
      logo: "",
      company_id: "COM001347",
      company_name: "Align Components  ",
      industry: "",
      display_name: "Align Components  ",
    },
    {
      field_type: "company",
      name: "Alkem LabS",
      field_id: "COM000034",
      website: "https://www.alkemlabs.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALKEM LABORATORIES LIMITED.png",
      company_id: "COM000034",
      company_name: "Alkem LabS",
      industry: "PHARMACEUTICAL",
      display_name: "Alkem LabS",
    },
    {
      field_type: "company",
      name: "All Time Plastics  ",
      field_id: "COM001348",
      website: "https://www.alltimeplastics.com/#/",
      group: "",
      logo: "",
      company_id: "COM001348",
      company_name: "All Time Plastics  ",
      industry: "",
      display_name: "All Time Plastics  ",
    },
    {
      field_type: "company",
      name: "Allanasons  ",
      field_id: "COM000035",
      website: "http://www.allana.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALLANASONS PRIVATE LIMITED.png",
      company_id: "COM000035",
      company_name: "Allanasons  ",
      display_name: "Allanasons  ",
      sector: "FMCG",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Allergan",
      field_id: "COM000036",
      website: "https://www.allergan.co.in/hi-in/home",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Allergan India Private Limited.png",
      company_id: "COM000036",
      company_name: "Allergan",
      industry: "PHARMACEUTICAL",
      display_name: "Allergan",
    },
    {
      field_type: "company",
      name: "Alliance India  ",
      field_id: "COM000037",
      website: "",
      group: "ALLIANCE INDIA PVT LTD",
      logo: "",
      company_id: "COM000037",
      company_name: "Alliance India  ",
      industry: "CONGLOMERATE",
      display_name: "Alliance India  ",
    },
    {
      field_type: "company",
      name: "Alok Industries ",
      field_id: "COM000038",
      website: "http://www.alokind.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALOK INDUSTRIES LIMITED.jpg",
      company_id: "COM000038",
      company_name: "Alok Industries ",
      industry: "TEXTILE",
      display_name: "Alok Industries ",
    },
    {
      field_type: "company",
      name: "Alok Ingots  ",
      field_id: "COM001192",
      website: "https://www.alokindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALOK INGOTS PRIVATE LIMITED.png",
      company_id: "COM001192",
      company_name: "Alok Ingots  ",
      industry: "",
      display_name: "Alok Ingots  ",
    },
    {
      field_type: "company",
      name: "Alom",
      field_id: "COM001096",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001096",
      company_name: "Alom",
      industry: "",
      display_name: "Alom",
    },
    {
      field_type: "company",
      name: "Alstom Transport",
      field_id: "COM000039",
      website: "https://www.alstom.com/alstom-india",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALSTOM TRANSPORT.jpg",
      company_id: "COM000039",
      company_name: "Alstom Transport",
      industry: "LOGISTICS",
      display_name: "Alstom Transport",
    },
    {
      field_type: "company",
      name: "Alstrong Enterprises",
      field_id: "COM000041",
      website: "https://www.alstrongindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Alstrong Enterprises India Private Limited.jpg",
      company_id: "COM000041",
      company_name: "Alstrong Enterprises",
      industry: "MANUFACTURING",
      display_name: "Alstrong Enterprises",
    },
    {
      field_type: "company",
      name: "Altech Infra",
      field_id: "COM001193",
      website: "http://www.altechinfra.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALTECH INFRASTRUCTURE INDIA PRIVATE LIMITED.jpg",
      company_id: "COM001193",
      company_name: "Altech Infra",
      industry: "",
      display_name: "Altech Infra",
    },
    {
      field_type: "company",
      name: "Alucopanel",
      field_id: "COM000042",
      website: "https://alucopanel.net",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALUCOPANEL.png",
      company_id: "COM000042",
      company_name: "Alucopanel",
      industry: "MANUFACTURING",
      display_name: "Alucopanel",
    },
    {
      field_type: "company",
      name: "Alufit",
      field_id: "COM000043",
      website: "http://www2.alufit.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ALUFIT INDIA PRIVATE LIMITED.png",
      company_id: "COM000043",
      company_name: "Alufit",
      industry: "MANUFACTURING",
      display_name: "Alufit",
    },
    {
      field_type: "company",
      name: "Amanta Healthcare ",
      field_id: "COM000044",
      website: "http://www.amanta.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AMANTA HEALTHCARE.png",
      company_id: "COM000044",
      company_name: "Amanta Healthcare ",
      industry: "PHARMACEUTICAL",
      display_name: "Amanta Healthcare ",
    },
    {
      field_type: "company",
      name: "Amar Ujala ",
      field_id: "COM000984",
      website: "https://www.amarujala.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Amar Ujala Limited.png",
      company_id: "COM000984",
      company_name: "Amar Ujala ",
      industry: "",
      display_name: "Amar Ujala ",
    },
    {
      field_type: "company",
      name: "Amara Raja Battery",
      field_id: "COM000045",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AMARA RAJA GROUP.png",
      company_id: "COM000045",
      company_name: "Amara Raja Battery",
      display_name: "Amara Raja Battery",
      sector: "Electricals",
      page_display_status: false,
      industry: "Electricals",
    },
    {
      field_type: "company",
      name: "Amazon",
      field_id: "COM000046",
      website: "https://www.amazon.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AMAZON INC.jpg",
      company_id: "COM000046",
      company_name: "Amazon",
      industry: "ECOMMERCE",
      display_name: "Amazon",
    },
    {
      field_type: "company",
      name: "Ambica Steels ",
      field_id: "COM001349",
      website: "https://ambicasteels.com/",
      group: "",
      logo: "",
      company_id: "COM001349",
      company_name: "Ambica Steels ",
      industry: "",
      display_name: "Ambica Steels ",
    },
    {
      field_type: "company",
      name: "Ambuja Cements ",
      field_id: "COM000047",
      website: "https://www.ambujacement.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AMBUJA CEMENTS LIMITED.jpg",
      company_id: "COM000047",
      company_name: "Ambuja Cements ",
      industry: "CEMENT",
      display_name: "Ambuja Cements ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "AMD Industries",
      field_id: "COM001350",
      website: "http://www.amdindustries.com",
      group: "",
      logo: "",
      company_id: "COM001350",
      company_name: "AMD Industries",
      industry: "",
      display_name: "AMD Industries",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "AMG Group ",
      field_id: "COM001194",
      website: "https://www.amg-group.co/",
      group: "AMG GROUP LIMITED",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AMG GROUP LIMITED.png",
      company_id: "COM001194",
      company_name: "AMG Group ",
      industry: "",
      display_name: "AMG Group ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Amira Nature Foods ",
      field_id: "COM000048",
      website: "https://www.amira.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AMIRA NATURE FOODS LIMITED.png",
      company_id: "COM000048",
      company_name: "Amira Nature Foods ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Amira Nature Foods ",
    },
    {
      field_type: "company",
      name: "Amit Metalics",
      field_id: "COM001351",
      website: "https://www.amitmetaliks.com/contact.html",
      group: "Amit Group of Companies",
      logo: "",
      company_id: "COM001351",
      company_name: "Amit Metalics",
      industry: "",
      display_name: "Amit Metalics",
    },
    {
      field_type: "company",
      name: "Amneal Pharma",
      field_id: "COM001352",
      website: "https://www.amneal.com/",
      group: "",
      logo: "",
      company_id: "COM001352",
      company_name: "Amneal Pharma",
      industry: "",
      display_name: "Amneal Pharma",
    },
    {
      field_type: "company",
      name: "Amri Global",
      field_id: "COM001353",
      website: "https://www.amriglobal.com/about-us/contact-us/",
      group: "",
      logo: "",
      company_id: "COM001353",
      company_name: "Amri Global",
      industry: "",
      display_name: "Amri Global",
    },
    {
      field_type: "company",
      name: "Amrit Cement ",
      field_id: "COM001354",
      website: "https://www.amritcement.com/",
      group: "",
      logo: "",
      company_id: "COM001354",
      company_name: "Amrit Cement ",
      industry: "",
      display_name: "Amrit Cement ",
    },
    {
      field_type: "company",
      name: "Amrut Distilleries  ",
      field_id: "COM001355",
      website: "http://www.amrutdistilleries.com",
      group: "",
      logo: "",
      company_id: "COM001355",
      company_name: "Amrut Distilleries  ",
      industry: "",
      display_name: "Amrut Distilleries  ",
    },
    {
      field_type: "company",
      name: "Amway",
      field_id: "COM000051",
      website: "http://www.amway.in/store/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Amway India Enterprises Private Limited.png",
      company_id: "COM000051",
      company_name: "Amway",
      industry: "HEALTHCARE",
      display_name: "Amway",
    },
    {
      field_type: "company",
      name: "Amul",
      field_id: "COM000050",
      website: "https://amul.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Anand Milk Union Limited.png",
      company_id: "COM000050",
      company_name: "Amul",
      display_name: "Amul",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Anchor Electricals",
      field_id: "COM000052",
      website: "http://lsin.panasonic.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANCHOR ELECTRICALS PRIVATE LIMITED.png",
      company_id: "COM000052",
      company_name: "Anchor Electricals",
      display_name: "Anchor Electricals",
      sector: "Electricals",
      page_display_status: false,
      industry: "Electricals",
    },
    {
      field_type: "company",
      name: "Anchor Health And Beauty Care  ",
      field_id: "COM000053",
      website: "http://www.anchorglobal.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANCHOR HEALTH AND BEAUTY CARE PRIVATE LIMITED.jpg",
      company_id: "COM000053",
      company_name: "Anchor Health And Beauty Care  ",
      display_name: "Anchor Health And Beauty Care  ",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Andhra Cements ",
      field_id: "COM001356",
      website: "https://www.andhracements.com/",
      group: "JAYPEE GROUP",
      logo: "",
      company_id: "COM001356",
      company_name: "Andhra Cements ",
      industry: "",
      display_name: "Andhra Cements ",
    },
    {
      field_type: "company",
      name: "Andhra Pradesh State Civil Supplies Corporation ",
      field_id: "COM001201",
      website: "http://apscsc.gov.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANDHRA PRADESH STATE CIVIL SUPPLIES CORPORATION LIMITED.jpg",
      company_id: "COM001201",
      company_name: "Andhra Pradesh State Civil Supplies Corporation ",
      industry: "",
      display_name: "Andhra Pradesh State Civil Supplies Corporation ",
    },
    {
      field_type: "company",
      name: "Andrew Yule And Company ",
      field_id: "COM001195",
      website: "http://www.andrewyule.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANDREW YULE AND COMPANY LIMITED.gif",
      company_id: "COM001195",
      company_name: "Andrew Yule And Company ",
      industry: "",
      display_name: "Andrew Yule And Company ",
    },
    {
      field_type: "company",
      name: "Andritz Hydro  ",
      field_id: "COM001357",
      website:
        "https://www.andritz.com/hydro-en/about-andritz-hydro/locations/india",
      group: "Andritz group",
      logo: "",
      company_id: "COM001357",
      company_name: "Andritz Hydro  ",
      industry: "",
      display_name: "Andritz Hydro  ",
    },
    {
      field_type: "company",
      name: "Angelique International ",
      field_id: "COM000054",
      website: "https://www.angelique-india.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANGELIQUE INTERNATIONAL LIMITED.png",
      company_id: "COM000054",
      company_name: "Angelique International ",
      industry: "CONSTRUCTION",
      display_name: "Angelique International ",
    },
    {
      field_type: "company",
      name: "AB Inbev",
      field_id: "COM000008",
      website: "https://www.ab-inbev.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANHEUSER BUSCH INBEV INDIA LIMITED.svg",
      company_id: "COM000008",
      company_name: "AB Inbev",
      industry: "BREWING",
      display_name: "AB Inbev",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Anjani Portland Cement ",
      field_id: "COM001358",
      website: "http://www.anjanicement.com/index.html",
      group: "CHETTINAD GROUP",
      logo: "",
      company_id: "COM001358",
      company_name: "Anjani Portland Cement ",
      industry: "",
      display_name: "Anjani Portland Cement ",
    },
    {
      field_type: "company",
      name: "Ankur Drugs",
      field_id: "COM001359",
      website: "https://www.ankurdrugs.com/",
      group: "",
      logo: "",
      company_id: "COM001359",
      company_name: "Ankur Drugs",
      industry: "",
      display_name: "Ankur Drugs",
    },
    {
      field_type: "company",
      name: "Anmol Industries ",
      field_id: "COM001196",
      website: "https://www.anmolindustries.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANMOL INDUSTRIES LIMITED.png",
      company_id: "COM001196",
      company_name: "Anmol Industries ",
      industry: "",
      display_name: "Anmol Industries ",
    },
    {
      field_type: "company",
      name: "Ans Steel Tubes ",
      field_id: "COM001360",
      website: "https://www.anssteel.com",
      group: "",
      logo: "",
      company_id: "COM001360",
      company_name: "Ans Steel Tubes ",
      industry: "",
      display_name: "Ans Steel Tubes ",
    },
    {
      field_type: "company",
      name: "Antelec ",
      field_id: "COM001197",
      website: "http://www.antelecltd.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANTELEC LIMITED.gif",
      company_id: "COM001197",
      company_name: "Antelec ",
      industry: "",
      display_name: "Antelec ",
    },
    {
      field_type: "company",
      name: "Anupam Industries ",
      field_id: "COM001361",
      website: "http://www.anupamgroup.com/en/contact-us.aspx",
      group: "Anupan Group",
      logo: "",
      company_id: "COM001361",
      company_name: "Anupam Industries ",
      industry: "",
      display_name: "Anupam Industries ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Anupam Rasayan",
      field_id: "COM000055",
      website: "http://www.anupamrasayan.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ANUPAM RASAYAN INDIA LIMITED.png",
      company_id: "COM000055",
      company_name: "Anupam Rasayan",
      industry: "CHEMICAL",
      display_name: "Anupam Rasayan",
    },
    {
      field_type: "company",
      name: "AOC Electronics",
      field_id: "COM001198",
      website: "http://www.aoc.com/home.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AOC GLOBAL.png",
      company_id: "COM001198",
      company_name: "AOC Electronics",
      industry: "",
      display_name: "AOC Electronics",
    },
    {
      field_type: "company",
      name: "Apar Industries",
      field_id: "COM000057",
      website: "http://www.apar.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/APAR INDUSTRIES LIMITED.jpg",
      company_id: "COM000057",
      company_name: "Apar Industries",
      industry: "CONGLOMERATE",
      display_name: "Apar Industries",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aparna Enterprises ",
      field_id: "COM000058",
      website: "https://aparnaenterprisesltd.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/APARNA ENTERPRISES LIMITED.jpg",
      company_id: "COM000058",
      company_name: "Aparna Enterprises ",
      industry: "BUILDING MATERIAL",
      display_name: "Aparna Enterprises ",
    },
    {
      field_type: "company",
      name: "APCO Mineral Industries",
      field_id: "COM000059",
      website: "https://www.apcomineral.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/APCO MINERAL INDUSTRIES.jpg",
      company_id: "COM000059",
      company_name: "APCO Mineral Industries",
      industry: "METALS AND MINING",
      display_name: "APCO Mineral Industries",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Apex Drugs",
      field_id: "COM001362",
      website: "https://www.apexdrugs.com/",
      group: "",
      logo: "",
      company_id: "COM001362",
      company_name: "Apex Drugs",
      industry: "",
      display_name: "Apex Drugs",
    },
    {
      field_type: "company",
      name: "Api Motors  ",
      field_id: "COM001199",
      website: "https://www.apimotors.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/API MOTORS PRIVATE LIMITED.jpg",
      company_id: "COM001199",
      company_name: "Api Motors  ",
      industry: "",
      display_name: "Api Motors  ",
    },
    {
      field_type: "company",
      name: "Apollo Tubes ",
      field_id: "COM000060",
      website: "https://www.aplapollo.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/APL APOLLO TUBES LIMITED.png",
      company_id: "COM000060",
      company_name: "Apollo Tubes ",
      industry: "STEEL",
      display_name: "Apollo Tubes ",
    },
    {
      field_type: "company",
      name: "Apollo Pharma",
      field_id: "COM001200",
      website: "https://www.apollopharmacy.in/",
      group: "APOLLO HOSPITAL ENTERPRISE LIMITED",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/APOLLO PHARMACY INDIA LIMITED.jpg",
      company_id: "COM001200",
      company_name: "Apollo Pharma",
      industry: "",
      display_name: "Apollo Pharma",
    },
    {
      field_type: "company",
      name: "Apollo Tyres ",
      field_id: "COM000061",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/APOLLO TYRES LIMITED.png",
      company_id: "COM000061",
      company_name: "Apollo Tyres ",
      industry: "TYRE",
      display_name: "Apollo Tyres ",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Apotex ",
      field_id: "COM001363",
      website: "http://www1.apotex.com/",
      group: "",
      logo: "",
      company_id: "COM001363",
      company_name: "Apotex ",
      industry: "",
      display_name: "Apotex ",
    },
    {
      field_type: "company",
      name: "Archies ",
      field_id: "COM000062",
      website: "https://www.archiesonline.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ARCHIES LIMITED.jpg",
      company_id: "COM000062",
      company_name: "Archies ",
      industry: "ECOMMERCE",
      display_name: "Archies ",
    },
    {
      field_type: "company",
      name: "Arham Technochem",
      field_id: "COM001121",
      website: "http://www.arhamtechnochem.com",
      group: "Venus Group",
      logo: "",
      company_id: "COM001121",
      company_name: "Arham Technochem",
      industry: "",
      display_name: "Arham Technochem",
    },
    {
      field_type: "company",
      name: "Arihant Coal",
      field_id: "COM001202",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001202",
      company_name: "Arihant Coal",
      industry: "",
      display_name: "Arihant Coal",
    },
    {
      field_type: "company",
      name: "Aristo Pharma",
      field_id: "COM000063",
      website: "http://aristopharma.org/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ARISTO PHARMACEUTICALS PRIVATE LIMITED.jpg",
      company_id: "COM000063",
      company_name: "Aristo Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Aristo Pharma",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Arjas Steel  ",
      field_id: "COM000064",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ARJAS STEEL PRIVATE LIMITED.jpg",
      company_id: "COM000064",
      company_name: "Arjas Steel  ",
      industry: "STEEL",
      display_name: "Arjas Steel  ",
    },
    {
      field_type: "company",
      name: "Arrowline Organics",
      field_id: "COM001203",
      website: "http://www.therightmoo.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ARROWLINE ORGANIC PRODUCTS PRIVATE LIMITED.PNG",
      company_id: "COM001203",
      company_name: "Arrowline Organics",
      industry: "",
      display_name: "Arrowline Organics",
    },
    {
      field_type: "company",
      name: "Articial Limbs Manufacturing Corporation Of India",
      field_id: "COM001364",
      website: "http://www.alimco.in",
      group: "",
      logo: "",
      company_id: "COM001364",
      company_name: "Articial Limbs Manufacturing Corporation Of India",
      industry: "",
      display_name: "Articial Limbs Manufacturing Corporation Of India",
    },
    {
      field_type: "company",
      name: "Arvind Textiles",
      field_id: "COM000065",
      website: "https://www.arvind.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ARVIND LIMITED.jpg",
      company_id: "COM000065",
      company_name: "Arvind Textiles",
      industry: "CONGLOMERATE",
      display_name: "Arvind Textiles",
    },
    {
      field_type: "company",
      name: "Asahi India Glass ",
      field_id: "COM000026",
      website: "https://www.aisglass.com/",
      group: "AIS GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Asahi India Glass Limited.png",
      company_id: "COM000026",
      company_name: "Asahi India Glass ",
      industry: "GLASS",
      display_name: "Asahi India Glass ",
    },
    {
      field_type: "company",
      name: "Ashirvad Pipes  ",
      field_id: "COM000067",
      website: "https://www.ashirvad.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASHIRVAD PIPES PRIVATE LIMITED.png",
      company_id: "COM000067",
      company_name: "Ashirvad Pipes  ",
      industry: "PLASTICS",
      display_name: "Ashirvad Pipes  ",
    },
    {
      field_type: "company",
      name: "Ashok Leyland Motors",
      field_id: "COM000068",
      website: "https://www.ashokleyland.com/en/web/ashokleyland/home",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASHOK LEYLAND.jpg",
      company_id: "COM000068",
      company_name: "Ashok Leyland Motors",
      industry: "AUTOMOBILE",
      display_name: "Ashok Leyland Motors",
    },
    {
      field_type: "company",
      name: "Ashoka Buildcon  ",
      field_id: "COM000069",
      website: "https://ashokabuildcon.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASHOKA BUILDCON LIMITED .png",
      company_id: "COM000069",
      company_name: "Ashoka Buildcon  ",
      industry: "INFRASTRUCTURE",
      display_name: "Ashoka Buildcon  ",
    },
    {
      field_type: "company",
      name: "Asian Colour Ispat ",
      field_id: "COM001365",
      website: "http://www.accil.com",
      group: "",
      logo: "",
      company_id: "COM001365",
      company_name: "Asian Colour Ispat ",
      industry: "",
      display_name: "Asian Colour Ispat ",
    },
    {
      field_type: "company",
      name: "Asian Concretes",
      field_id: "COM001366",
      website: "https://www.asiancements.com",
      group: "",
      logo: "",
      company_id: "COM001366",
      company_name: "Asian Concretes",
      industry: "",
      display_name: "Asian Concretes",
    },
    {
      field_type: "company",
      name: "Asian Paint",
      field_id: "COM000070",
      website: "https://www.asianpaints.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASIAN PAINTS LIMITED.png",
      company_id: "COM000070",
      company_name: "Asian Paint",
      industry: "PAINTS",
      display_name: "Asian Paint",
    },
    {
      field_type: "company",
      name: "Aska Fire Safety Equipments ",
      field_id: "COM001204",
      website: "https://askagroup.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASKA EQUIPMENTS LIMITED.jpg",
      company_id: "COM001204",
      company_name: "Aska Fire Safety Equipments ",
      industry: "",
      display_name: "Aska Fire Safety Equipments ",
    },
    {
      field_type: "company",
      name: "Askme",
      field_id: "COM000071",
      website: "http://www.askme.com.tw/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASKME INTERGROUP CO LIMITED.png",
      company_id: "COM000071",
      company_name: "Askme",
      industry: "MANUFACTURING",
      display_name: "Askme",
    },
    {
      field_type: "company",
      name: "Asrani Tubes",
      field_id: "COM000072",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASRANI TUBES LIMITED.jpg",
      company_id: "COM000072",
      company_name: "Asrani Tubes",
      industry: "MANUFACTURING",
      display_name: "Asrani Tubes",
    },
    {
      field_type: "company",
      name: "Astra Lifecare",
      field_id: "COM001367",
      website: "http://www.astralifecare.com/",
      group: "",
      logo: "",
      company_id: "COM001367",
      company_name: "Astra Lifecare",
      industry: "",
      display_name: "Astra Lifecare",
    },
    {
      field_type: "company",
      name: "Astrazeneca Pharma",
      field_id: "COM000073",
      website: "https://www.astrazeneca.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASTRAZENECA.png",
      company_id: "COM000073",
      company_name: "Astrazeneca Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Astrazeneca Pharma",
    },
    {
      field_type: "company",
      name: "Astron Paper And Board Mill ",
      field_id: "COM001205",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ASTRON PAPER AND BOARD MILL.jpg",
      company_id: "COM001205",
      company_name: "Astron Paper And Board Mill ",
      industry: "",
      display_name: "Astron Paper And Board Mill ",
    },
    {
      field_type: "company",
      name: "Atlas Copco",
      field_id: "COM000074",
      website: "https://www.atlascopco.com/en-us",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ATLAS COPCO LIMITED.jpg",
      company_id: "COM000074",
      company_name: "Atlas Copco",
      industry: "MANUFACTURING",
      display_name: "Atlas Copco",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Atra Pharma",
      field_id: "COM001368",
      website: "http://www.atrapharma.com/",
      group: "",
      logo: "",
      company_id: "COM001368",
      company_name: "Atra Pharma",
      industry: "",
      display_name: "Atra Pharma",
    },
    {
      field_type: "company",
      name: "Atul Chemicals and Polymers",
      field_id: "COM001369",
      website: "https://www.atul.co.in/",
      group: "",
      logo: "",
      company_id: "COM001369",
      company_name: "Atul Chemicals and Polymers",
      industry: "",
      display_name: "Atul Chemicals and Polymers",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Aurobindo Pharmaceuticals",
      field_id: "COM001065",
      website: "https://www.aurobindo.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AUROBINDO PHARMA.png",
      company_id: "COM001065",
      company_name: "Aurobindo Pharmaceuticals",
      industry: "",
      display_name: "Aurobindo Pharmaceuticals",
    },
    {
      field_type: "company",
      name: "Autolite Electric Vehicals",
      field_id: "COM001206",
      website: "https://www.autopal.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AUTOLITE INDIA LIMITED.jpg",
      company_id: "COM001206",
      company_name: "Autolite Electric Vehicals",
      industry: "",
      display_name: "Autolite Electric Vehicals",
    },
    {
      field_type: "company",
      name: "Automark Industries",
      field_id: "COM001207",
      website: "https://www.automark-india.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AUTOMARK INDUSTRIES INDIA PRIVATE LIMITED.jpg",
      company_id: "COM001207",
      company_name: "Automark Industries",
      industry: "",
      display_name: "Automark Industries",
    },
    {
      field_type: "company",
      name: "Ava Cholayil Health Care  ",
      field_id: "COM000075",
      website: "https://www.avacare.in/about-us",
      group: "CHOLAYIL PRIVATE LIMITED",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AVA CHOLAYIL HEALTH CARE PRIVATE LIMITED.png",
      company_id: "COM000075",
      company_name: "Ava Cholayil Health Care  ",
      industry: "HEALTHCARE",
      display_name: "Ava Cholayil Health Care  ",
    },
    {
      field_type: "company",
      name: "Avaids Technovators  ",
      field_id: "COM000076",
      website: "https://www.avaids.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AVAIDS TECHNOVATORS PRIVATE LIMITED.jpg",
      company_id: "COM000076",
      company_name: "Avaids Technovators  ",
      industry: "MANUFACTURING",
      display_name: "Avaids Technovators  ",
    },
    {
      field_type: "company",
      name: "Avani Petrochemicals",
      field_id: "COM001370",
      website: "https://avanipetrochem.com/index.html",
      group: "",
      logo: "",
      company_id: "COM001370",
      company_name: "Avani Petrochemicals",
      industry: "",
      display_name: "Avani Petrochemicals",
    },
    {
      field_type: "company",
      name: "Avantor ",
      field_id: "COM000077",
      website: "https://www.avantorsciences.com/en/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AVANTOR PERFORMANCE MATERIALS.jpg",
      company_id: "COM000077",
      company_name: "Avantor ",
      industry: "CHEMICAL",
      display_name: "Avantor ",
    },
    {
      field_type: "company",
      name: "DMart (Avenue Supermarts)",
      field_id: "COM001208",
      website: "https://www.dmartindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AVENUE SUPERMARTS LIMITED.jpg",
      company_id: "COM001208",
      company_name: "DMart (Avenue Supermarts)",
      industry: "",
      display_name: "DMart (Avenue Supermarts)",
    },
    {
      field_type: "company",
      name: "Avery Dennison",
      field_id: "COM001209",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AVERY DENNISON CORPORATION.png",
      company_id: "COM001209",
      company_name: "Avery Dennison",
      industry: "",
      display_name: "Avery Dennison",
    },
    {
      field_type: "company",
      name: "Avon Products ",
      field_id: "COM000078",
      website: "https://www.avon.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AVON PRODUCTS INC.png",
      company_id: "COM000078",
      company_name: "Avon Products ",
      industry: "FASHION AND CLOTHING",
      display_name: "Avon Products ",
    },
    {
      field_type: "company",
      name: "Axalta Coating",
      field_id: "COM001210",
      website: "https://www.axalta.com/corporate/en_US.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AXALTA COATING SYSTEMS.png",
      company_id: "COM001210",
      company_name: "Axalta Coating",
      industry: "",
      display_name: "Axalta Coating",
    },
    {
      field_type: "company",
      name: "Axel Polymers",
      field_id: "COM001211",
      website: "http://www.axelindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AXEL POLYMERS LIMITED.jpg",
      company_id: "COM001211",
      company_name: "Axel Polymers",
      industry: "",
      display_name: "Axel Polymers",
    },
    {
      field_type: "company",
      name: "Axles India",
      field_id: "COM000079",
      website: "http://www.axlesindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AXLES INDIA LIMITED.png",
      company_id: "COM000079",
      company_name: "Axles India",
      industry: "AUTOMOBILE",
      display_name: "Axles India",
    },
    {
      field_type: "company",
      name: "Axolo Ceramics",
      field_id: "COM001212",
      website: "http://www.axoloceramic.com/about-us.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/AXOLO CERAMIC PRIVATE LIMITED.png",
      company_id: "COM001212",
      company_name: "Axolo Ceramics",
      industry: "",
      display_name: "Axolo Ceramics",
    },
    {
      field_type: "company",
      name: "BN Traders",
      field_id: "COM000080",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000080",
      company_name: "BN Traders",
      industry: "ELECTRICALS",
      display_name: "BN Traders",
    },
    {
      field_type: "company",
      name: "Bacardi Rum",
      field_id: "COM001213",
      website: "https://www.bacardi.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BACARDI LIMITED.jpg",
      company_id: "COM001213",
      company_name: "Bacardi Rum",
      industry: "",
      display_name: "Bacardi Rum",
    },
    {
      field_type: "company",
      name: "Baccarose Perfumes",
      field_id: "COM000081",
      website: "http://www.baccarose.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BACCAROSE.jpg",
      company_id: "COM000081",
      company_name: "Baccarose Perfumes",
      industry: "FASHION AND CLOTHING",
      display_name: "Baccarose Perfumes",
    },
    {
      field_type: "company",
      name: "Baerlocher",
      field_id: "COM000082",
      website: "https://www.baerlocher.com",
      group: "Baerlocher Group",
      logo: "",
      company_id: "COM000082",
      company_name: "Baerlocher",
      industry: "PLASTICS",
      display_name: "Baerlocher",
    },
    {
      field_type: "company",
      name: "Bagalkot Cements",
      field_id: "COM001214",
      website: "http://www.bagalkotcement.com/",
      group: "Kanoria Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BAGALKOT CEMENT AND INDUSTRIES LIMITED.PNG",
      company_id: "COM001214",
      company_name: "Bagalkot Cements",
      industry: "",
      display_name: "Bagalkot Cements",
    },
    {
      field_type: "company",
      name: "Baidyanath Polymers",
      field_id: "COM000083",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000083",
      company_name: "Baidyanath Polymers",
      industry: "PLASTICS",
      display_name: "Baidyanath Polymers",
    },
    {
      field_type: "company",
      name: "Bajaj Automobiles",
      field_id: "COM001215",
      website: "https://www.bajajauto.com/",
      group: "Bajaj Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BAJAJ AUTO.png",
      company_id: "COM001215",
      company_name: "Bajaj Automobiles",
      industry: "",
      display_name: "Bajaj Automobiles",
    },
    {
      field_type: "company",
      name: "Bajaj Electricals ",
      field_id: "COM000084",
      website: "https://www.bajajelectricals.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BAJAJ ELECTRICALS LIMITED.jpg",
      company_id: "COM000084",
      company_name: "Bajaj Electricals ",
      display_name: "Bajaj Electricals ",
      sector: "Electricals",
      page_display_status: true,
      industry: "Electricals",
    },
    {
      field_type: "company",
      name: "Bakers Circle",
      field_id: "COM001098",
      website: "http://www.bakers.global/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BAKERS CIRCLE.png",
      company_id: "COM001098",
      company_name: "Bakers Circle",
      industry: "",
      display_name: "Bakers Circle",
    },
    {
      field_type: "company",
      name: "Bal Pharmaceuticals",
      field_id: "COM001371",
      website: "http://www.balpharma.com/",
      group: "",
      logo: "",
      company_id: "COM001371",
      company_name: "Bal Pharmaceuticals",
      industry: "",
      display_name: "Bal Pharmaceuticals",
    },
    {
      field_type: "company",
      name: "Balaji Agency",
      field_id: "COM000085",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BALAJI AGENCIES.png",
      company_id: "COM000085",
      company_name: "Balaji Agency",
      industry: "",
      display_name: "Balaji Agency",
    },
    {
      field_type: "company",
      name: "Balaji Dyes",
      field_id: "COM000086",
      website: "https://www.balajiindustrialsafety.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BALAJI INDUSTRIES.png",
      company_id: "COM000086",
      company_name: "Balaji Dyes",
      industry: "MANUFACTURING",
      display_name: "Balaji Dyes",
    },
    {
      field_type: "company",
      name: "Balasore Alloys ",
      field_id: "COM001216",
      website: "https://www.balasorealloys.com/",
      group: "Ispat group of Companies",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BALASORE ALLOYS LIMITED.PNG",
      company_id: "COM001216",
      company_name: "Balasore Alloys ",
      industry: "",
      display_name: "Balasore Alloys ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000087",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000087",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Balkrishna Industries Limited",
        field_id: "COM000087",
        website: "https://www.bkt-tires.com",
        group: "",
        logo: "",
        company_id: "COM000087",
        company_name: "Balkrishna Industries Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Balkrishna Tyres",
      field_id: "COM000088",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000088",
      company_name: "Balkrishna Tyres",
      industry: "TYRE",
      display_name: "Balkrishna Tyres",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "BILT Papers (Ballarpur Industries)",
      field_id: "COM001217",
      website: "https://bilt.com/",
      group: "Avantha Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BALLARPUR INDUSTRIES LIMITED.png",
      company_id: "COM001217",
      company_name: "BILT Papers (Ballarpur Industries)",
      industry: "",
      display_name: "BILT Papers (Ballarpur Industries)",
    },
    {
      field_type: "company",
      name: "Balmer Lawrie",
      field_id: "COM000090",
      website: "http://www.balmerlawrie.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BALMER LAWRIE AND CO LIMITED.jpg",
      company_id: "COM000090",
      company_name: "Balmer Lawrie",
      industry: "CONGLOMERATE",
      display_name: "Balmer Lawrie",
    },
    {
      field_type: "company",
      name: "Bambino Agro",
      field_id: "COM000091",
      website: "http://bambinoagro.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BAMBINO AGRO.png",
      company_id: "COM000091",
      company_name: "Bambino Agro",
      industry: "FMCG",
      display_name: "Bambino Agro",
    },
    {
      field_type: "company",
      name: "Banaskantha Milk Producers Union ",
      field_id: "COM001218",
      website: "http://banasdairy.coop/home.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BANASKANTHA DISTRICT COOPERATIVE MILK PRODUCERS UNION LIMITED.PNG",
      company_id: "COM001218",
      company_name: "Banaskantha Milk Producers Union ",
      industry: "",
      display_name: "Banaskantha Milk Producers Union ",
    },
    {
      field_type: "company",
      name: "Bansal Cement  ",
      field_id: "COM001372",
      website: "https://bansalcement.com/",
      group: "",
      logo: "",
      company_id: "COM001372",
      company_name: "Bansal Cement  ",
      industry: "",
      display_name: "Bansal Cement  ",
    },
    {
      field_type: "company",
      name: "Bansal Denim",
      field_id: "COM000092",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000092",
      company_name: "Bansal Denim",
      industry: "FASHION AND CLOTHING",
      display_name: "Bansal Denim",
    },
    {
      field_type: "company",
      name: "Bansal Trading Company",
      field_id: "COM000093",
      website: "https://www.bansaltradingco.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BANSAL TRADING COMPANY.jpg",
      company_id: "COM000093",
      company_name: "Bansal Trading Company",
      industry: "",
      display_name: "Bansal Trading Company",
    },
    {
      field_type: "company",
      name: "Barak Valley Cements ",
      field_id: "COM001373",
      website: "http://www.barakcement.com/",
      group: "",
      logo: "",
      company_id: "COM001373",
      company_name: "Barak Valley Cements ",
      industry: "",
      display_name: "Barak Valley Cements ",
    },
    {
      field_type: "company",
      name: "Baroda Agro Chemicals  (BACL)",
      field_id: "COM001374",
      website: "http://barodaagro.com/",
      group: "",
      logo: "",
      company_id: "COM001374",
      company_name: "Baroda Agro Chemicals  (BACL)",
      industry: "",
      display_name: "Baroda Agro Chemicals  (BACL)",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "BASF Chemicals",
      field_id: "COM000095",
      website: "https://www.basf.com/in/en.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BASF INDIA LIMITED.jpg",
      company_id: "COM000095",
      company_name: "BASF Chemicals",
      industry: "CHEMICAL",
      display_name: "BASF Chemicals",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Basic Pharma",
      field_id: "COM001375",
      website: "https://www.basicpharma.nl/",
      group: "",
      logo: "",
      company_id: "COM001375",
      company_name: "Basic Pharma",
      industry: "",
      display_name: "Basic Pharma",
    },
    {
      field_type: "company",
      name: "Bata",
      field_id: "COM000096",
      website: "https://www.bata.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BATA INDIA LIMITED.png",
      company_id: "COM000096",
      company_name: "Bata",
      industry: "MANUFACTURING",
      display_name: "Bata",
    },
    {
      field_type: "company",
      name: "Bausch And Lomb",
      field_id: "COM001376",
      website: "http://www.bausch.com/",
      group: "",
      logo: "",
      company_id: "COM001376",
      company_name: "Bausch And Lomb",
      industry: "",
      display_name: "Bausch And Lomb",
    },
    {
      field_type: "company",
      name: "Baxtar Labs",
      field_id: "COM000097",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BAXTER INDIA LIMITED.jpg",
      company_id: "COM000097",
      company_name: "Baxtar Labs",
      industry: "HEALTHCARE",
      display_name: "Baxtar Labs",
    },
    {
      field_type: "company",
      name: "Baxter Labs",
      field_id: "COM001377",
      website: "https://www.baxter.com",
      group: "",
      logo: "",
      company_id: "COM001377",
      company_name: "Baxter Labs",
      industry: "",
      display_name: "Baxter Labs",
    },
    {
      field_type: "company",
      name: "Bayer Phrama",
      field_id: "COM000098",
      website: "https://www.bayer.in",
      group: "Bayer Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BAYER INDIA LIMITED.jpg",
      company_id: "COM000098",
      company_name: "Bayer Phrama",
      industry: "PHARMACEUTICAL",
      display_name: "Bayer Phrama",
    },
    {
      field_type: "company",
      name: "Bayer Cropscience ",
      field_id: "COM001378",
      website: "https://www.bayer.in/agriculture.php",
      group: "",
      logo: "",
      company_id: "COM001378",
      company_name: "Bayer Cropscience ",
      industry: "",
      display_name: "Bayer Cropscience ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Bec Chemicals  ",
      field_id: "COM001219",
      website: "https://www.becchemicals.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BEC CHEMICALS PRIVATE LIMITED.jpg",
      company_id: "COM001219",
      company_name: "Bec Chemicals  ",
      industry: "",
      display_name: "Bec Chemicals  ",
    },
    {
      field_type: "company",
      name: "Bectors Food",
      field_id: "COM000100",
      website: "http://www.cremica.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BECTOR FOODS LIMITED.png",
      company_id: "COM000100",
      company_name: "Bectors Food",
      industry: "FMCG",
      display_name: "Bectors Food",
    },
    {
      field_type: "company",
      name: "Bedmutha Industries ",
      field_id: "COM000101",
      website: "http://www.bedmutha.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BEDMUTHA INDUSTRIES LIMITED.png",
      company_id: "COM000101",
      company_name: "Bedmutha Industries ",
      industry: "MANUFACTURING",
      display_name: "Bedmutha Industries ",
    },
    {
      field_type: "company",
      name: "Bemco Sleepers ",
      field_id: "COM000103",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000103",
      company_name: "Bemco Sleepers ",
      industry: "BUILDING MATERIAL",
      display_name: "Bemco Sleepers ",
    },
    {
      field_type: "company",
      name: "Benetton Group",
      field_id: "COM000099",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BENETTON GROUP.jpg",
      company_id: "COM000099",
      company_name: "Benetton Group",
      industry: "FASHION AND CLOTHING",
      display_name: "Benetton Group",
    },
    {
      field_type: "company",
      name: "Times New Paper",
      field_id: "COM001109",
      website: "http://www.timesgroup.com/",
      group: "",
      logo: "",
      company_id: "COM001109",
      company_name: "Times New Paper",
      industry: "",
      display_name: "Times New Paper",
    },
    {
      field_type: "company",
      name: "Berger Paints",
      field_id: "COM000104",
      website: "https://www.bergerpaints.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BERGER PAINTS INDIA LIMITED.png",
      company_id: "COM000104",
      company_name: "Berger Paints",
      industry: "PAINTS",
      display_name: "Berger Paints",
    },
    {
      field_type: "company",
      name: "Beumer India   ",
      field_id: "COM000105",
      website:
        "https://www.beumergroup.com/en/about-beumer-group/beumer-india-private-limited",
      group: "BEUMER GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BEUMER INDIA PRIVATE LIMITED .jpg",
      company_id: "COM000105",
      company_name: "Beumer India   ",
      industry: "MANUFACTURING",
      display_name: "Beumer India   ",
    },
    {
      field_type: "company",
      name: "Bg Shirke Construction",
      field_id: "COM000106",
      website: "https://www.shirkegroup.com",
      group: "Shirke Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BG SHIRKE CONSTRUCTION TECHNOLOGY PRIVATE LIMITED.jpg",
      company_id: "COM000106",
      company_name: "Bg Shirke Construction",
      industry: "CONSTRUCTION",
      display_name: "Bg Shirke Construction",
    },
    {
      field_type: "company",
      name: "BGR Energy",
      field_id: "COM000107",
      website: "http://www.bgrcorp.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BGR ENERGY SYSTEMS LIMITED.jpg",
      company_id: "COM000107",
      company_name: "BGR Energy",
      industry: "ENGINEERING SERVICES",
      display_name: "BGR Energy",
    },
    {
      field_type: "company",
      name: "BARC - Bhabha Atomic Research Centre",
      field_id: "COM000094",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHABHA ATOMIC RESEARCH CENTRE.jpg",
      company_id: "COM000094",
      company_name: "BARC - Bhabha Atomic Research Centre",
      industry: "",
      display_name: "BARC - Bhabha Atomic Research Centre",
    },
    {
      field_type: "company",
      name: "Bhagiratha Polymers  ",
      field_id: "COM000108",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000108",
      company_name: "Bhagiratha Polymers  ",
      industry: "MANUFACTURING",
      display_name: "Bhagiratha Polymers  ",
    },
    {
      field_type: "company",
      name: "Bhagirati Enterprise  ",
      field_id: "COM000109",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000109",
      company_name: "Bhagirati Enterprise  ",
      industry: "",
      display_name: "Bhagirati Enterprise  ",
    },
    {
      field_type: "company",
      name: "Bharat Electronics ",
      field_id: "COM000110",
      website: "http://www.bel-india.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARAT ELECTRONICS LIMITED (BEL).png",
      company_id: "COM000110",
      company_name: "Bharat Electronics ",
      industry: "ELECTRONICS",
      display_name: "Bharat Electronics ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "BharatForge",
      field_id: "COM001151",
      website: "https://www.bharatforge.com/",
      group: "Kalyani Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARAT FORGE LIMITED.png",
      company_id: "COM001151",
      company_name: "BharatForge",
      industry: "",
      display_name: "BharatForge",
    },
    {
      field_type: "company",
      name: "BHEL - Bharat Heavy Electricals ",
      field_id: "COM000111",
      website: "http://www.bhel.com/bhel-landing/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARAT HEAVY ELECTRICALS LIMITED.png",
      company_id: "COM000111",
      company_name: "BHEL - Bharat Heavy Electricals ",
      industry: "ELECTRICALS",
      display_name: "BHEL - Bharat Heavy Electricals ",
    },
    {
      field_type: "company",
      name: "Bharat Hitech Cement  ",
      field_id: "COM001379",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001379",
      company_name: "Bharat Hitech Cement  ",
      industry: "",
      display_name: "Bharat Hitech Cement  ",
    },
    {
      field_type: "company",
      name: "Bharat International",
      field_id: "COM000112",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000112",
      company_name: "Bharat International",
      industry: "",
      display_name: "Bharat International",
    },
    {
      field_type: "company",
      name: "Bharat Parenterals ",
      field_id: "COM001380",
      website: "https://www.bplindia.in/",
      group: "",
      logo: "",
      company_id: "COM001380",
      company_name: "Bharat Parenterals ",
      industry: "",
      display_name: "Bharat Parenterals ",
    },
    {
      field_type: "company",
      name: "BPCL - Bharat Petroleum Corporation ",
      field_id: "COM000113",
      website: "https://www.bharatpetroleum.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARAT PETROLEUM CORPORATION LIMITED.jpg",
      company_id: "COM000113",
      company_name: "BPCL - Bharat Petroleum Corporation ",
      industry: "OIL AND GAS",
      display_name: "BPCL - Bharat Petroleum Corporation ",
    },
    {
      field_type: "company",
      name: "Bharat Potteries ",
      field_id: "COM001220",
      website: "http://www.bharatpotteries.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARAT POTTERIES LIMITED.png",
      company_id: "COM001220",
      company_name: "Bharat Potteries ",
      industry: "",
      display_name: "Bharat Potteries ",
    },
    {
      field_type: "company",
      name: "BSNL - Bharat Sanchar Nigam ",
      field_id: "COM001229",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARAT SANCHAR NIGAM LIMITED.png",
      company_id: "COM001229",
      company_name: "BSNL - Bharat Sanchar Nigam ",
      industry: "",
      display_name: "BSNL - Bharat Sanchar Nigam ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Bharat Solvents",
      field_id: "COM000115",
      website: "http://www.bharatsolvent.com/",
      group: "",
      logo: "",
      company_id: "COM000115",
      company_name: "Bharat Solvents",
      industry: "CHEMICAL",
      display_name: "Bharat Solvents",
    },
    {
      field_type: "company",
      name: "Bharathi Cement",
      field_id: "COM000116",
      website: "http://www.bharathicement.com/",
      group: "Vicat Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARATHI CEMENT CORPORATION PRIVATE LIMITED.jpg",
      company_id: "COM000116",
      company_name: "Bharathi Cement",
      industry: "CEMENT",
      display_name: "Bharathi Cement",
    },
    {
      field_type: "company",
      name: "Bharatiya Reserve Bank Note Mudran",
      field_id: "COM000114",
      website: "https://www.brbnmpl.co.in/english/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARATIYA RESERVE BANK NOTE MUDRAN PRIVATE LIMITED (BRBNMPL).jpg",
      company_id: "COM000114",
      company_name: "Bharatiya Reserve Bank Note Mudran",
      industry: "PRINTING AND MINTING",
      display_name: "Bharatiya Reserve Bank Note Mudran",
    },
    {
      field_type: "company",
      name: "Airtel ",
      field_id: "COM000025",
      website: "https://www.airtel.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARTI AIRTEL LIMITED.jpg",
      company_id: "COM000025",
      company_name: "Airtel ",
      industry: "TELECOM",
      display_name: "Airtel ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Bharti Hexacom",
      field_id: "COM000118",
      website: "",
      group: "BHARTI AIRTEL",
      logo: "",
      company_id: "COM000118",
      company_name: "Bharti Hexacom",
      industry: "TELECOM",
      display_name: "Bharti Hexacom",
    },
    {
      field_type: "company",
      name: "Bharti Infratel ",
      field_id: "COM000119",
      website: "http://www.bharti-infratel.com/cps-portal/",
      group: "BHARTI GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARTI INFRATEL LIMITED.png",
      company_id: "COM000119",
      company_name: "Bharti Infratel ",
      industry: "INFRASTRUCTURE",
      display_name: "Bharti Infratel ",
    },
    {
      field_type: "company",
      name: "Bharti Retail ",
      field_id: "COM000120",
      website: "https://www.bharti.com/",
      group: "BHARTI ENTERPRISES",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHARTI RETAIL LIMITED.jpg",
      company_id: "COM000120",
      company_name: "Bharti Retail ",
      industry: "FMCG",
      display_name: "Bharti Retail ",
    },
    {
      field_type: "company",
      name: "Bhavya Cements ",
      field_id: "COM001381",
      website: "https://www.bhavyacements.com/",
      group: "",
      logo: "",
      company_id: "COM001381",
      company_name: "Bhavya Cements ",
      industry: "",
      display_name: "Bhavya Cements ",
    },
    {
      field_type: "company",
      name: "Bheema Cements ",
      field_id: "COM001382",
      website: "https://www.bheemacements.net/",
      group: "",
      logo: "",
      company_id: "COM001382",
      company_name: "Bheema Cements ",
      industry: "",
      display_name: "Bheema Cements ",
    },
    {
      field_type: "company",
      name: "Bhilai Jaypee Cement ",
      field_id: "COM001383",
      website: "http://www.bjcl.co.in/",
      group: "JAYPEE GROUP",
      logo: "",
      company_id: "COM001383",
      company_name: "Bhilai Jaypee Cement ",
      industry: "",
      display_name: "Bhilai Jaypee Cement ",
    },
    {
      field_type: "company",
      name: "Bhilosa Industries  ",
      field_id: "COM000122",
      website: "http://bhilosa.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BHILOSA INDUSTRIES PRIVATE LIMITED.png",
      company_id: "COM000122",
      company_name: "Bhilosa Industries  ",
      industry: "TEXTILE",
      display_name: "Bhilosa Industries  ",
    },
    {
      field_type: "company",
      name: "Bhushan Steel ",
      field_id: "COM000123",
      website: "http://tatasteelbsl.co.in",
      group: "",
      logo: "",
      company_id: "COM000123",
      company_name: "Bhushan Steel ",
      industry: "",
      display_name: "Bhushan Steel ",
    },
    {
      field_type: "company",
      name: "Bikanervala Foods  ",
      field_id: "COM001221",
      website: "https://bikanervala.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BIKANERVALA FOODS PRIVATE LIMITED.png",
      company_id: "COM001221",
      company_name: "Bikanervala Foods  ",
      industry: "",
      display_name: "Bikanervala Foods  ",
    },
    {
      field_type: "company",
      name: "Bill Forge  ",
      field_id: "COM001222",
      website: "https://www.billforge.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BILL FORGE PRIVATE LIMITED.jpg",
      company_id: "COM001222",
      company_name: "Bill Forge  ",
      industry: "",
      display_name: "Bill Forge  ",
    },
    {
      field_type: "company",
      name: "Biltech Building Elements ",
      field_id: "COM000124",
      website: "http://www.biltechindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BILTECH BUILDING ELEMENTS LIMITED.png",
      company_id: "COM000124",
      company_name: "Biltech Building Elements ",
      industry: "BUILDING MATERIAL",
      display_name: "Biltech Building Elements ",
    },
    {
      field_type: "company",
      name: "Binani Cement",
      field_id: "COM001384",
      website: "http://binaniindustries.com/",
      group: " Braj Binani Group",
      logo: "",
      company_id: "COM001384",
      company_name: "Binani Cement",
      industry: "",
      display_name: "Binani Cement",
    },
    {
      field_type: "company",
      name: "Biocon ",
      field_id: "COM000125",
      website: "https://www.biocon.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BIOCON LIMITED.png",
      company_id: "COM000125",
      company_name: "Biocon ",
      industry: "PHARMACEUTICAL",
      display_name: "Biocon ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Biomin",
      field_id: "COM000126",
      website: "https://www.biomin.net/en/contact/asia-pacific/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BIOMIN SINGAPORE PTE LIMITED.png",
      company_id: "COM000126",
      company_name: "Biomin",
      industry: "",
      display_name: "Biomin",
    },
    {
      field_type: "company",
      name: "Biostadt",
      field_id: "COM000127",
      website: "https://www.biostadt.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BIOSTADT INDIA LIMITED.png",
      company_id: "COM000127",
      company_name: "Biostadt",
      industry: "CHEMICAL",
      display_name: "Biostadt",
    },
    {
      field_type: "company",
      name: "Biotech International ",
      field_id: "COM001223",
      website: "https://www.biotech-int.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BIOTECH INTERNATIONAL LIMITED.jpg",
      company_id: "COM001223",
      company_name: "Biotech International ",
      industry: "",
      display_name: "Biotech International ",
    },
    {
      field_type: "company",
      name: "Birla Corp",
      field_id: "COM000128",
      website: "https://www.birlacorporation.com/",
      group: "M P Birla Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BIRLA CORPORATION LIMITED.jpg",
      company_id: "COM000128",
      company_name: "Birla Corp",
      industry: "CONGLOMERATE",
      display_name: "Birla Corp",
    },
    {
      field_type: "company",
      name: "Birla Shakti Cement",
      field_id: "COM001012",
      website: "https://www.birlashakticement.com",
      group: "",
      logo: "",
      company_id: "COM001012",
      company_name: "Birla Shakti Cement",
      industry: "CEMENT",
      display_name: "Birla Shakti Cement",
    },
    {
      field_type: "company",
      name: "Birla Tyres ",
      field_id: "COM000129",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BIRLA TYRES.jpg",
      company_id: "COM000129",
      company_name: "Birla Tyres ",
      industry: "TYRE",
      display_name: "Birla Tyres ",
    },
    {
      field_type: "company",
      name: "Bisleri ",
      field_id: "COM000131",
      website: "https://www.bisleri.com/",
      group: "PARLE GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BISLERI LIMITED.png",
      company_id: "COM000131",
      company_name: "Bisleri ",
      industry: "BREWING",
      display_name: "Bisleri ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "BlueOrb Global Energy Resources",
      field_id: "COM001224",
      website: "https://blueorb.org.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BLUE ORB GLOBAL ENERGY RESOURCE PRIVATE LIMITED.webp",
      company_id: "COM001224",
      company_name: "BlueOrb Global Energy Resources",
      industry: "",
      display_name: "BlueOrb Global Energy Resources",
    },
    {
      field_type: "company",
      name: "BlueStar ",
      field_id: "COM000134",
      website: "https://www.bluestarindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BLUE STAR LIMITED.png",
      company_id: "COM000134",
      company_name: "BlueStar ",
      display_name: "BlueStar ",
      sector: "FMCD",
      page_display_status: true,
      industry: "FMCD",
    },
    {
      field_type: "company",
      name: "Bombay Rayons",
      field_id: "COM001225",
      website: "http://www.bombayrayon.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BOMBAY RAYON FASHIONS LIMITED.jpg",
      company_id: "COM001225",
      company_name: "Bombay Rayons",
      industry: "",
      display_name: "Bombay Rayons",
    },
    {
      field_type: "company",
      name: "Borosil Glass",
      field_id: "COM001226",
      website: "http://www.borosil.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BOROSIL GLASS WORKS LIMITED.gif",
      company_id: "COM001226",
      company_name: "Borosil Glass",
      industry: "",
      display_name: "Borosil Glass",
    },
    {
      field_type: "company",
      name: "Bosch ",
      field_id: "COM000137",
      website: "https://www.bosch.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BOSCH LIMITED.png",
      company_id: "COM000137",
      company_name: "Bosch ",
      display_name: "Bosch ",
      sector: "Engineering Services",
      page_display_status: false,
      industry: "Auto Ancillary",
    },
    {
      field_type: "company",
      name: "Brahmaputra Crackers",
      field_id: "COM000139",
      website: "https://bcplonline.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BRAHMAPUTRA CRACKER AND POLYMER LIMITED (BCPL).jpg",
      company_id: "COM000139",
      company_name: "Brahmaputra Crackers",
      industry: "PLASTICS",
      display_name: "Brahmaputra Crackers",
    },
    {
      field_type: "company",
      name: "Brakes India  ",
      field_id: "COM000140",
      website: "https://www.brakesindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BRAKES INDIA PRIVATE LIMITED.png",
      company_id: "COM000140",
      company_name: "Brakes India  ",
      industry: "AUTOMOBILE",
      display_name: "Brakes India  ",
    },
    {
      field_type: "company",
      name: "Bridge And Roof Company",
      field_id: "COM001227",
      website: "https://bridgeroof.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BRIDGE AND ROOF CO INDIA LIMITED.jpg",
      company_id: "COM001227",
      company_name: "Bridge And Roof Company",
      industry: "",
      display_name: "Bridge And Roof Company",
    },
    {
      field_type: "company",
      name: "Bridgestone",
      field_id: "COM000141",
      website: "https://www.bridgestone.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BRIDGESTONE CORPORATION.png",
      company_id: "COM000141",
      company_name: "Bridgestone",
      industry: "TYRE",
      display_name: "Bridgestone",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Brilliant Bio Pharma",
      field_id: "COM001385",
      website: "https://brilliantbiopharma.com/",
      group: "",
      logo: "",
      company_id: "COM001385",
      company_name: "Brilliant Bio Pharma",
      industry: "",
      display_name: "Brilliant Bio Pharma",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Britacel Silicones ",
      field_id: "COM001228",
      website: "http://www.britacelsilicones.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BRITACEL SILICONES LIMITED.png",
      company_id: "COM001228",
      company_name: "Britacel Silicones ",
      industry: "",
      display_name: "Britacel Silicones ",
    },
    {
      field_type: "company",
      name: "Britannia",
      field_id: "COM000142",
      website: "http://britannia.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BRITANNIA INDUSTRIES LIMITED.jpg",
      company_id: "COM000142",
      company_name: "Britannia",
      industry: "FMCG",
      display_name: "Britannia",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "BSL Group",
      field_id: "COM000143",
      website: "https://www.bslholding.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BSL GROUP OF COMPANIES.png",
      company_id: "COM000143",
      company_name: "BSL Group",
      industry: "CONGLOMERATE",
      display_name: "BSL Group",
    },
    {
      field_type: "company",
      name: "BSN India",
      field_id: "COM000144",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000144",
      company_name: "BSN India",
      industry: "",
      display_name: "BSN India",
    },
    {
      field_type: "company",
      name: "Bsn Medical India",
      field_id: "COM000145",
      website: "https://www.bsnmedical.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BSN MEDICAL INDIA.png",
      company_id: "COM000145",
      company_name: "Bsn Medical India",
      industry: "MANUFACTURING",
      display_name: "Bsn Medical India",
    },
    {
      field_type: "company",
      name: "Bunge",
      field_id: "COM000146",
      website: "https://www.bungeindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BUNGE INDIA PRIVATE LIMITED.png",
      company_id: "COM000146",
      company_name: "Bunge",
      display_name: "Bunge",
      sector: "Agricultural Products",
      page_display_status: false,
      industry: "Agricultural Products",
    },
    {
      field_type: "company",
      name: "Burger King",
      field_id: "COM001230",
      website: "https://www.bk.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BURGER KING.png",
      company_id: "COM001230",
      company_name: "Burger King",
      industry: "",
      display_name: "Burger King",
    },
    {
      field_type: "company",
      name: "Business Standard News Paper",
      field_id: "COM000147",
      website: "https://www.business-standard.com/",
      group: "BP Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BUSINESS STANDARD LIMITED.jpg",
      company_id: "COM000147",
      company_name: "Business Standard News Paper",
      industry: "",
      display_name: "Business Standard News Paper",
    },
    {
      field_type: "company",
      name: "Butterfly - Gandhimathi Appliances ",
      field_id: "COM000148",
      website: "https://www.butterflyindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BUTTERFLY GANDHIMATHI APPLIANCES LIMITED.png",
      company_id: "COM000148",
      company_name: "Butterfly - Gandhimathi Appliances ",
      industry: "FMCD",
      display_name: "Butterfly - Gandhimathi Appliances ",
    },
    {
      field_type: "company",
      name: "C P World",
      field_id: "COM001238",
      website: "http://www.cpworldgroup.com/",
      group: "C P WORLD GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/C P WORLD GROUP.jpg",
      company_id: "COM001238",
      company_name: "C P World",
      industry: "",
      display_name: "C P World",
    },
    {
      field_type: "company",
      name: "CRI Pumps  ",
      field_id: "COM001240",
      website: "https://in.crigroups.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/C R I PUMPS PRIVATE LIMITED.jpg",
      company_id: "COM001240",
      company_name: "CRI Pumps  ",
      industry: "",
      display_name: "CRI Pumps  ",
    },
    {
      field_type: "company",
      name: "Zydus Cadila",
      field_id: "COM000150",
      website: "https://zyduscadila.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CADILA HEALTHCARE LIMITED.png",
      company_id: "COM000150",
      company_name: "Zydus Cadila",
      industry: "HEALTHCARE",
      display_name: "Zydus Cadila",
    },
    {
      field_type: "company",
      name: "Cadila Pharmaceuticals ",
      field_id: "COM000151",
      website: "https://www.cadilapharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CADILA PHARMACEUTICALS LIMITED.png",
      company_id: "COM000151",
      company_name: "Cadila Pharmaceuticals ",
      industry: "PHARMACEUTICAL",
      display_name: "Cadila Pharmaceuticals ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Calcom Cement",
      field_id: "COM001386",
      website: "https://www.dalmiacement.com/calcom-cement.html",
      group: "DALMIA BHARAT CEMENT",
      logo: "",
      company_id: "COM001386",
      company_name: "Calcom Cement",
      industry: "",
      display_name: "Calcom Cement",
    },
    {
      field_type: "company",
      name: "CalPro Bakery Products",
      field_id: "COM001231",
      website: "http://calprospecialities.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CALPROSPECIALITIES PRIVATE LIMITED.png",
      company_id: "COM001231",
      company_name: "CalPro Bakery Products",
      industry: "",
      display_name: "CalPro Bakery Products",
    },
    {
      field_type: "company",
      name: "Camfil Air Filtration",
      field_id: "COM000152",
      website: "https://www.camfil.com/en-in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CAMFIL AIR FILTRATION INDIA PRIVATE LIMITED.png",
      company_id: "COM000152",
      company_name: "Camfil Air Filtration",
      industry: "FMCD",
      display_name: "Camfil Air Filtration",
    },
    {
      field_type: "company",
      name: "Canteen Stores Department India",
      field_id: "COM001232",
      website: "http://csdindia.gov.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CANTEEN STORES DEPARTMENT.jpg",
      company_id: "COM001232",
      company_name: "Canteen Stores Department India",
      industry: "",
      display_name: "Canteen Stores Department India",
    },
    {
      field_type: "company",
      name: "Caparo Auto Parts",
      field_id: "COM000153",
      website: "https://www.caparo.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CAPARO PLC.png",
      company_id: "COM000153",
      company_name: "Caparo Auto Parts",
      industry: "STEEL",
      display_name: "Caparo Auto Parts",
    },
    {
      field_type: "company",
      name: "CUMI - Carborundum Universal ",
      field_id: "COM000154",
      website: "https://www.cumi-murugappa.com/",
      group: "Murugappa Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CARBORUNDUM UNIVERSAL LIMITED.jpg",
      company_id: "COM000154",
      company_name: "CUMI - Carborundum Universal ",
      industry: "CONGLOMERATE",
      display_name: "CUMI - Carborundum Universal ",
    },
    {
      field_type: "company",
      name: "Carestream Health",
      field_id: "COM000155",
      website:
        "https://www.carestream.com/en/us/contact-carestream-health-india",
      group: "Carestream Health",
      logo: "",
      company_id: "COM000155",
      company_name: "Carestream Health",
      industry: "MANUFACTURING",
      display_name: "Carestream Health",
    },
    {
      field_type: "company",
      name: "Cargill Foods",
      field_id: "COM000156",
      website: "https://www.cargill.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CARGILL INDIA.png",
      company_id: "COM000156",
      company_name: "Cargill Foods",
      display_name: "Cargill Foods",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Carlsberg",
      field_id: "COM000157",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Carlsberg Breweries A S.png",
      company_id: "COM000157",
      company_name: "Carlsberg",
      industry: "BREWING",
      display_name: "Carlsberg",
    },
    {
      field_type: "company",
      name: "Carrier Midea",
      field_id: "COM000158",
      website: "http://carriermideaindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CARRIER MIDEA INDIA.png",
      company_id: "COM000158",
      company_name: "Carrier Midea",
      industry: "MANUFACTURING",
      display_name: "Carrier Midea",
    },
    {
      field_type: "company",
      name: "Castrol Oil",
      field_id: "COM000159",
      website: "https://www.castrol.com/en_in/india.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CASTROL LIMITED.png",
      company_id: "COM000159",
      company_name: "Castrol Oil",
      industry: "OIL AND GAS",
      display_name: "Castrol Oil",
    },
    {
      field_type: "company",
      name: "Cavendish",
      field_id: "COM001066",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001066",
      company_name: "Cavendish",
      industry: "",
      display_name: "Cavendish",
    },
    {
      field_type: "company",
      name: "Cavinkare  ",
      field_id: "COM000160",
      website: "https://cavinkare.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CAVINKARE PRIVATE LIMITED.png",
      company_id: "COM000160",
      company_name: "Cavinkare  ",
      industry: "MANUFACTURING",
      display_name: "Cavinkare  ",
    },
    {
      field_type: "company",
      name: "CEAT",
      field_id: "COM000161",
      website: "https://www.ceat.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CEAT LIMITED.png",
      company_id: "COM000161",
      company_name: "CEAT",
      industry: "TYRE",
      display_name: "CEAT",
    },
    {
      field_type: "company",
      name: "CELLO",
      field_id: "COM001233",
      website: "https://www.celloworld.com/index",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CELLO WORLD.png",
      company_id: "COM001233",
      company_name: "CELLO",
      industry: "",
      display_name: "CELLO",
    },
    {
      field_type: "company",
      name: "CCI - Cement Corporation Of India  ",
      field_id: "COM000162",
      website: "https://www.cciltd.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CEMENT CORPORATION OF INDIA LIMITED .png",
      company_id: "COM000162",
      company_name: "CCI - Cement Corporation Of India  ",
      industry: "CEMENT",
      display_name: "CCI - Cement Corporation Of India  ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000163",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000163",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Cent Ply Pvt Ltd",
        field_id: "COM000163",
        website: "",
        group: "",
        logo: "",
        company_id: "COM000163",
        company_name: "Cent Ply Pvt Ltd",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Centaur Pharma",
      field_id: "COM001387",
      website: "https://www.centaurpharma.com/",
      group: "",
      logo: "",
      company_id: "COM001387",
      company_name: "Centaur Pharma",
      industry: "",
      display_name: "Centaur Pharma",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Central Railway",
      field_id: "COM000164",
      website: "https://cr.indianrailways.gov.in/",
      group: "INDIAN RAILWAYS",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CENTRAL RAILWAY.jpg",
      company_id: "COM000164",
      company_name: "Central Railway",
      industry: "",
      display_name: "Central Railway",
    },
    {
      field_type: "company",
      name: "Century Cement",
      field_id: "COM000165",
      website: "http://centurytextind.com/divisions/century-cement.html",
      group: "",
      logo: "",
      company_id: "COM000165",
      company_name: "Century Cement",
      industry: "CEMENT",
      display_name: "Century Cement",
    },
    {
      field_type: "company",
      name: "CenturyPly  ",
      field_id: "COM000166",
      website: "https://www.centuryply.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CENTURY PLYBOARDS INDIA LIMITED.png",
      company_id: "COM000166",
      company_name: "CenturyPly  ",
      industry: "FMCD",
      display_name: "CenturyPly  ",
    },
    {
      field_type: "company",
      name: "Century Pulp And Paper",
      field_id: "COM000167",
      website: "http://centurytextind.com/divisions/century-cement.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CENTURY PULP AND PAPER.png",
      company_id: "COM000167",
      company_name: "Century Pulp And Paper",
      industry: "PAPER",
      display_name: "Century Pulp And Paper",
    },
    {
      field_type: "company",
      name: "Century Rayon ",
      field_id: "COM000168",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CENTURY RAYON LIMITED.png",
      company_id: "COM000168",
      company_name: "Century Rayon ",
      industry: "MANUFACTURING",
      display_name: "Century Rayon ",
    },
    {
      field_type: "company",
      name: "Century Textiles",
      field_id: "COM001388",
      website: "http://centurytextind.com/businesses.html",
      group: "BK BIRLA GROUP",
      logo: "",
      company_id: "COM001388",
      company_name: "Century Textiles",
      industry: "",
      display_name: "Century Textiles",
    },
    {
      field_type: "company",
      name: "Cetex Petrochemicals ",
      field_id: "COM001389",
      website: "https://cetexpetro.com/",
      group: "",
      logo: "",
      company_id: "COM001389",
      company_name: "Cetex Petrochemicals ",
      industry: "",
      display_name: "Cetex Petrochemicals ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "CG Foods",
      field_id: "COM000169",
      website: "http://www.cgfmcg.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CG FOODS INDIA PRIVATE LIMITED.png",
      company_id: "COM000169",
      company_name: "CG Foods",
      industry: "FMCG",
      display_name: "CG Foods",
    },
    {
      field_type: "company",
      name: "CGI",
      field_id: "COM001234",
      website: "https://www.cgi.com/en",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CGI INC.png",
      company_id: "COM001234",
      company_name: "CGI",
      industry: "",
      display_name: "CGI",
    },
    {
      field_type: "company",
      name: "Chaphekar Engineering  ",
      field_id: "COM001235",
      website: "http://www.chaphekarengg.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CHAPHEKAR ENGINEERING PRIVATE LIMITED.jpg",
      company_id: "COM001235",
      company_name: "Chaphekar Engineering  ",
      industry: "",
      display_name: "Chaphekar Engineering  ",
    },
    {
      field_type: "company",
      name: "Chemex Chemicals",
      field_id: "COM000170",
      website: "https://www.chemex-me.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CHEMEX CHEMICAL AND HYGIENE PRODUCTS.png",
      company_id: "COM000170",
      company_name: "Chemex Chemicals",
      industry: "CHEMICAL",
      display_name: "Chemex Chemicals",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Chemfab Alkalies ",
      field_id: "COM000171",
      website: "https://chemfabalkalis.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CHEMFAB ALKALIS LIMITED.png",
      company_id: "COM000171",
      company_name: "Chemfab Alkalies ",
      industry: "CHEMICAL",
      display_name: "Chemfab Alkalies ",
    },
    {
      field_type: "company",
      name: "Chemplast Sanmar ",
      field_id: "COM000173",
      website: "http://sanmargroup.com/chemplast.php",
      group: "The Sanmar Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CHEMPLAST SANMAR LIMITED.jpeg",
      company_id: "COM000173",
      company_name: "Chemplast Sanmar ",
      industry: "CHEMICAL",
      display_name: "Chemplast Sanmar ",
    },
    {
      field_type: "company",
      name: "Chep India  ",
      field_id: "COM000174",
      website:
        "https://www.chep.com/in/en/consumer-goods/about-us/chep-india/about-chep-india",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CHEP INDIA PRIVATE LIMITED.png",
      company_id: "COM000174",
      company_name: "Chep India  ",
      industry: "CONGLOMERATE",
      display_name: "Chep India  ",
    },
    {
      field_type: "company",
      name: "Chettinad Cement",
      field_id: "COM001390",
      website: "https://www.chettinad.com/cement.php",
      group: "CHETTINAD GROUP",
      logo: "",
      company_id: "COM001390",
      company_name: "Chettinad Cement",
      industry: "",
      display_name: "Chettinad Cement",
    },
    {
      field_type: "company",
      name: "China Steel Corp",
      field_id: "COM000175",
      website: "https://www.csc.com.tw/csc_e/gc/gro_ste_p5.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CHINA STEEL CORPORATION INDIA PRIVATE LIMITED.png",
      company_id: "COM000175",
      company_name: "China Steel Corp",
      industry: "STEEL",
      display_name: "China Steel Corp",
    },
    {
      field_type: "company",
      name: "Medimix - Cholayil",
      field_id: "COM000176",
      website: "https://www.cholayil.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CHOLAYIL PRIVATE LIMITED.png",
      company_id: "COM000176",
      company_name: "Medimix - Cholayil",
      industry: "HEALTHCARE",
      display_name: "Medimix - Cholayil",
    },
    {
      field_type: "company",
      name: "CIL Nova Petrochemicals ",
      field_id: "COM000177",
      website: "https://cnpcl.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CIL NOVA PETROCHEMICALS LIMITED.png",
      company_id: "COM000177",
      company_name: "CIL Nova Petrochemicals ",
      industry: "OIL AND GAS",
      display_name: "CIL Nova Petrochemicals ",
    },
    {
      field_type: "company",
      name: "Cipla ",
      field_id: "COM000178",
      website: "https://www.cipla.com/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CIPLA LIMITED.png",
      company_id: "COM000178",
      company_name: "Cipla ",
      display_name: "Cipla ",
      sector: "Pharmaceutical",
      page_display_status: false,
      industry: "Pharmaceutical",
    },
    {
      field_type: "company",
      name: "Clariant Chemicals",
      field_id: "COM000179",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CLARIANT SPECIALTY CHEMICALS.png",
      company_id: "COM000179",
      company_name: "Clariant Chemicals",
      industry: "CHEMICAL",
      display_name: "Clariant Chemicals",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Classic Flooring",
      field_id: "COM000180",
      website: "https://www.classicflooring.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CLASSIC FLOORING.jpg",
      company_id: "COM000180",
      company_name: "Classic Flooring",
      industry: "CERAMICS",
      display_name: "Classic Flooring",
    },
    {
      field_type: "company",
      name: "JAWA Motercycles - Classic Legends  ",
      field_id: "COM001236",
      website: "https://www.jawamotorcycles.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CLASSIC LEGENDS PRIVATE LIMITED.svg",
      company_id: "COM001236",
      company_name: "JAWA Motercycles - Classic Legends  ",
      industry: "",
      display_name: "JAWA Motercycles - Classic Legends  ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000181",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000181",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Cmr Toyotsu Aluminium India Private Limited",
        field_id: "COM000181",
        website: "http://cmr-toyotsu.com/",
        group: "",
        logo: "",
        company_id: "COM000181",
        company_name: "Cmr Toyotsu Aluminium India Private Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "CMR Toyotsu",
      field_id: "COM000182",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000182",
      company_name: "CMR Toyotsu",
      industry: "MANUFACTURING",
      display_name: "CMR Toyotsu",
    },
    {
      field_type: "company",
      name: "Coimbatore Potteries",
      field_id: "COM000184",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000184",
      company_name: "Coimbatore Potteries",
      industry: "BUILDING MATERIAL",
      display_name: "Coimbatore Potteries",
    },
    {
      field_type: "company",
      name: "Colfax",
      field_id: "COM000185",
      website: "http://www.colfaxcorp.com/",
      group: "",
      logo: "",
      company_id: "COM000185",
      company_name: "Colfax",
      industry: "MANUFACTURING",
      display_name: "Colfax",
    },
    {
      field_type: "company",
      name: "Colgate",
      field_id: "COM000186",
      website: "https://www.colgatepalmolive.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/COLGATE PALMOLIVE COMPANY INDIA LIMITED.png",
      company_id: "COM000186",
      company_name: "Colgate",
      industry: "FMCG",
      display_name: "Colgate",
    },
    {
      field_type: "company",
      name: "Colorcon Pharma",
      field_id: "COM001391",
      website: "https://www.colorcon.com",
      group: "",
      logo: "",
      company_id: "COM001391",
      company_name: "Colorcon Pharma",
      industry: "",
      display_name: "Colorcon Pharma",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Comed Chemicals ",
      field_id: "COM001392",
      website: "http://www.comedchemicals.com/",
      group: "",
      logo: "",
      company_id: "COM001392",
      company_name: "Comed Chemicals ",
      industry: "",
      display_name: "Comed Chemicals ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Comfia Industries  ",
      field_id: "COM000187",
      website: "http://comfiaindustries.com/",
      group: "Astron Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/COMFIA INDUSTRIES PRIVATE LIMITED.png",
      company_id: "COM000187",
      company_name: "Comfia Industries  ",
      industry: "GLASS",
      display_name: "Comfia Industries  ",
    },
    {
      field_type: "company",
      name: "Condor Footwear",
      field_id: "COM000188",
      website: "http://www.condorinblu.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CONDOR FOOTWEAR INDIA LIMITED.png",
      company_id: "COM000188",
      company_name: "Condor Footwear",
      industry: "FASHION AND CLOTHING",
      display_name: "Condor Footwear",
    },
    {
      field_type: "company",
      name: "CCI - Container Corporation Of India ",
      field_id: "COM000189",
      website: "http://www.concorindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CONTAINER CORPORATION OF INDIA LIMITED.jpg",
      company_id: "COM000189",
      company_name: "CCI - Container Corporation Of India ",
      industry: "LOGISTICS",
      display_name: "CCI - Container Corporation Of India ",
    },
    {
      field_type: "company",
      name: "Continental Carbon",
      field_id: "COM001237",
      website: "http://continentalcarbonindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CONTINENTAL CARBON INDIA LIMITED.jpg",
      company_id: "COM001237",
      company_name: "Continental Carbon",
      industry: "",
      display_name: "Continental Carbon",
    },
    {
      field_type: "company",
      name: "Continental Tyres",
      field_id: "COM000190",
      website: "https://www.continental.com/en-in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CONTINENTAL CORPORATION INDIA.png",
      company_id: "COM000190",
      company_name: "Continental Tyres",
      industry: "MANUFACTURING",
      display_name: "Continental Tyres",
    },
    {
      field_type: "company",
      name: "Convertex",
      field_id: "COM000191",
      website: "http://www.convertexindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CONVERTEX INDIA PRIVATE LIMITED.png",
      company_id: "COM000191",
      company_name: "Convertex",
      industry: "MANUFACTURING",
      display_name: "Convertex",
    },
    {
      field_type: "company",
      name: "Coromandel",
      field_id: "COM000192",
      website: "https://coromandel.biz/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/COROMANDEL INTERNATIONAL LIMITED.png",
      company_id: "COM000192",
      company_name: "Coromandel",
      industry: "CHEMICAL",
      display_name: "Coromandel",
    },
    {
      field_type: "company",
      name: "Cosmic Nutracos Solutions  ",
      field_id: "COM000193",
      website: "http://www.cosmicnutracos.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/COSMIC NUTRACOS SOLUTIONS PRIVATE LIMITED.png",
      company_id: "COM000193",
      company_name: "Cosmic Nutracos Solutions  ",
      industry: "FASHION AND CLOTHING",
      display_name: "Cosmic Nutracos Solutions  ",
    },
    {
      field_type: "company",
      name: "Covestro India  ",
      field_id: "COM000194",
      website: "https://www.covestro.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/COVESTRO INDIA PRIVATE LIMITED.png",
      company_id: "COM000194",
      company_name: "Covestro India  ",
      industry: "PLASTICS",
      display_name: "Covestro India  ",
    },
    {
      field_type: "company",
      name: "Cravatex Footware",
      field_id: "COM000196",
      website: "http://www.cravatex.com/",
      group: "THE BATRA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CRAVATEX LIMITED.png",
      company_id: "COM000196",
      company_name: "Cravatex Footware",
      industry: "FASHION AND CLOTHING",
      display_name: "Cravatex Footware",
    },
    {
      field_type: "company",
      name: "Creambell Ice Cream",
      field_id: "COM001091",
      website: "https://creambell.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CREAMBELL ICE CREAM.png",
      company_id: "COM001091",
      company_name: "Creambell Ice Cream",
      display_name: "Creambell Ice Cream",
      sector: "Food Products",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Creative Free Trade Warehousing  ",
      field_id: "COM000197",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000197",
      company_name: "Creative Free Trade Warehousing  ",
      industry: "",
      display_name: "Creative Free Trade Warehousing  ",
    },
    {
      field_type: "company",
      name: "Creative Infra",
      field_id: "COM001239",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001239",
      company_name: "Creative Infra",
      industry: "",
      display_name: "Creative Infra",
    },
    {
      field_type: "company",
      name: "Cremica Food",
      field_id: "COM000198",
      website: "https://www.cremica.com/",
      group: "",
      logo: "",
      company_id: "COM000198",
      company_name: "Cremica Food",
      display_name: "Cremica Food",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "CG - Crompton Greaves Consumer Electricals ",
      field_id: "COM000200",
      website: "https://www.crompton.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CROMPTON GREAVES CONSUMER ELECTRICALS LIMITED.jpg",
      company_id: "COM000200",
      company_name: "CG - Crompton Greaves Consumer Electricals ",
      display_name: "CG - Crompton Greaves Consumer Electricals ",
      sector: "Electricals",
      page_display_status: false,
      industry: "Electricals",
    },
    {
      field_type: "company",
      name: "Cummins",
      field_id: "COM000201",
      website: "https://www.cumminsindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CUMMINS INDIA LIMITED.png",
      company_id: "COM000201",
      company_name: "Cummins",
      industry: "MANUFACTURING",
      display_name: "Cummins",
    },
    {
      field_type: "company",
      name: "DS Controls",
      field_id: "COM000204",
      website: "https://www.dsautomation.in/index.html",
      group: "",
      logo: "",
      company_id: "COM000204",
      company_name: "DS Controls",
      industry: "INDUSTRIAL AUTOMATION",
      display_name: "DS Controls",
    },
    {
      field_type: "company",
      name: "Dabur",
      field_id: "COM000205",
      website: "https://www.dabur.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DABUR INDIA LIMITED.png",
      company_id: "COM000205",
      company_name: "Dabur",
      display_name: "Dabur",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Dadi Impex  ",
      field_id: "COM000206",
      website: "http://dadiimpex.com/contact/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DADI IMPEX PRIVATE LIMITED.png",
      company_id: "COM000206",
      company_name: "Dadi Impex  ",
      industry: "FMCG",
      display_name: "Dadi Impex  ",
    },
    {
      field_type: "company",
      name: "Daikin Industries ",
      field_id: "COM000207",
      website: "https://www.daikin.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DAIKIN INDUSTRIES LIMITED.png",
      company_id: "COM000207",
      company_name: "Daikin Industries ",
      industry: "ELECTRICALS",
      display_name: "Daikin Industries ",
    },
    {
      field_type: "company",
      name: "Dalmia Bharat ",
      field_id: "COM001241",
      website: "https://www.dalmiabharat.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DALMIA BHARAT LIMITED.png",
      company_id: "COM001241",
      company_name: "Dalmia Bharat ",
      industry: "",
      display_name: "Dalmia Bharat ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "DAMCO",
      field_id: "COM000208",
      website: "https://www.damco.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DAMCO INDIA PRIVATE LIMITED.png",
      company_id: "COM000208",
      company_name: "DAMCO",
      industry: "LOGISTICS",
      display_name: "DAMCO",
    },
    {
      field_type: "company",
      name: "Danieli India ",
      field_id: "COM000209",
      website: "https://www.danieli.com/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DANIELI INDIA LIMITED.png",
      company_id: "COM000209",
      company_name: "Danieli India ",
      industry: "MANUFACTURING",
      display_name: "Danieli India ",
    },
    {
      field_type: "company",
      name: "Daramic",
      field_id: "COM000210",
      website: "https://www.daramic.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DARAMIC LLC.png",
      company_id: "COM000210",
      company_name: "Daramic",
      industry: "ELECTRICALS",
      display_name: "Daramic",
    },
    {
      field_type: "company",
      name: "Darshan Incesnse",
      field_id: "COM000211",
      website: "http://darshanincense.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DARSHAN INTERNATIONAL.png",
      company_id: "COM000211",
      company_name: "Darshan Incesnse",
      industry: "",
      display_name: "Darshan Incesnse",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000226",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000226",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Davita Care India Private Limited",
        field_id: "COM000226",
        website: "",
        group: "",
        logo: "",
        company_id: "COM000226",
        company_name: "Davita Care India Private Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Davita Care",
      field_id: "COM000212",
      website: "https://www.davita.in/contact.php",
      group: "",
      logo: "",
      company_id: "COM000212",
      company_name: "Davita Care",
      industry: "HEALTHCARE",
      display_name: "Davita Care",
    },
    {
      field_type: "company",
      name: "Db Schenker",
      field_id: "COM000213",
      website: "https://www.dbschenker.com/in-en/about",
      group: "Deutsche Bahn",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DB SCHENKER.png",
      company_id: "COM000213",
      company_name: "Db Schenker",
      industry: "LOGISTICS",
      display_name: "Db Schenker",
    },
    {
      field_type: "company",
      name: "DCM Engineering",
      field_id: "COM000214",
      website: "http://www.dcmengg.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DCM ENGINEERING PRODUCTS LIMITED.jpg",
      company_id: "COM000214",
      company_name: "DCM Engineering",
      industry: "CONGLOMERATE",
      display_name: "DCM Engineering",
    },
    {
      field_type: "company",
      name: "DCM Shriram ",
      field_id: "COM001393",
      website: "https://www.dcmshriram.com/cement",
      group: "DCM GROUP",
      logo: "",
      company_id: "COM001393",
      company_name: "DCM Shriram ",
      industry: "",
      display_name: "DCM Shriram ",
    },
    {
      field_type: "company",
      name: "DCW",
      field_id: "COM000215",
      website: "http://www.dcwltd.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DCW LIMITED.jpg",
      company_id: "COM000215",
      company_name: "DCW",
      industry: "CHEMICAL",
      display_name: "DCW",
    },
    {
      field_type: "company",
      name: "Decathlon Sports",
      field_id: "COM000216",
      website: "https://www.decathlon.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Decathlon Sports India Private Limited.png",
      company_id: "COM000216",
      company_name: "Decathlon Sports",
      industry: "FASHION AND CLOTHING",
      display_name: "Decathlon Sports",
    },
    {
      field_type: "company",
      name: "Deccan Cements ",
      field_id: "COM001394",
      website: "https://deccancements.com/index.php",
      group: "",
      logo: "",
      company_id: "COM001394",
      company_name: "Deccan Cements ",
      industry: "",
      display_name: "Deccan Cements ",
    },
    {
      field_type: "company",
      name: "Deepak Fertilisers",
      field_id: "COM000218",
      website: "https://www.dfpcl.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DEEPAK FERTILISERS AND PETROCHEMICALS CORPORATION LIMITED.png",
      company_id: "COM000218",
      company_name: "Deepak Fertilisers",
      industry: "CONGLOMERATE",
      display_name: "Deepak Fertilisers",
    },
    {
      field_type: "company",
      name: "Del Monte Foods ",
      field_id: "COM001242",
      website: "https://www.delmonte.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DEL MONTE FOODS INC.png",
      company_id: "COM001242",
      company_name: "Del Monte Foods ",
      industry: "",
      display_name: "Del Monte Foods ",
    },
    {
      field_type: "company",
      name: "Delphi TVS",
      field_id: "COM000220",
      website: "https://www.delphitvs.com/",
      group: "Delphi Technologies Ltd, MORE",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DELPHI-TVS TECHNOLOGIES.png",
      company_id: "COM000220",
      company_name: "Delphi TVS",
      industry: "AUTOMOBILE",
      display_name: "Delphi TVS",
    },
    {
      field_type: "company",
      name: "Delta Electronics  ",
      field_id: "COM000221",
      website: "https://www.deltaelectronicsindia.com/",
      group: "Delta Energy Systems (Singapore) Pte. Ltd.",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DELTA INDIA ELECTRONICS PRIVATE LIMITED.jpg",
      company_id: "COM000221",
      company_name: "Delta Electronics  ",
      industry: "ELECTRONICS",
      display_name: "Delta Electronics  ",
    },
    {
      field_type: "company",
      name: "Delta Paper Mills ",
      field_id: "COM000222",
      website: "http://www.deltapapermills.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DELTA PAPER MILLS LIMITED.jpg",
      company_id: "COM000222",
      company_name: "Delta Paper Mills ",
      industry: "PAPER",
      display_name: "Delta Paper Mills ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Delta Power",
      field_id: "COM000223",
      website: "https://www.deltapowersolutions.com/en-in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DELTA POWER SOLUTIONS INDIA PRIVATE LIMITED.png",
      company_id: "COM000223",
      company_name: "Delta Power",
      industry: "ELECTRONICS",
      display_name: "Delta Power",
    },
    {
      field_type: "company",
      name: "Denso Kirloskar",
      field_id: "COM000224",
      website: "",
      group: "Denso",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DENSO KIRLOSKAR INDUSTRIES PRIVATE LIMITED.png",
      company_id: "COM000224",
      company_name: "Denso Kirloskar",
      industry: "AUTOMOBILE",
      display_name: "Denso Kirloskar",
    },
    {
      field_type: "company",
      name: "Deoleo",
      field_id: "COM000225",
      website: "https://deoleo.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DEO LEO.png",
      company_id: "COM000225",
      company_name: "Deoleo",
      industry: "",
      display_name: "Deoleo",
    },
    {
      field_type: "company",
      name: "Deys Medical",
      field_id: "COM001395",
      website: "http://www.deysmedical.com/",
      group: "",
      logo: "",
      company_id: "COM001395",
      company_name: "Deys Medical",
      industry: "",
      display_name: "Deys Medical",
    },
    {
      field_type: "company",
      name: "Dhanuka Agritech ",
      field_id: "COM001243",
      website: "https://www.dhanuka.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DHANUKA AGRITECH LIMITED.png",
      company_id: "COM001243",
      company_name: "Dhanuka Agritech ",
      industry: "",
      display_name: "Dhanuka Agritech ",
    },
    {
      field_type: "company",
      name: "Dharam Chand Ladha Mal",
      field_id: "COM001117",
      website: "http://www.naulakha.co.in",
      group: "",
      logo: "",
      company_id: "COM001117",
      company_name: "Dharam Chand Ladha Mal",
      industry: "",
      display_name: "Dharam Chand Ladha Mal",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000227",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000227",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Dharampal Satyapal Limited",
        field_id: "COM000227",
        website: "http://www.dsgroup.com/",
        group: "DS Group",
        logo: "",
        company_id: "COM000227",
        company_name: "Dharampal Satyapal Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Dharti Dredging",
      field_id: "COM000228",
      website: "http://dharti.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DHARTI DREDGING AND INFRASTRUCTURE LIMITED.png",
      company_id: "COM000228",
      company_name: "Dharti Dredging",
      industry: "INFRASTRUCTURE",
      display_name: "Dharti Dredging",
    },
    {
      field_type: "company",
      name: "Dhunseri Petrochem and Tea",
      field_id: "COM000230",
      website: "http://aspetindia.com/about-us/who-we-are/",
      group: "",
      logo: "",
      company_id: "COM000230",
      company_name: "Dhunseri Petrochem and Tea",
      industry: "CONGLOMERATE",
      display_name: "Dhunseri Petrochem and Tea",
    },
    {
      field_type: "company",
      name: "Dia India",
      field_id: "COM000231",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000231",
      company_name: "Dia India",
      industry: "",
      display_name: "Dia India",
    },
    {
      field_type: "company",
      name: "Diamond Cement ",
      field_id: "COM001396",
      website: "http://diamondcements.com/index.html",
      group: "",
      logo: "",
      company_id: "COM001396",
      company_name: "Diamond Cement ",
      industry: "",
      display_name: "Diamond Cement ",
    },
    {
      field_type: "company",
      name: "Diebold Nixdorf",
      field_id: "COM001110",
      website:
        "https://www.googleadservices.com/pagead/aclk?sa=L&ai=DChcSEwi7o6rqmfjjAhWNhHAKHXGoBSAYABAAGgJzYg&ohost=www.google.com&cid=CAASE-RoQMnxbx5I8OCDrbBM55rtN04&sig=AOD64_3A9WDdSbkfrXQss_1GQCeRhIdRoQ&q=&ved=2ahUKEwjgzaHqmfjjAhUS5o8KHaQHCPsQ0Qx6BAgPEAE&adurl=",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DIEBOLD NIXDORF INDIA PRIVATE LIMITED.png",
      company_id: "COM001110",
      company_name: "Diebold Nixdorf",
      industry: "",
      display_name: "Diebold Nixdorf",
    },
    {
      field_type: "company",
      name: "Dish Infra Services  ",
      field_id: "COM000232",
      website: "",
      group: "DISH TV",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DISH INFRA SERVICES PRIVATE LIMITED.jpg",
      company_id: "COM000232",
      company_name: "Dish Infra Services  ",
      industry: "INFRASTRUCTURE",
      display_name: "Dish Infra Services  ",
    },
    {
      field_type: "company",
      name: "Diversey ",
      field_id: "COM000233",
      website: "https://diversey.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DIVERSEY INC.jpg",
      company_id: "COM000233",
      company_name: "Diversey ",
      industry: "CHEMICAL",
      display_name: "Diversey ",
    },
    {
      field_type: "company",
      name: "Dixon Valve And Coupling Company",
      field_id: "COM000234",
      website: "https://www.dixonvalve.com/splash",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Dixon Valve and Coupling Company.jpg",
      company_id: "COM000234",
      company_name: "Dixon Valve And Coupling Company",
      industry: "MANUFACTURING",
      display_name: "Dixon Valve And Coupling Company",
    },
    {
      field_type: "company",
      name: "Dongkuk Steel Mill",
      field_id: "COM001244",
      website: "https://www.dongkuk.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DONGKUKSTEEL MILL CO LIMITED.jpg",
      company_id: "COM001244",
      company_name: "Dongkuk Steel Mill",
      industry: "",
      display_name: "Dongkuk Steel Mill",
    },
    {
      field_type: "company",
      name: "Dow Agrosciences",
      field_id: "COM000235",
      website: "https://www.corteva.in/",
      group: "Dow Chemical Company",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Dow AgroSciences LLC.png",
      company_id: "COM000235",
      company_name: "Dow Agrosciences",
      industry: "CHEMICAL",
      display_name: "Dow Agrosciences",
    },
    {
      field_type: "company",
      name: "Dow Chemical",
      field_id: "COM000237",
      website: "https://in.dow.com/en-us",
      group: "Dow Holdings LLC",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DOW CHEMICAL INTERNATIONAL LIMITED.png",
      company_id: "COM000237",
      company_name: "Dow Chemical",
      industry: "CHEMICAL",
      display_name: "Dow Chemical",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000236",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000236",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Dow Chemical International Private Limited",
        field_id: "COM000236",
        website: "https://in.dow.com",
        group: "",
        logo: "",
        company_id: "COM000236",
        company_name: "Dow Chemical International Private Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Dp Cocoa Products  ",
      field_id: "COM000238",
      website: "https://dpchocolates.com/",
      group: "",
      logo: "",
      company_id: "COM000238",
      company_name: "Dp Cocoa Products  ",
      industry: "FMCG",
      display_name: "Dp Cocoa Products  ",
    },
    {
      field_type: "company",
      name: "Dp Foods",
      field_id: "COM000239",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000239",
      company_name: "Dp Foods",
      industry: "FMCG",
      display_name: "Dp Foods",
    },
    {
      field_type: "company",
      name: "Dr Reddys",
      field_id: "COM001397",
      website: "https://www.drreddys.com/",
      group: "",
      logo: "",
      company_id: "COM001397",
      company_name: "Dr Reddys",
      display_name: "Dr Reddys",
      sector: "Pharmaceutical",
      page_display_status: false,
      industry: "Pharmaceutical",
    },
    {
      field_type: "company",
      name: "Ds Group",
      field_id: "COM000242",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DS%20GROUP.jpg",
      company_id: "COM000242",
      company_name: "Ds Group",
      display_name: "DS Group",
      sector: "FMCG",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Ds Spices",
      field_id: "COM001245",
      website: "http://www.catchfoods.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DS SPICECO PRIVATE LIMITED.png",
      company_id: "COM001245",
      company_name: "Ds Spices",
      industry: "",
      display_name: "Ds Spices",
    },
    {
      field_type: "company",
      name: "Ducati Motor",
      field_id: "COM000243",
      website: "https://www.ducati.com/in/en/home",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Ducati Motor Holding S P A.png",
      company_id: "COM000243",
      company_name: "Ducati Motor",
      industry: "AUTOMOBILE",
      display_name: "Ducati Motor",
    },
    {
      field_type: "company",
      name: "Dukes Products",
      field_id: "COM000244",
      website: "https://dukesindia.com/",
      group: "RAVI FOODS PRIVATE LIMITED",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DUKES PRODUCTS INDIA LIMITED.png",
      company_id: "COM000244",
      company_name: "Dukes Products",
      industry: "FMCG",
      display_name: "Dukes Products",
    },
    {
      field_type: "company",
      name: "DuPont",
      field_id: "COM000245",
      website: "https://www.dupont.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DuPont de Nemours Inc.png",
      company_id: "COM000245",
      company_name: "DuPont",
      industry: "CHEMICAL",
      display_name: "DuPont",
    },
    {
      field_type: "company",
      name: "Durian Furniture",
      field_id: "COM000246",
      website: "https://www.durian.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/DURIAN INDUSTRIES LIMITED.png",
      company_id: "COM000246",
      company_name: "Durian Furniture",
      industry: "FMCD",
      display_name: "Durian Furniture",
    },
    {
      field_type: "company",
      name: "EID Parry",
      field_id: "COM000247",
      website: "http://www.eidparry.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/E I D PARRY INDIA LIMITED.jpg",
      company_id: "COM000247",
      company_name: "EID Parry",
      industry: "FMCG",
      display_name: "EID Parry",
    },
    {
      field_type: "company",
      name: "Merck",
      field_id: "COM000607",
      website: "https://www.merckgroup.com/in-en/company.html",
      group: "Merck Group",
      logo: "",
      company_id: "COM000607",
      company_name: "Merck",
      industry: "PHARMACEUTICAL",
      display_name: "Merck",
    },
    {
      field_type: "company",
      name: "Eapro",
      field_id: "COM001067",
      website: "https://www.eapro.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EAPRO GLOBAL LIMITED.png",
      company_id: "COM001067",
      company_name: "Eapro",
      industry: "",
      display_name: "Eapro",
    },
    {
      field_type: "company",
      name: "East India Petroleum  ",
      field_id: "COM001398",
      website: "http://www.eastindiapetro.com/",
      group: "",
      logo: "",
      company_id: "COM001398",
      company_name: "East India Petroleum  ",
      industry: "",
      display_name: "East India Petroleum  ",
    },
    {
      field_type: "company",
      name: "East India Pharma Works",
      field_id: "COM001399",
      website: "https://www.eastindiapharma.org/",
      group: "",
      logo: "",
      company_id: "COM001399",
      company_name: "East India Pharma Works",
      industry: "",
      display_name: "East India Pharma Works",
    },
    {
      field_type: "company",
      name: "East India Udyog ",
      field_id: "COM001246",
      website: "http://eastindiaudyog.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EAST INDIA UDYOG LIMITED.jpg",
      company_id: "COM001246",
      company_name: "East India Udyog ",
      industry: "",
      display_name: "East India Udyog ",
    },
    {
      field_type: "company",
      name: "Eastman",
      field_id: "COM000248",
      website: "https://eastmanglobal.com/",
      group: "Eastman Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EASTMAN CHEMICAL COMPANY.png",
      company_id: "COM000248",
      company_name: "Eastman",
      industry: "CHEMICAL",
      display_name: "Eastman",
    },
    {
      field_type: "company",
      name: "Eaton",
      field_id: "COM001118",
      website: "https://www.eaton.com",
      group: "",
      logo: "",
      company_id: "COM001118",
      company_name: "Eaton",
      industry: "",
      display_name: "Eaton",
    },
    {
      field_type: "company",
      name: "Eberspacher",
      field_id: "COM000249",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EBERSPACHER.png",
      company_id: "COM000249",
      company_name: "Eberspacher",
      industry: "AUTOMOBILE",
      display_name: "Eberspacher",
    },
    {
      field_type: "company",
      name: "Eicher Motors ",
      field_id: "COM000250",
      website: "https://www.royalenfield.com/in/en/our-world/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EICHER MOTORS LIMITED.png",
      company_id: "COM000250",
      company_name: "Eicher Motors ",
      industry: "AUTOMOBILE",
      display_name: "Eicher Motors ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000251",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000251",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Eid Parry India Limited",
        field_id: "COM000251",
        website: "http://www.eidparry.com",
        group: "Murugappa Group",
        logo: "",
        company_id: "COM000251",
        company_name: "Eid Parry India Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Eisai Pharma",
      field_id: "COM001400",
      website: "https://www.eisai.com/index.html",
      group: "",
      logo: "",
      company_id: "COM001400",
      company_name: "Eisai Pharma",
      industry: "",
      display_name: "Eisai Pharma",
    },
    {
      field_type: "company",
      name: "Eisenmann",
      field_id: "COM000252",
      website:
        "https://www.eisenmann.com/en/about-EISENMANN/at-a-glance/locations/india.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EISENMANN INDIA PRIVATE LIMITED.png",
      company_id: "COM000252",
      company_name: "Eisenmann",
      industry: "MANUFACTURING",
      display_name: "Eisenmann",
    },
    {
      field_type: "company",
      name: "Electrolytic Plating Co",
      field_id: "COM000950",
      website: "https://www.epcltd.co.uk/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Electrolytic Plating Company Limited.png",
      company_id: "COM000950",
      company_name: "Electrolytic Plating Co",
      industry: "ENGINEERING SERVICES",
      display_name: "Electrolytic Plating Co",
    },
    {
      field_type: "company",
      name: "Elgi Rubber ",
      field_id: "COM001248",
      website: "http://www.elgirubber.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ELGI RUBBER COMPANY LIMITED.png",
      company_id: "COM001248",
      company_name: "Elgi Rubber ",
      industry: "",
      display_name: "Elgi Rubber ",
    },
    {
      field_type: "company",
      name: "Eli Lilly And Co",
      field_id: "COM000253",
      website: "https://www.lillyindia.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ELI LILLY AND COMPANY.png",
      company_id: "COM000253",
      company_name: "Eli Lilly And Co",
      industry: "PHARMACEUTICAL",
      display_name: "Eli Lilly And Co",
    },
    {
      field_type: "company",
      name: "Emami Agrotech ",
      field_id: "COM001068",
      website: "http://www.emamiagrotech.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EMAMI AGROTECH LIMITED.png",
      company_id: "COM001068",
      company_name: "Emami Agrotech ",
      industry: "",
      display_name: "Emami Agrotech ",
    },
    {
      field_type: "company",
      name: "Emami Cement ",
      field_id: "COM000254",
      website: "https://www.emamicement.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EMAMI CEMENT LIMITED.png",
      company_id: "COM000254",
      company_name: "Emami Cement ",
      industry: "CEMENT",
      display_name: "Emami Cement ",
    },
    {
      field_type: "company",
      name: "Emami Skin Care",
      field_id: "COM000255",
      website: "http://www.emamiltd.in/",
      group: "EMAMI GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EMAMI LIMITED.jpg",
      company_id: "COM000255",
      company_name: "Emami Skin Care",
      industry: "FMCG",
      display_name: "Emami Skin Care",
    },
    {
      field_type: "company",
      name: "Emco Corp",
      field_id: "COM000256",
      website: "https://emco.ca/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EMCO CORPORATION.png",
      company_id: "COM000256",
      company_name: "Emco Corp",
      industry: "MANUFACTURING",
      display_name: "Emco Corp",
    },
    {
      field_type: "company",
      name: "Emerson Network Power",
      field_id: "COM000257",
      website: "https://www.vertiv.com",
      group: "Vertiv Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EMERSON NETWORK POWER.png",
      company_id: "COM000257",
      company_name: "Emerson Network Power",
      industry: "",
      display_name: "Emerson Network Power",
    },
    {
      field_type: "company",
      name: "Emmennar Pharmaceuticals",
      field_id: "COM001401",
      website: "http://emmennar.com",
      group: "",
      logo: "",
      company_id: "COM001401",
      company_name: "Emmennar Pharmaceuticals",
      industry: "",
      display_name: "Emmennar Pharmaceuticals",
    },
    {
      field_type: "company",
      name: "Empire Corp",
      field_id: "COM000258",
      website: "http://empirecorporation.com",
      group: "",
      logo: "",
      company_id: "COM000258",
      company_name: "Empire Corp",
      industry: "FASHION AND CLOTHING",
      display_name: "Empire Corp",
    },
    {
      field_type: "company",
      name: "Enanti Labs  ",
      field_id: "COM001402",
      website: "http://www.enantilabs.com",
      group: "",
      logo: "",
      company_id: "COM001402",
      company_name: "Enanti Labs  ",
      industry: "",
      display_name: "Enanti Labs  ",
    },
    {
      field_type: "company",
      name: "Endurance Technologies ",
      field_id: "COM001249",
      website: "https://endurancegroup.com/",
      group: "",
      logo: "",
      company_id: "COM001249",
      company_name: "Endurance Technologies ",
      industry: "",
      display_name: "Endurance Technologies ",
    },
    {
      field_type: "company",
      name: "Energy Beverages  ",
      field_id: "COM001250",
      website: "http://currentclear.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ENERGY BEVERAGES PRIVATE LIMITED.PNG",
      company_id: "COM001250",
      company_name: "Energy Beverages  ",
      industry: "",
      display_name: "Energy Beverages  ",
    },
    {
      field_type: "company",
      name: "Enkay Technologies",
      field_id: "COM000259",
      website: "https://www.enkayindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Enkay Converged Technologies LLP.png",
      company_id: "COM000259",
      company_name: "Enkay Technologies",
      industry: "TELECOM",
      display_name: "Enkay Technologies",
    },
    {
      field_type: "company",
      name: "EPC Ltd",
      field_id: "COM000260",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000260",
      company_name: "EPC Ltd",
      industry: "",
      display_name: "EPC Ltd",
    },
    {
      field_type: "company",
      name: "ESAB",
      field_id: "COM000261",
      website: "https://www.esabindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ESAB.jpg",
      company_id: "COM000261",
      company_name: "ESAB",
      industry: "ELECTRICALS",
      display_name: "ESAB",
    },
    {
      field_type: "company",
      name: "Escorts Group",
      field_id: "COM000262",
      website: "https://www.escortsgroup.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ESCORTS GROUP.jpg",
      company_id: "COM000262",
      company_name: "Escorts Group",
      industry: "MANUFACTURING",
      display_name: "Escorts Group",
    },
    {
      field_type: "company",
      name: "Essar Steel",
      field_id: "COM000263",
      website: "http://www.essarsteel.com/",
      group: "ESSAR GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ESSAR STEEL.png",
      company_id: "COM000263",
      company_name: "Essar Steel",
      display_name: "Essar Steel",
      sector: "Steel",
      page_display_status: false,
      industry: "Steel",
    },
    {
      field_type: "company",
      name: "Essel Propack ",
      field_id: "COM000265",
      website: "https://www.esselpropack.com/",
      group: "Essel Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ESSEL PROPACK LIMITED.jpg",
      company_id: "COM000265",
      company_name: "Essel Propack ",
      industry: "PACKAGING",
      display_name: "Essel Propack ",
    },
    {
      field_type: "company",
      name: "Essel Group",
      field_id: "COM000264",
      website: "http://www.esselgroup.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ESSEL GROUP.png",
      company_id: "COM000264",
      company_name: "Essel Group",
      industry: "CONGLOMERATE",
      display_name: "Essel Group",
    },
    {
      field_type: "company",
      name: "Essentra",
      field_id: "COM001251",
      website: "https://www.essentracomponents.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ESSENTRA INDIA PRIVATE LIMITED.png",
      company_id: "COM001251",
      company_name: "Essentra",
      industry: "",
      display_name: "Essentra",
    },
    {
      field_type: "company",
      name: "Essilor Of America ",
      field_id: "COM001403",
      website: "https://www.essilorusa.com/",
      group: "",
      logo: "",
      company_id: "COM001403",
      company_name: "Essilor Of America ",
      industry: "",
      display_name: "Essilor Of America ",
    },
    {
      field_type: "company",
      name: "ETA Genara ",
      field_id: "COM000266",
      website: "https://www.generalindia.com/",
      group: "",
      logo: "",
      company_id: "COM000266",
      company_name: "ETA Genara ",
      industry: "MANUFACTURING",
      display_name: "ETA Genara ",
    },
    {
      field_type: "company",
      name: "ET Chem  ",
      field_id: "COM001167",
      website: "http://www.metchem.co.in/",
      group: "",
      logo: "",
      company_id: "COM001167",
      company_name: "ET Chem  ",
      industry: "",
      display_name: "ET Chem  ",
    },
    {
      field_type: "company",
      name: "Ethicon",
      field_id: "COM001404",
      website: "https://www.ethicon.com",
      group: "",
      logo: "",
      company_id: "COM001404",
      company_name: "Ethicon",
      industry: "",
      display_name: "Ethicon",
    },
    {
      field_type: "company",
      name: "Eureka Forbes ",
      field_id: "COM000267",
      website: "https://www.eurekaforbes.com/",
      group: "shapoorji Pallonji Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EUREKA FORBES LIMITED.png",
      company_id: "COM000267",
      company_name: "Eureka Forbes ",
      industry: "FMCD",
      display_name: "Eureka Forbes ",
    },
    {
      field_type: "company",
      name: "Eurolife Healthcare  ",
      field_id: "COM001252",
      website: "https://eurolifehealthcare.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EUROLIFE HEALTHCARE PRIVATE LIMITED.png",
      company_id: "COM001252",
      company_name: "Eurolife Healthcare  ",
      industry: "",
      display_name: "Eurolife Healthcare  ",
    },
    {
      field_type: "company",
      name: "Eveready",
      field_id: "COM000268",
      website: "http://www.evereadyindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EVEREADY INDUSTRIES INDIA LIMITED.png",
      company_id: "COM000268",
      company_name: "Eveready",
      industry: "MANUFACTURING",
      display_name: "Eveready",
    },
    {
      field_type: "company",
      name: "Everest Industries",
      field_id: "COM000269",
      website: "https://www.everestind.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EVEREST INDUSTRIES.png",
      company_id: "COM000269",
      company_name: "Everest Industries",
      display_name: "Everest Industries",
      sector: "Steel",
      page_display_status: false,
      industry: "Building Materials",
    },
    {
      field_type: "company",
      name: "Evershine Oleochem ",
      field_id: "COM000270",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000270",
      company_name: "Evershine Oleochem ",
      industry: "FMCG",
      display_name: "Evershine Oleochem ",
    },
    {
      field_type: "company",
      name: "Evonik India  ",
      field_id: "COM000271",
      website: "https://aps.evonik.com/region/seaanz/en/company/seaanz/india/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EVONIK INDIA PRIVATE LIMITED.jpg",
      company_id: "COM000271",
      company_name: "Evonik India  ",
      industry: "CHEMICAL",
      display_name: "Evonik India  ",
    },
    {
      field_type: "company",
      name: "Excel Crop Care ",
      field_id: "COM001405",
      website: "http://www.excelcropcare.com/index.php",
      group: "",
      logo: "",
      company_id: "COM001405",
      company_name: "Excel Crop Care ",
      industry: "",
      display_name: "Excel Crop Care ",
    },
    {
      field_type: "company",
      name: "Exide Industries ",
      field_id: "COM000272",
      website: "https://www.exideindustries.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EXIDE INDUSTRIES LIMITED.png",
      company_id: "COM000272",
      company_name: "Exide Industries ",
      industry: "MANUFACTURING",
      display_name: "Exide Industries ",
    },
    {
      field_type: "company",
      name: "Expeditors International Of Washington ",
      field_id: "COM000273",
      website: "https://www.expeditors.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Expeditors International of Washington Inc.png",
      company_id: "COM000273",
      company_name: "Expeditors International Of Washington ",
      industry: "LOGISTICS",
      display_name: "Expeditors International Of Washington ",
    },
    {
      field_type: "company",
      name: "Exxonmobil",
      field_id: "COM000274",
      website: "https://corporate.exxonmobil.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/EXXONMOBIL.png",
      company_id: "COM000274",
      company_name: "Exxonmobil",
      industry: "OIL AND GAS",
      display_name: "Exxonmobil",
    },
    {
      field_type: "company",
      name: "Ezee Pack",
      field_id: "COM000275",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000275",
      company_name: "Ezee Pack",
      industry: "PACKAGING",
      display_name: "Ezee Pack",
    },
    {
      field_type: "company",
      name: "Faurecia",
      field_id: "COM001069",
      website: "https://www.faurecia.com/en",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FAURECIA.png",
      company_id: "COM001069",
      company_name: "Faurecia",
      industry: "",
      display_name: "Faurecia",
    },
    {
      field_type: "company",
      name: "FDC",
      field_id: "COM000276",
      website: "http://www.fdcindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FDC LIMITED.png",
      company_id: "COM000276",
      company_name: "FDC",
      industry: "PHARMACEUTICAL",
      display_name: "FDC",
    },
    {
      field_type: "company",
      name: "Featherlite Products  ",
      field_id: "COM001253",
      website: "https://www.featherlitefurniture.com/company-profile",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FEATHERLITE PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM001253",
      company_name: "Featherlite Products  ",
      industry: "",
      display_name: "Featherlite Products  ",
    },
    {
      field_type: "company",
      name: "Federal Mogul Corp",
      field_id: "COM000277",
      website: "http://www.federalmogul.com/en-US/OE/Pages/home.aspx",
      group: "Tenneco",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FEDERAL-MOGUL CORPORATION.png",
      company_id: "COM000277",
      company_name: "Federal Mogul Corp",
      industry: "AUTOMOBILE",
      display_name: "Federal Mogul Corp",
    },
    {
      field_type: "company",
      name: "Fena  ",
      field_id: "COM000278",
      website: "https://www.fena.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FENA PRIVATE LIMITED.jpg",
      company_id: "COM000278",
      company_name: "Fena  ",
      industry: "FMCG",
      display_name: "Fena  ",
    },
    {
      field_type: "company",
      name: "Fenesta Building Systems",
      field_id: "COM000279",
      website: "https://www.fenesta.com",
      group: "DCM SHRIRAM GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FENESTA BUILDING SYSTEMS.png",
      company_id: "COM000279",
      company_name: "Fenesta Building Systems",
      industry: "MANUFACTURING",
      display_name: "Fenesta Building Systems",
    },
    {
      field_type: "company",
      name: "Fermenta Biotech ",
      field_id: "COM001406",
      website: "https://www.fermentabiotech.com/",
      group: "",
      logo: "",
      company_id: "COM001406",
      company_name: "Fermenta Biotech ",
      industry: "",
      display_name: "Fermenta Biotech ",
    },
    {
      field_type: "company",
      name: "Ferrero",
      field_id: "COM001254",
      website: "https://www.ferreroindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FERRERO INDIA PRIVATE LIMITED.webp",
      company_id: "COM001254",
      company_name: "Ferrero",
      display_name: "Ferrero",
      sector: "FMCG",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Ferro Alloys Corp",
      field_id: "COM001255",
      website: "http://www.facorgroup.in/",
      group: "FACOR Group",
      logo: "",
      company_id: "COM001255",
      company_name: "Ferro Alloys Corp",
      industry: "",
      display_name: "Ferro Alloys Corp",
    },
    {
      field_type: "company",
      name: "Fertichem Cotspin ",
      field_id: "COM001256",
      website: "https://www.fertichemgroup.com/",
      group: "Fertichem Group",
      logo: "",
      company_id: "COM001256",
      company_name: "Fertichem Cotspin ",
      industry: "",
      display_name: "Fertichem Cotspin ",
    },
    {
      field_type: "company",
      name: "Fieldfresh Foods  ",
      field_id: "COM000280",
      website: "https://www.fieldfreshfoods.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FIELDFRESH FOODS PRIVATE LIMITED.png",
      company_id: "COM000280",
      company_name: "Fieldfresh Foods  ",
      industry: "FMCG",
      display_name: "Fieldfresh Foods  ",
    },
    {
      field_type: "company",
      name: "Filatex",
      field_id: "COM000281",
      website: "https://www.filatex.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FILATEX INDIA LIMITED.png",
      company_id: "COM000281",
      company_name: "Filatex",
      industry: "TEXTILE",
      display_name: "Filatex",
    },
    {
      field_type: "company",
      name: "Finar Chemicals",
      field_id: "COM001257",
      website: "https://www.finarchemicals.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FINAR LIMITED.png",
      company_id: "COM001257",
      company_name: "Finar Chemicals",
      industry: "",
      display_name: "Finar Chemicals",
    },
    {
      field_type: "company",
      name: "Fine Organics",
      field_id: "COM001258",
      website: "https://www.fineorganics.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FINE ORGANIC INDUSTRIES LIMITED.png",
      company_id: "COM001258",
      company_name: "Fine Organics",
      industry: "",
      display_name: "Fine Organics",
    },
    {
      field_type: "company",
      name: "Fine Tech Corp",
      field_id: "COM000282",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000282",
      company_name: "Fine Tech Corp",
      industry: "",
      display_name: "Fine Tech Corp",
    },
    {
      field_type: "company",
      name: "Finearc Systems  ",
      field_id: "COM001259",
      website: "http://www.finearcsystems.com/",
      group: "",
      logo: "",
      company_id: "COM001259",
      company_name: "Finearc Systems  ",
      industry: "",
      display_name: "Finearc Systems  ",
    },
    {
      field_type: "company",
      name: "Finolex",
      field_id: "COM001093",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FINOLEX INDUSTRIES LIMITED.jpg",
      company_id: "COM001093",
      company_name: "Finolex",
      industry: "MANUFACTURING",
      display_name: "Finolex",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Firmenich Aromatics",
      field_id: "COM000283",
      website: "https://www.firmenich.com/",
      group: "",
      logo: "",
      company_id: "COM000283",
      company_name: "Firmenich Aromatics",
      industry: "",
      display_name: "Firmenich Aromatics",
    },
    {
      field_type: "company",
      name: "Fleetguard Filters  ",
      field_id: "COM001260",
      website: "https://www.fleetguard-filtrum.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FLEETGUARD FILTERS PRIVATE LIMITED.png",
      company_id: "COM001260",
      company_name: "Fleetguard Filters  ",
      industry: "",
      display_name: "Fleetguard Filters  ",
    },
    {
      field_type: "company",
      name: "Flexituff",
      field_id: "COM000284",
      website: "http://flexituff.com/home/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FlexiTuff Ventures International Limited.png",
      company_id: "COM000284",
      company_name: "Flexituff",
      industry: "PLASTICS",
      display_name: "Flexituff",
    },
    {
      field_type: "company",
      name: "Flexo Foam  ",
      field_id: "COM001261",
      website: "https://www.flexofoam.com/contact-us.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FLEXO FOAM PRIVATE LIMITED.png",
      company_id: "COM001261",
      company_name: "Flexo Foam  ",
      industry: "",
      display_name: "Flexo Foam  ",
    },
    {
      field_type: "company",
      name: "Flipkart",
      field_id: "COM000285",
      website: "https://www.flipkart.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Flipkart Internet Private Limited.png",
      company_id: "COM000285",
      company_name: "Flipkart",
      industry: "ECOMMERCE",
      display_name: "Flipkart",
    },
    {
      field_type: "company",
      name: "Flyocrete Green Concrete ",
      field_id: "COM001262",
      website: "http://www.flyocrete.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FLYOCRETE GREEN CONCRETE LLP.png",
      company_id: "COM001262",
      company_name: "Flyocrete Green Concrete ",
      industry: "",
      display_name: "Flyocrete Green Concrete ",
    },
    {
      field_type: "company",
      name: "FMC",
      field_id: "COM000287",
      website: "http://www.fmc.in/",
      group: "FMC Corporation",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FMC CHEMINOVA INDIA PRIVATE LIMITED.png",
      company_id: "COM000287",
      company_name: "FMC",
      industry: "CHEMICAL",
      display_name: "FMC",
    },
    {
      field_type: "company",
      name: "FCI - Food Corporation Of India",
      field_id: "COM000288",
      website: "http://fci.gov.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FOOD CORPORATION OF INDIA.png",
      company_id: "COM000288",
      company_name: "FCI - Food Corporation Of India",
      industry: "",
      display_name: "FCI - Food Corporation Of India",
    },
    {
      field_type: "company",
      name: "Forace Polymers  ",
      field_id: "COM001070",
      website: "http://www.foracepolymers.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FORACE POLYMERS PRIVATE LIMITED.png",
      company_id: "COM001070",
      company_name: "Forace Polymers  ",
      industry: "",
      display_name: "Forace Polymers  ",
    },
    {
      field_type: "company",
      name: "Force Motors ",
      field_id: "COM000289",
      website: "https://www.forcemotors.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FORCE MOTORS LIMITED.png",
      company_id: "COM000289",
      company_name: "Force Motors ",
      industry: "AUTOMOBILE",
      display_name: "Force Motors ",
    },
    {
      field_type: "company",
      name: "Ford Motor Co",
      field_id: "COM001071",
      website: "https://www.india.ford.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FORD MOTOR COMPANY.webp",
      company_id: "COM001071",
      company_name: "Ford Motor Co",
      industry: "",
      display_name: "Ford Motor Co",
    },
    {
      field_type: "company",
      name: "Forech ",
      field_id: "COM000290",
      website: "https://forech.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FORECH LIMITED.png",
      company_id: "COM000290",
      company_name: "Forech ",
      industry: "MANUFACTURING",
      display_name: "Forech ",
    },
    {
      field_type: "company",
      name: "Fosroc ",
      field_id: "COM000291",
      website: "https://www.fosroc.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FOSROC INC.png",
      company_id: "COM000291",
      company_name: "Fosroc ",
      industry: "BUILDING MATERIAL",
      display_name: "Fosroc ",
    },
    {
      field_type: "company",
      name: "Fourrts Laboratories",
      field_id: "COM000292",
      website: "http://www.fourrts.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FOURRTS INDIA LABORATORIES PRIVATE LIMITED.jpg",
      company_id: "COM000292",
      company_name: "Fourrts Laboratories",
      industry: "PHARMACEUTICAL",
      display_name: "Fourrts Laboratories",
    },
    {
      field_type: "company",
      name: "Fresenius Kabi",
      field_id: "COM001407",
      website: "https://www.fresenius-kabi.com/",
      group: "",
      logo: "",
      company_id: "COM001407",
      company_name: "Fresenius Kabi",
      industry: "",
      display_name: "Fresenius Kabi",
    },
    {
      field_type: "company",
      name: "Fresh And Honest Cafe ",
      field_id: "COM000293",
      website:
        "https://www.lavazza.in/en/business/offices/fresh-and-honest.html",
      group: "Lavazza",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FRESH AND HONEST CAFE LIMITED.png",
      company_id: "COM000293",
      company_name: "Fresh And Honest Cafe ",
      industry: "",
      display_name: "Fresh And Honest Cafe ",
    },
    {
      field_type: "company",
      name: "Fuchs Lubricants",
      field_id: "COM000295",
      website: "https://www.fuchs.com/sea/sg/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FUCHS LUBRICANTS PTE LIMITED.png",
      company_id: "COM000295",
      company_name: "Fuchs Lubricants",
      industry: "OIL AND GAS",
      display_name: "Fuchs Lubricants",
    },
    {
      field_type: "company",
      name: "Fujifilm",
      field_id: "COM000296",
      website: "http://www.fujifilm.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FUJIFILM.png",
      company_id: "COM000296",
      company_name: "Fujifilm",
      industry: "MANUFACTURING",
      display_name: "Fujifilm",
    },
    {
      field_type: "company",
      name: "Furnitech Seating",
      field_id: "COM000297",
      website: "http://furnitechseating.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FURNITECH SEATING SYSTEMS PRIVATE LIMITED.png",
      company_id: "COM000297",
      company_name: "Furnitech Seating",
      industry: "FMCD",
      display_name: "Furnitech Seating",
    },
    {
      field_type: "company",
      name: "Future Consumer ",
      field_id: "COM000298",
      website: "http://futureconsumer.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FUTURE CONSUMER LIMITED.png",
      company_id: "COM000298",
      company_name: "Future Consumer ",
      industry: "FMCG",
      display_name: "Future Consumer ",
    },
    {
      field_type: "company",
      name: "Future Retail ",
      field_id: "COM001270",
      website:
        "http://www.hushpuppies.in/hushpuppies/faces/tiles/catalogue.jsp?catalogueID=128",
      group: "Wolverine World Wide",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/FUTURE RETAIL LIMITED.jpg",
      company_id: "COM001270",
      company_name: "Future Retail ",
      industry: "",
      display_name: "Future Retail ",
    },
    {
      field_type: "company",
      name: "G Nandy",
      field_id: "COM000300",
      website: "http://www.gnandyandco.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/G NANDY AND COMPANY.png",
      company_id: "COM000300",
      company_name: "G Nandy",
      industry: "ELECTRICALS",
      display_name: "G Nandy",
    },
    {
      field_type: "company",
      name: "GAIL",
      field_id: "COM000302",
      website: "https://gailonline.com/home.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GAIL INDIA LIMITED.png",
      company_id: "COM000302",
      company_name: "GAIL",
      industry: "OIL AND GAS",
      display_name: "GAIL",
    },
    {
      field_type: "company",
      name: "Galaxy Surfacetant ",
      field_id: "COM000303",
      website: "http://www.galaxysurfactants.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GALAXY SURFACETANT LIMITED.jpg",
      company_id: "COM000303",
      company_name: "Galaxy Surfacetant ",
      industry: "HEALTHCARE",
      display_name: "Galaxy Surfacetant ",
    },
    {
      field_type: "company",
      name: "Gallantt Metal ",
      field_id: "COM001263",
      website: "http://www.gallantt.com/index.html",
      group: "GALLANT GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GALLANTT METAL LIMITED.jpg",
      company_id: "COM001263",
      company_name: "Gallantt Metal ",
      industry: "",
      display_name: "Gallantt Metal ",
    },
    {
      field_type: "company",
      name: "Galpha Labs",
      field_id: "COM000304",
      website: "http://www.galpha.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GALPHA LABORATORIES LIMITED.png",
      company_id: "COM000304",
      company_name: "Galpha Labs",
      industry: "PHARMACEUTICAL",
      display_name: "Galpha Labs",
    },
    {
      field_type: "company",
      name: "Gandhar Oil Refinery ",
      field_id: "COM001264",
      website: "https://www.gandharoil.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GANDHAR OIL REFINERY LIMITED.svg",
      company_id: "COM001264",
      company_name: "Gandhar Oil Refinery ",
      industry: "",
      display_name: "Gandhar Oil Refinery ",
    },
    {
      field_type: "company",
      name: "Gandour Food Processing  ",
      field_id: "COM000306",
      website: "https://www.gandour.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GANDOUR INDIA FOOD PROCESSING PVT LTD.png",
      company_id: "COM000306",
      company_name: "Gandour Food Processing  ",
      industry: "FMCG",
      display_name: "Gandour Food Processing  ",
    },
    {
      field_type: "company",
      name: "Garden Reach Shipbuilders",
      field_id: "COM000308",
      website: "http://www.grse.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GARDEN REACH SHIPBUILDERS AND ENGINEERS LIMITED.png",
      company_id: "COM000308",
      company_name: "Garden Reach Shipbuilders",
      industry: "MANUFACTURING",
      display_name: "Garden Reach Shipbuilders",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000307",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000307",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Garden Research Builders",
        field_id: "COM000307",
        website: "",
        group: "",
        logo: "",
        company_id: "COM000307",
        company_name: "Garden Research Builders",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Gemini Cooking Oils",
      field_id: "COM000310",
      website: "https://www.gefindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GEMINI EDIBLES AND FATS INDIA PRIVATE LIMITED.png",
      company_id: "COM000310",
      company_name: "Gemini Cooking Oils",
      industry: "FMCG",
      display_name: "Gemini Cooking Oils",
    },
    {
      field_type: "company",
      name: "GE - General Electric",
      field_id: "COM000311",
      website: "https://www.ge.com/",
      group: "GENERAL ELECTRICAL",
      logo: "",
      company_id: "COM000311",
      company_name: "GE - General Electric",
      industry: "CONGLOMERATE",
      display_name: "GE - General Electric",
    },
    {
      field_type: "company",
      name: "General Electrical Transmission And Distribution",
      field_id: "COM000301",
      website: "https://www.ge.com/in/ge-td-india-limited",
      group: "GENERAL ELECTRICAL",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GENERAL ELECTRICALS TRANSMISSION AND DISTRIBUTION INDIA LIMITED.png",
      company_id: "COM000301",
      company_name: "General Electrical Transmission And Distribution",
      industry: "ELECTRICALS",
      display_name: "General Electrical Transmission And Distribution",
    },
    {
      field_type: "company",
      name: "General Mills",
      field_id: "COM000312",
      website: "https://www.generalmills.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GENERAL MILLS INCORPORAION.png",
      company_id: "COM000312",
      company_name: "General Mills",
      display_name: "General Mills",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "General Motors",
      field_id: "COM000313",
      website: "https://www.gm.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GENERAL MOTORS.png",
      company_id: "COM000313",
      company_name: "General Motors",
      industry: "AUTOMOBILE",
      display_name: "General Motors",
    },
    {
      field_type: "company",
      name: "Genus Power Infrastructures ",
      field_id: "COM001124",
      website: "https://genuspower.com/",
      group: "Kailash Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Genus Power Infrastructures Limited.png",
      company_id: "COM001124",
      company_name: "Genus Power Infrastructures ",
      industry: "",
      display_name: "Genus Power Infrastructures ",
    },
    {
      field_type: "company",
      name: "Gerdau Steel",
      field_id: "COM000314",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000314",
      company_name: "Gerdau Steel",
      industry: "",
      display_name: "Gerdau Steel",
    },
    {
      field_type: "company",
      name: "Gharda Chemicals ",
      field_id: "COM001408",
      website: "https://www.gharda.com/",
      group: "",
      logo: "",
      company_id: "COM001408",
      company_name: "Gharda Chemicals ",
      industry: "",
      display_name: "Gharda Chemicals ",
    },
    {
      field_type: "company",
      name: "GHCL",
      field_id: "COM001265",
      website: "https://www.ghcl.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GHCL LIMITED.jpg",
      company_id: "COM001265",
      company_name: "GHCL",
      industry: "",
      display_name: "GHCL",
    },
    {
      field_type: "company",
      name: "Gibam",
      field_id: "COM000316",
      website: "https://www.gibam.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GIBAM INDIA PRIVATE LIMITED.svg",
      company_id: "COM000316",
      company_name: "Gibam",
      industry: "MANUFACTURING",
      display_name: "Gibam",
    },
    {
      field_type: "company",
      name: "Ginni Filaments ",
      field_id: "COM000317",
      website: "http://ginnifilaments.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GINNI FILAMENTS LIMITED.png",
      company_id: "COM000317",
      company_name: "Ginni Filaments ",
      industry: "TEXTILE",
      display_name: "Ginni Filaments ",
    },
    {
      field_type: "company",
      name: "GKN Driveline",
      field_id: "COM000318",
      website: "https://www.gknautomotive.com/",
      group: "",
      logo: "",
      company_id: "COM000318",
      company_name: "GKN Driveline",
      industry: "AUTOMOBILE",
      display_name: "GKN Driveline",
    },
    {
      field_type: "company",
      name: "Gland Pharmaceuticals",
      field_id: "COM001409",
      website: "http://www.glandpharma.com/contact.html",
      group: "",
      logo: "",
      company_id: "COM001409",
      company_name: "Gland Pharmaceuticals",
      industry: "",
      display_name: "Gland Pharmaceuticals",
    },
    {
      field_type: "company",
      name: "GSK - Glaxosmithkline",
      field_id: "COM000319",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GSK%20GlaxoSmithKline.png",
      company_id: "COM000319",
      company_name: "GSK - Glaxosmithkline",
      display_name: "GSK - Glaxosmithkline Consumers",
      sector: "Pharmaceutical",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Glenmark Pharma",
      field_id: "COM000320",
      website: "https://www.glenmarkpharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GLENMARK PHARMACUETICALS LIMITED.jpg",
      company_id: "COM000320",
      company_name: "Glenmark Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Glenmark Pharma",
    },
    {
      field_type: "company",
      name: "Global Aluminium  ",
      field_id: "COM000321",
      website: "http://globalaluminium.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GLOBAL ALUMINIUM PRIVATE LIMITED.png",
      company_id: "COM000321",
      company_name: "Global Aluminium  ",
      industry: "MANUFACTURING",
      display_name: "Global Aluminium  ",
    },
    {
      field_type: "company",
      name: "Global Net Lease",
      field_id: "COM000323",
      website: "http://globalnetlease.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GLOBAL NET LEASE.png",
      company_id: "COM000323",
      company_name: "Global Net Lease",
      industry: "",
      display_name: "Global Net Lease",
    },
    {
      field_type: "company",
      name: "Global Pharmatech  ",
      field_id: "COM001410",
      website: "https://globalpharmatech.com/about-us/",
      group: "",
      logo: "",
      company_id: "COM001410",
      company_name: "Global Pharmatech  ",
      industry: "",
      display_name: "Global Pharmatech  ",
    },
    {
      field_type: "company",
      name: "Globe International Pharma",
      field_id: "COM000326",
      website: "http://globesite-001-site1.gtempurl.com/",
      group: "GLOBE GROUP",
      logo: "",
      company_id: "COM000326",
      company_name: "Globe International Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Globe International Pharma",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Globus Spirits ",
      field_id: "COM001266",
      website: "https://www.globusspirits.com/home.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GLOBUS SPIRITS LIMITED.gif",
      company_id: "COM001266",
      company_name: "Globus Spirits ",
      industry: "",
      display_name: "Globus Spirits ",
    },
    {
      field_type: "company",
      name: "Glochem",
      field_id: "COM001411",
      website: "https://glochemindia.com/",
      group: "",
      logo: "",
      company_id: "COM001411",
      company_name: "Glochem",
      industry: "",
      display_name: "Glochem",
    },
    {
      field_type: "company",
      name: "Gloster",
      field_id: "COM000327",
      website: "http://www.glostercable.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GLOSTER CABLES LIMITED.png",
      company_id: "COM000327",
      company_name: "Gloster",
      industry: "MANUFACTURING",
      display_name: "Gloster",
    },
    {
      field_type: "company",
      name: "Glow Pharmaceuticals",
      field_id: "COM001267",
      website: "https://glowpharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GLOW PHARMA PRIVATE LIMITED.png",
      company_id: "COM001267",
      company_name: "Glow Pharmaceuticals",
      industry: "",
      display_name: "Glow Pharmaceuticals",
    },
    {
      field_type: "company",
      name: "Godfrey Phillips",
      field_id: "COM000331",
      website: "https://www.godfreyphillips.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GODFREY PHILLIPS INDIA LIMITED.png",
      company_id: "COM000331",
      company_name: "Godfrey Phillips",
      industry: "FMCG",
      display_name: "Godfrey Phillips",
    },
    {
      field_type: "company",
      name: "Godrej Agrovet ",
      field_id: "COM000333",
      website: "http://www.godrejagrovet.com/",
      group: "GODREJ GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GODREJ AGROVET LIMITED.jpg",
      company_id: "COM000333",
      company_name: "Godrej Agrovet ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Godrej Agrovet ",
    },
    {
      field_type: "company",
      name: "Godrej And Boyce",
      field_id: "COM000332",
      website: "http://www.godrejandboyce.com/godrejandboyce/index.aspx?id=16",
      group: "GODREJ GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GODREJ AND BOYCE MANUFACTURING COMPANY LIMITED.jpg",
      company_id: "COM000332",
      company_name: "Godrej And Boyce",
      display_name: "Godrej And Boyce",
      sector: "FMCD",
      page_display_status: false,
      industry: "FMCD",
    },
    {
      field_type: "company",
      name: "Godrej Consumer",
      field_id: "COM000334",
      website: "https://www.godrejcp.com",
      group: "GODREJ GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GODREJ%20CONSUMER%20PRODUCTS%C2%A0LIMITED.jpg",
      company_id: "COM000334",
      company_name: "Godrej Consumer",
      display_name: "GCPL - Godrej Consumer",
      sector: "FMCG",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000336",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000336",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Godrej Food And Industries Limited",
        field_id: "COM000336",
        website: "http://www.godrejagrovet.com",
        group: "",
        logo: "",
        company_id: "COM000336",
        company_name: "Godrej Food And Industries Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Godrej Gold Coin Aquafeed ",
      field_id: "COM000337",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000337",
      company_name: "Godrej Gold Coin Aquafeed ",
      industry: "CONSTRUCTION",
      display_name: "Godrej Gold Coin Aquafeed ",
    },
    {
      field_type: "company",
      name: "Gokak Textiles ",
      field_id: "COM000339",
      website: "http://www.gokakmills.com/",
      group: "SHAPOORJI PALLONJI",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GOKAK TEXTILES LIMITED.gif",
      company_id: "COM000339",
      company_name: "Gokak Textiles ",
      industry: "TEXTILE",
      display_name: "Gokak Textiles ",
    },
    {
      field_type: "company",
      name: "Gokul Agro",
      field_id: "COM001125",
      website: "https://www.gokulagro.com/about-us/",
      group: "GOKUL REFOILS & SOLVENT LTD",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GOKUL AGRO RESOURCES LIMITED.png",
      company_id: "COM001125",
      company_name: "Gokul Agro",
      industry: "",
      display_name: "Gokul Agro",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Gokul Refoils",
      field_id: "COM000340",
      website: "http://www.gokulgroup.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GOKUL REFOILS AND SOLVENT LIMITED.jpg",
      company_id: "COM000340",
      company_name: "Gokul Refoils",
      industry: "FMCG",
      display_name: "Gokul Refoils",
    },
    {
      field_type: "company",
      name: "Gold Plus Glass",
      field_id: "COM000341",
      website: "http://goldplusgroup.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GOLD PLUS GLASS INDUSTRY LIMITED.jpg",
      company_id: "COM000341",
      company_name: "Gold Plus Glass",
      industry: "GLASS",
      display_name: "Gold Plus Glass",
    },
    {
      field_type: "company",
      name: "Goli Vada Pav",
      field_id: "COM000342",
      website: "https://m.golivadapav.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GOLI VADA PAV.jpg",
      company_id: "COM000342",
      company_name: "Goli Vada Pav",
      industry: "FMCG",
      display_name: "Goli Vada Pav",
    },
    {
      field_type: "company",
      name: "Goodyear",
      field_id: "COM000343",
      website: "https://www.goodyear.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GOODYEAR INDIA LIMITED.png",
      company_id: "COM000343",
      company_name: "Goodyear",
      industry: "TYRE",
      display_name: "Goodyear",
    },
    {
      field_type: "company",
      name: "Grace Infrastructure  ",
      field_id: "COM000346",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000346",
      company_name: "Grace Infrastructure  ",
      industry: "INFRASTRUCTURE",
      display_name: "Grace Infrastructure  ",
    },
    {
      field_type: "company",
      name: "Graham Blowpack  ",
      field_id: "COM001094",
      website: "http://www.grahamblowpack.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GRAHAM BLOWPACK PRIVATE LIMITED.png",
      company_id: "COM001094",
      company_name: "Graham Blowpack  ",
      industry: "",
      display_name: "Graham Blowpack  ",
    },
    {
      field_type: "company",
      name: "Graphite",
      field_id: "COM001126",
      website: "https://www.graphiteindia.com/",
      group: "",
      logo: "",
      company_id: "COM001126",
      company_name: "Graphite",
      industry: "",
      display_name: "Graphite",
    },
    {
      field_type: "company",
      name: "Grasim",
      field_id: "COM000347",
      website: "http://www.grasim.com/",
      group: "ADITYA BIRLA",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GRASIM INDUSTRIES LIMITED.png",
      company_id: "COM000347",
      company_name: "Grasim",
      industry: "CONGLOMERATE",
      display_name: "Grasim",
    },
    {
      field_type: "company",
      name: "Gravita",
      field_id: "COM000348",
      website: "https://www.gravitaindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GRAVITA INDIA LIMITED.png",
      company_id: "COM000348",
      company_name: "Gravita",
      industry: "MANUFACTURING",
      display_name: "Gravita",
    },
    {
      field_type: "company",
      name: "GRB Dairy Foods  ",
      field_id: "COM001127",
      website: "https://www.grbdairyfood.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GRB DAIRY FOODS PRIVATE LIMITED.png",
      company_id: "COM001127",
      company_name: "GRB Dairy Foods  ",
      industry: "",
      display_name: "GRB Dairy Foods  ",
    },
    {
      field_type: "company",
      name: "Greatwhite",
      field_id: "COM001128",
      website: "https://www.great-white.in/index.php/contact/#",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GREATWHITE GLOBAL PRIVATE LIMITED.png",
      company_id: "COM001128",
      company_name: "Greatwhite",
      industry: "",
      display_name: "Greatwhite",
    },
    {
      field_type: "company",
      name: "Green Gas ",
      field_id: "COM000315",
      website: "https://gglonline.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GREEN GAS LIMITED.png",
      company_id: "COM000315",
      company_name: "Green Gas ",
      industry: "OIL AND GAS",
      display_name: "Green Gas ",
    },
    {
      field_type: "company",
      name: "Green Ginger Traders",
      field_id: "COM000349",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000349",
      company_name: "Green Ginger Traders",
      industry: "",
      display_name: "Green Ginger Traders",
    },
    {
      field_type: "company",
      name: "Greendot Foods",
      field_id: "COM000351",
      website: "https://www.cornitos.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GREENDOT HEALTH FOODS PVT LTD.png",
      company_id: "COM000351",
      company_name: "Greendot Foods",
      industry: "FMCG",
      display_name: "Greendot Foods",
    },
    {
      field_type: "company",
      name: "Greenply",
      field_id: "COM000352",
      website: "http://www.greenply.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GREENPLY INDUSTRIES LIMITED.jpg",
      company_id: "COM000352",
      company_name: "Greenply",
      industry: "FMCD",
      display_name: "Greenply",
    },
    {
      field_type: "company",
      name: "Grofers",
      field_id: "COM000353",
      website:
        "https://grofers.com/?%243p=a_google_adwords&%24always_deeplink=false&lpurl=https%3A%2F%2Fgrofers.com%2F%3Fgclsrc%3Daw.ds%26&~ad_set_id=74980020446&~campaign_id=2058320844&~channel=g&~keyword=grofers&~placement=&gclid=EAIaIQobChMI44HSxvDy4wIV04RwCh3W1wHYEAAYASAAEgK3oPD_BwE&gclid=EAIaIQobChMI44HSxvDy4wIV04RwCh3W1wHYEAAYASAAEgK3oPD_BwE&gclsrc=aw.ds&_branch_match_id=687931166086131218",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GROFERS.png",
      company_id: "COM000353",
      company_name: "Grofers",
      industry: "ECOMMERCE",
      display_name: "Grofers",
    },
    {
      field_type: "company",
      name: "GS Caltex",
      field_id: "COM001129",
      website: "https://www.gscaltexindia.com/",
      group: "GS Caltex Corporation",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GS CALTEX INDIA PRIVATE LIMITED.jpg",
      company_id: "COM001129",
      company_name: "GS Caltex",
      industry: "",
      display_name: "GS Caltex",
    },
    {
      field_type: "company",
      name: "GSP Crop Science  ",
      field_id: "COM000354",
      website: "https://gspcrop.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GSP CROP SCIENCE PRIVATE LIMITED.png",
      company_id: "COM000354",
      company_name: "GSP Crop Science  ",
      industry: "CHEMICAL",
      display_name: "GSP Crop Science  ",
    },
    {
      field_type: "company",
      name: "Guardian Castings  ",
      field_id: "COM000355",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000355",
      company_name: "Guardian Castings  ",
      industry: "MANUFACTURING",
      display_name: "Guardian Castings  ",
    },
    {
      field_type: "company",
      name: "Guiltfree",
      field_id: "COM000356",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GUILTFREE INDUSTRIES LIMITED.jpg",
      company_id: "COM000356",
      company_name: "Guiltfree",
      industry: "FMCG",
      display_name: "Guiltfree",
    },
    {
      field_type: "company",
      name: "Gujarat Borosil ",
      field_id: "COM000357",
      website: "http://gujaratborosil.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GUJARAT BOROSIL LIMITED.gif",
      company_id: "COM000357",
      company_name: "Gujarat Borosil ",
      industry: "GLASS",
      display_name: "Gujarat Borosil ",
    },
    {
      field_type: "company",
      name: "Gujrat Narmada Valley Fertilizers ",
      field_id: "COM000359",
      website: "https://www.gnfc.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GUJRAT NARMADA VALLEY FERTILIZERS AND CHEMICALS LIMITED.gif",
      company_id: "COM000359",
      company_name: "Gujrat Narmada Valley Fertilizers ",
      industry: "CHEMICAL",
      display_name: "Gujrat Narmada Valley Fertilizers ",
    },
    {
      field_type: "company",
      name: "Gulf Oil",
      field_id: "COM001268",
      website: "https://www.gulfoilindia.com/",
      group: "Hinduja Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GULF OIL LUBRICANTS INDIA LIMITED.png",
      company_id: "COM001268",
      company_name: "Gulf Oil",
      industry: "",
      display_name: "Gulf Oil",
    },
    {
      field_type: "company",
      name: "Gupta Power Infrastructure ",
      field_id: "COM000360",
      website: "https://www.guptapower.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GUPTA POWER INFRASTRUCTURE LIMITED.png",
      company_id: "COM000360",
      company_name: "Gupta Power Infrastructure ",
      industry: "ELECTRICALS",
      display_name: "Gupta Power Infrastructure ",
    },
    {
      field_type: "company",
      name: "H And R Johnson",
      field_id: "COM000416",
      website: "https://www.hrjohnsonindia.com/",
      group: "JOHNSON LIMITED",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/H AND R JOHNSON INDIA.png",
      company_id: "COM000416",
      company_name: "H And R Johnson",
      industry: "CERAMICS",
      display_name: "H And R Johnson",
    },
    {
      field_type: "company",
      name: "HD Wires",
      field_id: "COM000363",
      website: "https://www.hdwires.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/H D WIRES PRIVATE LIMITED.png",
      company_id: "COM000363",
      company_name: "HD Wires",
      industry: "MANUFACTURING",
      display_name: "HD Wires",
    },
    {
      field_type: "company",
      name: "HQ Lamps",
      field_id: "COM001139",
      website: "http://www.hqlamps.in/Aboutus.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/H Q LAMPS MANUFACTURING COMPANY PRIVATE LIMITED.jpg",
      company_id: "COM001139",
      company_name: "HQ Lamps",
      industry: "",
      display_name: "HQ Lamps",
    },
    {
      field_type: "company",
      name: "Haier Corp",
      field_id: "COM000364",
      website: "https://www.haier.com/in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HAIER INCORPORATION.png",
      company_id: "COM000364",
      company_name: "Haier Corp",
      industry: "ELECTRONICS",
      display_name: "Haier Corp",
    },
    {
      field_type: "company",
      name: "Hajee Ap Bava",
      field_id: "COM000373",
      website: "http://hapbco.co/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HAJEE AP BAVA AND COMPANY PRIVATE LIMITED.png",
      company_id: "COM000373",
      company_name: "Hajee Ap Bava",
      industry: "CONSTRUCTION",
      display_name: "Hajee Ap Bava",
    },
    {
      field_type: "company",
      name: "Haldia Petrochemicals ",
      field_id: "COM000367",
      website: "https://www.hplindia.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HALDIA PETROCHEMICALS LIMITED.jpg",
      company_id: "COM000367",
      company_name: "Haldia Petrochemicals ",
      industry: "OIL AND GAS",
      display_name: "Haldia Petrochemicals ",
    },
    {
      field_type: "company",
      name: "Haldiram",
      field_id: "COM000368",
      website: "http://www.haldiram.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HALDIRAM SNACKS PRIVATE LIMITED.png",
      company_id: "COM000368",
      company_name: "Haldiram",
      industry: "FMCG",
      display_name: "Haldiram",
    },
    {
      field_type: "company",
      name: "Haldyn Glass ",
      field_id: "COM000369",
      website: "http://www.haldynglass.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HALDYN GLASS LIMITED.jpg",
      company_id: "COM000369",
      company_name: "Haldyn Glass ",
      industry: "GLASS",
      display_name: "Haldyn Glass ",
    },
    {
      field_type: "company",
      name: "Halonix",
      field_id: "COM001130",
      website: "http://www.halonix.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HALONIX TECHNOLOGIES PRIVATE LIMITED.png",
      company_id: "COM001130",
      company_name: "Halonix",
      industry: "",
      display_name: "Halonix",
    },
    {
      field_type: "company",
      name: "Hamilton",
      field_id: "COM000370",
      website: "https://www.hamiltonindia.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HAMILTON HOUSEWARES PRIVATE LIMITED.png",
      company_id: "COM000370",
      company_name: "Hamilton",
      industry: "FMCD",
      display_name: "Hamilton",
    },
    {
      field_type: "company",
      name: "Hamon",
      field_id: "COM000371",
      website: "https://www.hamon.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HAMON.svg",
      company_id: "COM000371",
      company_name: "Hamon",
      industry: "CONGLOMERATE",
      display_name: "Hamon",
    },
    {
      field_type: "company",
      name: "Hanjer Biotech",
      field_id: "COM000372",
      website: "http://www.hanjer.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HANJER BIOTECH ENERGIES PRIVATE LIMITED.gif",
      company_id: "COM000372",
      company_name: "Hanjer Biotech",
      industry: "",
      display_name: "Hanjer Biotech",
    },
    {
      field_type: "company",
      name: "Happy Steels  ",
      field_id: "COM000374",
      website: "http://www.happysteels.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HAPPY STEELS PRIVATE LIMITED.jpg",
      company_id: "COM000374",
      company_name: "Happy Steels  ",
      industry: "STEEL",
      display_name: "Happy Steels  ",
    },
    {
      field_type: "company",
      name: "Harihar Alloys  ",
      field_id: "COM001131",
      website: "http://www.hariharalloy.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HARIHAR ALLOYS PRIVATE LIMITED.jpg",
      company_id: "COM001131",
      company_name: "Harihar Alloys  ",
      industry: "",
      display_name: "Harihar Alloys  ",
    },
    {
      field_type: "company",
      name: "Harison Pumps  ",
      field_id: "COM000375",
      website: "https://harisonpump.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HARISON PUMPS PRIVATE LIMITED.png",
      company_id: "COM000375",
      company_name: "Harison Pumps  ",
      industry: "MANUFACTURING",
      display_name: "Harison Pumps  ",
    },
    {
      field_type: "company",
      name: "Harley Davidson Motor Co",
      field_id: "COM000376",
      website: "https://www.harley-davidson.com/in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HARLEY DAVIDSON MOTOR COMPANY INDIA PRIVATE LIMITED.png",
      company_id: "COM000376",
      company_name: "Harley Davidson Motor Co",
      industry: "AUTOMOBILE",
      display_name: "Harley Davidson Motor Co",
    },
    {
      field_type: "company",
      name: "Harman Finochem ",
      field_id: "COM001412",
      website: "http://harmanfinochem.com/",
      group: "",
      logo: "",
      company_id: "COM001412",
      company_name: "Harman Finochem ",
      industry: "",
      display_name: "Harman Finochem ",
    },
    {
      field_type: "company",
      name: "Harrisons Malayalam ",
      field_id: "COM000377",
      website: "https://www.harrisonsmalayalam.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HARRISONS MALAYALAM LIMITED.jpg",
      company_id: "COM000377",
      company_name: "Harrisons Malayalam ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Harrisons Malayalam ",
    },
    {
      field_type: "company",
      name: "Hatsun Agro Product ",
      field_id: "COM000378",
      website: "https://www.hap.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HATSUN AGRO PRODUCT LIMITED.png",
      company_id: "COM000378",
      company_name: "Hatsun Agro Product ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Hatsun Agro Product ",
    },
    {
      field_type: "company",
      name: "Havells",
      field_id: "COM000379",
      website: "https://www.havells.com/#gref",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HAVELLS INDIA LIMITED 2.png",
      company_id: "COM000379",
      company_name: "Havells",
      industry: "ELECTRICALS",
      display_name: "Havells",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Havmor Ice Cream ",
      field_id: "COM000380",
      website: "https://www.havmor.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HAVMOR ICE CREAM LIMITED.png",
      company_id: "COM000380",
      company_name: "Havmor Ice Cream ",
      industry: "FMCG",
      display_name: "Havmor Ice Cream ",
    },
    {
      field_type: "company",
      name: "Hawkins",
      field_id: "COM001132",
      website: "http://www.hawkinscookers.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HAWKINS COOKERS LIMITED.jpg",
      company_id: "COM001132",
      company_name: "Hawkins",
      industry: "",
      display_name: "Hawkins",
    },
    {
      field_type: "company",
      name: "HCL Technologies ",
      field_id: "COM001133",
      website: "https://www.hcltech.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HCL TECHNOLOGIES LIMITED.png",
      company_id: "COM001133",
      company_name: "HCL Technologies ",
      industry: "",
      display_name: "HCL Technologies ",
    },
    {
      field_type: "company",
      name: "Hector Beverages",
      field_id: "COM000384",
      website: "http://www.paperboatdrinks.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HECTOR BEVERAGES PRIVATE LIMITED.png",
      company_id: "COM000384",
      company_name: "Hector Beverages",
      industry: "BREWING",
      display_name: "Hector Beverages",
    },
    {
      field_type: "company",
      name: "HEG",
      field_id: "COM001413",
      website: "https://hegltd.com/",
      group: "",
      logo: "",
      company_id: "COM001413",
      company_name: "HEG",
      industry: "",
      display_name: "HEG",
    },
    {
      field_type: "company",
      name: "Heidelberg Cement",
      field_id: "COM001134",
      website: "http://www.mycemco.com/",
      group: "HEIDELBERGCEMENT Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HEIDELBERGCEMENT INDIA LIMITED..png",
      company_id: "COM001134",
      company_name: "Heidelberg Cement",
      industry: "",
      display_name: "Heidelberg Cement",
    },
    {
      field_type: "company",
      name: "Hemadri Cements ",
      field_id: "COM001414",
      website: "http://www.hemadricements.com/",
      group: "",
      logo: "",
      company_id: "COM001414",
      company_name: "Hemadri Cements ",
      industry: "",
      display_name: "Hemadri Cements ",
    },
    {
      field_type: "company",
      name: "Henkel Adhesives",
      field_id: "COM000386",
      website: "https://www.henkel.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HENKEL ADHESIVES TECHNOLOGIES INDIA PRIVATE LIMITED.svg",
      company_id: "COM000386",
      company_name: "Henkel Adhesives",
      industry: "CHEMICAL",
      display_name: "Henkel Adhesives",
    },
    {
      field_type: "company",
      name: "Herbal Concepts",
      field_id: "COM000387",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000387",
      company_name: "Herbal Concepts",
      industry: "HEALTHCARE",
      display_name: "Herbal Concepts",
    },
    {
      field_type: "company",
      name: "Herbalife",
      field_id: "COM000388",
      website: "https://company.herbalife.co.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HERBALIFE INTERNATIONAL OF AMERICA INCORPORATION.gif",
      company_id: "COM000388",
      company_name: "Herbalife",
      industry: "HEALTHCARE",
      display_name: "Herbalife",
    },
    {
      field_type: "company",
      name: "Hero Motocorp",
      field_id: "COM000389",
      website: "https://www.heromotocorp.com/en-in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HERO MOTOCORP LIMITED.png",
      company_id: "COM000389",
      company_name: "Hero Motocorp",
      industry: "AUTOMOBILE",
      display_name: "Hero Motocorp",
    },
    {
      field_type: "company",
      name: "Hershey",
      field_id: "COM000390",
      website:
        "https://www.thehersheycompany.com/libs/granite/core/content/login.html?resource=%2Fen_us%2F500.html&$$login$$=%24%24login%24%24&j_reason=unknown&j_reason_code=unknown",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HERSHEY INDIA PRIVATE LIMITED.jpg",
      company_id: "COM000390",
      company_name: "Hershey",
      industry: "FMCG",
      display_name: "Hershey",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "HP - Hewlett Packard",
      field_id: "COM000391",
      website: "https://www.hpe.com/in/en/home.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HEWLETT PACKARD ENTERPRISE DEVELOPMENT LP.png",
      company_id: "COM000391",
      company_name: "HP - Hewlett Packard",
      industry: "TECHNOLOGY",
      display_name: "HP - Hewlett Packard",
    },
    {
      field_type: "company",
      name: "Hi Tech Bottling ",
      field_id: "COM000406",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000406",
      company_name: "Hi Tech Bottling ",
      industry: "MANUFACTURING",
      display_name: "Hi Tech Bottling ",
    },
    {
      field_type: "company",
      name: "Hikal ",
      field_id: "COM001415",
      website: "https://www.hikal.com/",
      group: "",
      logo: "",
      company_id: "COM001415",
      company_name: "Hikal ",
      industry: "",
      display_name: "Hikal ",
    },
    {
      field_type: "company",
      name: "HIL",
      field_id: "COM000394",
      website: "https://hil.in/",
      group: "CK BIRLA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HIL LIMITED.png",
      company_id: "COM000394",
      company_name: "HIL",
      industry: "CONGLOMERATE",
      display_name: "HIL",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Hills Cement",
      field_id: "COM001416",
      website: "https://www.tajcement.com/",
      group: "",
      logo: "",
      company_id: "COM001416",
      company_name: "Hills Cement",
      industry: "",
      display_name: "Hills Cement",
    },
    {
      field_type: "company",
      name: "Himadri Chemical ",
      field_id: "COM000395",
      website: "https://www.himadri.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HIMADRI SPECIALITY CHEMICAL LIMITED.svg",
      company_id: "COM000395",
      company_name: "Himadri Chemical ",
      industry: "CHEMICAL",
      display_name: "Himadri Chemical ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Himrag Coir",
      field_id: "COM000396",
      website: "http://www.relaxspring.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HIMRAG COIR PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM000396",
      company_name: "Himrag Coir",
      industry: "MANUFACTURING",
      display_name: "Himrag Coir",
    },
    {
      field_type: "company",
      name: "Hindalco",
      field_id: "COM000397",
      website: "http://www.hindalco.com/",
      group: "ADITYA BIRLA",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDALCO INDUSTRIES LIMITED.png",
      company_id: "COM000397",
      company_name: "Hindalco",
      display_name: "Hindalco",
      sector: "Metals and Mining",
      page_display_status: false,
      industry: "Metals and Mining",
    },
    {
      field_type: "company",
      name: "HAL - Hindustan Aeronautics ",
      field_id: "COM000366",
      website: "https://hal-india.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN AERONAUTICS LIMITED.png",
      company_id: "COM000366",
      company_name: "HAL - Hindustan Aeronautics ",
      industry: "",
      display_name: "HAL - Hindustan Aeronautics ",
    },
    {
      field_type: "company",
      name: "Hindustan Antibiotics ",
      field_id: "COM001417",
      website: "http://www.hindantibiotics.in/",
      group: "",
      logo: "",
      company_id: "COM001417",
      company_name: "Hindustan Antibiotics ",
      industry: "",
      display_name: "Hindustan Antibiotics ",
    },
    {
      field_type: "company",
      name: "Hindustan Coca Cola",
      field_id: "COM000398",
      website: "https://www.hccb.in/en",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN COCA COLA BEVERAGES PRIVATE LIMITED.webp",
      company_id: "COM000398",
      company_name: "Hindustan Coca Cola",
      industry: "BREWING",
      display_name: "Hindustan Coca Cola",
    },
    {
      field_type: "company",
      name: "Hindustan Copper ",
      field_id: "COM000399",
      website: "https://www.hindustancopper.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN COPPER LIMITED.png",
      company_id: "COM000399",
      company_name: "Hindustan Copper ",
      industry: "METALS AND MINING",
      display_name: "Hindustan Copper ",
    },
    {
      field_type: "company",
      name: "Hindustan Insecticides ",
      field_id: "COM001135",
      website: "http://hil.gov.in/HomePage.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN INSECTICIDES LIMITED.gif",
      company_id: "COM001135",
      company_name: "Hindustan Insecticides ",
      industry: "",
      display_name: "Hindustan Insecticides ",
    },
    {
      field_type: "company",
      name: "Hindustan Newsprint ",
      field_id: "COM001136",
      website: "http://www.hnlonline.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN NEWSPRINT LTD.jpg",
      company_id: "COM001136",
      company_name: "Hindustan Newsprint ",
      industry: "",
      display_name: "Hindustan Newsprint ",
    },
    {
      field_type: "company",
      name: "Hindustan Organic Chemicals ",
      field_id: "COM001418",
      website: "http://www.hoclindia.com/",
      group: "",
      logo: "",
      company_id: "COM001418",
      company_name: "Hindustan Organic Chemicals ",
      industry: "",
      display_name: "Hindustan Organic Chemicals ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Hindustan Pencils  ",
      field_id: "COM000400",
      website: "https://www.hindustanpencils.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN PENCILS PRIVATE LIMITED.jpg",
      company_id: "COM000400",
      company_name: "Hindustan Pencils  ",
      industry: "MANUFACTURING",
      display_name: "Hindustan Pencils  ",
    },
    {
      field_type: "company",
      name: "HPCL - Hindustan Petroleum Corporation ",
      field_id: "COM000401",
      website: "https://www.hindustanpetroleum.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN PETROLEUM CORPORATION LIMITED.png",
      company_id: "COM000401",
      company_name: "HPCL - Hindustan Petroleum Corporation ",
      industry: "OIL AND GAS",
      display_name: "HPCL - Hindustan Petroleum Corporation ",
    },
    {
      field_type: "company",
      name: "Hindustan Unilever ",
      field_id: "COM000402",
      website: "https://www.hul.co.in/",
      group: "Unilever",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN UNILEVER LIMITED.png",
      company_id: "COM000402",
      company_name: "Hindustan Unilever ",
      industry: "FMCG",
      display_name: "Hindustan Unilever ",
    },
    {
      field_type: "company",
      name: "HZL - Hindustan Zinc",
      field_id: "COM000403",
      website: "https://www.hzlindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN ZINC LIMITED.jpg",
      company_id: "COM000403",
      company_name: "HZL - Hindustan Zinc",
      industry: "METALS AND MINING",
      display_name: "HZL - Hindustan Zinc",
    },
    {
      field_type: "company",
      name: "HNG - Hindusthan National Glass",
      field_id: "COM000409",
      website: "http://www.hngil.com/",
      group: "HNG Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDUSTAN NATIONAL GLASS & INDUSTRIES LIMITED.jpg",
      company_id: "COM000409",
      company_name: "HNG - Hindusthan National Glass",
      industry: "GLASS",
      display_name: "HNG - Hindusthan National Glass",
    },
    {
      field_type: "company",
      name: "Hindusthan Urban Infra",
      field_id: "COM000404",
      website: "http://hindusthanurban.com/",
      group: "",
      logo: "",
      company_id: "COM000404",
      company_name: "Hindusthan Urban Infra",
      industry: "INFRASTRUCTURE",
      display_name: "Hindusthan Urban Infra",
    },
    {
      field_type: "company",
      name: "Hindware",
      field_id: "COM001097",
      website: "https://www.hindwarehomes.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HINDWARE.png",
      company_id: "COM001097",
      company_name: "Hindware",
      industry: "BUILDING MATERIAL",
      display_name: "Hindware",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Hirotec",
      field_id: "COM001137",
      website: "https://www.hirotecindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HIROTEC INDIA PRIVATE LIMITED.bmp",
      company_id: "COM001137",
      company_name: "Hirotec",
      industry: "",
      display_name: "Hirotec",
    },
    {
      field_type: "company",
      name: "Hitachi ",
      field_id: "COM000405",
      website: "https://www.hitachi.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HITACHI LIMITED.gif",
      company_id: "COM000405",
      company_name: "Hitachi ",
      industry: "CONGLOMERATE",
      display_name: "Hitachi ",
    },
    {
      field_type: "company",
      name: "HLL Lifecare ",
      field_id: "COM001269",
      website: "http://www.lifecarehll.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HLL LIFECARE LIMITED.png",
      company_id: "COM001269",
      company_name: "HLL Lifecare ",
      industry: "",
      display_name: "HLL Lifecare ",
    },
    {
      field_type: "company",
      name: "HMM Infra ",
      field_id: "COM000408",
      website: "http://hmminfra.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HMM INFRA LIMITED.jpg",
      company_id: "COM000408",
      company_name: "HMM Infra ",
      industry: "STEEL",
      display_name: "HMM Infra ",
    },
    {
      field_type: "company",
      name: "HNV Castings  ",
      field_id: "COM000410",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000410",
      company_name: "HNV Castings  ",
      industry: "STEEL",
      display_name: "HNV Castings  ",
    },
    {
      field_type: "company",
      name: "Hofons",
      field_id: "COM001138",
      website: "http://www.hofincons.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HOFINCONS INTERNATIONAL PRIVATE LIMITED.png",
      company_id: "COM001138",
      company_name: "Hofons",
      industry: "",
      display_name: "Hofons",
    },
    {
      field_type: "company",
      name: "Honda Motors",
      field_id: "COM000412",
      website: "https://global.honda/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HONDA MOTOR COMPANY LIMITED.png",
      company_id: "COM000412",
      company_name: "Honda Motors",
      industry: "AUTOMOBILE",
      display_name: "Honda Motors",
    },
    {
      field_type: "company",
      name: "Honeywell Automation",
      field_id: "COM000414",
      website: "https://www.honeywell.com/en-us/global/en-in/hail",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HONEYWELL AUTOMATION INDIA LIMITED.webp",
      company_id: "COM000414",
      company_name: "Honeywell Automation",
      industry: "TECHNOLOGY",
      display_name: "Honeywell Automation",
    },
    {
      field_type: "company",
      name: "HMEL - HPCL Mittal Energy ",
      field_id: "COM000407",
      website: "http://www.hmel.in/about-us",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HPCL MITTAL ENERGY LIMITED.png",
      company_id: "COM000407",
      company_name: "HMEL - HPCL Mittal Energy ",
      industry: "",
      display_name: "HMEL - HPCL Mittal Energy ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000417",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HSIL LIMITED.jpg",
      company_id: "COM000417",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Hsil Limited",
        field_id: "COM000417",
        website: "https://www.hsilgroup.com",
        group: "",
        logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HSIL LIMITED.jpg",
        company_id: "COM000417",
        company_name: "Hsil Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Huber Suhner",
      field_id: "COM000418",
      website: "https://www.hubersuhner.com/en",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HUBER SUHNER.svg",
      company_id: "COM000418",
      company_name: "Huber Suhner",
      industry: "ELECTRONICS",
      display_name: "Huber Suhner",
    },
    {
      field_type: "company",
      name: "Hughes Communications",
      field_id: "COM001122",
      website: "http://www.hughes.in/",
      group: "Hughes Network Systems, LLC (Hughes)",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HUGHES COMMUNICATIONS INDIA LIMITED.jpg",
      company_id: "COM001122",
      company_name: "Hughes Communications",
      industry: "",
      display_name: "Hughes Communications",
    },
    {
      field_type: "company",
      name: "Huhtamaki",
      field_id: "COM000419",
      website:
        "https://www2.huhtamaki.com/web/flexible-packaging-india/huhtamaki-ppl-flexible-packaging-india#/",
      group: "HUHTAMAKI GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HUHTAMAKI PPL LIMITED.jpg",
      company_id: "COM000419",
      company_name: "Huhtamaki",
      industry: "PACKAGING",
      display_name: "Huhtamaki",
    },
    {
      field_type: "company",
      name: "Huntsman",
      field_id: "COM000420",
      website: "https://www.huntsman.com/corporate/a/Home",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HUNTSMAN INTERNATIONAL LLC.bmp",
      company_id: "COM000420",
      company_name: "Huntsman",
      industry: "CHEMICAL",
      display_name: "Huntsman",
    },
    {
      field_type: "company",
      name: "Hyundai Motors",
      field_id: "COM000422",
      website: "https://www.hyundai.com/worldwide/en",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/HYUNDAI MOTOR COMPANY.jpg",
      company_id: "COM000422",
      company_name: "Hyundai Motors",
      industry: "AUTOMOBILE",
      display_name: "Hyundai Motors",
    },
    {
      field_type: "company",
      name: "IAC Electricals  ",
      field_id: "COM000423",
      website: "http://iacelectricals.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/IAC ELECTRICALS PRIVATE LIMITED.png",
      company_id: "COM000423",
      company_name: "IAC Electricals  ",
      industry: "ELECTRICALS",
      display_name: "IAC Electricals  ",
    },
    {
      field_type: "company",
      name: "IBEX Engineering  ",
      field_id: "COM000424",
      website: "http://ibexengineering.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/IBEX ENGINEERING PRIVATE LIMITED.png",
      company_id: "COM000424",
      company_name: "IBEX Engineering  ",
      industry: "MANUFACTURING",
      display_name: "IBEX Engineering  ",
    },
    {
      field_type: "company",
      name: "Idcol Ferro Chrome",
      field_id: "COM001271",
      website: "http://www.ifcal.nic.in/",
      group: "IDCOL",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/IDCOL FERRO CHROME & ALLOYS LIMITED.jpg",
      company_id: "COM001271",
      company_name: "Idcol Ferro Chrome",
      industry: "",
      display_name: "Idcol Ferro Chrome",
    },
    {
      field_type: "company",
      name: "IFB ",
      field_id: "COM000427",
      website: "http://www.ifbindustries.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/IFB INDUSTRIES LIMITED.png",
      company_id: "COM000427",
      company_name: "IFB ",
      industry: "FMCD",
      display_name: "IFB ",
    },
    {
      field_type: "company",
      name: "Ihsedu Agrochem  ",
      field_id: "COM000429",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000429",
      company_name: "Ihsedu Agrochem  ",
      industry: "FMCG",
      display_name: "Ihsedu Agrochem  ",
    },
    {
      field_type: "company",
      name: "Impex Metal",
      field_id: "COM000430",
      website: "http://www.impexmetal.in",
      group: "SKP GROUP",
      logo: "",
      company_id: "COM000430",
      company_name: "Impex Metal",
      industry: "METALS AND MINING",
      display_name: "Impex Metal",
    },
    {
      field_type: "company",
      name: "Inbisco",
      field_id: "COM000431",
      website: "http://inbiscoindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INBISCO INDIA.png",
      company_id: "COM000431",
      company_name: "Inbisco",
      industry: "FMCG",
      display_name: "Inbisco",
    },
    {
      field_type: "company",
      name: "Indag",
      field_id: "COM000432",
      website: "https://indagrubber.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDAG RUBBER LIMITED.png",
      company_id: "COM000432",
      company_name: "Indag",
      industry: "MANUFACTURING",
      display_name: "Indag",
    },
    {
      field_type: "company",
      name: "ICL - Independent Container Line ",
      field_id: "COM000433",
      website: "https://www.icl-ltd.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDEPENDENT CONTAINER LINE LIMITED.png",
      company_id: "COM000433",
      company_name: "ICL - Independent Container Line ",
      industry: "LOGISTICS",
      display_name: "ICL - Independent Container Line ",
    },
    {
      field_type: "company",
      name: "India Cements ",
      field_id: "COM000434",
      website: "https://www.indiacements.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/India Cements Limited.png",
      company_id: "COM000434",
      company_name: "India Cements ",
      display_name: "India Cements ",
      sector: "Cement",
      page_display_status: false,
      industry: "Cement",
    },
    {
      field_type: "company",
      name: "India Glycols ",
      field_id: "COM000435",
      website: "https://www.indiaglycols.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIA GLYCOLS LIMITED.gif",
      company_id: "COM000435",
      company_name: "India Glycols ",
      industry: "CHEMICAL",
      display_name: "India Glycols ",
    },
    {
      field_type: "company",
      name: "India Post",
      field_id: "COM001140",
      website: "https://www.indiapost.gov.in/vas/Pages/IndiaPostHome.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIA POST.svg",
      company_id: "COM001140",
      company_name: "India Post",
      industry: "",
      display_name: "India Post",
    },
    {
      field_type: "company",
      name: "India Yamaha Motor",
      field_id: "COM000436",
      website: "https://www.yamaha-motor-india.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIA YAMAHA MOTOR PRIVATE LIMITED.png",
      company_id: "COM000436",
      company_name: "India Yamaha Motor",
      industry: "AUTOMOBILE",
      display_name: "India Yamaha Motor",
    },
    {
      field_type: "company",
      name: "Indian Additives ",
      field_id: "COM000437",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000437",
      company_name: "Indian Additives ",
      industry: "CHEMICAL",
      display_name: "Indian Additives ",
    },
    {
      field_type: "company",
      name: "Indian Air Force",
      field_id: "COM001080",
      website: "http://indianairforce.nic.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIAN AIR FORCE.png",
      company_id: "COM001080",
      company_name: "Indian Air Force",
      industry: "",
      display_name: "Indian Air Force",
    },
    {
      field_type: "company",
      name: "Indian Cane Power ",
      field_id: "COM001272",
      website: "http://icpluttur.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIAN CANE POWER LIMITED.png",
      company_id: "COM001272",
      company_name: "Indian Cane Power ",
      industry: "",
      display_name: "Indian Cane Power ",
    },
    {
      field_type: "company",
      name: "Indian Farmers Fertiliser Cooperative ",
      field_id: "COM000438",
      website: "http://www.iffco.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIAN FARMERS FERTILISER COOPERATIVE LIMITED.png",
      company_id: "COM000438",
      company_name: "Indian Farmers Fertiliser Cooperative ",
      industry: "CHEMICAL",
      display_name: "Indian Farmers Fertiliser Cooperative ",
    },
    {
      field_type: "company",
      name: "IOCL - Indian Oil Corporation ",
      field_id: "COM000440",
      website: "https://www.iocl.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIAN OIL CORPORATION LIMITED.gif",
      company_id: "COM000440",
      company_name: "IOCL - Indian Oil Corporation ",
      industry: "OIL AND GAS",
      display_name: "IOCL - Indian Oil Corporation ",
    },
    {
      field_type: "company",
      name: "IPCL - Indian Petrochemicals Corporation ",
      field_id: "COM000441",
      website:
        "https://dipam.gov.in/indian-petrochemicals-corporation-ltd-ipcl",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIAN PETROCHEMICALS CORPORATION LIMITED.gif",
      company_id: "COM000441",
      company_name: "IPCL - Indian Petrochemicals Corporation ",
      industry: "OIL AND GAS",
      display_name: "IPCL - Indian Petrochemicals Corporation ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "IRCTC - Indian Railway Catering And Tourism Corporation",
      field_id: "COM000442",
      website: "https://www.irctc.co.in/nget/train-search",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIAN RAILWAY CATERING AND TOURISM CORPORATION.jpg",
      company_id: "COM000442",
      company_name: "IRCTC - Indian Railway Catering And Tourism Corporation",
      industry: "",
      display_name: "IRCTC - Indian Railway Catering And Tourism Corporation",
    },
    {
      field_type: "company",
      name: "Indian Steel Corporation ",
      field_id: "COM001141",
      website: "https://indiansteels.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIAN STEEL CORPORATION LIMITED.jpg",
      company_id: "COM001141",
      company_name: "Indian Steel Corporation ",
      industry: "",
      display_name: "Indian Steel Corporation ",
    },
    {
      field_type: "company",
      name: "Indian Synthetic Rubber  ",
      field_id: "COM000443",
      website: "http://isrl.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDIAN SYNTHETIC RUBBER PRIVATE LIMITED.png",
      company_id: "COM000443",
      company_name: "Indian Synthetic Rubber  ",
      industry: "MANUFACTURING",
      display_name: "Indian Synthetic Rubber  ",
    },
    {
      field_type: "company",
      name: "Indo Borax",
      field_id: "COM000444",
      website: "http://www.indoborax.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDO BORAX AND CHEMICALS LIMITED.jpg",
      company_id: "COM000444",
      company_name: "Indo Borax",
      industry: "CHEMICAL",
      display_name: "Indo Borax",
    },
    {
      field_type: "company",
      name: "Indoco Remedies ",
      field_id: "COM000445",
      website: "http://indoco.com/m/index.asp",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDOCO REMEDIES LIMITED.png",
      company_id: "COM000445",
      company_name: "Indoco Remedies ",
      industry: "PHARMACEUTICAL",
      display_name: "Indoco Remedies ",
    },
    {
      field_type: "company",
      name: "Indofil Industries ",
      field_id: "COM001142",
      website: "https://www.indofil.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDOFIL INDUSTRIES LIMITED.png",
      company_id: "COM001142",
      company_name: "Indofil Industries ",
      industry: "",
      display_name: "Indofil Industries ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Indo Rama",
      field_id: "COM001143",
      website: "http://www.indorama.com/about-us",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDORAMA CORPORATION.png",
      company_id: "COM001143",
      company_name: "Indo Rama",
      display_name: "Indo Rama",
      sector: "Chemical",
      page_display_status: false,
      industry: "Chemical",
    },
    {
      field_type: "company",
      name: "Indus Towers",
      field_id: "COM000446",
      website: "https://www.industowers.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INDUS TOWERS.svg",
      company_id: "COM000446",
      company_name: "Indus Towers",
      industry: "TELECOM",
      display_name: "Indus Towers",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000447",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INEOS STYROLUTION.png",
      company_id: "COM000447",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Ineos Styrolution Group",
        field_id: "COM000447",
        website: "https://www.ineos-styrolution.com/index.html",
        group: "",
        logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INEOS STYROLUTION.png",
        company_id: "COM000447",
        company_name: "Ineos Styrolution Group",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Ineos Styrolution",
      field_id: "COM000908",
      website:
        "https://www.ineosstyrolutionindia.com/INTERSHOP/web/WFS/Styrolution-India-Site/en_US/-/USD/ViewHomepage-Start",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INEOS Styrolution India Limited.png",
      company_id: "COM000908",
      company_name: "Ineos Styrolution",
      industry: "MANUFACTURING",
      display_name: "Ineos Styrolution",
    },
    {
      field_type: "company",
      name: "Croma - Infiniti Retail ",
      field_id: "COM000199",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000199",
      company_name: "Croma - Infiniti Retail ",
      industry: "FMCD",
      display_name: "Croma - Infiniti Retail ",
    },
    {
      field_type: "company",
      name: "Infutec",
      field_id: "COM001116",
      website: "http://infutec.net",
      group: "",
      logo: "",
      company_id: "COM001116",
      company_name: "Infutec",
      industry: "",
      display_name: "Infutec",
    },
    {
      field_type: "company",
      name: "Insulation And Electrical Products  ",
      field_id: "COM001274",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001274",
      company_name: "Insulation And Electrical Products  ",
      industry: "",
      display_name: "Insulation And Electrical Products  ",
    },
    {
      field_type: "company",
      name: "Intas Pharma",
      field_id: "COM000449",
      website: "https://www.intaspharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INTAS PHARMACEUTICALS LIMITED.gif",
      company_id: "COM000449",
      company_name: "Intas Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Intas Pharma",
    },
    {
      field_type: "company",
      name: "Interarch",
      field_id: "COM000450",
      website: "http://www.interarchbuildings.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INTERARCH BUILDING PRODUCTS PRIVATE LIMITED.gif",
      company_id: "COM000450",
      company_name: "Interarch",
      industry: "MANUFACTURING",
      display_name: "Interarch",
    },
    {
      field_type: "company",
      name: "International Cars And Motors ",
      field_id: "COM000451",
      website: "www.imcl.co.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INTERNATIONAL CARS AND MOTORS LIMITED.jpg",
      company_id: "COM000451",
      company_name: "International Cars And Motors ",
      industry: "AUTOMOBILE",
      display_name: "International Cars And Motors ",
    },
    {
      field_type: "company",
      name: "International Paper",
      field_id: "COM001111",
      website: "http://www.internationalpaper.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INTERNATIONAL PAPER INDIA PRIVATE LIMITED.png",
      company_id: "COM001111",
      company_name: "International Paper",
      display_name: "International Paper",
      sector: "Paper",
      page_display_status: false,
      industry: "Paper",
    },
    {
      field_type: "company",
      name: "International Print O Pac ",
      field_id: "COM000452",
      website: "http://www.ippindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INTERNATIONAL PRINT O PAC LIMITED.jpg",
      company_id: "COM000452",
      company_name: "International Print O Pac ",
      industry: "PRINTING AND MINTING",
      display_name: "International Print O Pac ",
    },
    {
      field_type: "company",
      name: "IPCA Laboratories ",
      field_id: "COM001419",
      website: "https://www.ipca.com",
      group: "",
      logo: "",
      company_id: "COM001419",
      company_name: "IPCA Laboratories ",
      industry: "",
      display_name: "IPCA Laboratories ",
    },
    {
      field_type: "company",
      name: "Isarel Chemicals ",
      field_id: "COM000425",
      website: "http://www.icl-group.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ISAREL CHEMICALS LIMITED.png",
      company_id: "COM000425",
      company_name: "Isarel Chemicals ",
      industry: "",
      display_name: "Isarel Chemicals ",
    },
    {
      field_type: "company",
      name: "ISC Projects  ",
      field_id: "COM000454",
      website: "http://iscprojects.co.in/default.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ISC PROJECTS PRIVATE LIMITED.png",
      company_id: "COM000454",
      company_name: "ISC Projects  ",
      industry: "CONSTRUCTION",
      display_name: "ISC Projects  ",
    },
    {
      field_type: "company",
      name: "ISGEC Heavy Engineering ",
      field_id: "COM000455",
      website: "http://www.isgec.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ISGEC HEAVY ENGINEERING LIMITED.jpg",
      company_id: "COM000455",
      company_name: "ISGEC Heavy Engineering ",
      industry: "MANUFACTURING",
      display_name: "ISGEC Heavy Engineering ",
    },
    {
      field_type: "company",
      name: "Isuzu Motors ",
      field_id: "COM000456",
      website: "https://www.isuzu.co.jp/world/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ISUZU MOTORS LIMITED.gif",
      company_id: "COM000456",
      company_name: "Isuzu Motors ",
      industry: "AUTOMOBILE",
      display_name: "Isuzu Motors ",
    },
    {
      field_type: "company",
      name: "Itarsi Oils And Flours ",
      field_id: "COM000513",
      website: "https://kngroup.in",
      group: "",
      logo: "",
      company_id: "COM000513",
      company_name: "Itarsi Oils And Flours ",
      industry: "FMCG",
      display_name: "Itarsi Oils And Flours ",
    },
    {
      field_type: "company",
      name: "ITC",
      field_id: "COM000457",
      website: "https://www.itcportal.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ITC.PNG",
      company_id: "COM000457",
      company_name: "ITC",
      industry: "CONGLOMERATE",
      display_name: "ITC",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "ITW",
      field_id: "COM001144",
      website: "https://www.itw.com/about-itw/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ITW INDIA PRIVATE LIMITED.jpg",
      company_id: "COM001144",
      company_name: "ITW",
      industry: "",
      display_name: "ITW",
    },
    {
      field_type: "company",
      name: "Ivax Paper Chemicals",
      field_id: "COM001113",
      website: "https://www.ivaxchem.com",
      group: "",
      logo: "",
      company_id: "COM001113",
      company_name: "Ivax Paper Chemicals",
      industry: "",
      display_name: "Ivax Paper Chemicals",
    },
    {
      field_type: "company",
      name: "Ivl Dhunseri Petrochem",
      field_id: "COM000458",
      website: "http://ivldhunseri.com/about-us/company-profile/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/IVL DHUNSERI PETROCHEM INDUSTRIES PRIVATE LIMITED.png",
      company_id: "COM000458",
      company_name: "Ivl Dhunseri Petrochem",
      industry: "OIL AND GAS",
      display_name: "Ivl Dhunseri Petrochem",
    },
    {
      field_type: "company",
      name: "Ivp ",
      field_id: "COM000459",
      website: "http://www.ivpindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/IVP LIMITED.jpg",
      company_id: "COM000459",
      company_name: "Ivp ",
      industry: "CHEMICAL",
      display_name: "Ivp ",
    },
    {
      field_type: "company",
      name: "JB Chemicals And Pharma",
      field_id: "COM001420",
      website: "https://www.jbcpl.com/",
      group: "",
      logo: "",
      company_id: "COM001420",
      company_name: "JB Chemicals And Pharma",
      industry: "",
      display_name: "JB Chemicals And Pharma",
    },
    {
      field_type: "company",
      name: "JK Ansell ",
      field_id: "COM001421",
      website: "http://www.jkinvesto.com",
      group: "J K Investo Trade India Limited JKIT",
      logo: "",
      company_id: "COM001421",
      company_name: "JK Ansell ",
      industry: "",
      display_name: "JK Ansell ",
    },
    {
      field_type: "company",
      name: "Jagatjit Industries ",
      field_id: "COM000462",
      website: "http://jagatjit.com/",
      group: "",
      logo: "",
      company_id: "COM000462",
      company_name: "Jagatjit Industries ",
      industry: "BREWING",
      display_name: "Jagatjit Industries ",
    },
    {
      field_type: "company",
      name: "Jagdamba Polymers  ",
      field_id: "COM000463",
      website: "http://ankurwares.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAGDAMBA POLYMERS PRIVATE LIMITED.jpg",
      company_id: "COM000463",
      company_name: "Jagdamba Polymers  ",
      industry: "PLASTICS",
      display_name: "Jagdamba Polymers  ",
    },
    {
      field_type: "company",
      name: "Jaguar Overseas ",
      field_id: "COM000464",
      website: "http://www.jaguaroverseas.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAGUAR OVERSEAS LIMITED.png",
      company_id: "COM000464",
      company_name: "Jaguar Overseas ",
      industry: "AUTOMOBILE",
      display_name: "Jaguar Overseas ",
    },
    {
      field_type: "company",
      name: "Jai Surgicals ",
      field_id: "COM001422",
      website: "https://www.jaisurgicals.com/",
      group: "",
      logo: "",
      company_id: "COM001422",
      company_name: "Jai Surgicals ",
      industry: "",
      display_name: "Jai Surgicals ",
    },
    {
      field_type: "company",
      name: "Jain Irrigation",
      field_id: "COM000466",
      website: "https://www.jains.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAIN IRRIGATION SYSTEMS LIMITED.png",
      company_id: "COM000466",
      company_name: "Jain Irrigation",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Jain Irrigation",
    },
    {
      field_type: "company",
      name: "Jain Steel",
      field_id: "COM000467",
      website: "https://www.jainsteels.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAIN STEEL INDUSTRIES.gif",
      company_id: "COM000467",
      company_name: "Jain Steel",
      industry: "STEEL",
      display_name: "Jain Steel",
    },
    {
      field_type: "company",
      name: "Jao Transmission ",
      field_id: "COM000468",
      website: "http://www.jainco.net/home.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAINCO TRANSMISSION LIMITED.png",
      company_id: "COM000468",
      company_name: "Jao Transmission ",
      industry: "ELECTRICALS",
      display_name: "Jao Transmission ",
    },
    {
      field_type: "company",
      name: "Jaiprakash Associates ",
      field_id: "COM000465",
      website: "http://www.jalindia.com/",
      group: "JAYPEE GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAIPRAKASH ASSOCIATES LIMITED.png",
      company_id: "COM000465",
      company_name: "Jaiprakash Associates ",
      industry: "CONGLOMERATE",
      display_name: "Jaiprakash Associates ",
    },
    {
      field_type: "company",
      name: "Jakson",
      field_id: "COM000469",
      website: "https://www.jakson.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAKSON.jpg",
      company_id: "COM000469",
      company_name: "Jakson",
      industry: "MANUFACTURING",
      display_name: "Jakson",
    },
    {
      field_type: "company",
      name: "Jammu And Kashmir Cements ",
      field_id: "COM001423",
      website: "https://www.jkcl.co.in/",
      group: "",
      logo: "",
      company_id: "COM001423",
      company_name: "Jammu And Kashmir Cements ",
      industry: "",
      display_name: "Jammu And Kashmir Cements ",
    },
    {
      field_type: "company",
      name: "Japan Metal Building Systems  ",
      field_id: "COM000470",
      website: "https://www.japanmetals.net/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAPAN METAL BUILDING SYSTEMS PRIVATE LIMITED.png",
      company_id: "COM000470",
      company_name: "Japan Metal Building Systems  ",
      industry: "MANUFACTURING",
      display_name: "Japan Metal Building Systems  ",
    },
    {
      field_type: "company",
      name: "Jaquar",
      field_id: "COM000471",
      website: "https://www.jaquar.com/products/",
      group: "JAQUAR GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAQUAR AND COMPANY PRIVATE LIMITED.png",
      company_id: "COM000471",
      company_name: "Jaquar",
      industry: "FMCD",
      display_name: "Jaquar",
    },
    {
      field_type: "company",
      name: "Jay Ace",
      field_id: "COM000472",
      website: "http://jpmgroup.co.in/Jay%20Ace%20Technologies.htm",
      group: "JP MAHINDRA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAY ACE TECHNOLOGIES LIMITED.jpg",
      company_id: "COM000472",
      company_name: "Jay Ace",
      industry: "MANUFACTURING",
      display_name: "Jay Ace",
    },
    {
      field_type: "company",
      name: "Jayaswal Neco",
      field_id: "COM000473",
      website: "https://www.jayaswalneco.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAYASWAL NECO INDUSTRIES LIMITED.png",
      company_id: "COM000473",
      company_name: "Jayaswal Neco",
      industry: "MANUFACTURING",
      display_name: "Jayaswal Neco",
    },
    {
      field_type: "company",
      name: "Jaypee Cement ",
      field_id: "COM000474",
      website: "http://www.jalindia.com/gallery-cement.html",
      group: "JAYPEE GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JAYPEE BALAJI CEMENT.png",
      company_id: "COM000474",
      company_name: "Jaypee Cement ",
      industry: "CEMENT",
      display_name: "Jaypee Cement ",
    },
    {
      field_type: "company",
      name: "Jayprakash Cement ",
      field_id: "COM000476",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000476",
      company_name: "Jayprakash Cement ",
      industry: "",
      display_name: "Jayprakash Cement ",
    },
    {
      field_type: "company",
      name: "JBM Auto ",
      field_id: "COM000477",
      website: "http://www.jbmgroup.com/JBM-Auto-Ltd.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JBM AUTO LIMITED.png",
      company_id: "COM000477",
      company_name: "JBM Auto ",
      industry: "AUTOMOBILE",
      display_name: "JBM Auto ",
    },
    {
      field_type: "company",
      name: "JCB",
      field_id: "COM000478",
      website: "https://www.jcb.com/en-in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JCB INDIA LIMITED.png",
      company_id: "COM000478",
      company_name: "JCB",
      industry: "AUTOMOBILE",
      display_name: "JCB",
    },
    {
      field_type: "company",
      name: "Jindal Group",
      field_id: "COM000480",
      website: "http://www.jindalgroup.com/",
      group: "JINDAL GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JINDAL GROUP.gif",
      company_id: "COM000480",
      company_name: "Jindal Group",
      industry: "",
      display_name: "Jindal Group",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Jindal Industries ",
      field_id: "COM001073",
      website: "http://www.jindalinds.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JINDAL INDUSTRIES PRIVATE LIMITED.png",
      company_id: "COM001073",
      company_name: "Jindal Industries ",
      industry: "",
      display_name: "Jindal Industries ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Jindal Stainless ",
      field_id: "COM000479",
      website: "https://www.jindalstainless.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JINDAL STAINLESS LIMITED.png",
      company_id: "COM000479",
      company_name: "Jindal Stainless ",
      industry: "STEEL",
      display_name: "Jindal Stainless ",
    },
    {
      field_type: "company",
      name: "Jindal Steel And Power ",
      field_id: "COM000481",
      website: "https://www.jindalsteelpower.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JINDAL STEEL AND POWER LIMITED.png",
      company_id: "COM000481",
      company_name: "Jindal Steel And Power ",
      industry: "STEEL",
      display_name: "Jindal Steel And Power ",
    },
    {
      field_type: "company",
      name: "JK Cement ",
      field_id: "COM000460",
      website: "https://www.jkcement.com/home",
      group: "JK GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JK CEMENT LIMITED.png",
      company_id: "COM000460",
      company_name: "JK Cement ",
      display_name: "JK Cement ",
      sector: "Cement",
      page_display_status: false,
      industry: "Cement",
    },
    {
      field_type: "company",
      name: "JK Lakshmi Cement ",
      field_id: "COM001424",
      website: "http://www.jklakshmicement.com/",
      group: " JK Organisation",
      logo: "",
      company_id: "COM001424",
      company_name: "JK Lakshmi Cement ",
      industry: "",
      display_name: "JK Lakshmi Cement ",
    },
    {
      field_type: "company",
      name: "JK Paper ",
      field_id: "COM001145",
      website: "https://www.jkpaper.com/",
      group: "JK Organizations",
      logo: "",
      company_id: "COM001145",
      company_name: "JK Paper ",
      industry: "",
      display_name: "JK Paper ",
    },
    {
      field_type: "company",
      name: "JK Tyre And Industries ",
      field_id: "COM000482",
      website: "https://www.jktyre.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JK TYRE AND INDUSTRIES LIMITED.jpg",
      company_id: "COM000482",
      company_name: "JK Tyre And Industries ",
      display_name: "JK Tyre And Industries ",
      sector: "Tyre",
      page_display_status: false,
      industry: "Tyre",
    },
    {
      field_type: "company",
      name: "JK White Cement",
      field_id: "COM001425",
      website: "https://www.jkwhitecement.com/",
      group: "JK Cement Ltd.",
      logo: "",
      company_id: "COM001425",
      company_name: "JK White Cement",
      industry: "",
      display_name: "JK White Cement",
    },
    {
      field_type: "company",
      name: "JMC Projects",
      field_id: "COM000484",
      website: "https://www.jmcprojects.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JMC PROJECTS INDIA LIMITED.png",
      company_id: "COM000484",
      company_name: "JMC Projects",
      industry: "CONSTRUCTION",
      display_name: "JMC Projects",
    },
    {
      field_type: "company",
      name: "JMD Oils  ",
      field_id: "COM001146",
      website: "https://www.jmdoils.com/",
      group: "JMD Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JMD OILS PRIVATE LIMITED.gif",
      company_id: "COM001146",
      company_name: "JMD Oils  ",
      industry: "",
      display_name: "JMD Oils  ",
    },
    {
      field_type: "company",
      name: "JMT Enterprises  ",
      field_id: "COM000461",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000461",
      company_name: "JMT Enterprises  ",
      industry: "FMCG",
      display_name: "JMT Enterprises  ",
    },
    {
      field_type: "company",
      name: "JOCIL",
      field_id: "COM001147",
      website: "http://jocil.in/joc.htm",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JOCIL LIMITED.jpg",
      company_id: "COM001147",
      company_name: "JOCIL",
      industry: "",
      display_name: "JOCIL",
    },
    {
      field_type: "company",
      name: "Johnson And Johnson  ",
      field_id: "COM000486",
      website: "https://www.jnj.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Johnson%20And%20Johnson.jpg",
      company_id: "COM000486",
      company_name: "Johnson And Johnson  ",
      industry: "CONGLOMERATE",
      display_name: "J&J - Johnson And Johnson  ",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Johnson Controls",
      field_id: "COM000487",
      website: "https://www.johnsoncontrols.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JOHNSON CONTROLS.png",
      company_id: "COM000487",
      company_name: "Johnson Controls",
      industry: "MANUFACTURING",
      display_name: "Johnson Controls",
    },
    {
      field_type: "company",
      name: "JSW Cement ",
      field_id: "COM000488",
      website: "https://www.jsw.in/groups",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JSW CEMENT LIMITED.jpeg",
      company_id: "COM000488",
      company_name: "JSW Cement ",
      industry: "CEMENT",
      display_name: "JSW Cement ",
    },
    {
      field_type: "company",
      name: "JSW Group",
      field_id: "COM001074",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001074",
      company_name: "JSW Group",
      industry: "",
      display_name: "JSW Group",
    },
    {
      field_type: "company",
      name: "JSW Severfield Structures ",
      field_id: "COM001075",
      website: "https://www.jssl.in/",
      group: "JSW Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JSW SEVERFIELD STRUCTURES LIMITED.png",
      company_id: "COM001075",
      company_name: "JSW Severfield Structures ",
      industry: "",
      display_name: "JSW Severfield Structures ",
    },
    {
      field_type: "company",
      name: "JSW Steel Coated Products ",
      field_id: "COM001148",
      website: "https://www.jsw.in/steel/about-us",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JSW STEEL COATED PRODUCTS LIMITED.jpeg",
      company_id: "COM001148",
      company_name: "JSW Steel Coated Products ",
      industry: "",
      display_name: "JSW Steel Coated Products ",
    },
    {
      field_type: "company",
      name: "JSW Steel ",
      field_id: "COM000489",
      website: "https://www.jsw.in/",
      group: "JSW Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JSW STEEL LIMITED.png",
      company_id: "COM000489",
      company_name: "JSW Steel ",
      display_name: "JSW Steel ",
      sector: "Steel",
      page_display_status: false,
      industry: "Steel",
    },
    {
      field_type: "company",
      name: "Jubilant Generics ",
      field_id: "COM000490",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000490",
      company_name: "Jubilant Generics ",
      industry: "MANUFACTURING",
      display_name: "Jubilant Generics ",
    },
    {
      field_type: "company",
      name: "Jubilant Industries ",
      field_id: "COM001275",
      website: "https://www.jubilantindustries.com/",
      group: "Jubilant Bhartia group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JUBILANT INDUSTRIES LIMITED.jpg",
      company_id: "COM001275",
      company_name: "Jubilant Industries ",
      industry: "",
      display_name: "Jubilant Industries ",
    },
    {
      field_type: "company",
      name: "Jubilant Life Sciences ",
      field_id: "COM001149",
      website: "https://www.jubl.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JUBILANT LIFE SCIENCES LIMITED.png",
      company_id: "COM001149",
      company_name: "Jubilant Life Sciences ",
      industry: "",
      display_name: "Jubilant Life Sciences ",
    },
    {
      field_type: "company",
      name: "JVL Agro Industries ",
      field_id: "COM000492",
      website: "http://www.jvlagro.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JVL AGRO INDUSTRIES LIMITED.png",
      company_id: "COM000492",
      company_name: "JVL Agro Industries ",
      industry: "FMCG",
      display_name: "JVL Agro Industries ",
    },
    {
      field_type: "company",
      name: "Jyothy Labs",
      field_id: "COM000483",
      website: "http://www.jyothylaboratories.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/JYOTHY LABORATORIES LIMITED.png",
      company_id: "COM000483",
      company_name: "Jyothy Labs",
      display_name: "Jyothy Labs",
      sector: "FMCG",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "K And D Engineering",
      field_id: "COM000493",
      website: "http://kdeng.com/",
      group: "",
      logo: "",
      company_id: "COM000493",
      company_name: "K And D Engineering",
      industry: "CONSTRUCTION",
      display_name: "K And D Engineering",
    },
    {
      field_type: "company",
      name: "KAG",
      field_id: "COM001150",
      website: "https://www.kagindia.com/company-overview/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KAG INDIA PRIVATE LIMITED.png",
      company_id: "COM001150",
      company_name: "KAG",
      industry: "",
      display_name: "KAG",
    },
    {
      field_type: "company",
      name: "Kajaria Ceramics ",
      field_id: "COM000494",
      website: "https://www.kajariaceramics.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KAJARIA CERAMICS LIMITED.png",
      company_id: "COM000494",
      company_name: "Kajaria Ceramics ",
      industry: "CERAMICS",
      display_name: "Kajaria Ceramics ",
    },
    {
      field_type: "company",
      name: "Kakatiya Cement",
      field_id: "COM001426",
      website: "http://www.kakatiyacements.com/",
      group: "",
      logo: "",
      company_id: "COM001426",
      company_name: "Kakatiya Cement",
      industry: "",
      display_name: "Kakatiya Cement",
    },
    {
      field_type: "company",
      name: "Kaleesuwari Refinery  ",
      field_id: "COM000495",
      website: "http://kaleesuwari.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KALEESUWARI REFINERY PRIVATE LIMITED.png",
      company_id: "COM000495",
      company_name: "Kaleesuwari Refinery  ",
      industry: "FMCG",
      display_name: "Kaleesuwari Refinery  ",
    },
    {
      field_type: "company",
      name: "Kalpataru Power Transmission ",
      field_id: "COM000496",
      website: "https://kalpatarupower.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KALPATARU POWER TRANSMISSION LIMITED.jpg",
      company_id: "COM000496",
      company_name: "Kalpataru Power Transmission ",
      industry: "CONSTRUCTION",
      display_name: "Kalpataru Power Transmission ",
    },
    {
      field_type: "company",
      name: "Kalyani Steels ",
      field_id: "COM001152",
      website: "http://www.kalyanisteels.com/",
      group: "Kalyani Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KALYANI STEELS LIMITED.jpg",
      company_id: "COM001152",
      company_name: "Kalyani Steels ",
      industry: "",
      display_name: "Kalyani Steels ",
    },
    {
      field_type: "company",
      name: "Kalyanpur Cements ",
      field_id: "COM000497",
      website: "https://www.kalyanpur.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KALYANPUR CEMENTS LIMITED.jpg",
      company_id: "COM000497",
      company_name: "Kalyanpur Cements ",
      industry: "CEMENT",
      display_name: "Kalyanpur Cements ",
    },
    {
      field_type: "company",
      name: "Kamani Oil",
      field_id: "COM000498",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000498",
      company_name: "Kamani Oil",
      industry: "FMCG",
      display_name: "Kamani Oil",
    },
    {
      field_type: "company",
      name: "Kandhari Beverages  ",
      field_id: "COM001112",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001112",
      company_name: "Kandhari Beverages  ",
      industry: "",
      display_name: "Kandhari Beverages  ",
    },
    {
      field_type: "company",
      name: "Kansai Nerolac Paints ",
      field_id: "COM000499",
      website: "https://www.nerolac.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KANSAI NEROLAC PAINTS LIMITED.png",
      company_id: "COM000499",
      company_name: "Kansai Nerolac Paints ",
      industry: "PAINTS",
      display_name: "Kansai Nerolac Paints ",
    },
    {
      field_type: "company",
      name: "Karamtara Engineering  ",
      field_id: "COM000500",
      website: "http://www.karamtara.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KARAMTARA ENGINEERING PRIVATE LIMITED.gif",
      company_id: "COM000500",
      company_name: "Karamtara Engineering  ",
      industry: "MANUFACTURING",
      display_name: "Karamtara Engineering  ",
    },
    {
      field_type: "company",
      name: "Karnataka Agro Chemicals  ",
      field_id: "COM001153",
      website: "",
      group: "Multiplex Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KARNATAKA AGRO CHEMICALS PRIVATE LIMITED.png",
      company_id: "COM001153",
      company_name: "Karnataka Agro Chemicals  ",
      industry: "",
      display_name: "Karnataka Agro Chemicals  ",
    },
    {
      field_type: "company",
      name: "Kmf Nandini -  Karnataka Cooperative Milk Federation ",
      field_id: "COM000501",
      website: "https://www.kmfnandini.coop/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KARNATAKA COOPERATIVE MILK PRODUCERS FEDERATION LIMITED.png",
      company_id: "COM000501",
      company_name: "Kmf Nandini -  Karnataka Cooperative Milk Federation ",
      industry: "FMCG",
      display_name: "Kmf Nandini -  Karnataka Cooperative Milk Federation ",
    },
    {
      field_type: "company",
      name: "Kaslikar Hardware",
      field_id: "COM000502",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000502",
      company_name: "Kaslikar Hardware",
      industry: "FMCD",
      display_name: "Kaslikar Hardware",
    },
    {
      field_type: "company",
      name: "Katwa Cements  ",
      field_id: "COM001427",
      website: "http://katwa.in/",
      group: "",
      logo: "",
      company_id: "COM001427",
      company_name: "Katwa Cements  ",
      industry: "",
      display_name: "Katwa Cements  ",
    },
    {
      field_type: "company",
      name: "Kay Bouvet Engineering ",
      field_id: "COM000503",
      website: "https://www.kaybouvet.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KAY BOUVET ENGINEERING LIMITED.png",
      company_id: "COM000503",
      company_name: "Kay Bouvet Engineering ",
      industry: "MANUFACTURING",
      display_name: "Kay Bouvet Engineering ",
    },
    {
      field_type: "company",
      name: "Kaya ",
      field_id: "COM001154",
      website: "https://www.kaya.in/contact-us",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KAYA LIMITED.png",
      company_id: "COM001154",
      company_name: "Kaya ",
      industry: "",
      display_name: "Kaya ",
    },
    {
      field_type: "company",
      name: "KCC Paint",
      field_id: "COM000504",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000504",
      company_name: "KCC Paint",
      industry: "PAINTS",
      display_name: "KCC Paint",
    },
    {
      field_type: "company",
      name: "KEC International ",
      field_id: "COM000505",
      website: "https://www.kecrpg.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KEC INTERNATIONAL LIMITED.jpg",
      company_id: "COM000505",
      company_name: "KEC International ",
      industry: "CONSTRUCTION",
      display_name: "KEC International ",
    },
    {
      field_type: "company",
      name: "Keerthi Industries ",
      field_id: "COM001428",
      website: "http://www.keerthiindustries.com/",
      group: "",
      logo: "",
      company_id: "COM001428",
      company_name: "Keerthi Industries ",
      industry: "",
      display_name: "Keerthi Industries ",
    },
    {
      field_type: "company",
      name: "KEI Industries ",
      field_id: "COM001155",
      website: "https://www.kei-ind.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KEI INDUSTRIES LIMITED.png",
      company_id: "COM001155",
      company_name: "KEI Industries ",
      industry: "",
      display_name: "KEI Industries ",
    },
    {
      field_type: "company",
      name: "Kekule Pharma ",
      field_id: "COM001429",
      website: "http://www.kekulepharma.com",
      group: "",
      logo: "",
      company_id: "COM001429",
      company_name: "Kekule Pharma ",
      industry: "",
      display_name: "Kekule Pharma ",
    },
    {
      field_type: "company",
      name: "Kellogg",
      field_id: "COM000506",
      website: "https://www.kelloggs.in/en_IN/home.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KELLOGG INDIA PRIVATE LIMITED.png",
      company_id: "COM000506",
      company_name: "Kellogg",
      display_name: "Kellogg",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Kemwell Biopharma  ",
      field_id: "COM000507",
      website: "https://www.kemwellbiopharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KEMWELL BIOPHARMA PRIVATE LIMITED.png",
      company_id: "COM000507",
      company_name: "Kemwell Biopharma  ",
      industry: "PHARMACEUTICAL",
      display_name: "Kemwell Biopharma  ",
    },
    {
      field_type: "company",
      name: "Kent RO",
      field_id: "COM000508",
      website: "https://www.kent.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KENT RO SYSTEMS LIMITED.png",
      company_id: "COM000508",
      company_name: "Kent RO",
      industry: "FMCD",
      display_name: "Kent RO",
    },
    {
      field_type: "company",
      name: "Keshri Industries",
      field_id: "COM000509",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000509",
      company_name: "Keshri Industries",
      industry: "FASHION AND CLOTHING",
      display_name: "Keshri Industries",
    },
    {
      field_type: "company",
      name: "Kesoram Cement ",
      field_id: "COM000511",
      website: "https://www.kesocorp.com/DOCS/home.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KESORAM CEMENT LIMITED.png",
      company_id: "COM000511",
      company_name: "Kesoram Cement ",
      industry: "CEMENT",
      display_name: "Kesoram Cement ",
    },
    {
      field_type: "company",
      name: "Keventer Agro ",
      field_id: "COM000512",
      website: "https://www.keventer.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KEVENTER AGRO LIMITED.png",
      company_id: "COM000512",
      company_name: "Keventer Agro ",
      industry: "FMCG",
      display_name: "Keventer Agro ",
    },
    {
      field_type: "company",
      name: "Khanna Paper Mills  ",
      field_id: "COM001276",
      website: "http://www.khannapaper.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KHANNA PAPER MILLS PRIVATE LIMITED.png",
      company_id: "COM001276",
      company_name: "Khanna Paper Mills  ",
      industry: "",
      display_name: "Khanna Paper Mills  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Kido Enterprises",
      field_id: "COM000514",
      website: "https://kidoenterprises.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KIDO ENTERPRISES.png",
      company_id: "COM000514",
      company_name: "Kido Enterprises",
      industry: "MANUFACTURING",
      display_name: "Kido Enterprises",
    },
    {
      field_type: "company",
      name: "Kirby Building Systems",
      field_id: "COM000515",
      website: "http://www.kirbybuildingsystems.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KIRBY BUILDING SYSTEMS.png",
      company_id: "COM000515",
      company_name: "Kirby Building Systems",
      industry: "MANUFACTURING",
      display_name: "Kirby Building Systems",
    },
    {
      field_type: "company",
      name: "Kirloskar Oil Engines ",
      field_id: "COM000516",
      website: "http://koel.kirloskar.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KIRLOSKAR OIL ENGINES LIMITED.png",
      company_id: "COM000516",
      company_name: "Kirloskar Oil Engines ",
      industry: "AUTOMOBILE",
      display_name: "Kirloskar Oil Engines ",
    },
    {
      field_type: "company",
      name: "Kkalpana Industries",
      field_id: "COM001076",
      website: "https://kkalpanagroup.com/",
      group: "Kkalpana Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KKALPANA INDUSTRIES INDIA LIMITED.png",
      company_id: "COM001076",
      company_name: "Kkalpana Industries",
      industry: "",
      display_name: "Kkalpana Industries",
    },
    {
      field_type: "company",
      name: "KKG Industries  ",
      field_id: "COM000517",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000517",
      company_name: "KKG Industries  ",
      industry: "ELECTRICALS",
      display_name: "KKG Industries  ",
    },
    {
      field_type: "company",
      name: "KLJ Polymers",
      field_id: "COM001077",
      website: "http://kljgroup.com/aboutus.html",
      group: "KLJ Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KLJ POLYMERS AND CHEMICALS LIMITED.png",
      company_id: "COM001077",
      company_name: "KLJ Polymers",
      industry: "",
      display_name: "KLJ Polymers",
    },
    {
      field_type: "company",
      name: "Kobelco Construction Equipment",
      field_id: "COM000519",
      website: "https://www.kobelco-in.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KOBELCO CONSTRUCTION MACHINERY EUROPE B V.png",
      company_id: "COM000519",
      company_name: "Kobelco Construction Equipment",
      industry: "MANUFACTURING",
      display_name: "Kobelco Construction Equipment",
    },
    {
      field_type: "company",
      name: "Komatsu ",
      field_id: "COM000520",
      website: "https://home.komatsu/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KOMATSU LIMITED.png",
      company_id: "COM000520",
      company_name: "Komatsu ",
      industry: "MANUFACTURING",
      display_name: "Komatsu ",
    },
    {
      field_type: "company",
      name: "Kone Elevator ",
      field_id: "COM000521",
      website: "https://www.kone.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KONE ELEVATOR INDIA PRIVATE LIMITED.webp",
      company_id: "COM000521",
      company_name: "Kone Elevator ",
      industry: "MANUFACTURING",
      display_name: "Kone Elevator ",
    },
    {
      field_type: "company",
      name: "Kongsberg Maritime",
      field_id: "COM001156",
      website:
        "https://www.km.kongsberg.com/ks/web/nobkj0407.nsf/WebKongsbergSubsidiariesCountry?ReadForm&Cat=India",
      group: "Kongsberg Gruppen (KOG)",
      logo: "",
      company_id: "COM001156",
      company_name: "Kongsberg Maritime",
      industry: "",
      display_name: "Kongsberg Maritime",
    },
    {
      field_type: "company",
      name: "Koppert Biological Systems",
      field_id: "COM001123",
      website: "https://www.koppert.in/",
      group: "Koppert B.V.",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KOPPERT BIOLOGICAL SYSTEMS INDIA PRIVATE LIMITED.png",
      company_id: "COM001123",
      company_name: "Koppert Biological Systems",
      industry: "",
      display_name: "Koppert Biological Systems",
    },
    {
      field_type: "company",
      name: "Kopran ",
      field_id: "COM001430",
      website: "http://www.kopran.com/",
      group: "",
      logo: "",
      company_id: "COM001430",
      company_name: "Kopran ",
      industry: "",
      display_name: "Kopran ",
    },
    {
      field_type: "company",
      name: "Heinz",
      field_id: "COM000385",
      website: "http://www.heinz.co.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KRAFT HEINZ INDIA PRIVATE LIMITED.jpg",
      company_id: "COM000385",
      company_name: "Heinz",
      display_name: "Heinz",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Kris Flexipacks  ",
      field_id: "COM000522",
      website: "https://www.krisflexipacks.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KRIS FLEXIPACKS PRIVATE LIMITED.png",
      company_id: "COM000522",
      company_name: "Kris Flexipacks  ",
      industry: "PACKAGING",
      display_name: "Kris Flexipacks  ",
    },
    {
      field_type: "company",
      name: "Krishak Bharathi Cooperative ",
      field_id: "COM000523",
      website: "https://www.kribhco.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KRISHAK BHARATHI COOPERATIVE LIMITED.png",
      company_id: "COM000523",
      company_name: "Krishak Bharathi Cooperative ",
      industry: "",
      display_name: "Krishak Bharathi Cooperative ",
    },
    {
      field_type: "company",
      name: "Krishi Rasayan Exports  ",
      field_id: "COM000524",
      website: "http://www.krishirasayan.com/krishirasayan/",
      group: "KRISHI RAASAYAN GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KRISHI RASAYAN EXPORTS PRIVATE LIMITED.jpg",
      company_id: "COM000524",
      company_name: "Krishi Rasayan Exports  ",
      industry: "CHEMICAL",
      display_name: "Krishi Rasayan Exports  ",
    },
    {
      field_type: "company",
      name: "Krishna Cement Products",
      field_id: "COM000525",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000525",
      company_name: "Krishna Cement Products",
      industry: "CEMENT",
      display_name: "Krishna Cement Products",
    },
    {
      field_type: "company",
      name: "Kriti Industries",
      field_id: "COM000526",
      website: "http://www.kritiindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KRITI INDUSTRIES INDIA LIMITED.png",
      company_id: "COM000526",
      company_name: "Kriti Industries",
      industry: "PLASTICS",
      display_name: "Kriti Industries",
    },
    {
      field_type: "company",
      name: "Kubota Agricultural Machinery ",
      field_id: "COM000527",
      website: "https://www.kubota.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KUBOTA AGRICULTURAL MACHINERY INDIA PRIVATE LIMITED.png",
      company_id: "COM000527",
      company_name: "Kubota Agricultural Machinery ",
      industry: "MANUFACTURING",
      display_name: "Kubota Agricultural Machinery ",
    },
    {
      field_type: "company",
      name: "Kudremukh Iron And Steel Company ",
      field_id: "COM001157",
      website: "https://www.kioclltd.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KUDREMUKH IRON AND STEEL COMPANY LIMITED.png",
      company_id: "COM001157",
      company_name: "Kudremukh Iron And Steel Company ",
      industry: "",
      display_name: "Kudremukh Iron And Steel Company ",
    },
    {
      field_type: "company",
      name: "Kunal Remedies  ",
      field_id: "COM001078",
      website: "http://www.krplindia.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KUNAL REMEDIES PRIVATE LIMITED.png",
      company_id: "COM001078",
      company_name: "Kunal Remedies  ",
      industry: "",
      display_name: "Kunal Remedies  ",
    },
    {
      field_type: "company",
      name: "Kunnath Paper Mills  ",
      field_id: "COM001158",
      website: "http://kunnathpapermill.com/contact-us/",
      group: " ",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KUNNATH PAPER MILLS PRIVATE LIMITED.jpg",
      company_id: "COM001158",
      company_name: "Kunnath Paper Mills  ",
      industry: "",
      display_name: "Kunnath Paper Mills  ",
    },
    {
      field_type: "company",
      name: "Kurlon",
      field_id: "COM000529",
      website: "https://www.kurlon.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KURLON.png",
      company_id: "COM000529",
      company_name: "Kurlon",
      industry: "MANUFACTURING",
      display_name: "Kurlon",
    },
    {
      field_type: "company",
      name: "Kusum Healthcare  ",
      field_id: "COM001431",
      website: "http://www.kusumhealthcare.com/",
      group: "",
      logo: "",
      company_id: "COM001431",
      company_name: "Kusum Healthcare  ",
      industry: "",
      display_name: "Kusum Healthcare  ",
    },
    {
      field_type: "company",
      name: "Kwality ",
      field_id: "COM000530",
      website: "https://www.kwality.com/#pro3",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KWALITY LIMITED.jpg",
      company_id: "COM000530",
      company_name: "Kwality ",
      industry: "FMCG",
      display_name: "Kwality ",
    },
    {
      field_type: "company",
      name: "Kyocera Corporation",
      field_id: "COM000531",
      website: "https://global.kyocera.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/KYOCERA CORPORATION.gif",
      company_id: "COM000531",
      company_name: "Kyocera Corporation",
      industry: "ELECTRONICS",
      display_name: "Kyocera Corporation",
    },
    {
      field_type: "company",
      name: "Larsen And Toubro (L&T) Geo Structure",
      field_id: "COM000533",
      website: "https://www.lntecc.com/homepage/GeoStructure/home.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LARSEN AND TOUBRO GEO STRUCTURE.jpg",
      company_id: "COM000533",
      company_name: "Larsen And Toubro (L&T) Geo Structure",
      industry: "CONSTRUCTION",
      display_name: "Larsen And Toubro (L&T) Geo Structure",
    },
    {
      field_type: "company",
      name: "Larsen And Toubro (L&T) Hydrocarbon Engineering",
      field_id: "COM000534",
      website: "http://www.lnthydrocarbon.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LARSEN AND TOUBRO HYDROCARBON ENGINEERING.jpg",
      company_id: "COM000534",
      company_name: "Larsen And Toubro (L&T) Hydrocarbon Engineering",
      industry: "ENGINEERING SERVICES",
      display_name: "Larsen And Toubro (L&T) Hydrocarbon Engineering",
    },
    {
      field_type: "company",
      name: "Labguard",
      field_id: "COM001159",
      website: "http://www.labguard.biz/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LABGUARD INDIA PRIVATE LIMITED.png",
      company_id: "COM001159",
      company_name: "Labguard",
      industry: "",
      display_name: "Labguard",
    },
    {
      field_type: "company",
      name: "Lafarge",
      field_id: "COM000535",
      website: "https://www.lafargeholcim.com/directory",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LAFARGE INDIA LIMITED.jpg",
      company_id: "COM000535",
      company_name: "Lafarge",
      industry: "CEMENT",
      display_name: "Lafarge",
    },
    {
      field_type: "company",
      name: "Larsen And Toubro (L&T) ",
      field_id: "COM000536",
      website: "http://www.larsentoubro.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LARSEN AND TOUBRO LIMITED.jpg",
      company_id: "COM000536",
      company_name: "Larsen And Toubro (L&T) ",
      industry: "CONGLOMERATE",
      display_name: "Larsen And Toubro (L&T) ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Lava International ",
      field_id: "COM000537",
      website: "https://www.lavamobiles.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LAVA INTERNATIONAL LIMITED.png",
      company_id: "COM000537",
      company_name: "Lava International ",
      industry: "TECHNOLOGY",
      display_name: "Lava International ",
    },
    {
      field_type: "company",
      name: "Le Crueset",
      field_id: "COM000538",
      website: "https://www.le-creuset.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LE CRUESET INDIA PRIVATE LIMITED.png",
      company_id: "COM000538",
      company_name: "Le Crueset",
      industry: "FMCD",
      display_name: "Le Crueset",
    },
    {
      field_type: "company",
      name: "Lear Corporation",
      field_id: "COM000539",
      website: "https://www.lear.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LEAR CORPORATION.png",
      company_id: "COM000539",
      company_name: "Lear Corporation",
      industry: "AUTOMOBILE",
      display_name: "Lear Corporation",
    },
    {
      field_type: "company",
      name: "Lebracs Rubber  ",
      field_id: "COM000540",
      website: "https://www.lebracsrubber.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LEBRACS RUBBER PRIVATE LIMITED.png",
      company_id: "COM000540",
      company_name: "Lebracs Rubber  ",
      industry: "MANUFACTURING",
      display_name: "Lebracs Rubber  ",
    },
    {
      field_type: "company",
      name: "Lee Pharmaceuticals",
      field_id: "COM001432",
      website: "http://leepharma.com/",
      group: "",
      logo: "",
      company_id: "COM001432",
      company_name: "Lee Pharmaceuticals",
      industry: "",
      display_name: "Lee Pharmaceuticals",
    },
    {
      field_type: "company",
      name: "Legrand",
      field_id: "COM000541",
      website: "https://www.legrand.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LEGRAND.png",
      company_id: "COM000541",
      company_name: "Legrand",
      display_name: "Legrand",
      sector: "Electronics",
      page_display_status: false,
      industry: "Electronics",
    },
    {
      field_type: "company",
      name: "Lenovo",
      field_id: "COM001101",
      website: "https://www.lenovo.com",
      group: "",
      logo: "",
      company_id: "COM001101",
      company_name: "Lenovo",
      industry: "",
      display_name: "Lenovo",
    },
    {
      field_type: "company",
      name: "LG Electronics",
      field_id: "COM000542",
      website: "https://www.lg.com/in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LG ELECTRONICS INDIA PRIVATE LIMITED.png",
      company_id: "COM000542",
      company_name: "LG Electronics",
      industry: "ELECTRONICS",
      display_name: "LG Electronics",
    },
    {
      field_type: "company",
      name: "Lifestyle",
      field_id: "COM000543",
      website: "https://www.lifestylestores.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LIFESTYLE.svg",
      company_id: "COM000543",
      company_name: "Lifestyle",
      industry: "FASHION AND CLOTHING",
      display_name: "Lifestyle",
    },
    {
      field_type: "company",
      name: "Loln Pharma",
      field_id: "COM000544",
      website: "https://www.lincolnpharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LINCOLN PHARMACEUTICALS LIMITED.png",
      company_id: "COM000544",
      company_name: "Loln Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Loln Pharma",
    },
    {
      field_type: "company",
      name: "Lineage Power  ",
      field_id: "COM000545",
      website: "http://lineagepowersystems.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LINEAGE POWER PRIVATE LIMITED.png",
      company_id: "COM000545",
      company_name: "Lineage Power  ",
      industry: "MANUFACTURING",
      display_name: "Lineage Power  ",
    },
    {
      field_type: "company",
      name: "Lion Polymers",
      field_id: "COM000546",
      website: "http://www.lionpolymers.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LION POLYMERS INCORPORATED.png",
      company_id: "COM000546",
      company_name: "Lion Polymers",
      industry: "PLASTICS",
      display_name: "Lion Polymers",
    },
    {
      field_type: "company",
      name: "Lm Trading  ",
      field_id: "COM000532",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000532",
      company_name: "Lm Trading  ",
      industry: "FMCD",
      display_name: "Lm Trading  ",
    },
    {
      field_type: "company",
      name: "Load Controls",
      field_id: "COM000549",
      website: "http://loadcontrols.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LOAD CONTROLS INDIA PRIVATE LIMITED.jpg",
      company_id: "COM000549",
      company_name: "Load Controls",
      industry: "ELECTRICALS",
      display_name: "Load Controls",
    },
    {
      field_type: "company",
      name: "Lodha Impex  ",
      field_id: "COM001160",
      website: "https://www.thelodhagroup.com/reach.php",
      group: "The Lodha Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LODHA IMPEX PRIVATE LIMITED.jpg",
      company_id: "COM001160",
      company_name: "Lodha Impex  ",
      industry: "",
      display_name: "Lodha Impex  ",
    },
    {
      field_type: "company",
      name: "Loreal",
      field_id: "COM000550",
      website: "https://www.loreal.co.in/group/company-overview/who-we-are.htm",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LOREAL INDIA PRIVATE LIMITED.webp",
      company_id: "COM000550",
      company_name: "Loreal",
      industry: "FMCG",
      display_name: "Loreal",
    },
    {
      field_type: "company",
      name: "Lorom India Corp",
      field_id: "COM001161",
      website: "https://www.lorom.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LOROM INDIA CORPORATION PRIVATE LIMITED.jpg",
      company_id: "COM001161",
      company_name: "Lorom India Corp",
      industry: "",
      display_name: "Lorom India Corp",
    },
    {
      field_type: "company",
      name: "Lotus Powergear  ",
      field_id: "COM000551",
      website: "https://lppl.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LOTUS POWERGEAR PRIVATE LIMITED.webp",
      company_id: "COM000551",
      company_name: "Lotus Powergear  ",
      industry: "ELECTRICALS",
      display_name: "Lotus Powergear  ",
    },
    {
      field_type: "company",
      name: "LRC Speciality Chemicals  ",
      field_id: "COM000552",
      website: "http://www.lrc-india.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LRC SPECIALITY CHEMICALS PRIVATE LIMITED.png",
      company_id: "COM000552",
      company_name: "LRC Speciality Chemicals  ",
      industry: "CHEMICAL",
      display_name: "LRC Speciality Chemicals  ",
    },
    {
      field_type: "company",
      name: "Lubi Industries ",
      field_id: "COM000553",
      website: "http://www.lubipumps.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LUBI INDUSTRIES LLP.png",
      company_id: "COM000553",
      company_name: "Lubi Industries ",
      industry: "MANUFACTURING",
      display_name: "Lubi Industries ",
    },
    {
      field_type: "company",
      name: "Lubrizol Advanced Materials  ",
      field_id: "COM000554",
      website: "https://www.lubrizol.com/en",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LUBRIZOL ADVANCED MATERIALS INDIA PRIVATE LIMITED.jpg",
      company_id: "COM000554",
      company_name: "Lubrizol Advanced Materials  ",
      industry: "CHEMICAL",
      display_name: "Lubrizol Advanced Materials  ",
    },
    {
      field_type: "company",
      name: "Lucas TVS",
      field_id: "COM000555",
      website: "http://www.lucas-tvs.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LUCAS TVS LIMITED.png",
      company_id: "COM000555",
      company_name: "Lucas TVS",
      industry: "AUTOMOBILE",
      display_name: "Lucas TVS",
    },
    {
      field_type: "company",
      name: "Lucid Pharma",
      field_id: "COM000556",
      website: "http://lucidpharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LUCID PHARMA.png",
      company_id: "COM000556",
      company_name: "Lucid Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Lucid Pharma",
    },
    {
      field_type: "company",
      name: "Luminous Electric",
      field_id: "COM000557",
      website: "https://luminouselectricnj.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LUMINOUS ELECTRIC LLC.jpg",
      company_id: "COM000557",
      company_name: "Luminous Electric",
      industry: "ELECTRICALS",
      display_name: "Luminous Electric",
    },
    {
      field_type: "company",
      name: "Luminous Power Technologies  ",
      field_id: "COM000558",
      website: "https://www.luminousindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LUMINOUS POWER TECHNOLOGIES PRIVATE LIMITED.png",
      company_id: "COM000558",
      company_name: "Luminous Power Technologies  ",
      industry: "MANUFACTURING",
      display_name: "Luminous Power Technologies  ",
    },
    {
      field_type: "company",
      name: "Lupin ",
      field_id: "COM000559",
      website: "https://www.lupin.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LUPIN LIMITED.png",
      company_id: "COM000559",
      company_name: "Lupin ",
      industry: "PHARMACEUTICAL",
      display_name: "Lupin ",
    },
    {
      field_type: "company",
      name: "M Brothers Construction",
      field_id: "COM000560",
      website: "http://www.mbrothersconstruction.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/M Brothers Construction.png",
      company_id: "COM000560",
      company_name: "M Brothers Construction",
      industry: "",
      display_name: "M Brothers Construction",
    },
    {
      field_type: "company",
      name: "Maan Aluminium ",
      field_id: "COM000566",
      website: "http://www.maanaluminium.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAAN ALUMINIUM LIMITED.png",
      company_id: "COM000566",
      company_name: "Maan Aluminium ",
      industry: "METALS AND MINING",
      display_name: "Maan Aluminium ",
    },
    {
      field_type: "company",
      name: "Macawber Beekay  ",
      field_id: "COM000567",
      website: "https://www.mbl.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MACAWBER BEEKAY PRIVATE LIMITED.jpg",
      company_id: "COM000567",
      company_name: "Macawber Beekay  ",
      industry: "ENGINEERING SERVICES",
      display_name: "Macawber Beekay  ",
    },
    {
      field_type: "company",
      name: "Macleods Pharma ",
      field_id: "COM000568",
      website: "https://www.macleodspharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MACLEODS PHARMACEUTICALS LIMITED.png",
      company_id: "COM000568",
      company_name: "Macleods Pharma ",
      industry: "PHARMACEUTICAL",
      display_name: "Macleods Pharma ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "MRF -  Madras Rubber Factory ",
      field_id: "COM000569",
      website: "https://www.mrftyres.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MADRAS RUBBER FACTORY LIMITED.jpg",
      company_id: "COM000569",
      company_name: "MRF -  Madras Rubber Factory ",
      industry: "MANUFACTURING",
      display_name: "MRF -  Madras Rubber Factory ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Madura Coats  ",
      field_id: "COM000570",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000570",
      company_name: "Madura Coats  ",
      industry: "TEXTILE",
      display_name: "Madura Coats  ",
    },
    {
      field_type: "company",
      name: "Magnasys Material Handling",
      field_id: "COM000571",
      website: "http://magnasys.org/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAGNASYS MATERIAL HANDLING AND STORAGE SYSTEMS PRIVATE.gif",
      company_id: "COM000571",
      company_name: "Magnasys Material Handling",
      industry: "MANUFACTURING",
      display_name: "Magnasys Material Handling",
    },
    {
      field_type: "company",
      name: "Mahakali Foods  ",
      field_id: "COM000572",
      website: "http://www.mahakalifoods.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAHAKALI FOODS PRIVATE LIMITED.jpg",
      company_id: "COM000572",
      company_name: "Mahakali Foods  ",
      industry: "FMCG",
      display_name: "Mahakali Foods  ",
    },
    {
      field_type: "company",
      name: "Maheshwari Pharma",
      field_id: "COM000574",
      website: "https://www.mpil-herbal.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAHESHWARI PHARMACEUTICALS INDIA LIMITED.png",
      company_id: "COM000574",
      company_name: "Maheshwari Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Maheshwari Pharma",
    },
    {
      field_type: "company",
      name: "Mahima Fibers  ",
      field_id: "COM000575",
      website: "http://mahimacotton.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAHIMA FIBERS PRIVATE LIMITED.png",
      company_id: "COM000575",
      company_name: "Mahima Fibers  ",
      industry: "TEXTILE",
      display_name: "Mahima Fibers  ",
    },
    {
      field_type: "company",
      name: "Mahindra Agri",
      field_id: "COM000577",
      website: "http://mahindraagri.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAHINDRA AGRI SOLUTIONS LIMITED.png",
      company_id: "COM000577",
      company_name: "Mahindra Agri",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Mahindra Agri",
    },
    {
      field_type: "company",
      name: "Mahindra And Mahindra ",
      field_id: "COM000576",
      website: "https://www.mahindra.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAHINDRA AND MAHINDRA LIMITED.png",
      company_id: "COM000576",
      company_name: "Mahindra And Mahindra ",
      industry: "AUTOMOBILE",
      display_name: "Mahindra And Mahindra ",
    },
    {
      field_type: "company",
      name: "Mahindra CIE Automotive ",
      field_id: "COM000578",
      website: "http://www.mahindracie.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAHINDRA CIE AUTOMOTIVE LIMITED.jpg",
      company_id: "COM000578",
      company_name: "Mahindra CIE Automotive ",
      industry: "AUTOMOBILE",
      display_name: "Mahindra CIE Automotive ",
    },
    {
      field_type: "company",
      name: "Mailam",
      field_id: "COM001162",
      website: "http://www.mailamindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAILAM INDIA LIMITED.png",
      company_id: "COM001162",
      company_name: "Mailam",
      industry: "",
      display_name: "Mailam",
    },
    {
      field_type: "company",
      name: "Maitri Enterprises ",
      field_id: "COM001163",
      website: "http://www.maitrienterprises.com/contact-us.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAITRI ENTERPRISES LIMITED.png",
      company_id: "COM001163",
      company_name: "Maitri Enterprises ",
      industry: "",
      display_name: "Maitri Enterprises ",
    },
    {
      field_type: "company",
      name: "Maiyas Restaurants  ",
      field_id: "COM000580",
      website: "http://www.maiyas.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAIYAS RESTAURANTS PRIVATE LIMITED.jpg",
      company_id: "COM000580",
      company_name: "Maiyas Restaurants  ",
      industry: "",
      display_name: "Maiyas Restaurants  ",
    },
    {
      field_type: "company",
      name: "Malabar Cements ",
      field_id: "COM001433",
      website: "https://www.malabarcements.co.in/en/",
      group: "",
      logo: "",
      company_id: "COM001433",
      company_name: "Malabar Cements ",
      industry: "",
      display_name: "Malabar Cements ",
    },
    {
      field_type: "company",
      name: "Malladi Drugs And Pharma ",
      field_id: "COM001434",
      website: "http://malladi.com/",
      group: "",
      logo: "",
      company_id: "COM001434",
      company_name: "Malladi Drugs And Pharma ",
      industry: "",
      display_name: "Malladi Drugs And Pharma ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Malwa Industries ",
      field_id: "COM001277",
      website: "http://www.malwagroup.com/",
      group: "MALWA GROUP",
      logo: "",
      company_id: "COM001277",
      company_name: "Malwa Industries ",
      industry: "",
      display_name: "Malwa Industries ",
    },
    {
      field_type: "company",
      name: "Man Industries",
      field_id: "COM001079",
      website: "http://www.mangroup.com/",
      group: "Man Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAN INDUSTRIES INDIA LIMITED.png",
      company_id: "COM001079",
      company_name: "Man Industries",
      industry: "",
      display_name: "Man Industries",
    },
    {
      field_type: "company",
      name: "Mando Automotive",
      field_id: "COM001164",
      website: "https://www.anandgroupindia.com/mandoautomotiveindia/",
      group: "ANAND Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MANDO AUTOMOTIVE INDIA PRIVATE LIMITED.gif",
      company_id: "COM001164",
      company_name: "Mando Automotive",
      industry: "",
      display_name: "Mando Automotive",
    },
    {
      field_type: "company",
      name: "Mangalam Cement ",
      field_id: "COM001435",
      website: "http://www.mangalamcement.com/",
      group: "BK BIRLA GROUP",
      logo: "",
      company_id: "COM001435",
      company_name: "Mangalam Cement ",
      industry: "",
      display_name: "Mangalam Cement ",
    },
    {
      field_type: "company",
      name: "Manikgarh Cement",
      field_id: "COM000581",
      website: "http://birlagoldcement.com/our-plants/manikgarh",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MANIKGARH CEMENT.jpg",
      company_id: "COM000581",
      company_name: "Manikgarh Cement",
      industry: "CEMENT",
      display_name: "Manikgarh Cement",
    },
    {
      field_type: "company",
      name: "Manipal Technologies ",
      field_id: "COM001165",
      website: "https://manipaltechnologies.com/",
      group: "MANIPAL GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MANIPAL TECHNOLOGIES LIMITED.png",
      company_id: "COM001165",
      company_name: "Manipal Technologies ",
      industry: "",
      display_name: "Manipal Technologies ",
    },
    {
      field_type: "company",
      name: "Manjeet Cotton  ",
      field_id: "COM000582",
      website: "http://www.manjeetgroup.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MANJEET COTTON PRIVATE LIMITED.png",
      company_id: "COM000582",
      company_name: "Manjeet Cotton  ",
      industry: "RAW MATERIAL",
      display_name: "Manjeet Cotton  ",
    },
    {
      field_type: "company",
      name: "Manjushree Technopack ",
      field_id: "COM000583",
      website: "http://manjushreeindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MANJUSHREE TECHNOPACK LIMITED.png",
      company_id: "COM000583",
      company_name: "Manjushree Technopack ",
      industry: "PACKAGING",
      display_name: "Manjushree Technopack ",
    },
    {
      field_type: "company",
      name: "Mankind Pharma",
      field_id: "COM000584",
      website: "https://www.mankindpharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MANKIND PHARMA.png",
      company_id: "COM000584",
      company_name: "Mankind Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Mankind Pharma",
    },
    {
      field_type: "company",
      name: "Manoj Cables ",
      field_id: "COM000585",
      website: "http://www.manojcable.com/home.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MANOJ CABLES LIMITED.jpg",
      company_id: "COM000585",
      company_name: "Manoj Cables ",
      industry: "MANUFACTURING",
      display_name: "Manoj Cables ",
    },
    {
      field_type: "company",
      name: "Marico ",
      field_id: "COM000586",
      website: "https://marico.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MARICO LIMITED.png",
      company_id: "COM000586",
      company_name: "Marico ",
      display_name: "Marico ",
      sector: "FMCG",
      page_display_status: true,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Marino Food",
      field_id: "COM001278",
      website: "http://www.marinofoods.in/",
      group: "Chhawnika’s",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MARINO FOOD PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM001278",
      company_name: "Marino Food",
      industry: "",
      display_name: "Marino Food",
    },
    {
      field_type: "company",
      name: "Marksans Pharma ",
      field_id: "COM001436",
      website: "http://marksanspharma.com/",
      group: "",
      logo: "",
      company_id: "COM001436",
      company_name: "Marksans Pharma ",
      industry: "",
      display_name: "Marksans Pharma ",
    },
    {
      field_type: "company",
      name: "MARS",
      field_id: "COM000587",
      website: "https://www.mars.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MARS INCORPORATE.svg",
      company_id: "COM000587",
      company_name: "MARS",
      industry: "",
      display_name: "MARS",
    },
    {
      field_type: "company",
      name: "Maruti Suzuki",
      field_id: "COM000588",
      website: "https://www.marutisuzuki.com/corporate/about-us",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MARUTI SUZUKI INDIA LIMITED.jpg",
      company_id: "COM000588",
      company_name: "Maruti Suzuki",
      industry: "AUTOMOBILE",
      display_name: "Maruti Suzuki",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Maschio Gaspardo",
      field_id: "COM000590",
      website: "https://www.maschio.com/home-hi-IN/",
      group: "",
      logo: "",
      company_id: "COM000590",
      company_name: "Maschio Gaspardo",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Maschio Gaspardo",
    },
    {
      field_type: "company",
      name: "Max Cement ",
      field_id: "COM001437",
      website: "http://www.maxcement.co.in/",
      group: "",
      logo: "",
      company_id: "COM001437",
      company_name: "Max Cement ",
      industry: "",
      display_name: "Max Cement ",
    },
    {
      field_type: "company",
      name: "Max Link",
      field_id: "COM000591",
      website: "http://maxlinkindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAX LINK.png",
      company_id: "COM000591",
      company_name: "Max Link",
      industry: "FMCG",
      display_name: "Max Link",
    },
    {
      field_type: "company",
      name: "Max Speciality Films ",
      field_id: "COM000592",
      website: "https://www.maxspecialityfilms.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MAX SPECIALITY FILMS LIMITED.png",
      company_id: "COM000592",
      company_name: "Max Speciality Films ",
      industry: "PACKAGING",
      display_name: "Max Speciality Films ",
    },
    {
      field_type: "company",
      name: "Maxpro Homecare Products  ",
      field_id: "COM000593",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000593",
      company_name: "Maxpro Homecare Products  ",
      industry: "FMCD",
      display_name: "Maxpro Homecare Products  ",
    },
    {
      field_type: "company",
      name: "Mayur Traders",
      field_id: "COM000594",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000594",
      company_name: "Mayur Traders",
      industry: "MANUFACTURING",
      display_name: "Mayur Traders",
    },
    {
      field_type: "company",
      name: "MCC Chemicals",
      field_id: "COM000595",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000595",
      company_name: "MCC Chemicals",
      industry: "CHEMICAL",
      display_name: "MCC Chemicals",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "MCNROE Consumer",
      field_id: "COM000596",
      website: "https://mcnroe.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MCNROE CONSUMER PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM000596",
      company_name: "MCNROE Consumer",
      industry: "FMCG",
      display_name: "MCNROE Consumer",
    },
    {
      field_type: "company",
      name: "MCPI",
      field_id: "COM000597",
      website: "https://mcpi.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MCPI PRIVATE LIMITED.jpg",
      company_id: "COM000597",
      company_name: "MCPI",
      industry: "CHEMICAL",
      display_name: "MCPI",
    },
    {
      field_type: "company",
      name: "MDH",
      field_id: "COM001166",
      website: "http://mdhspices.com/about-us/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MDH PRIVATE LIMITED.png",
      company_id: "COM001166",
      company_name: "MDH",
      industry: "",
      display_name: "MDH",
    },
    {
      field_type: "company",
      name: "Medicamen Biotech ",
      field_id: "COM001438",
      website: "http://www.medicamen.com/",
      group: "",
      logo: "",
      company_id: "COM001438",
      company_name: "Medicamen Biotech ",
      industry: "",
      display_name: "Medicamen Biotech ",
    },
    {
      field_type: "company",
      name: "Medilux Labs",
      field_id: "COM001439",
      website: "https://www.medilux.co.in/",
      group: "",
      logo: "",
      company_id: "COM001439",
      company_name: "Medilux Labs",
      industry: "",
      display_name: "Medilux Labs",
    },
    {
      field_type: "company",
      name: "Medipol Pharma",
      field_id: "COM000601",
      website: "https://www.medipol.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MEDIPOL PHARMACEUTICAL INDIA PRIVATE LIMITED.png",
      company_id: "COM000601",
      company_name: "Medipol Pharma",
      industry: "PHARMACEUTICAL",
      display_name: "Medipol Pharma",
    },
    {
      field_type: "company",
      name: "Medley Pharma ",
      field_id: "COM001440",
      website: "https://www.medleylab.com/",
      group: "",
      logo: "",
      company_id: "COM001440",
      company_name: "Medley Pharma ",
      industry: "",
      display_name: "Medley Pharma ",
    },
    {
      field_type: "company",
      name: "Medreich ",
      field_id: "COM001441",
      website: "https://www.medreich.com/index.php",
      group: "",
      logo: "",
      company_id: "COM001441",
      company_name: "Medreich ",
      industry: "",
      display_name: "Medreich ",
    },
    {
      field_type: "company",
      name: "Megafine Pharma  ",
      field_id: "COM001442",
      website: "https://megafine.in/home",
      group: "",
      logo: "",
      company_id: "COM001442",
      company_name: "Megafine Pharma  ",
      industry: "",
      display_name: "Megafine Pharma  ",
    },
    {
      field_type: "company",
      name: "Megha Engineering",
      field_id: "COM000602",
      website: "https://www.meil.in/",
      group: "MEIL Group of companies",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MEGHA ENGINEERING & INFRASTRUCTURES LIMITED.svg",
      company_id: "COM000602",
      company_name: "Megha Engineering",
      industry: "ENGINEERING SERVICES",
      display_name: "Megha Engineering",
    },
    {
      field_type: "company",
      name: "Meghalaya Cements ",
      field_id: "COM001443",
      website: "https://www.topcem.in/",
      group: "",
      logo: "",
      company_id: "COM001443",
      company_name: "Meghalaya Cements ",
      industry: "",
      display_name: "Meghalaya Cements ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM001444",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001444",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Meghmani Llp",
        field_id: "COM001444",
        website: "http://www.meghmanigroup.com",
        group: "",
        logo: "",
        company_id: "COM001444",
        company_name: "Meghmani Llp",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Meghmani Organics ",
      field_id: "COM000603",
      website: "http://www.meghmani.com/corp_abtus.htm",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Meghmani Organics Limited.gif",
      company_id: "COM000603",
      company_name: "Meghmani Organics ",
      industry: "CHEMICAL",
      display_name: "Meghmani Organics ",
    },
    {
      field_type: "company",
      name: "Mehru Electrical",
      field_id: "COM000604",
      website: "https://www.mehru.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MEHRU ELECTRICAL & MECHANICAL ENGINEERS PRIVATE LIMITED.png",
      company_id: "COM000604",
      company_name: "Mehru Electrical",
      industry: "MANUFACTURING",
      display_name: "Mehru Electrical",
    },
    {
      field_type: "company",
      name: "Menarini Asia",
      field_id: "COM000599",
      website: "https://www.menariniapac.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MENARINI ASIA PACIFIC PRIVATE LIMITED.png",
      company_id: "COM000599",
      company_name: "Menarini Asia",
      industry: "PHARMACEUTICAL",
      display_name: "Menarini Asia",
    },
    {
      field_type: "company",
      name: "Mercedes Benz",
      field_id: "COM000606",
      website: "https://www.mercedes-benz.co.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Mercedes-Benz India Private Limited.svg",
      company_id: "COM000606",
      company_name: "Mercedes Benz",
      industry: "AUTOMOBILE",
      display_name: "Mercedes Benz",
    },
    {
      field_type: "company",
      name: "Meridian Flour Mills ",
      field_id: "COM000608",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000608",
      company_name: "Meridian Flour Mills ",
      industry: "FMCG",
      display_name: "Meridian Flour Mills ",
    },
    {
      field_type: "company",
      name: "Merino Industries",
      field_id: "COM000609",
      website: "https://www.merinoindia.com/About-us-new.php",
      group: "Merino Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MERINO INDUSTRIES LIMITED.png",
      company_id: "COM000609",
      company_name: "Merino Industries",
      industry: "CONGLOMERATE",
      display_name: "Merino Industries",
    },
    {
      field_type: "company",
      name: "Metalman Auto  ",
      field_id: "COM000610",
      website: "https://metalmanauto.com",
      group: "",
      logo: "",
      company_id: "COM000610",
      company_name: "Metalman Auto  ",
      industry: "MANUFACTURING",
      display_name: "Metalman Auto  ",
    },
    {
      field_type: "company",
      name: "Metalsa",
      field_id: "COM001279",
      website: "https://www.metalsa.com/",
      group: "Grupo Proeza",
      logo: "",
      company_id: "COM001279",
      company_name: "Metalsa",
      industry: "",
      display_name: "Metalsa",
    },
    {
      field_type: "company",
      name: "Metcon Realty And Infrastructure  ",
      field_id: "COM001168",
      website: "https://www.metcon.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/METCON INDIA REALTY AND INFRASTRUCTURE PVT LTD.PNG",
      company_id: "COM001168",
      company_name: "Metcon Realty And Infrastructure  ",
      industry: "",
      display_name: "Metcon Realty And Infrastructure  ",
    },
    {
      field_type: "company",
      name: "Metenere ",
      field_id: "COM000611",
      website: "http://www.metenere.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Metenere Limited.png",
      company_id: "COM000611",
      company_name: "Metenere ",
      industry: "METALS AND MINING",
      display_name: "Metenere ",
    },
    {
      field_type: "company",
      name: "Metro Tyres ",
      field_id: "COM000612",
      website: "https://www.metrotyres.com",
      group: "Metro Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/METRO TYRES LIMITED.png",
      company_id: "COM000612",
      company_name: "Metro Tyres ",
      industry: "TYRE",
      display_name: "Metro Tyres ",
    },
    {
      field_type: "company",
      name: "Metrochem",
      field_id: "COM001445",
      website: "https://www.metroapi.com/",
      group: "",
      logo: "",
      company_id: "COM001445",
      company_name: "Metrochem",
      industry: "",
      display_name: "Metrochem",
    },
    {
      field_type: "company",
      name: "Metso",
      field_id: "COM000613",
      website: "https://www.metso.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Metso Corporation.png",
      company_id: "COM000613",
      company_name: "Metso",
      industry: "CONGLOMERATE",
      display_name: "Metso",
    },
    {
      field_type: "company",
      name: "MGB Group",
      field_id: "COM000614",
      website: "http://www.mgbrothers.com/",
      group: "",
      logo: "",
      company_id: "COM000614",
      company_name: "MGB Group",
      industry: "",
      display_name: "MGB Group",
    },
    {
      field_type: "company",
      name: "Michelin Tyres",
      field_id: "COM000615",
      website: "https://www.michelin.in/",
      group: "The Michelin Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Michelin India Private Limited.svg",
      company_id: "COM000615",
      company_name: "Michelin Tyres",
      industry: "TYRE",
      display_name: "Michelin Tyres",
    },
    {
      field_type: "company",
      name: "Micro Inks ",
      field_id: "COM000616",
      website: "",
      group: "MHM Holding GmbH",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MICRO INKS LIMITED.jpg",
      company_id: "COM000616",
      company_name: "Micro Inks ",
      industry: "PRINTING AND MINTING",
      display_name: "Micro Inks ",
    },
    {
      field_type: "company",
      name: "Micro Labs ",
      field_id: "COM001446",
      website: "http://www.microlabsltd.com/",
      group: "",
      logo: "",
      company_id: "COM001446",
      company_name: "Micro Labs ",
      industry: "",
      display_name: "Micro Labs ",
    },
    {
      field_type: "company",
      name: "Micromax Informatics ",
      field_id: "COM000617",
      website: "http://www.micromaxinfo.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Micromax Informatics Limited.png",
      company_id: "COM000617",
      company_name: "Micromax Informatics ",
      industry: "ELECTRONICS",
      display_name: "Micromax Informatics ",
    },
    {
      field_type: "company",
      name: "ONIDA - MIRC Electronics ",
      field_id: "COM000684",
      website: "https://www.onida.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MIRC ELECTRONICS LIMITED.png",
      company_id: "COM000684",
      company_name: "ONIDA - MIRC Electronics ",
      display_name: "ONIDA - MIRC Electronics ",
      sector: "FMCD",
      page_display_status: true,
      industry: "Electronics",
    },
    {
      field_type: "company",
      name: "Mitashi Edutainment  ",
      field_id: "COM000619",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000619",
      company_name: "Mitashi Edutainment  ",
      industry: "FMCD",
      display_name: "Mitashi Edutainment  ",
    },
    {
      field_type: "company",
      name: "MK Retail Solutions  ",
      field_id: "COM000620",
      website: "https://www.mkretail.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/M K Retail.png",
      company_id: "COM000620",
      company_name: "MK Retail Solutions  ",
      industry: "FMCG",
      display_name: "MK Retail Solutions  ",
    },
    {
      field_type: "company",
      name: "MMTC",
      field_id: "COM000621",
      website: "https://mmtclimited.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MMTC Limited.gif",
      company_id: "COM000621",
      company_name: "MMTC",
      industry: "METALS AND MINING",
      display_name: "MMTC",
    },
    {
      field_type: "company",
      name: "Mobis  ",
      field_id: "COM000622",
      website: "http://www.mobistc-india.com",
      group: "Hyundai Motor Company",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Mobis India Limited.gif",
      company_id: "COM000622",
      company_name: "Mobis  ",
      industry: "",
      display_name: "Mobis  ",
    },
    {
      field_type: "company",
      name: "Modern Packaging Company",
      field_id: "COM000624",
      website: "http://www.modpkg.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MODERN PACKAGING COMPANY.png",
      company_id: "COM000624",
      company_name: "Modern Packaging Company",
      industry: "PACKAGING",
      display_name: "Modern Packaging Company",
    },
    {
      field_type: "company",
      name: "Mohini Health And Hygiene ",
      field_id: "COM001447",
      website: "https://mohinihealthandhygiene.com/",
      group: "",
      logo: "",
      company_id: "COM001447",
      company_name: "Mohini Health And Hygiene ",
      industry: "",
      display_name: "Mohini Health And Hygiene ",
    },
    {
      field_type: "company",
      name: "Mohit Minerals  ",
      field_id: "COM000625",
      website: "http://www.mohitminerals.in/profile.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MOHIT MINERALS PRIVATE LIMITED.jpg",
      company_id: "COM000625",
      company_name: "Mohit Minerals  ",
      industry: "METALS AND MINING",
      display_name: "Mohit Minerals  ",
    },
    {
      field_type: "company",
      name: "Moil ",
      field_id: "COM001169",
      website: "http://moil.nic.in/Hindi/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MOIL LIMITED.PNG",
      company_id: "COM001169",
      company_name: "Moil ",
      industry: "",
      display_name: "Moil ",
    },
    {
      field_type: "company",
      name: "Monarch Ergo  ",
      field_id: "COM000626",
      website: "https://www.monarchergo.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Monarch Ergo Private Limited.png",
      company_id: "COM000626",
      company_name: "Monarch Ergo  ",
      industry: "FMCD",
      display_name: "Monarch Ergo  ",
    },
    {
      field_type: "company",
      name: "Mondelez Foods  ",
      field_id: "COM000598",
      website: "https://in.mondelezinternational.com/home",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/CADBURY INDIA LIMITED.png",
      company_id: "COM000598",
      company_name: "Mondelez Foods  ",
      industry: "FMCG",
      display_name: "Mondelez Foods  ",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Monsanto",
      field_id: "COM000627",
      website: "https://www.monsantoglobal.com/global/in/Pages/default.aspx",
      group: "Bayer AG",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Monsanto Company.png",
      company_id: "COM000627",
      company_name: "Monsanto",
      industry: "CHEMICAL",
      display_name: "Monsanto",
    },
    {
      field_type: "company",
      name: "Montage Enterprises  ",
      field_id: "COM000628",
      website: "http://www.montageind.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MONTAGE ENTERPRISES PRIVATE LIMITED.png",
      company_id: "COM000628",
      company_name: "Montage Enterprises  ",
      industry: "PACKAGING",
      display_name: "Montage Enterprises  ",
    },
    {
      field_type: "company",
      name: "Morepen Laboratories ",
      field_id: "COM001448",
      website: "http://www.morepen.com/",
      group: "",
      logo: "",
      company_id: "COM001448",
      company_name: "Morepen Laboratories ",
      industry: "",
      display_name: "Morepen Laboratories ",
    },
    {
      field_type: "company",
      name: "Mother Dairy",
      field_id: "COM000629",
      website: "https://www.motherdairy.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Mother Dairy Fruit and Vegetable Private Limited.png",
      company_id: "COM000629",
      company_name: "Mother Dairy",
      display_name: "Mother Dairy",
      sector: "FMCG",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "MPD Industries  ",
      field_id: "COM000630",
      website: "http://mpdyechem.com/",
      group: "",
      logo: "",
      company_id: "COM000630",
      company_name: "MPD Industries  ",
      industry: "CHEMICAL",
      display_name: "MPD Industries  ",
    },
    {
      field_type: "company",
      name: "MPPC Steel  ",
      field_id: "COM000631",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000631",
      company_name: "MPPC Steel  ",
      industry: "STEEL",
      display_name: "MPPC Steel  ",
    },
    {
      field_type: "company",
      name: "MRT Signals ",
      field_id: "COM000561",
      website: "http://www.mrtsignals.com/about.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/M R T SIGNALS LIMITED.png",
      company_id: "COM000561",
      company_name: "MRT Signals ",
      industry: "TELECOM",
      display_name: "MRT Signals ",
    },
    {
      field_type: "company",
      name: "Ms Agarwal Foundries  ",
      field_id: "COM000018",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MS AGARWAL FOUNDRIES PRIVATE LIMITED.jpg",
      company_id: "COM000018",
      company_name: "Ms Agarwal Foundries  ",
      industry: "STEEL",
      display_name: "Ms Agarwal Foundries  ",
    },
    {
      field_type: "company",
      name: "MNS Laboratories",
      field_id: "COM001449",
      website: "http://msnlabs.com",
      group: "MSN GROUP",
      logo: "",
      company_id: "COM001449",
      company_name: "MNS Laboratories",
      industry: "",
      display_name: "MNS Laboratories",
    },
    {
      field_type: "company",
      name: "MTR Foods  ",
      field_id: "COM001095",
      website: "https://www.mtrfoods.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MTR FOODS PRIVATE LIMITED.png",
      company_id: "COM001095",
      company_name: "MTR Foods  ",
      display_name: "MTR Foods  ",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Multani Pharma ",
      field_id: "COM000635",
      website: "http://www.multanilabs.com/",
      group: "Multani Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Multani Pharmaceuticals Limited.png",
      company_id: "COM000635",
      company_name: "Multani Pharma ",
      industry: "PHARMACEUTICAL",
      display_name: "Multani Pharma ",
    },
    {
      field_type: "company",
      name: "Multibase",
      field_id: "COM000636",
      website: "https://www.multibaseindia.com/about-us.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Multibase India Limited.png",
      company_id: "COM000636",
      company_name: "Multibase",
      industry: "CHEMICAL",
      display_name: "Multibase",
    },
    {
      field_type: "company",
      name: "My Home Industries  ",
      field_id: "COM000637",
      website: "https://www.myhomegroup.co.in/cement/",
      group: "My Home Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/MY HOME INDUSTRIES PRIVATE LIMITED.gif",
      company_id: "COM000637",
      company_name: "My Home Industries  ",
      industry: "CEMENT",
      display_name: "My Home Industries  ",
    },
    {
      field_type: "company",
      name: "Mylan",
      field_id: "COM001450",
      website: "https://www.mylan.in/",
      group: "",
      logo: "",
      company_id: "COM001450",
      company_name: "Mylan",
      industry: "",
      display_name: "Mylan",
    },
    {
      field_type: "company",
      name: "N Ranga Rao And Sons  ",
      field_id: "COM000638",
      website: "http://www.nrrs.com/pages/ourstory",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/N Ranga Rao & Sons Private Limited.gif",
      company_id: "COM000638",
      company_name: "N Ranga Rao And Sons  ",
      industry: "",
      display_name: "N Ranga Rao And Sons  ",
    },
    {
      field_type: "company",
      name: "Nagarjuna Fertilizers",
      field_id: "COM000641",
      website: "http://www.nagarjunafertilizers.com/aboutus.htm",
      group: "Nagarjuna Group",
      logo: "",
      company_id: "COM000641",
      company_name: "Nagarjuna Fertilizers",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Nagarjuna Fertilizers",
    },
    {
      field_type: "company",
      name: "Nahar Industries",
      field_id: "COM000644",
      website: "http://www.owmnahar.com/nahar_ie/about.php",
      group: "Nahar Group of Companies",
      logo: "",
      company_id: "COM000644",
      company_name: "Nahar Industries",
      industry: "TEXTILE",
      display_name: "Nahar Industries",
    },
    {
      field_type: "company",
      name: "Nahar Textiles  ",
      field_id: "COM000643",
      website: "http://www.nahartex.com/index.php",
      group: "",
      logo: "",
      company_id: "COM000643",
      company_name: "Nahar Textiles  ",
      industry: "TEXTILE",
      display_name: "Nahar Textiles  ",
    },
    {
      field_type: "company",
      name: "Narmada Extrusions ",
      field_id: "COM000646",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000646",
      company_name: "Narmada Extrusions ",
      industry: "TEXTILE",
      display_name: "Narmada Extrusions ",
    },
    {
      field_type: "company",
      name: "NATCO Pharma ",
      field_id: "COM001451",
      website: "https://www.natcopharma.co.in/",
      group: "",
      logo: "",
      company_id: "COM001451",
      company_name: "NATCO Pharma ",
      industry: "",
      display_name: "NATCO Pharma ",
    },
    {
      field_type: "company",
      name: "National Aluminium Company ",
      field_id: "COM000647",
      website: "https://nalcoindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/National Aluminium Company Limited.png",
      company_id: "COM000647",
      company_name: "National Aluminium Company ",
      industry: "METALS AND MINING",
      display_name: "National Aluminium Company ",
    },
    {
      field_type: "company",
      name: "National Engineering Industries ",
      field_id: "COM001170",
      website: "https://www.nbcbearings.com/",
      group: "CK Birla Group",
      logo: "",
      company_id: "COM001170",
      company_name: "National Engineering Industries ",
      industry: "",
      display_name: "National Engineering Industries ",
    },
    {
      field_type: "company",
      name: "National Seeds Corp ",
      field_id: "COM000649",
      website: "https://www.indiaseeds.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NATIONAL SEEDS CORPORATION LIMITED.jpg",
      company_id: "COM000649",
      company_name: "National Seeds Corp ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "National Seeds Corp ",
    },
    {
      field_type: "company",
      name: "National Steel And Agro",
      field_id: "COM000650",
      website: "https://www.nsail.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NATIONAL STEEL & AGRO INDUSTRIES LIMITED.png",
      company_id: "COM000650",
      company_name: "National Steel And Agro",
      industry: "STEEL",
      display_name: "National Steel And Agro",
    },
    {
      field_type: "company",
      name: "Natural Capsules ",
      field_id: "COM000651",
      website: "http://www.naturalcapsules.com/",
      group: "",
      logo: "",
      company_id: "COM000651",
      company_name: "Natural Capsules ",
      industry: "PHARMACEUTICAL",
      display_name: "Natural Capsules ",
    },
    {
      field_type: "company",
      name: "Naurisco Beverages  ",
      field_id: "COM000652",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000652",
      company_name: "Naurisco Beverages  ",
      industry: "BREWING",
      display_name: "Naurisco Beverages  ",
    },
    {
      field_type: "company",
      name: "Nava Bharat Ventures ",
      field_id: "COM001280",
      website: "http://www.nbventures.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NAVA BHARAT VENTURES LIMITED.PNG",
      company_id: "COM001280",
      company_name: "Nava Bharat Ventures ",
      industry: "",
      display_name: "Nava Bharat Ventures ",
    },
    {
      field_type: "company",
      name: "NCC",
      field_id: "COM000653",
      website: "http://ncclimited.com/overview.html",
      group: "NCC Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NCC LIMITED.gif",
      company_id: "COM000653",
      company_name: "NCC",
      industry: "CONSTRUCTION",
      display_name: "NCC",
    },
    {
      field_type: "company",
      name: "Ncl Industries ",
      field_id: "COM001452",
      website: "http://www.nclind.com/nagarjuna-cement.html",
      group: "",
      logo: "",
      company_id: "COM001452",
      company_name: "Ncl Industries ",
      industry: "",
      display_name: "Ncl Industries ",
    },
    {
      field_type: "company",
      name: "Neel Metal Products ",
      field_id: "COM000654",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000654",
      company_name: "Neel Metal Products ",
      industry: "MANUFACTURING",
      display_name: "Neel Metal Products ",
    },
    {
      field_type: "company",
      name: "NELCO ",
      field_id: "COM000656",
      website: "https://www.nelco.in/about-us/profile/company-profile.php",
      group: "TATA Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Nelco.jpg",
      company_id: "COM000656",
      company_name: "NELCO ",
      industry: "ELECTRONICS",
      display_name: "NELCO ",
    },
    {
      field_type: "company",
      name: "Nestle",
      field_id: "COM000657",
      website: "https://www.nestle.in/aboutus",
      group: "NESTLE S A",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NESTLE INDIA LIMITED.png",
      company_id: "COM000657",
      company_name: "Nestle",
      industry: "FMCG",
      display_name: "Nestle",
    },
    {
      field_type: "company",
      name: "Neuland Labs",
      field_id: "COM001453",
      website: "https://www.neulandlabs.com/",
      group: "",
      logo: "",
      company_id: "COM001453",
      company_name: "Neuland Labs",
      industry: "",
      display_name: "Neuland Labs",
    },
    {
      field_type: "company",
      name: "Nexon Paints  ",
      field_id: "COM001171",
      website: "https://www.nexonpaints.com/about",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NEXON PAINTS PRIVATE LIMITED.png",
      company_id: "COM001171",
      company_name: "Nexon Paints  ",
      industry: "",
      display_name: "Nexon Paints  ",
    },
    {
      field_type: "company",
      name: "Nexteer Automotive",
      field_id: "COM000658",
      website: "https://www.nexteer.com/about/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Nexteer Automotive.png",
      company_id: "COM000658",
      company_name: "Nexteer Automotive",
      industry: "INDUSTRIAL AUTOMATION",
      display_name: "Nexteer Automotive",
    },
    {
      field_type: "company",
      name: "Nilons Enterprises  ",
      field_id: "COM000660",
      website:
        "http://www.nilons.com/about-nilons-pickle-masala-manufacturer-new/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NILONS ENTERPRISES PRIVATE LIMITED.png",
      company_id: "COM000660",
      company_name: "Nilons Enterprises  ",
      industry: "FMCG",
      display_name: "Nilons Enterprises  ",
    },
    {
      field_type: "company",
      name: "Nippon Paint",
      field_id: "COM000661",
      website: "https://nipponpaint.co.in/",
      group: "NIPSEA Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Nippon Paint India Company Limited.png",
      company_id: "COM000661",
      company_name: "Nippon Paint",
      industry: "PAINTS",
      display_name: "Nippon Paint",
    },
    {
      field_type: "company",
      name: "Nippon Steel Corp",
      field_id: "COM000662",
      website: "https://www.nipponsteel.com/en/company/",
      group: "",
      logo: "",
      company_id: "COM000662",
      company_name: "Nippon Steel Corp",
      industry: "STEEL",
      display_name: "Nippon Steel Corp",
    },
    {
      field_type: "company",
      name: "Nipro Pharma Packaging ",
      field_id: "COM000664",
      website: "https://www.nipro-pharmapackaging.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NIPRO PHARMAPACKAGING.png",
      company_id: "COM000664",
      company_name: "Nipro Pharma Packaging ",
      industry: "GLASS",
      display_name: "Nipro Pharma Packaging ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "NIRMA ",
      field_id: "COM000665",
      website: "http://www.nirma.co.in/genesis.htm",
      group: "NIRMA GROUP",
      logo: "",
      company_id: "COM000665",
      company_name: "NIRMA ",
      industry: "FMCG",
      display_name: "NIRMA ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Nissan Motor",
      field_id: "COM001281",
      website: "",
      group: "Nissan Motor Company",
      logo: "",
      company_id: "COM001281",
      company_name: "Nissan Motor",
      industry: "",
      display_name: "Nissan Motor",
    },
    {
      field_type: "company",
      name: "NITCO",
      field_id: "COM000667",
      website: "https://nitco.in/About-Nitco/Company-Profile.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NITCO LIMITED.png",
      company_id: "COM000667",
      company_name: "NITCO",
      industry: "",
      display_name: "NITCO",
    },
    {
      field_type: "company",
      name: "NIVEA - Beiersdorf",
      field_id: "COM001172",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NIVEA%20-%20Beiersdorf.png",
      company_id: "COM001172",
      company_name: "NIVEA - Beiersdorf",
      industry: "FMCG",
      display_name: "NIVEA - Beiersdorf",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "NLMK India Service Centre  ",
      field_id: "COM000668",
      website: "https://nlmk.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NLMK India Service Centre Private Limited.png",
      company_id: "COM000668",
      company_name: "NLMK India Service Centre  ",
      industry: "MANUFACTURING",
      display_name: "NLMK India Service Centre  ",
    },
    {
      field_type: "company",
      name: "NMC Industries  ",
      field_id: "COM000669",
      website: "http://www.nmcindustries.com/intro.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NMC INDUSTRIES PRIVATE LIMITED.png",
      company_id: "COM000669",
      company_name: "NMC Industries  ",
      industry: "MANUFACTURING",
      display_name: "NMC Industries  ",
    },
    {
      field_type: "company",
      name: "North Eastern Electric Power Corp ",
      field_id: "COM000670",
      website: "https://neepco.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/North Eastern Electric Power Corporation Limited.png",
      company_id: "COM000670",
      company_name: "North Eastern Electric Power Corp ",
      industry: "ELECTRICALS",
      display_name: "North Eastern Electric Power Corp ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000600",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000600",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Novares India Automotive Private Limited",
        field_id: "COM000600",
        website: "https://www.novaresteam.com/",
        group: "Novares Group",
        logo: "",
        company_id: "COM000600",
        company_name: "Novares India Automotive Private Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Novares  Automotive  ",
      field_id: "COM000671",
      website: "https://www.novartis.in/",
      group: "NOVARTIS",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NOVARTIS INDIA LIMITED.svg",
      company_id: "COM000671",
      company_name: "Novares  Automotive  ",
      industry: "PHARMACEUTICAL",
      display_name: "Novares  Automotive  ",
    },
    {
      field_type: "company",
      name: "Novateur Electrical And Digital Systems  ",
      field_id: "COM000672",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000672",
      company_name: "Novateur Electrical And Digital Systems  ",
      industry: "ELECTRICALS",
      display_name: "Novateur Electrical And Digital Systems  ",
    },
    {
      field_type: "company",
      name: "Novus ",
      field_id: "COM000673",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NOVUS LIMITED.png",
      company_id: "COM000673",
      company_name: "Novus ",
      industry: "PHARMACEUTICAL",
      display_name: "Novus ",
    },
    {
      field_type: "company",
      name: "NPS Drive Automation  ",
      field_id: "COM000648",
      website: "http://npsdapl.com",
      group: "",
      logo: "",
      company_id: "COM000648",
      company_name: "NPS Drive Automation  ",
      industry: "",
      display_name: "NPS Drive Automation  ",
    },
    {
      field_type: "company",
      name: "NTPC",
      field_id: "COM000676",
      website: "https://www.ntpc.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/NTPC LIMITED.svg",
      company_id: "COM000676",
      company_name: "NTPC",
      industry: "CONGLOMERATE",
      display_name: "NTPC",
    },
    {
      field_type: "company",
      name: "Nuetech Solar  ",
      field_id: "COM000677",
      website: "http://www.nuetechsolar.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Nuetech Solar Systems Private Limited.png",
      company_id: "COM000677",
      company_name: "Nuetech Solar  ",
      industry: "MANUFACTURING",
      display_name: "Nuetech Solar  ",
    },
    {
      field_type: "company",
      name: "Nuziveedu Seeds ",
      field_id: "COM000678",
      website: "http://www.nuziveeduseeds.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Nuziveedu Seeds Limited.png",
      company_id: "COM000678",
      company_name: "Nuziveedu Seeds ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Nuziveedu Seeds ",
    },
    {
      field_type: "company",
      name: "Obeetee Textiles  ",
      field_id: "COM000680",
      website: "http://www.obeetee.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/OBEETEE TEXTILES PRIVATE LIMITED.png",
      company_id: "COM000680",
      company_name: "Obeetee Textiles  ",
      industry: "TEXTILE",
      display_name: "Obeetee Textiles  ",
    },
    {
      field_type: "company",
      name: "Oerlikon Textile  ",
      field_id: "COM001173",
      website: "https://www.oerlikon.com/en/company/about-us/",
      group: "OC Oerlikon Management AG",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/OERLIKON TEXTILE INDIA PRIVATE LIMITED.svg",
      company_id: "COM001173",
      company_name: "Oerlikon Textile  ",
      industry: "",
      display_name: "Oerlikon Textile  ",
    },
    {
      field_type: "company",
      name: "Ogene Systems  ",
      field_id: "COM001454",
      website: "http://ogene.co.in/",
      group: "",
      logo: "",
      company_id: "COM001454",
      company_name: "Ogene Systems  ",
      industry: "",
      display_name: "Ogene Systems  ",
    },
    {
      field_type: "company",
      name: "ONGC - Oil And Natural Gas Corp ",
      field_id: "COM000681",
      website: "https://www.ongcindia.com/wps/wcm/connect/en/home/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Oil and Natural Gas Corporation Limited.png",
      company_id: "COM000681",
      company_name: "ONGC - Oil And Natural Gas Corp ",
      industry: "OIL AND GAS",
      display_name: "ONGC - Oil And Natural Gas Corp ",
    },
    {
      field_type: "company",
      name: "Okaya Power  ",
      field_id: "COM001174",
      website: "https://www.okayapower.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/OKAYA POWER PRIVATE LIMITED.PNG",
      company_id: "COM001174",
      company_name: "Okaya Power  ",
      industry: "",
      display_name: "Okaya Power  ",
    },
    {
      field_type: "company",
      name: "Olam International",
      field_id: "COM001092",
      website: "https://www.olamgroup.com/",
      group: "Olam Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/OLAM INTERNATIONAL.png",
      company_id: "COM001092",
      company_name: "Olam International",
      display_name: "Olam International",
      sector: "Agricultural Products",
      page_display_status: false,
      industry: "Agricultural Products",
    },
    {
      field_type: "company",
      name: "Om Tirupati Paper Products",
      field_id: "COM000682",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000682",
      company_name: "Om Tirupati Paper Products",
      industry: "PAPER",
      display_name: "Om Tirupati Paper Products",
    },
    {
      field_type: "company",
      name: "ONGC Petro Additions ",
      field_id: "COM000685",
      website: "http://www.opalindia.in/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ONGC Petro additions Limited.jpg",
      company_id: "COM000685",
      company_name: "ONGC Petro Additions ",
      industry: "",
      display_name: "ONGC Petro Additions ",
    },
    {
      field_type: "company",
      name: "Oranate Solar",
      field_id: "COM000695",
      website: "https://www.ornatesolar.com",
      group: "Hans Air Services Private Limited",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ORNATE SOLAR.png",
      company_id: "COM000695",
      company_name: "Oranate Solar",
      industry: "MANUFACTURING",
      display_name: "Oranate Solar",
    },
    {
      field_type: "company",
      name: "Orchid Chemicals",
      field_id: "COM001455",
      website: "http://www.orchidpharma.com/",
      group: "",
      logo: "",
      company_id: "COM001455",
      company_name: "Orchid Chemicals",
      industry: "",
      display_name: "Orchid Chemicals",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Organic India  ",
      field_id: "COM000687",
      website: "https://www.organicindia.com/contactus",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ORGANIC INDIA PRIVATE LIMITED.png",
      company_id: "COM000687",
      company_name: "Organic India  ",
      industry: "HEALTHCARE",
      display_name: "Organic India  ",
    },
    {
      field_type: "company",
      name: "Ori Plast ",
      field_id: "COM000694",
      website: "https://oriplast.com/ori-plast/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ORI-PLAST LTD.png",
      company_id: "COM000694",
      company_name: "Ori Plast ",
      industry: "PLASTICS",
      display_name: "Ori Plast ",
    },
    {
      field_type: "company",
      name: "Orient Cement ",
      field_id: "COM000690",
      website: "https://www.orientcement.com/",
      group: "CK BIRLA Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ORIENT CEMENT LIMITED.png",
      company_id: "COM000690",
      company_name: "Orient Cement ",
      industry: "CEMENT",
      display_name: "Orient Cement ",
    },
    {
      field_type: "company",
      name: "Orient Electric ",
      field_id: "COM000691",
      website: "https://www.orientelectric.com/",
      group: "CK BIRLA Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Orient Electric Limited.png",
      company_id: "COM000691",
      company_name: "Orient Electric ",
      industry: "ELECTRICALS",
      display_name: "Orient Electric ",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Orient Paper",
      field_id: "COM000692",
      website: "https://www.orientpaperindia.com/",
      group: "CK BIRLA Group",
      logo: "",
      company_id: "COM000692",
      company_name: "Orient Paper",
      industry: "PAPER",
      display_name: "Orient Paper",
    },
    {
      field_type: "company",
      name: "Orient Press ",
      field_id: "COM001175",
      website: "http://www.orientpressltd.com/",
      group: "",
      logo: "",
      company_id: "COM001175",
      company_name: "Orient Press ",
      industry: "",
      display_name: "Orient Press ",
    },
    {
      field_type: "company",
      name: "Oriental Rubber Industries ",
      field_id: "COM001081",
      website: "http://orientalrubber.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ORIENTAL RUBBER.png",
      company_id: "COM001081",
      company_name: "Oriental Rubber Industries ",
      industry: "",
      display_name: "Oriental Rubber Industries ",
    },
    {
      field_type: "company",
      name: "Oriental Veneer Products ",
      field_id: "COM000693",
      website: "http://www.ovpl.co.in/",
      group: "",
      logo: "",
      company_id: "COM000693",
      company_name: "Oriental Veneer Products ",
      industry: "MANUFACTURING",
      display_name: "Oriental Veneer Products ",
    },
    {
      field_type: "company",
      name: "Orientbell ",
      field_id: "COM000689",
      website: "https://www.orientbell.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ORIENTBELL LIMITED.png",
      company_id: "COM000689",
      company_name: "Orientbell ",
      industry: "CERAMICS",
      display_name: "Orientbell ",
    },
    {
      field_type: "company",
      name: "Osram",
      field_id: "COM000696",
      website: "https://www.osram.in/cb/services/osram-on-the-web/index.jsp",
      group: "OSRAM GmbH",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/OSRAM INDIA PRIVATE LIMITED.png",
      company_id: "COM000696",
      company_name: "Osram",
      industry: "ELECTRICALS",
      display_name: "Osram",
    },
    {
      field_type: "company",
      name: "Otis Elevator Co",
      field_id: "COM000697",
      website: "https://www.otis.com/en/us/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Otis Elevator Company India Limited.png",
      company_id: "COM000697",
      company_name: "Otis Elevator Co",
      industry: "ELECTRONICS",
      display_name: "Otis Elevator Co",
    },
    {
      field_type: "company",
      name: "Overseas Polymers  ",
      field_id: "COM000698",
      website: "http://www.overseaspolymers.com/company-profile.html",
      group: "",
      logo: "",
      company_id: "COM000698",
      company_name: "Overseas Polymers  ",
      industry: "PLASTICS",
      display_name: "Overseas Polymers  ",
    },
    {
      field_type: "company",
      name: "Owens Corning",
      field_id: "COM000699",
      website:
        "http://www.owenscorningindia.com/OCIndia/Our_Company/Our_Company.asp",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/OWENS CORNING INDIA LTD.gif",
      company_id: "COM000699",
      company_name: "Owens Corning",
      industry: "GLASS",
      display_name: "Owens Corning",
    },
    {
      field_type: "company",
      name: "Paharpur Cooling Towers ",
      field_id: "COM000701",
      website: "https://www.paharpur.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Paharpur Cooling Towers Limited.png",
      company_id: "COM000701",
      company_name: "Paharpur Cooling Towers ",
      industry: "MANUFACTURING",
      display_name: "Paharpur Cooling Towers ",
    },
    {
      field_type: "company",
      name: "Panacea Biotec ",
      field_id: "COM001456",
      website: "https://www.panaceabiotec.com/about-panacea-biotec",
      group: "",
      logo: "",
      company_id: "COM001456",
      company_name: "Panacea Biotec ",
      industry: "",
      display_name: "Panacea Biotec ",
    },
    {
      field_type: "company",
      name: "Panasonic Energy Co ",
      field_id: "COM000702",
      website: "https://www.panasonicenergyindia.in/companyprofile.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PANASONIC ENERGY CO LIMITED.png",
      company_id: "COM000702",
      company_name: "Panasonic Energy Co ",
      industry: "ELECTRICALS",
      display_name: "Panasonic Energy Co ",
    },
    {
      field_type: "company",
      name: "Panyam Cements",
      field_id: "COM001457",
      website: "https://www.panyamcements.com/",
      group: "",
      logo: "",
      company_id: "COM001457",
      company_name: "Panyam Cements",
      industry: "",
      display_name: "Panyam Cements",
    },
    {
      field_type: "company",
      name: "Parag Milk Foods ",
      field_id: "COM000703",
      website: "http://www.paragmilkfoods.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PARAG MILK FOODS LIMITED.png",
      company_id: "COM000703",
      company_name: "Parag Milk Foods ",
      display_name: "Parag Milk Foods ",
      sector: "Food Products",
      page_display_status: true,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Paragon Polymer Products  ",
      field_id: "COM000704",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000704",
      company_name: "Paragon Polymer Products  ",
      industry: "PLASTICS",
      display_name: "Paragon Polymer Products  ",
    },
    {
      field_type: "company",
      name: "Paras Pharma",
      field_id: "COM001458",
      website: "http://paraspharma.org/",
      group: "",
      logo: "",
      company_id: "COM001458",
      company_name: "Paras Pharma",
      industry: "",
      display_name: "Paras Pharma",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Parasakti Cement",
      field_id: "COM000705",
      website: "https://www.parasakticement.com/company-profile.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PARASAKTI CEMENT INDUSTRIES LIMITED.png",
      company_id: "COM000705",
      company_name: "Parasakti Cement",
      industry: "CEMENT",
      display_name: "Parasakti Cement",
    },
    {
      field_type: "company",
      name: "Parekhplast",
      field_id: "COM000706",
      website: "https://www.parekhplast.com/company/about/",
      group: "",
      logo: "",
      company_id: "COM000706",
      company_name: "Parekhplast",
      industry: "",
      display_name: "Parekhplast",
    },
    {
      field_type: "company",
      name: "Parenteral Drugs",
      field_id: "COM000707",
      website: "http://www.pdindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PARENTERAL DRUGS INDIA LIMITED.png",
      company_id: "COM000707",
      company_name: "Parenteral Drugs",
      industry: "PHARMACEUTICAL",
      display_name: "Parenteral Drugs",
    },
    {
      field_type: "company",
      name: "Parimal Mandir",
      field_id: "COM000708",
      website: "https://parimalmandir.in",
      group: "",
      logo: "",
      company_id: "COM000708",
      company_name: "Parimal Mandir",
      industry: "MANUFACTURING",
      display_name: "Parimal Mandir",
    },
    {
      field_type: "company",
      name: "Parle Agro  ",
      field_id: "COM000709",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PARLE AGRO PRIVATE LIMITED.png",
      company_id: "COM000709",
      company_name: "Parle Agro  ",
      display_name: "Parle Agro  ",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Parle Group",
      field_id: "COM000710",
      website: "",
      group: "Parle Group",
      logo: "",
      company_id: "COM000710",
      company_name: "Parle Group",
      industry: "",
      display_name: "Parle Group",
    },
    {
      field_type: "company",
      name: "Parle Products  ",
      field_id: "COM000711",
      website: "http://www.parleproducts.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PARLE PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM000711",
      company_name: "Parle Products  ",
      industry: "FMCG",
      display_name: "Parle Products  ",
    },
    {
      field_type: "company",
      name: "Parryware",
      field_id: "COM000712",
      website: "http://www.parryware.in/our-company/about-us/history",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PARRYWARE BATHROOM PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM000712",
      company_name: "Parryware",
      industry: "FMCD",
      display_name: "Parryware",
    },
    {
      field_type: "company",
      name: "Partap Fabrics  ",
      field_id: "COM000713",
      website: "",
      group: "Partap Group",
      logo: "",
      company_id: "COM000713",
      company_name: "Partap Fabrics  ",
      industry: "TEXTILE",
      display_name: "Partap Fabrics  ",
    },
    {
      field_type: "company",
      name: "Patanjali Ayurved ",
      field_id: "COM000714",
      website: "http://patanjaliayurved.org/",
      group: "",
      logo: "",
      company_id: "COM000714",
      company_name: "Patanjali Ayurved ",
      industry: "PHARMACEUTICAL",
      display_name: "Patanjali Ayurved ",
    },
    {
      field_type: "company",
      name: "PE Electronics ",
      field_id: "COM000718",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000718",
      company_name: "PE Electronics ",
      industry: "ELECTRONICS",
      display_name: "PE Electronics ",
    },
    {
      field_type: "company",
      name: "Pearl Drinks ",
      field_id: "COM000719",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000719",
      company_name: "Pearl Drinks ",
      industry: "BREWING",
      display_name: "Pearl Drinks ",
    },
    {
      field_type: "company",
      name: "Pearl Polymers ",
      field_id: "COM000720",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PEARL POLYMERS LIMITED.png",
      company_id: "COM000720",
      company_name: "Pearl Polymers ",
      industry: "PLASTICS",
      display_name: "Pearl Polymers ",
    },
    {
      field_type: "company",
      name: "Penna Cement",
      field_id: "COM000721",
      website: "https://www.pennacement.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Penna Cement Industries Limited.png",
      company_id: "COM000721",
      company_name: "Penna Cement",
      industry: "CEMENT",
      display_name: "Penna Cement",
    },
    {
      field_type: "company",
      name: "Pensol",
      field_id: "COM000722",
      website: "https://pensol.com/overview.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PENSOL INDUSTRIES LIMITED.png",
      company_id: "COM000722",
      company_name: "Pensol",
      industry: "CHEMICAL",
      display_name: "Pensol",
    },
    {
      field_type: "company",
      name: "Peps Industries  ",
      field_id: "COM001176",
      website: "http://www.pepsindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PEPS INDUSTRIES PRIVATE LIMITED.PNG",
      company_id: "COM001176",
      company_name: "Peps Industries  ",
      industry: "",
      display_name: "Peps Industries  ",
    },
    {
      field_type: "company",
      name: "Pepsico",
      field_id: "COM000724",
      website: "http://www.pepsicoindia.co.in/company/pepsico-india/about-us",
      group: "PEPSICO",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PEPSICO INCORPORATED.jpg",
      company_id: "COM000724",
      company_name: "Pepsico",
      industry: "BREWING",
      display_name: "Pepsico",
    },
    {
      field_type: "company",
      name: "Perfecto Electricals  ",
      field_id: "COM000725",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000725",
      company_name: "Perfecto Electricals  ",
      industry: "ELECTRICALS",
      display_name: "Perfecto Electricals  ",
    },
    {
      field_type: "company",
      name: "Perfetti Van Melle",
      field_id: "COM000727",
      website: "http://www.perfettivanmelle.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Perfetti Van Melle India Private Limited.jpg",
      company_id: "COM000727",
      company_name: "Perfetti Van Melle",
      display_name: "Perfetti Van Melle",
      sector: "FMCG",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Pernod Ricard",
      field_id: "COM000728",
      website: "https://www.pernod-ricard.com/en-in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Pernod%20Ricard.png",
      company_id: "COM000728",
      company_name: "Pernod Ricard",
      industry: "BREWING",
      display_name: "Pernod Ricard",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Perrigo",
      field_id: "COM001459",
      website: "https://www.perrigo.com/",
      group: "",
      logo: "",
      company_id: "COM001459",
      company_name: "Perrigo",
      industry: "",
      display_name: "Perrigo",
    },
    {
      field_type: "company",
      name: "Pfizer",
      field_id: "COM000729",
      website: "https://www.pfizerindia.com/eNewsWebsite/index.aspx",
      group: "",
      logo: "",
      company_id: "COM000729",
      company_name: "Pfizer",
      industry: "PHARMACEUTICAL",
      display_name: "Pfizer",
    },
    {
      field_type: "company",
      name: "Philip Morris",
      field_id: "COM001177",
      website: "https://www.pmi.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PHILIP MORRIS INDIA PRIVATE LIMITED.jpg",
      company_id: "COM001177",
      company_name: "Philip Morris",
      industry: "",
      display_name: "Philip Morris",
    },
    {
      field_type: "company",
      name: "Philips",
      field_id: "COM000731",
      website:
        "https://www.philips.co.in/content/corporate/en_IN/about-philips/company-profile.html/",
      group: "Royal Philips",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PHILIPS INDIA LIMITED.svg",
      company_id: "COM000731",
      company_name: "Philips",
      industry: "ELECTRICALS",
      display_name: "Philips",
    },
    {
      field_type: "company",
      name: "Phillips Carbon Black ",
      field_id: "COM000732",
      website: "https://www.pcblltd.com/about-us/",
      group: "RP-Sanjiv Goenka Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PHILLIPS CARBON BLACK LIMITED.jpg",
      company_id: "COM000732",
      company_name: "Phillips Carbon Black ",
      industry: "MANUFACTURING",
      display_name: "Phillips Carbon Black ",
    },
    {
      field_type: "company",
      name: "Pidilite",
      field_id: "COM000733",
      website: "http://www.pidilite.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PIDILITE INDUSTRIES LIMITED.png",
      company_id: "COM000733",
      company_name: "Pidilite",
      display_name: "Pidilite",
      sector: "Chemical",
      page_display_status: false,
      industry: "Chemical",
    },
    {
      field_type: "company",
      name: "Pilot",
      field_id: "COM000735",
      website: "https://pilotindustries.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PILOT INDUSTRIES LIMITED.jpg",
      company_id: "COM000735",
      company_name: "Pilot",
      industry: "METALS AND MINING",
      display_name: "Pilot",
    },
    {
      field_type: "company",
      name: "Pinnacle Biomed  ",
      field_id: "COM001282",
      website: "http://pinnaclebiomed.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PINNACLE BIOMED PRIVATE LIMITED.PNG",
      company_id: "COM001282",
      company_name: "Pinnacle Biomed  ",
      industry: "",
      display_name: "Pinnacle Biomed  ",
    },
    {
      field_type: "company",
      name: "Pioneer Electronics  ",
      field_id: "COM000736",
      website: "https://pioneer-india.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Pioneer India Electronics Private Limited.png",
      company_id: "COM000736",
      company_name: "Pioneer Electronics  ",
      display_name: "Pioneer Electronics  ",
      sector: "Electronics",
      page_display_status: false,
      industry: "Agri Inputs",
    },
    {
      field_type: "company",
      name: "Piramal Enterprises ",
      field_id: "COM000737",
      website: "https://www.piramal.com/about-us/who-we-are",
      group: "The Piramal Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PIRAMAL ENTERPRISES Limited.svg",
      company_id: "COM000737",
      company_name: "Piramal Enterprises ",
      industry: "PHARMACEUTICAL",
      display_name: "Piramal Enterprises ",
    },
    {
      field_type: "company",
      name: "Piramal Glass  ",
      field_id: "COM000738",
      website: "https://www.piramalglass.com/",
      group: "The Piramal Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PIRAMAL GLASS PRIVATE LIMITED.png",
      company_id: "COM000738",
      company_name: "Piramal Glass  ",
      industry: "GLASS",
      display_name: "Piramal Glass  ",
    },
    {
      field_type: "company",
      name: "Pitambari Products  ",
      field_id: "COM000739",
      website: "https://www.pitambari.com/",
      group: "Pitambari Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PITAMBARI PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM000739",
      company_name: "Pitambari Products  ",
      industry: "FMCG",
      display_name: "Pitambari Products  ",
    },
    {
      field_type: "company",
      name: "PKL Ltd",
      field_id: "COM001178",
      website: "https://www.clix.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PKL LIMITED.png",
      company_id: "COM001178",
      company_name: "PKL Ltd",
      industry: "",
      display_name: "PKL Ltd",
    },
    {
      field_type: "company",
      name: "Polycon ",
      field_id: "COM001179",
      website: "http://www.polyconltd.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/POLYCON INTERNATIONAL LTD..png",
      company_id: "COM001179",
      company_name: "Polycon ",
      industry: "",
      display_name: "Polycon ",
    },
    {
      field_type: "company",
      name: "Polycab",
      field_id: "COM000741",
      website: "https://polycab.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/POLYCAB WIRES PRIVATE LIMITED.png",
      company_id: "COM000741",
      company_name: "Polycab",
      industry: "MANUFACTURING",
      display_name: "Polycab",
    },
    {
      field_type: "company",
      name: "Portescap",
      field_id: "COM000742",
      website: "https://www.portescap.com/contact-portescap",
      group: "PORTESCAP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PORTESCAP INDIA PRIVATE LIMITED.png",
      company_id: "COM000742",
      company_name: "Portescap",
      industry: "MANUFACTURING",
      display_name: "Portescap",
    },
    {
      field_type: "company",
      name: "Posco India Steel Distribution Center  ",
      field_id: "COM000743",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000743",
      company_name: "Posco India Steel Distribution Center  ",
      industry: "STEEL",
      display_name: "Posco India Steel Distribution Center  ",
    },
    {
      field_type: "company",
      name: "Posco Maharashtra Steel  ",
      field_id: "COM001115",
      website: "http://www.poscomaharashtra.com",
      group: "",
      logo: "",
      company_id: "COM001115",
      company_name: "Posco Maharashtra Steel  ",
      industry: "",
      display_name: "Posco Maharashtra Steel  ",
    },
    {
      field_type: "company",
      name: "Power Grid Corp Of India ",
      field_id: "COM000730",
      website: "https://www.powergridindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/POWER GRID CORPORATION OF INDIA LIMITED.png",
      company_id: "COM000730",
      company_name: "Power Grid Corp Of India ",
      industry: "ELECTRICALS",
      display_name: "Power Grid Corp Of India ",
    },
    {
      field_type: "company",
      name: "PPG Asian Paints  ",
      field_id: "COM000746",
      website: "http://www.ppgasianpaints.com/about-us/who-we-are.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PPG Asian Paints Private Limited.png",
      company_id: "COM000746",
      company_name: "PPG Asian Paints  ",
      industry: "PAINTS",
      display_name: "PPG Asian Paints  ",
    },
    {
      field_type: "company",
      name: "Prabhu Chemicals",
      field_id: "COM000748",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000748",
      company_name: "Prabhu Chemicals",
      industry: "CHEMICAL",
      display_name: "Prabhu Chemicals",
    },
    {
      field_type: "company",
      name: "Prabu Soap Works",
      field_id: "COM000749",
      website: "http://www.arasansoap.net",
      group: "Arasan Group",
      logo: "",
      company_id: "COM000749",
      company_name: "Prabu Soap Works",
      industry: "FMCG",
      display_name: "Prabu Soap Works",
    },
    {
      field_type: "company",
      name: "Pragati Cemex  ",
      field_id: "COM001460",
      website: "https://www.pragaticement.com/",
      group: "",
      logo: "",
      company_id: "COM001460",
      company_name: "Pragati Cemex  ",
      industry: "",
      display_name: "Pragati Cemex  ",
    },
    {
      field_type: "company",
      name: "Praj Industries ",
      field_id: "COM000750",
      website: "https://www.praj.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PRAJ INDUSTRIES LIMITED.png",
      company_id: "COM000750",
      company_name: "Praj Industries ",
      industry: "ENGINEERING SERVICES",
      display_name: "Praj Industries ",
    },
    {
      field_type: "company",
      name: "Prakruti Machines",
      field_id: "COM000751",
      website: "https://prakrutimachines.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PRAKRUTI MACHINES.jpg",
      company_id: "COM000751",
      company_name: "Prakruti Machines",
      industry: "MANUFACTURING",
      display_name: "Prakruti Machines",
    },
    {
      field_type: "company",
      name: "Precision Camshafts ",
      field_id: "COM000717",
      website: "https://www.pclindia.in/about-us.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PRECISION CAMSHAFTS LIMITED.png",
      company_id: "COM000717",
      company_name: "Precision Camshafts ",
      industry: "MANUFACTURING",
      display_name: "Precision Camshafts ",
    },
    {
      field_type: "company",
      name: "Precision International",
      field_id: "COM000752",
      website: "http://transmissionkits.com/company/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PRECISION INTERNATIONAL.png",
      company_id: "COM000752",
      company_name: "Precision International",
      industry: "MANUFACTURING",
      display_name: "Precision International",
    },
    {
      field_type: "company",
      name: "Precision Pressing Manufacturers",
      field_id: "COM000753",
      website: "http://www.ppm.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PRECISION PRESSING MANUFACTURERS.png",
      company_id: "COM000753",
      company_name: "Precision Pressing Manufacturers",
      industry: "MANUFACTURING",
      display_name: "Precision Pressing Manufacturers",
    },
    {
      field_type: "company",
      name: "Precision Wires India ",
      field_id: "COM001180",
      website: "http://precisionwires.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PRECISION WIRES INDIA LIMITED.PNG",
      company_id: "COM001180",
      company_name: "Precision Wires India ",
      industry: "",
      display_name: "Precision Wires India ",
    },
    {
      field_type: "company",
      name: "Preet Tyres",
      field_id: "COM000754",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000754",
      company_name: "Preet Tyres",
      industry: "TYRE",
      display_name: "Preet Tyres",
    },
    {
      field_type: "company",
      name: "Premier Cables And Conductors  ",
      field_id: "COM001181",
      website: "https://premiercables.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PREMIER CABLES AND CONDUCTORS PRIVATE LIMITED.png",
      company_id: "COM001181",
      company_name: "Premier Cables And Conductors  ",
      industry: "",
      display_name: "Premier Cables And Conductors  ",
    },
    {
      field_type: "company",
      name: "Pricol ",
      field_id: "COM000755",
      website: "http://www.pricol.com/",
      group: "",
      logo: "",
      company_id: "COM000755",
      company_name: "Pricol ",
      industry: "AUTOMOBILE",
      display_name: "Pricol ",
    },
    {
      field_type: "company",
      name: "Primetals Technologies ",
      field_id: "COM000756",
      website: "https://www.primetals.com/about-us/corporate-organization/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/PRIMETALS TECHNOLOGIES LIMITED.png",
      company_id: "COM000756",
      company_name: "Primetals Technologies ",
      industry: "CONSTRUCTION",
      display_name: "Primetals Technologies ",
    },
    {
      field_type: "company",
      name: "Preton Plasma Physics Lab",
      field_id: "COM000747",
      website: "https://www.pppl.gov/about",
      group: "",
      logo: "",
      company_id: "COM000747",
      company_name: "Preton Plasma Physics Lab",
      industry: "",
      display_name: "Preton Plasma Physics Lab",
    },
    {
      field_type: "company",
      name: "Prism Johnson ",
      field_id: "COM001461",
      website: "http://prismjohnson.in/",
      group: "",
      logo: "",
      company_id: "COM001461",
      company_name: "Prism Johnson ",
      industry: "",
      display_name: "Prism Johnson ",
    },
    {
      field_type: "company",
      name: "Provimi",
      field_id: "COM000758",
      website: "https://www.provimi.in//",
      group: "Cargill Animal Nutrition",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Provimi Animal Nutrition India Private Limited.png",
      company_id: "COM000758",
      company_name: "Provimi",
      industry: "",
      display_name: "Provimi",
    },
    {
      field_type: "company",
      name: "Punj Lloyd ",
      field_id: "COM000759",
      website: "http://www.punjlloydgroup.com/",
      group: "PUNJ LLOYD GROUP",
      logo: "",
      company_id: "COM000759",
      company_name: "Punj Lloyd ",
      industry: "CONSTRUCTION",
      display_name: "Punj Lloyd ",
    },
    {
      field_type: "company",
      name: "Punjab Biomass Power ",
      field_id: "COM000716",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000716",
      company_name: "Punjab Biomass Power ",
      industry: "ENGINEERING SERVICES",
      display_name: "Punjab Biomass Power ",
    },
    {
      field_type: "company",
      name: "Quikr",
      field_id: "COM000760",
      website: "https://www.quikr.com/html/about.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/QUIKR INDIA PRIVATE LIMITED.png",
      company_id: "COM000760",
      company_name: "Quikr",
      industry: "ECOMMERCE",
      display_name: "Quikr",
    },
    {
      field_type: "company",
      name: "R Pac",
      field_id: "COM000810",
      website: "http://www.r-pac.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/r-pac International Corporation.jpg",
      company_id: "COM000810",
      company_name: "R Pac",
      industry: "LOGISTICS",
      display_name: "R Pac",
    },
    {
      field_type: "company",
      name: "R R Remedies  ",
      field_id: "COM000762",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000762",
      company_name: "R R Remedies  ",
      industry: "PHARMACEUTICAL",
      display_name: "R R Remedies  ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000763",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000763",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "R V Chemicals",
        field_id: "COM000763",
        website: "",
        group: "",
        logo: "",
        company_id: "COM000763",
        company_name: "R V Chemicals",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "R V Chemicals",
      field_id: "COM000818",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000818",
      company_name: "R V Chemicals",
      industry: "CHEMICAL",
      display_name: "R V Chemicals",
    },
    {
      field_type: "company",
      name: "Racold Thermo ",
      field_id: "COM000764",
      website: "https://www.racold.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RACOLD THERMO LIMITED.png",
      company_id: "COM000764",
      company_name: "Racold Thermo ",
      industry: "MANUFACTURING",
      display_name: "Racold Thermo ",
    },
    {
      field_type: "company",
      name: "Radhu Products  ",
      field_id: "COM000765",
      website: "https://www.radhutyres.com",
      group: "",
      logo: "",
      company_id: "COM000765",
      company_name: "Radhu Products  ",
      industry: "TYRE",
      display_name: "Radhu Products  ",
    },
    {
      field_type: "company",
      name: "Radiant Hitech Engg  ",
      field_id: "COM000766",
      website: "http://www.radiantengg.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RADIANT HITECH ENGG PRIVATE LIMITED.jpg",
      company_id: "COM000766",
      company_name: "Radiant Hitech Engg  ",
      industry: "ENGINEERING SERVICES",
      display_name: "Radiant Hitech Engg  ",
    },
    {
      field_type: "company",
      name: "Radico Khaitan ",
      field_id: "COM000767",
      website: "https://www.radicokhaitan.com/",
      group: "",
      logo: "",
      company_id: "COM000767",
      company_name: "Radico Khaitan ",
      industry: "CHEMICAL",
      display_name: "Radico Khaitan ",
    },
    {
      field_type: "company",
      name: "Rahul Detergents  ",
      field_id: "COM000769",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000769",
      company_name: "Rahul Detergents  ",
      industry: "FMCG",
      display_name: "Rahul Detergents  ",
    },
    {
      field_type: "company",
      name: "Rain Carbon orporated",
      field_id: "COM001462",
      website: "https://www.raincarbon.com/",
      group: "",
      logo: "",
      company_id: "COM001462",
      company_name: "Rain Carbon orporated",
      industry: "",
      display_name: "Rain Carbon orporated",
    },
    {
      field_type: "company",
      name: "Rain Industries ",
      field_id: "COM001463",
      website: "https://www.rain-industries.com/",
      group: "",
      logo: "",
      company_id: "COM001463",
      company_name: "Rain Industries ",
      industry: "",
      display_name: "Rain Industries ",
    },
    {
      field_type: "company",
      name: "Raina Engineering  ",
      field_id: "COM001283",
      website: "http://www.rainaengineers.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RAINA ENGINEERING PVT. LTD..gif",
      company_id: "COM001283",
      company_name: "Raina Engineering  ",
      industry: "",
      display_name: "Raina Engineering  ",
    },
    {
      field_type: "company",
      name: "Rainbow Denim ",
      field_id: "COM000770",
      website: "https://rainbowdenim.com/",
      group: "",
      logo: "",
      company_id: "COM000770",
      company_name: "Rainbow Denim ",
      industry: "FASHION AND CLOTHING",
      display_name: "Rainbow Denim ",
    },
    {
      field_type: "company",
      name: "Raja Crowns And Cans  ",
      field_id: "COM000771",
      website: "http://rajacans.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RAJA CROWNS AND CANS PRIVATE LIMITED.jpg",
      company_id: "COM000771",
      company_name: "Raja Crowns And Cans  ",
      industry: "MANUFACTURING",
      display_name: "Raja Crowns And Cans  ",
    },
    {
      field_type: "company",
      name: "Rajalakshmi Agro Corp",
      field_id: "COM000772",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000772",
      company_name: "Rajalakshmi Agro Corp",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Rajalakshmi Agro Corp",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Rajasthan Electronics And Instruments ",
      field_id: "COM001284",
      website: "http://www.reiljp.com/HindiWeb/indexH.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RAJASTHAN ELECTRONICS AND INSTRUMENTS LTD.gif",
      company_id: "COM001284",
      company_name: "Rajasthan Electronics And Instruments ",
      industry: "",
      display_name: "Rajasthan Electronics And Instruments ",
    },
    {
      field_type: "company",
      name: "Rajratan Global Wire ",
      field_id: "COM000775",
      website: "http://www.rajratan.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Rajratan Global Wire Limited.png",
      company_id: "COM000775",
      company_name: "Rajratan Global Wire ",
      industry: "MANUFACTURING",
      display_name: "Rajratan Global Wire ",
    },
    {
      field_type: "company",
      name: "Rajuri Steel  ",
      field_id: "COM001285",
      website: "http://www.rajuristeels.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RAJURI STEELS PRIVATE LIMITED.jpg",
      company_id: "COM001285",
      company_name: "Rajuri Steel  ",
      industry: "",
      display_name: "Rajuri Steel  ",
    },
    {
      field_type: "company",
      name: "Rak Ceramics",
      field_id: "COM000777",
      website: "https://www.rakceramics.com/uk/en/dealers/india/",
      group: "RAK Ceramics",
      logo: "",
      company_id: "COM000777",
      company_name: "Rak Ceramics",
      industry: "CERAMICS",
      display_name: "Rak Ceramics",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Rakyan Beverages  ",
      field_id: "COM000787",
      website: "https://www.rawpressery.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Rakyan Beverages.webp",
      company_id: "COM000787",
      company_name: "Rakyan Beverages  ",
      industry: "FMCG",
      display_name: "Rakyan Beverages  ",
    },
    {
      field_type: "company",
      name: "Rallis",
      field_id: "COM000778",
      website: "http://www.rallis.co.in/",
      group: "TATA Chemicals, TATA Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RALLIS INDIA LIMITED.jpg",
      company_id: "COM000778",
      company_name: "Rallis",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Rallis",
    },
    {
      field_type: "company",
      name: "Ramdev Food Products  ",
      field_id: "COM000779",
      website: "https://www.ramdev.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RAMDEV FOOD PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM000779",
      company_name: "Ramdev Food Products  ",
      industry: "FMCG",
      display_name: "Ramdev Food Products  ",
    },
    {
      field_type: "company",
      name: "Rane Holdings ",
      field_id: "COM000780",
      website: "http://ranegroup.com/products/",
      group: "Rane Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Rane Holdings Limited.png",
      company_id: "COM000780",
      company_name: "Rane Holdings ",
      industry: "AUTOMOBILE",
      display_name: "Rane Holdings ",
    },
    {
      field_type: "company",
      name: "Raptakos Brett",
      field_id: "COM000781",
      website: "http://www.raptakos.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Raptakos Brett & Co Limited.gif",
      company_id: "COM000781",
      company_name: "Raptakos Brett",
      industry: "PHARMACEUTICAL",
      display_name: "Raptakos Brett",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000782",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000782",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Rasaa Foods Private Limited",
        field_id: "COM000782",
        website: "",
        group: "",
        logo: "",
        company_id: "COM000782",
        company_name: "Rasaa Foods Private Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Rasaa Foods  ",
      field_id: "COM000784",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000784",
      company_name: "Rasaa Foods  ",
      industry: "",
      display_name: "Rasaa Foods  ",
    },
    {
      field_type: "company",
      name: "Rashmi Cement ",
      field_id: "COM001464",
      website: "https://www.rashmigroup.com/rashmi-cement-ltd/",
      group: "RASHMI GROUP",
      logo: "",
      company_id: "COM001464",
      company_name: "Rashmi Cement ",
      industry: "",
      display_name: "Rashmi Cement ",
    },
    {
      field_type: "company",
      name: "Rashtriya Chemicals And Fertilizers ",
      field_id: "COM001286",
      website: "http://www.rcfltd.com/index.php/hi/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RASHTRIYA CHEMICALS AND FERTILIZERS LIMITED.png",
      company_id: "COM001286",
      company_name: "Rashtriya Chemicals And Fertilizers ",
      industry: "",
      display_name: "Rashtriya Chemicals And Fertilizers ",
    },
    {
      field_type: "company",
      name: "Rasna  ",
      field_id: "COM000783",
      website: "https://www.rasnainternational.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RASNA PRIVATE LIMITED.png",
      company_id: "COM000783",
      company_name: "Rasna  ",
      industry: "BREWING",
      display_name: "Rasna  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Ratnamani Metals And Tubes ",
      field_id: "COM001287",
      website: "http://www.ratnamani.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RATNAMANI METALS AND TUBES LIMITED.png",
      company_id: "COM001287",
      company_name: "Ratnamani Metals And Tubes ",
      industry: "",
      display_name: "Ratnamani Metals And Tubes ",
    },
    {
      field_type: "company",
      name: "Ratnasagar Herbals  ",
      field_id: "COM000785",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000785",
      company_name: "Ratnasagar Herbals  ",
      industry: "HEALTHCARE",
      display_name: "Ratnasagar Herbals  ",
    },
    {
      field_type: "company",
      name: "Ravin Cables ",
      field_id: "COM001288",
      website: "http://www.ravincables.com/",
      group: "Group Snap Available",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RAVIN CABLES LTD.gif",
      company_id: "COM001288",
      company_name: "Ravin Cables ",
      industry: "",
      display_name: "Ravin Cables ",
    },
    {
      field_type: "company",
      name: "Ravish Tyres",
      field_id: "COM000786",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000786",
      company_name: "Ravish Tyres",
      industry: "TYRE",
      display_name: "Ravish Tyres",
    },
    {
      field_type: "company",
      name: "Raymond ",
      field_id: "COM000788",
      website: "http://www.raymond.in/theraymondgroup?subcat=130",
      group: "Raymond Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RAYMOND LIMITED.png",
      company_id: "COM000788",
      company_name: "Raymond ",
      industry: "FASHION AND CLOTHING",
      display_name: "Raymond ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "RDC Concrete India  ",
      field_id: "COM000790",
      website: "https://www.rdcconcrete.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RDC CONCRETE INDIA PRIVATE LIMITED.png",
      company_id: "COM000790",
      company_name: "RDC Concrete India  ",
      industry: "CEMENT",
      display_name: "RDC Concrete India  ",
    },
    {
      field_type: "company",
      name: "RB - Reckitt Benckiser",
      field_id: "COM000791",
      website: "https://www.rb.com/offices/india/",
      group: "Reckitt Benckiser Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RB%20-%20Reckitt%20Benckiser.jpg",
      company_id: "COM000791",
      company_name: "RB - Reckitt Benckiser",
      display_name: "RB - Reckitt Benckiser",
      sector: "FMCG",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Relaxo Footwears ",
      field_id: "COM000792",
      website: "http://www.relaxofootwear.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Relaxo Footwears Limited.png",
      company_id: "COM000792",
      company_name: "Relaxo Footwears ",
      industry: "FASHION AND CLOTHING",
      display_name: "Relaxo Footwears ",
    },
    {
      field_type: "company",
      name: "Reliance Cement Co",
      field_id: "COM000794",
      website: "",
      group: "RELIANCE INDUSTRIES LIMITED",
      logo: "",
      company_id: "COM000794",
      company_name: "Reliance Cement Co",
      industry: "CEMENT",
      display_name: "Reliance Cement Co",
    },
    {
      field_type: "company",
      name: "Reliance Dyes",
      field_id: "COM000795",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000795",
      company_name: "Reliance Dyes",
      industry: "CHEMICAL",
      display_name: "Reliance Dyes",
    },
    {
      field_type: "company",
      name: "Reliance Industries",
      field_id: "COM000793",
      website: "https://www.ril.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RELIANCE INDUSTRIES LIMITED.png",
      company_id: "COM000793",
      company_name: "Reliance Industries",
      industry: "CONGLOMERATE",
      display_name: "Reliance Industries",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Reliance Jio ",
      field_id: "COM000796",
      website: "https://www.jio.com/",
      group: "RELIANCE INDUSTRIES LIMITED",
      logo: "",
      company_id: "COM000796",
      company_name: "Reliance Jio ",
      industry: "TELECOM",
      display_name: "Reliance Jio ",
    },
    {
      field_type: "company",
      name: "Reliance Petroleum ",
      field_id: "COM001465",
      website: "https://www.reliancepetroleum.com/",
      group: "",
      logo: "",
      company_id: "COM001465",
      company_name: "Reliance Petroleum ",
      industry: "",
      display_name: "Reliance Petroleum ",
    },
    {
      field_type: "company",
      name: "Reliance Retail ",
      field_id: "COM000797",
      website: "https://www.relianceretail.com/",
      group: "RELIANCE INDUSTRIES LIMITED",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RELIANCE RETAIL LIMITED.png",
      company_id: "COM000797",
      company_name: "Reliance Retail ",
      industry: "FMCG",
      display_name: "Reliance Retail ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "RBI - Reserve Bank Of India",
      field_id: "COM000789",
      website: "https://www.rbi.org.in/home.aspx",
      group: "",
      logo: "",
      company_id: "COM000789",
      company_name: "RBI - Reserve Bank Of India",
      industry: "PRINTING AND MINTING",
      display_name: "RBI - Reserve Bank Of India",
    },
    {
      field_type: "company",
      name: "Rexam Beverage Can",
      field_id: "COM000798",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000798",
      company_name: "Rexam Beverage Can",
      industry: "BREWING",
      display_name: "Rexam Beverage Can",
    },
    {
      field_type: "company",
      name: "Rhodium Ferro Alloys  ",
      field_id: "COM001291",
      website: "http://ferroalloys.net/about.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RHODIUM FERRO ALLOYS PRIVATE LIMITED.png",
      company_id: "COM001291",
      company_name: "Rhodium Ferro Alloys  ",
      industry: "",
      display_name: "Rhodium Ferro Alloys  ",
    },
    {
      field_type: "company",
      name: "Rich Graviss Products  ",
      field_id: "COM001292",
      website: "http://www.richgraviss.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RICH GRAVISS PRODUCTS PRIVATE LIMITED.png",
      company_id: "COM001292",
      company_name: "Rich Graviss Products  ",
      industry: "",
      display_name: "Rich Graviss Products  ",
    },
    {
      field_type: "company",
      name: "Ricoh ",
      field_id: "COM000799",
      website: "https://www.ricoh.co.in/",
      group: "Ricoh Group",
      logo: "",
      company_id: "COM000799",
      company_name: "Ricoh ",
      industry: "TECHNOLOGY",
      display_name: "Ricoh ",
    },
    {
      field_type: "company",
      name: "Rimjhim Ispat ",
      field_id: "COM000801",
      website: "http://www.rimjhimispat.com/",
      group: "Novel Sugar, Juhi Alloys, Rimjhim Steel",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RIMJHIM ISPAT LIMITED.png",
      company_id: "COM000801",
      company_name: "Rimjhim Ispat ",
      industry: "STEEL",
      display_name: "Rimjhim Ispat ",
    },
    {
      field_type: "company",
      name: "Rittal  ",
      field_id: "COM000803",
      website: "https://www.rittal.com/in-en/content/en/start/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RITTAL INDIA PRIVATE LIMITED.gif",
      company_id: "COM000803",
      company_name: "Rittal  ",
      industry: "ENGINEERING SERVICES",
      display_name: "Rittal  ",
    },
    {
      field_type: "company",
      name: "RNB Cements  ",
      field_id: "COM001466",
      website: "https://www.rnbgroup.org/",
      group: "RNB GROUP",
      logo: "",
      company_id: "COM001466",
      company_name: "RNB Cements  ",
      industry: "",
      display_name: "RNB Cements  ",
    },
    {
      field_type: "company",
      name: "Roca Bathroom Products  ",
      field_id: "COM000805",
      website: "http://www.roca.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ROCA BATHROOM PRODUCTS PRIVATE LIMITED.PNG",
      company_id: "COM000805",
      company_name: "Roca Bathroom Products  ",
      industry: "FMCD",
      display_name: "Roca Bathroom Products  ",
    },
    {
      field_type: "company",
      name: "Rockwell Automation  ",
      field_id: "COM001099",
      website: "https://www.rockwellautomation.com/en_IN/overview.page",
      group: "Rockwell Automation, Inc.",
      logo: "",
      company_id: "COM001099",
      company_name: "Rockwell Automation  ",
      industry: "",
      display_name: "Rockwell Automation  ",
    },
    {
      field_type: "company",
      name: "Rockworth Systems Furniture",
      field_id: "COM001082",
      website: "http://rockworth.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ROCKWORTH.png",
      company_id: "COM001082",
      company_name: "Rockworth Systems Furniture",
      industry: "",
      display_name: "Rockworth Systems Furniture",
    },
    {
      field_type: "company",
      name: "Rohit Ferro Tech ",
      field_id: "COM000806",
      website: "https://www.rohitferrotech.com/",
      group: "Sky Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ROHIT FERRO-TECH LIMITED.png",
      company_id: "COM000806",
      company_name: "Rohit Ferro Tech ",
      industry: "MANUFACTURING",
      display_name: "Rohit Ferro Tech ",
    },
    {
      field_type: "company",
      name: "Rolastar  ",
      field_id: "COM000807",
      website: "https://www.rolastar.com/",
      group: "Ruskin titus India plc",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ROLASTAR PRIVATE LIMITED.jpg",
      company_id: "COM000807",
      company_name: "Rolastar  ",
      industry: "MANUFACTURING",
      display_name: "Rolastar  ",
    },
    {
      field_type: "company",
      name: "Rr Remedies",
      field_id: "COM000811",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000811",
      company_name: "Rr Remedies",
      industry: "",
      display_name: "Rr Remedies",
    },
    {
      field_type: "company",
      name: "RSAL Steel  ",
      field_id: "COM000814",
      website: "https://www.rsalsteel.com/",
      group: "Ruchi Strips & Alloys",
      logo: "",
      company_id: "COM000814",
      company_name: "RSAL Steel  ",
      industry: "STEEL",
      display_name: "RSAL Steel  ",
    },
    {
      field_type: "company",
      name: "Ruchi Soya Industries ",
      field_id: "COM000815",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000815",
      company_name: "Ruchi Soya Industries ",
      display_name: "Ruchi Soya Industries ",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Ruma Isolator Co",
      field_id: "COM000816",
      website: "https://rumaisolator.in/about.htm",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RUMA ISOLATOR COMPANY.png",
      company_id: "COM000816",
      company_name: "Ruma Isolator Co",
      industry: "MANUFACTURING",
      display_name: "Ruma Isolator Co",
    },
    {
      field_type: "company",
      name: "Rushi Enterprise",
      field_id: "COM000817",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000817",
      company_name: "Rushi Enterprise",
      industry: "FMCG",
      display_name: "Rushi Enterprise",
    },
    {
      field_type: "company",
      name: "S A I Brushes  ",
      field_id: "COM000823",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000823",
      company_name: "S A I Brushes  ",
      industry: "FMCG",
      display_name: "S A I Brushes  ",
    },
    {
      field_type: "company",
      name: "SC Johnson",
      field_id: "COM000819",
      website: "https://www.scjohnson.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/S C JOHNSON & SON INC.svg",
      company_id: "COM000819",
      company_name: "SC Johnson",
      display_name: "SC Johnson",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "SP Auto Engineering Works  ",
      field_id: "COM000887",
      website: "http://spautogroup.com/",
      group: "S P Auto Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/S P Auto Engineering Works Private Limited.png",
      company_id: "COM000887",
      company_name: "SP Auto Engineering Works  ",
      industry: "AUTOMOBILE",
      display_name: "SP Auto Engineering Works  ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000821",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000821",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "S P S Processors Private Limited",
        field_id: "COM000821",
        website: "",
        group: "",
        logo: "",
        company_id: "COM000821",
        company_name: "S P S Processors Private Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "SPS Processors  ",
      field_id: "COM000889",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000889",
      company_name: "SPS Processors  ",
      industry: "",
      display_name: "SPS Processors  ",
    },
    {
      field_type: "company",
      name: "SS Engineering Works",
      field_id: "COM000824",
      website: "https://www.ssenggworks.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/S S ENGINEERING WORKS.jpg",
      company_id: "COM000824",
      company_name: "SS Engineering Works",
      industry: "MANUFACTURING",
      display_name: "SS Engineering Works",
    },
    {
      field_type: "company",
      name: "S S Fasteners  ",
      field_id: "COM000822",
      website: "http://ssfasteners.net/",
      group: "http://ssfasteners.net/",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/S S FASTENERS PRIVATE LIMITED.png",
      company_id: "COM000822",
      company_name: "S S Fasteners  ",
      industry: "MANUFACTURING",
      display_name: "S S Fasteners  ",
    },
    {
      field_type: "company",
      name: "SAB Miller ",
      field_id: "COM000825",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000825",
      company_name: "SAB Miller ",
      industry: "BREWING",
      display_name: "SAB Miller ",
    },
    {
      field_type: "company",
      name: "Sachi Steel ",
      field_id: "COM001293",
      website: "https://www.sachiagency.com/",
      group:
        "SACHI AGENCY is authorised distributor of TATA TISCON for Gujarat. ",
      logo: "",
      company_id: "COM001293",
      company_name: "Sachi Steel ",
      industry: "",
      display_name: "Sachi Steel ",
    },
    {
      field_type: "company",
      name: "Sagar Cements ",
      field_id: "COM000827",
      website: "http://www.sagarcements.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAGAR CEMENTS LIMITED.gif",
      company_id: "COM000827",
      company_name: "Sagar Cements ",
      industry: "CEMENT",
      display_name: "Sagar Cements ",
    },
    {
      field_type: "company",
      name: "Sahara Q Shop",
      field_id: "COM000828",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000828",
      company_name: "Sahara Q Shop",
      industry: "",
      display_name: "Sahara Q Shop",
    },
    {
      field_type: "company",
      name: "Sahyadri Industries ",
      field_id: "COM000829",
      website: "http://www.silworld.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAHYADRI INDUSTRIES LIMITED.png",
      company_id: "COM000829",
      company_name: "Sahyadri Industries ",
      industry: "BUILDING MATERIAL",
      display_name: "Sahyadri Industries ",
    },
    {
      field_type: "company",
      name: "Saint Gobain - Glass",
      field_id: "COM000564",
      website: "https://www.saint-gobain.co.in/",
      group: "SAINT GOBAIN GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAINT GOBAIN GLASS INDIA PRIVATE LIMITED.jpg",
      company_id: "COM000564",
      company_name: "Saint Gobain - Glass",
      industry: "GLASS",
      display_name: "Saint Gobain - Glass",
    },
    {
      field_type: "company",
      name: "Saint Gobain - Gyproc",
      field_id: "COM000565",
      website: "https://www.gyproc.in/home",
      group: "SAINT GOBAIN GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAINT GOBAIN GYPROC INDIA LIMITED.png",
      company_id: "COM000565",
      company_name: "Saint Gobain - Gyproc",
      industry: "BUILDING MATERIAL",
      display_name: "Saint Gobain - Gyproc",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Saint Gobain India",
      field_id: "COM000845",
      website: "https://www.saint-gobain.co.in",
      group: "",
      logo: "",
      company_id: "COM000845",
      company_name: "Saint Gobain India",
      industry: "",
      display_name: "Saint Gobain India",
    },
    {
      field_type: "company",
      name: "Saint Gobain Sekurit India ",
      field_id: "COM001294",
      website: "http://www.sekuritindia.com/",
      group: "Indian subsidiary of Saint-Gobain Sekurit France",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAINT-GOBAIN SEKURIT INDIA LIMITED.jpg",
      company_id: "COM001294",
      company_name: "Saint Gobain Sekurit India ",
      industry: "",
      display_name: "Saint Gobain Sekurit India ",
    },
    {
      field_type: "company",
      name: "Saint Gobain - Weber",
      field_id: "COM000831",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAINT-GOBAIN WEBER INDIA PRIVATE LIMITED.svg",
      company_id: "COM000831",
      company_name: "Saint Gobain - Weber",
      industry: "BUILDING MATERIAL",
      display_name: "Saint Gobain - Weber",
    },
    {
      field_type: "company",
      name: "Saj Food Products  ",
      field_id: "COM000832",
      website: "http://www.biskfarm.com/About-Us",
      group: "Aparna Group of Companies",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/BISK FARM.png",
      company_id: "COM000832",
      company_name: "Saj Food Products  ",
      industry: "FMCG",
      display_name: "Saj Food Products  ",
    },
    {
      field_type: "company",
      name: "Saj Test Plant  ",
      field_id: "COM001295",
      website: "http://www.sajdyno.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAJ TEST PLANT PRIVATE LIMITED.PNG",
      company_id: "COM001295",
      company_name: "Saj Test Plant  ",
      industry: "",
      display_name: "Saj Test Plant  ",
    },
    {
      field_type: "company",
      name: "Sakthi Auto Component ",
      field_id: "COM001296",
      website: "https://www.sakthiauto.com/",
      group: "Group Snap Available",
      logo: "",
      company_id: "COM001296",
      company_name: "Sakthi Auto Component ",
      industry: "",
      display_name: "Sakthi Auto Component ",
    },
    {
      field_type: "company",
      name: "Sampoorna Feeds  ",
      field_id: "COM000833",
      website: "http://sampoornafeeds.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAMPOORNA FEEDS PRIVATE LIMITED.png",
      company_id: "COM000833",
      company_name: "Sampoorna Feeds  ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Sampoorna Feeds  ",
    },
    {
      field_type: "company",
      name: "Samsonite South Asia  ",
      field_id: "COM000834",
      website: "https://www.samsoniteindia.com/contact-us.html",
      group: "",
      logo: "",
      company_id: "COM000834",
      company_name: "Samsonite South Asia  ",
      display_name: "Samsonite South Asia  ",
      sector: "Luggage",
      page_display_status: false,
      industry: "Luggage",
    },
    {
      field_type: "company",
      name: "Samsung  ",
      field_id: "COM000835",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000835",
      company_name: "Samsung  ",
      industry: "ELECTRONICS",
      display_name: "Samsung  ",
    },
    {
      field_type: "company",
      name: "Sandoz",
      field_id: "COM001467",
      website: "https://www.sandoz.com/",
      group: "",
      logo: "",
      company_id: "COM001467",
      company_name: "Sandoz",
      industry: "",
      display_name: "Sandoz",
    },
    {
      field_type: "company",
      name: "Sanofi",
      field_id: "COM000836",
      website: "https://www.sanofi.com/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SANOFI.png",
      company_id: "COM000836",
      company_name: "Sanofi",
      industry: "PHARMACEUTICAL",
      display_name: "Sanofi",
    },
    {
      field_type: "company",
      name: "Saraca Labs ",
      field_id: "COM001468",
      website: "https://www.saraca.com/",
      group: "",
      logo: "",
      company_id: "COM001468",
      company_name: "Saraca Labs ",
      industry: "",
      display_name: "Saraca Labs ",
    },
    {
      field_type: "company",
      name: "Sarvotham Care ",
      field_id: "COM000837",
      website: "https://sarvothamcare.com/",
      group: "",
      logo: "",
      company_id: "COM000837",
      company_name: "Sarvotham Care ",
      industry: "PHARMACEUTICAL",
      display_name: "Sarvotham Care ",
    },
    {
      field_type: "company",
      name: "Satrac Engineering  ",
      field_id: "COM001297",
      website: "https://www.satrac.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SATRAC ENGINEERING PRIVATE LIMITED.png",
      company_id: "COM001297",
      company_name: "Satrac Engineering  ",
      industry: "",
      display_name: "Satrac Engineering  ",
    },
    {
      field_type: "company",
      name: "Satyam Roller Flour Mills  ",
      field_id: "COM000839",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000839",
      company_name: "Satyam Roller Flour Mills  ",
      industry: "FMCG",
      display_name: "Satyam Roller Flour Mills  ",
    },
    {
      field_type: "company",
      name: "Saurashtra Cement ",
      field_id: "COM001469",
      website: "http://www.hathi-sidheecements.com/hathi_site/",
      group: "THE MEHTA GROUP",
      logo: "",
      company_id: "COM001469",
      company_name: "Saurashtra Cement ",
      industry: "",
      display_name: "Saurashtra Cement ",
    },
    {
      field_type: "company",
      name: "Savera Pharma  ",
      field_id: "COM001470",
      website: "https://saverapharma.com/",
      group: "",
      logo: "",
      company_id: "COM001470",
      company_name: "Savera Pharma  ",
      industry: "",
      display_name: "Savera Pharma  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Schlumberger Asia Services ",
      field_id: "COM000840",
      website: "https://www.slb.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SCHLUMBERGER ASIA SERVICES LIMITED.svg",
      company_id: "COM000840",
      company_name: "Schlumberger Asia Services ",
      industry: "OIL AND GAS",
      display_name: "Schlumberger Asia Services ",
    },
    {
      field_type: "company",
      name: "Schneider Electric  ",
      field_id: "COM000841",
      website:
        "https://www.schneider-electric.co.in/en/about-us/company-profile/#",
      group: "Schneider Electric SE",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Schneider Electric India Private Limited.svg",
      company_id: "COM000841",
      company_name: "Schneider Electric  ",
      industry: "ELECTRICALS",
      display_name: "Schneider Electric  ",
    },
    {
      field_type: "company",
      name: "Schreiber Foods",
      field_id: "COM000842",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Schreiber Foods Incorporated.png",
      company_id: "COM000842",
      company_name: "Schreiber Foods",
      industry: "FMCG",
      display_name: "Schreiber Foods",
    },
    {
      field_type: "company",
      name: "Schwing Stetter  ",
      field_id: "COM000843",
      website: "https://www.schwingstetterindia.com/",
      group: "Schwing Group of companies GmbH",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SCHWING STETTER INDIA PRIVATE LIMITED.png",
      company_id: "COM000843",
      company_name: "Schwing Stetter  ",
      industry: "MANUFACTURING",
      display_name: "Schwing Stetter  ",
    },
    {
      field_type: "company",
      name: "Sealwel Corp  ",
      field_id: "COM000844",
      website: "http://www.sealwel.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SEALWEL CORPORATION PRIVATE LIMITED.jpg",
      company_id: "COM000844",
      company_name: "Sealwel Corp  ",
      industry: "ELECTRICALS",
      display_name: "Sealwel Corp  ",
    },
    {
      field_type: "company",
      name: "Shahi Exports  ",
      field_id: "COM000846",
      website: "https://www.shahi.co.in/",
      group: "",
      logo: "",
      company_id: "COM000846",
      company_name: "Shahi Exports  ",
      industry: "LOGISTICS",
      display_name: "Shahi Exports  ",
    },
    {
      field_type: "company",
      name: "Shakti Bhog Foods ",
      field_id: "COM000847",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000847",
      company_name: "Shakti Bhog Foods ",
      industry: "FMCG",
      display_name: "Shakti Bhog Foods ",
    },
    {
      field_type: "company",
      name: "Shalimar Paints ",
      field_id: "COM000848",
      website: "https://industrial.shalimarpaints.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHALIMAR PAINTS LIMITED.jpg",
      company_id: "COM000848",
      company_name: "Shalimar Paints ",
      industry: "PAINTS",
      display_name: "Shalimar Paints ",
    },
    {
      field_type: "company",
      name: "Shanghai Acebright Pharma",
      field_id: "COM001471",
      website: "http://www.acebright.com/",
      group: "Acebright",
      logo: "",
      company_id: "COM001471",
      company_name: "Shanghai Acebright Pharma",
      industry: "",
      display_name: "Shanghai Acebright Pharma",
    },
    {
      field_type: "company",
      name: "Shapoorji Paloonji",
      field_id: "COM000849",
      website: "",
      group: "Shapoorji Pallonji Group",
      logo: "",
      company_id: "COM000849",
      company_name: "Shapoorji Paloonji",
      industry: "CONGLOMERATE",
      display_name: "Shapoorji Paloonji",
    },
    {
      field_type: "company",
      name: "Shasun Pharma ",
      field_id: "COM001083",
      website: "https://scrip.pharmaintelligence.informa.com",
      group: "",
      logo: "",
      company_id: "COM001083",
      company_name: "Shasun Pharma ",
      industry: "",
      display_name: "Shasun Pharma ",
    },
    {
      field_type: "company",
      name: "Sheela Foam ",
      field_id: "COM000850",
      website: "http://www.sheelafoam.com/about-us.html",
      group: "Sheela Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHEELA FOAM  LIMITED.jpg",
      company_id: "COM000850",
      company_name: "Sheela Foam ",
      industry: "MANUFACTURING",
      display_name: "Sheela Foam ",
    },
    {
      field_type: "company",
      name: "Shell India",
      field_id: "COM000851",
      website: "https://www.shell.in/",
      group: "Shell India",
      logo: "",
      company_id: "COM000851",
      company_name: "Shell India",
      industry: "CHEMICAL",
      display_name: "Shell India",
    },
    {
      field_type: "company",
      name: "Shell Mrpl Aviation Fuels And Services ",
      field_id: "COM000852",
      website: "http://shellmrpl.co.in/",
      group: "Shell India",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHELL MRPL AVIATION FUELS & SERVICES LIMITED.jpg",
      company_id: "COM000852",
      company_name: "Shell Mrpl Aviation Fuels And Services ",
      industry: "",
      display_name: "Shell Mrpl Aviation Fuels And Services ",
    },
    {
      field_type: "company",
      name: "Shifa Remedies  ",
      field_id: "COM000853",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000853",
      company_name: "Shifa Remedies  ",
      industry: "PHARMACEUTICAL",
      display_name: "Shifa Remedies  ",
    },
    {
      field_type: "company",
      name: "Shlok Chemicals",
      field_id: "COM000854",
      website: "https://shlokchemicals.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHLOK CHEMICALS.png",
      company_id: "COM000854",
      company_name: "Shlok Chemicals",
      industry: "CHEMICAL",
      display_name: "Shlok Chemicals",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Shoppers Stop",
      field_id: "COM000855",
      website: "https://www.shoppersstop.com/",
      group: "K Raheja Corp Group",
      logo: "",
      company_id: "COM000855",
      company_name: "Shoppers Stop",
      display_name: "Shoppers Stop",
      sector: "Fashion and Clothing",
      page_display_status: false,
      industry: "Retail",
    },
    {
      field_type: "company",
      name: "Shree Amba Industries",
      field_id: "COM000856",
      website: "https://www.shreeamba.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHREE AMBA INDUSTRIES.png",
      company_id: "COM000856",
      company_name: "Shree Amba Industries",
      industry: "MANUFACTURING",
      display_name: "Shree Amba Industries",
    },
    {
      field_type: "company",
      name: "Shree Cement ",
      field_id: "COM000857",
      website: "https://www.shreecement.com/pages/about.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHREE CEMENT LIMITED.png",
      company_id: "COM000857",
      company_name: "Shree Cement ",
      industry: "CEMENT",
      display_name: "Shree Cement ",
    },
    {
      field_type: "company",
      name: "Shree Digvijay Cement Company ",
      field_id: "COM001472",
      website: "https://www.digvijaycement.com/",
      group: "",
      logo: "",
      company_id: "COM001472",
      company_name: "Shree Digvijay Cement Company ",
      industry: "",
      display_name: "Shree Digvijay Cement Company ",
    },
    {
      field_type: "company",
      name: "Shree Krishna Paper Mills And Industries ",
      field_id: "COM000858",
      website: "https://www.skpmil.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHREE KRISHNA PAPER MILLS & INDUSTRIES LIMITED.png",
      company_id: "COM000858",
      company_name: "Shree Krishna Paper Mills And Industries ",
      industry: "PAPER",
      display_name: "Shree Krishna Paper Mills And Industries ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Shree Krishna Tyre",
      field_id: "COM000859",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000859",
      company_name: "Shree Krishna Tyre",
      industry: "",
      display_name: "Shree Krishna Tyre",
    },
    {
      field_type: "company",
      name: "Shree Precoated Steels ",
      field_id: "COM001298",
      website: "http://www.spsl.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHREE PRECOATED STEELS LIMITED.jpg",
      company_id: "COM001298",
      company_name: "Shree Precoated Steels ",
      industry: "",
      display_name: "Shree Precoated Steels ",
    },
    {
      field_type: "company",
      name: "Shree Rajasthan Syntex ",
      field_id: "COM001100",
      website: "http://www.srsl.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHREE RAJASTHAN SYNTEX LIMITED.png",
      company_id: "COM001100",
      company_name: "Shree Rajasthan Syntex ",
      industry: "",
      display_name: "Shree Rajasthan Syntex ",
    },
    {
      field_type: "company",
      name: "Shree Rayalseema Hypo Hi Strenght ",
      field_id: "COM000860",
      website: "https://www.tgvgroup.com/srhhl/about%20us.html",
      group: "TGV Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHREE RAYALSEEMA HYPO HI-STRENGHT LIMITED.jpg",
      company_id: "COM000860",
      company_name: "Shree Rayalseema Hypo Hi Strenght ",
      industry: "",
      display_name: "Shree Rayalseema Hypo Hi Strenght ",
    },
    {
      field_type: "company",
      name: "Shree Renuka Sugars ",
      field_id: "COM001290",
      website: "http://www.renukasugars.com/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHREE RENUKA SUGARS LIMITED.png",
      company_id: "COM001290",
      company_name: "Shree Renuka Sugars ",
      industry: "",
      display_name: "Shree Renuka Sugars ",
    },
    {
      field_type: "company",
      name: "Shreya Life Sciences  ",
      field_id: "COM000861",
      website: "http://www.shreya.co.in/",
      group: "Shreya Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHREYA LIFE SCIENCES PRIVATE LIMITED.jpg",
      company_id: "COM000861",
      company_name: "Shreya Life Sciences  ",
      industry: "PHARMACEUTICAL",
      display_name: "Shreya Life Sciences  ",
    },
    {
      field_type: "company",
      name: "Shriji Polymers ",
      field_id: "COM000862",
      website: "https://shrijipolymers.com/company-profile/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHRIJI POLYMERS INDIA LIMITED.png",
      company_id: "COM000862",
      company_name: "Shriji Polymers ",
      industry: "PLASTICS",
      display_name: "Shriji Polymers ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Shyam Metalics And Energy ",
      field_id: "COM001084",
      website: "https://www.shyammetalics.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SHYAM METALICS AND ENERGY LIMITED.png",
      company_id: "COM001084",
      company_name: "Shyam Metalics And Energy ",
      industry: "METALS AND MINING",
      display_name: "Shyam Metalics And Energy ",
    },
    {
      field_type: "company",
      name: "SICAGEN",
      field_id: "COM000864",
      website: "https://sicagen.com/about-overview/",
      group: "AM International",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SICAGEN INDIA LIMITED.png",
      company_id: "COM000864",
      company_name: "SICAGEN",
      industry: "INFRASTRUCTURE",
      display_name: "SICAGEN",
    },
    {
      field_type: "company",
      name: "Siddharth Grease",
      field_id: "COM001473",
      website: "http://www.siddharthpetro.com/",
      group: "",
      logo: "",
      company_id: "COM001473",
      company_name: "Siddharth Grease",
      industry: "",
      display_name: "Siddharth Grease",
    },
    {
      field_type: "company",
      name: "Sidhi Vinayaka Fab Engineering  ",
      field_id: "COM000867",
      website: "http://sidhivinayakafab.com/index.html",
      group: "",
      logo: "",
      company_id: "COM000867",
      company_name: "Sidhi Vinayaka Fab Engineering  ",
      industry: "MANUFACTURING",
      display_name: "Sidhi Vinayaka Fab Engineering  ",
    },
    {
      field_type: "company",
      name: "Siechem Technologies  ",
      field_id: "COM000868",
      website: "https://www.siechem.com/company/about-us/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Siechem Technologies PRIVATE LIMITED.jpg",
      company_id: "COM000868",
      company_name: "Siechem Technologies  ",
      industry: "",
      display_name: "Siechem Technologies  ",
    },
    {
      field_type: "company",
      name: "Siemens Gamesa Renewable Power  ",
      field_id: "COM000869",
      website: "https://www.siemensgamesa.com/en-int",
      group: "Siemens Gamesa Renewable Energy S.A",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SIEMENS GAMESA RENEWABLE ENERGY.png",
      company_id: "COM000869",
      company_name: "Siemens Gamesa Renewable Power  ",
      industry: "ENGINEERING SERVICES",
      display_name: "Siemens Gamesa Renewable Power  ",
    },
    {
      field_type: "company",
      name: "Siemens Healthcare  ",
      field_id: "COM000870",
      website: "https://www.siemens-healthineers.com/en-in/about",
      group: "Siemens AG",
      logo: "",
      company_id: "COM000870",
      company_name: "Siemens Healthcare  ",
      industry: "HEALTHCARE",
      display_name: "Siemens Healthcare  ",
    },
    {
      field_type: "company",
      name: "Siemens India ",
      field_id: "COM000871",
      website: "https://new.siemens.com/in/en/company/about.html",
      group: "Siemens AG",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SIEMENS INDIA LIMITED.png",
      company_id: "COM000871",
      company_name: "Siemens India ",
      display_name: "Siemens India ",
      sector: "Engineering Services",
      page_display_status: false,
      industry: "Electricals",
    },
    {
      field_type: "company",
      name: "Signet Chemical Corp  ",
      field_id: "COM001299",
      website: "http://www.signetchem.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SIGNET CHEMICAL CORPORATION PRIVATE LIMITED.png",
      company_id: "COM001299",
      company_name: "Signet Chemical Corp  ",
      industry: "",
      display_name: "Signet Chemical Corp  ",
    },
    {
      field_type: "company",
      name: "Sika",
      field_id: "COM000872",
      website: "https://ind.sika.com/",
      group: "SIKA Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SIKA INDIA PRIVATE LIMITED.png",
      company_id: "COM000872",
      company_name: "Sika",
      industry: "CONGLOMERATE",
      display_name: "Sika",
    },
    {
      field_type: "company",
      name: "Simplex Infrastructures ",
      field_id: "COM001300",
      website: "http://www.simplexinfra.com/#ad-image-0",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SIMPLEX INFRASTRUCTURES LIMITED.png",
      company_id: "COM001300",
      company_name: "Simplex Infrastructures ",
      industry: "",
      display_name: "Simplex Infrastructures ",
    },
    {
      field_type: "company",
      name: "Singer India ",
      field_id: "COM000873",
      website: "https://www.singerindia.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SINGER INDIA LIMITED.png",
      company_id: "COM000873",
      company_name: "Singer India ",
      industry: "FMCD",
      display_name: "Singer India ",
    },
    {
      field_type: "company",
      name: "Sintex Industries ",
      field_id: "COM001102",
      website: "http://www.sintex.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/INTEX TECHNOLOGIES (INDIA) LIMITED.png",
      company_id: "COM001102",
      company_name: "Sintex Industries ",
      industry: "",
      display_name: "Sintex Industries ",
    },
    {
      field_type: "company",
      name: "SIONC Pharma  ",
      field_id: "COM001474",
      website: "www.sioncpharmaceuticals.com",
      group: "",
      logo: "",
      company_id: "COM001474",
      company_name: "SIONC Pharma  ",
      industry: "",
      display_name: "SIONC Pharma  ",
    },
    {
      field_type: "company",
      name: "Sipta Coated Steels ",
      field_id: "COM001301",
      website:
        "http://www.jaicorpindia.com/business/manufacturing/steel/steel_home.html",
      group: "AMALGAMATED TO JAI CORPORATION PVT LTD",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SIPTA COATED STEELS LIMITED.jpg",
      company_id: "COM001301",
      company_name: "Sipta Coated Steels ",
      industry: "",
      display_name: "Sipta Coated Steels ",
    },
    {
      field_type: "company",
      name: "Sisecam Flat Glass",
      field_id: "COM000874",
      website: "http://www.sisecam.com.tr/en/business-segments/flat-glass",
      group: "SISECAM GROUP",
      logo: "",
      company_id: "COM000874",
      company_name: "Sisecam Flat Glass",
      industry: "GLASS",
      display_name: "Sisecam Flat Glass",
    },
    {
      field_type: "company",
      name: "Sivanandha Pipes Fittings ",
      field_id: "COM000875",
      website: "http://www.sivanandha.com/aboutus.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SIVANANDHA PIPES FITTINGS LIMITED.jpg",
      company_id: "COM000875",
      company_name: "Sivanandha Pipes Fittings ",
      industry: "MANUFACTURING",
      display_name: "Sivanandha Pipes Fittings ",
    },
    {
      field_type: "company",
      name: "Ski Carbon Black",
      field_id: "COM000876",
      website: "https://birlacarbon.com/about/",
      group: "Aditya Birla Group",
      logo: "",
      company_id: "COM000876",
      company_name: "Ski Carbon Black",
      industry: "MANUFACTURING",
      display_name: "Ski Carbon Black",
    },
    {
      field_type: "company",
      name: "Skipper ",
      field_id: "COM000877",
      website: "https://www.skipperlimited.com/about-us/company-profile.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SKIPPER LIMITED.png",
      company_id: "COM000877",
      company_name: "Skipper ",
      industry: "MANUFACTURING",
      display_name: "Skipper ",
    },
    {
      field_type: "company",
      name: "Skm Industries  ",
      field_id: "COM001303",
      website: "https://www.skmindustries.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SKM INDUSTRIES PRIVATE LIMITED.jpg",
      company_id: "COM001303",
      company_name: "Skm Industries  ",
      industry: "",
      display_name: "Skm Industries  ",
    },
    {
      field_type: "company",
      name: "Skoda",
      field_id: "COM000878",
      website: "https://www.skoda-auto.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ŠKODA Auto India Private Limited.png",
      company_id: "COM000878",
      company_name: "Skoda",
      industry: "AUTOMOBILE",
      display_name: "Skoda",
    },
    {
      field_type: "company",
      name: "Sky Plast Minerals",
      field_id: "COM000879",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000879",
      company_name: "Sky Plast Minerals",
      industry: "METALS AND MINING",
      display_name: "Sky Plast Minerals",
    },
    {
      field_type: "company",
      name: "Skymap Pharma  ",
      field_id: "COM000880",
      website: "http://www.skymap.in/",
      group: "",
      logo: "",
      company_id: "COM000880",
      company_name: "Skymap Pharma  ",
      industry: "PHARMACEUTICAL",
      display_name: "Skymap Pharma  ",
    },
    {
      field_type: "company",
      name: "SM Corp ",
      field_id: "COM000881",
      website: "http://smcorp.in/",
      group: "SM Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SM Corporation Limited.png",
      company_id: "COM000881",
      company_name: "SM Corp ",
      industry: "CONGLOMERATE",
      display_name: "SM Corp ",
    },
    {
      field_type: "company",
      name: "Smilax Labs ",
      field_id: "COM001475",
      website: "http://www.smilaxlabs.com/",
      group: "",
      logo: "",
      company_id: "COM001475",
      company_name: "Smilax Labs ",
      industry: "",
      display_name: "Smilax Labs ",
    },
    {
      field_type: "company",
      name: "SMS Pharma ",
      field_id: "COM001476",
      website: "https://smspharma.com/",
      group: "",
      logo: "",
      company_id: "COM001476",
      company_name: "SMS Pharma ",
      industry: "",
      display_name: "SMS Pharma ",
    },
    {
      field_type: "company",
      name: "SNAM Alloys  ",
      field_id: "COM000882",
      website: "http://snam.co.in/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SNAM ALLOYS PRIVATE LIMITED.png",
      company_id: "COM000882",
      company_name: "SNAM Alloys  ",
      industry: "METALS AND MINING",
      display_name: "SNAM Alloys  ",
    },
    {
      field_type: "company",
      name: "Snapdeal  ",
      field_id: "COM001304",
      website: "https://www.snapdeal.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SNAPDEAL PRIVATE LIMITED.PNG",
      company_id: "COM001304",
      company_name: "Snapdeal  ",
      industry: "",
      display_name: "Snapdeal  ",
    },
    {
      field_type: "company",
      name: "Somany Ceramics ",
      field_id: "COM000883",
      website: "https://www.somanyceramics.com/company-overview",
      group: "",
      logo: "",
      company_id: "COM000883",
      company_name: "Somany Ceramics ",
      industry: "CERAMICS",
      display_name: "Somany Ceramics ",
    },
    {
      field_type: "company",
      name: "Sona Alloys  ",
      field_id: "COM000884",
      website: "http://www.sonaalloys.com/?AspxAutoDetectCookieSupport=1",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SONA ALLOYS PRIVATE LIMITED.png",
      company_id: "COM000884",
      company_name: "Sona Alloys  ",
      industry: "METALS AND MINING",
      display_name: "Sona Alloys  ",
    },
    {
      field_type: "company",
      name: "Soni Steel And Appliances  ",
      field_id: "COM000885",
      website: "http://sonisteelandappliances.com/",
      group: "Shetty Group",
      logo: "",
      company_id: "COM000885",
      company_name: "Soni Steel And Appliances  ",
      industry: "STEEL",
      display_name: "Soni Steel And Appliances  ",
    },
    {
      field_type: "company",
      name: "Sony",
      field_id: "COM000886",
      website: "https://www.sony.co.in/microsite/overview/",
      group: "Sony Corporation",
      logo: "",
      company_id: "COM000886",
      company_name: "Sony",
      display_name: "Sony",
      sector: "Electronics",
      page_display_status: false,
      industry: "Electronics",
    },
    {
      field_type: "company",
      name: "South Asia LPG Company  ",
      field_id: "COM001477",
      website: "http://www.salpg.com/",
      group: "",
      logo: "",
      company_id: "COM001477",
      company_name: "South Asia LPG Company  ",
      industry: "",
      display_name: "South Asia LPG Company  ",
    },
    {
      field_type: "company",
      name: "Spack Automotives  ",
      field_id: "COM000745",
      website: "https://powerspack.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Spack Automotives Private Limited.png",
      company_id: "COM000745",
      company_name: "Spack Automotives  ",
      industry: "INDUSTRIAL AUTOMATION",
      display_name: "Spack Automotives  ",
    },
    {
      field_type: "company",
      name: "SPM Autocomp Systems  ",
      field_id: "COM000888",
      website: "https://www.spmauto.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SPM AUTOCOMP SYSTEMS PRIVATE LIMITED.png",
      company_id: "COM000888",
      company_name: "SPM Autocomp Systems  ",
      industry: "INDUSTRIAL AUTOMATION",
      display_name: "SPM Autocomp Systems  ",
    },
    {
      field_type: "company",
      name: "Sree Jayajothi Cements ",
      field_id: "COM000890",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000890",
      company_name: "Sree Jayajothi Cements ",
      industry: "CEMENT",
      display_name: "Sree Jayajothi Cements ",
    },
    {
      field_type: "company",
      name: "Sree LPC  ",
      field_id: "COM001478",
      website: "http://www.sreelpg.in/tsginfsreelpg.in2.1/index.php",
      group: "",
      logo: "",
      company_id: "COM001478",
      company_name: "Sree LPC  ",
      industry: "",
      display_name: "Sree LPC  ",
    },
    {
      field_type: "company",
      name: "Sree Rayalaseema Hi Strength Hypo ",
      field_id: "COM000891",
      website: "http://www.srhhl.com/",
      group: "TGV Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SREE RAYALASEEMA HI-STRENGTH HYPO LIMITEd.png",
      company_id: "COM000891",
      company_name: "Sree Rayalaseema Hi Strength Hypo ",
      industry: "CHEMICAL",
      display_name: "Sree Rayalaseema Hi Strength Hypo ",
    },
    {
      field_type: "company",
      name: "SRL",
      field_id: "COM000892",
      website: "https://www.srf.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SRF LIMITED.png",
      company_id: "COM000892",
      company_name: "SRL",
      industry: "CONGLOMERATE",
      display_name: "SRL",
    },
    {
      field_type: "company",
      name: "Sri Chakra Cement ",
      field_id: "COM001479",
      website: "http://www.srichakracement.com/",
      group: "",
      logo: "",
      company_id: "COM001479",
      company_name: "Sri Chakra Cement ",
      industry: "",
      display_name: "Sri Chakra Cement ",
    },
    {
      field_type: "company",
      name: "Sri Gopikrishna Infrastructure  ",
      field_id: "COM000893",
      website: "http://www.sgipl.com/",
      group: "",
      logo: "",
      company_id: "COM000893",
      company_name: "Sri Gopikrishna Infrastructure  ",
      industry: "INFRASTRUCTURE",
      display_name: "Sri Gopikrishna Infrastructure  ",
    },
    {
      field_type: "company",
      name: "Sri Krishna Tyres",
      field_id: "COM000894",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000894",
      company_name: "Sri Krishna Tyres",
      industry: "TYRE",
      display_name: "Sri Krishna Tyres",
    },
    {
      field_type: "company",
      name: "Sri Lalitha Cement Industries ",
      field_id: "COM001480",
      website: "http://slcil.com/",
      group: "",
      logo: "",
      company_id: "COM001480",
      company_name: "Sri Lalitha Cement Industries ",
      industry: "",
      display_name: "Sri Lalitha Cement Industries ",
    },
    {
      field_type: "company",
      name: "SSD Oil Mills Company ",
      field_id: "COM000896",
      website: "https://ssdoil.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SSD OIL MILLS COMPANY LIMITED.png",
      company_id: "COM000896",
      company_name: "SSD Oil Mills Company ",
      industry: "FMCG",
      display_name: "SSD Oil Mills Company ",
    },
    {
      field_type: "company",
      name: "SSF Plastics  ",
      field_id: "COM000897",
      website: "http://www.ssfplastics.com/about.htm",
      group: "",
      logo: "",
      company_id: "COM000897",
      company_name: "SSF Plastics  ",
      industry: "PLASTICS",
      display_name: "SSF Plastics  ",
    },
    {
      field_type: "company",
      name: "Stafford Controls ",
      field_id: "COM000898",
      website: "http://www.staffordcontrols.com/about/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/STAFFORD CONTROLS LIMITED.png",
      company_id: "COM000898",
      company_name: "Stafford Controls ",
      industry: "MANUFACTURING",
      display_name: "Stafford Controls ",
    },
    {
      field_type: "company",
      name: "Stainless Steel Fasteners",
      field_id: "COM000895",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000895",
      company_name: "Stainless Steel Fasteners",
      industry: "",
      display_name: "Stainless Steel Fasteners",
    },
    {
      field_type: "company",
      name: "Staples",
      field_id: "COM000899",
      website: "https://www.staples.com",
      group: "",
      logo: "",
      company_id: "COM000899",
      company_name: "Staples",
      industry: "MANUFACTURING",
      display_name: "Staples",
    },
    {
      field_type: "company",
      name: "Star Cement ",
      field_id: "COM000900",
      website: "http://starcement.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/STAR CEMENT LIMITED.png",
      company_id: "COM000900",
      company_name: "Star Cement ",
      industry: "CEMENT",
      display_name: "Star Cement ",
    },
    {
      field_type: "company",
      name: "SAIL -  Authority Of India ",
      field_id: "COM000902",
      website: "https://www.sail.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SAIL.jpg",
      company_id: "COM000902",
      company_name: "SAIL -  Authority Of India ",
      industry: "STEEL",
      display_name: "SAIL -  Authority Of India ",
    },
    {
      field_type: "company",
      name: "Steel Strips Wheels ",
      field_id: "COM000903",
      website: "https://www.sswlindia.com/pages/index.htm",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Steel Strips Wheels Limited.gif",
      company_id: "COM000903",
      company_name: "Steel Strips Wheels ",
      industry: "STEEL",
      display_name: "Steel Strips Wheels ",
    },
    {
      field_type: "company",
      name: "Sterling Agro Industries ",
      field_id: "COM001305",
      website: "https://www.steragro.com/#1Page",
      group: "NOVA DAIRY PRODUCTS",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/STERLING AGRO INDUSTRIES LIMITED.gif",
      company_id: "COM001305",
      company_name: "Sterling Agro Industries ",
      industry: "",
      display_name: "Sterling Agro Industries ",
    },
    {
      field_type: "company",
      name: "Sterlite Copper",
      field_id: "COM000904",
      website: "https://www.sterlitecopper.com/",
      group: "Vedanta Limited",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Sterlite Copper.png",
      company_id: "COM000904",
      company_name: "Sterlite Copper",
      industry: "METALS AND MINING",
      display_name: "Sterlite Copper",
    },
    {
      field_type: "company",
      name: "Sterlite Power ",
      field_id: "COM000905",
      website: "https://www.sterlitepower.com/",
      group: "Vedanta Limited",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Sterlite Power.png",
      company_id: "COM000905",
      company_name: "Sterlite Power ",
      industry: "ELECTRICALS",
      display_name: "Sterlite Power ",
    },
    {
      field_type: "company",
      name: "Stork Ferro And Minerals",
      field_id: "COM000906",
      website: "http://www.storkgrp.ru/en/",
      group: "Stork Group",
      logo: "",
      company_id: "COM000906",
      company_name: "Stork Ferro And Minerals",
      industry: "METALS AND MINING",
      display_name: "Stork Ferro And Minerals",
    },
    {
      field_type: "company",
      name: "Strides Pharma Science ",
      field_id: "COM001481",
      website: "http://www.strides.com/",
      group: "",
      logo: "",
      company_id: "COM001481",
      company_name: "Strides Pharma Science ",
      industry: "",
      display_name: "Strides Pharma Science ",
    },
    {
      field_type: "company",
      name: "Stulz Chspl  ",
      field_id: "COM000907",
      website: "https://www.stulz.in/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/STULZ-CHSPL India Private Limited.png",
      company_id: "COM000907",
      company_name: "Stulz Chspl  ",
      industry: "MANUFACTURING",
      display_name: "Stulz Chspl  ",
    },
    {
      field_type: "company",
      name: "Su Kam Power",
      field_id: "COM000912",
      website: "www.su-kam.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Su-Kam Power Systems Limited.png",
      company_id: "COM000912",
      company_name: "Su Kam Power",
      industry: "ELECTRICALS",
      display_name: "Su Kam Power",
    },
    {
      field_type: "company",
      name: "Subways Foods  ",
      field_id: "COM001306",
      website:
        "https://www.subway.com/en-IN/OwnAFranchise/ContactFranchiseSales",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SUBWAYS FOODS PRIVATE LIMITED.png",
      company_id: "COM001306",
      company_name: "Subways Foods  ",
      industry: "",
      display_name: "Subways Foods  ",
    },
    {
      field_type: "company",
      name: "Sudhir Power ",
      field_id: "COM000909",
      website: "http://www.sudhirpower.com/index.html",
      group: "Sudhir",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SUDHIR POWER Limited.png",
      company_id: "COM000909",
      company_name: "Sudhir Power ",
      industry: "ELECTRICALS",
      display_name: "Sudhir Power ",
    },
    {
      field_type: "company",
      name: "Suguna Foods  ",
      field_id: "COM000910",
      website: "https://www.sugunafoods.co.in/index.asp",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Suguna Foods Private Limited.png",
      company_id: "COM000910",
      company_name: "Suguna Foods  ",
      industry: "FMCG",
      display_name: "Suguna Foods  ",
    },
    {
      field_type: "company",
      name: "Sujeet Hardware",
      field_id: "COM000911",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000911",
      company_name: "Sujeet Hardware",
      industry: "FMCD",
      display_name: "Sujeet Hardware",
    },
    {
      field_type: "company",
      name: "Sulzer ",
      field_id: "COM001307",
      website: "https://www.sulzer.com/en/about-us/our-company",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SULZER PUMPS INDIA PRIVATE LIMITED.png",
      company_id: "COM001307",
      company_name: "Sulzer ",
      industry: "",
      display_name: "Sulzer ",
    },
    {
      field_type: "company",
      name: "Sumangala Steel  ",
      field_id: "COM001308",
      website: "https://www.sreesumangala.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SUMANGALA STEEL PRIVATE LIMITED.png",
      company_id: "COM001308",
      company_name: "Sumangala Steel  ",
      industry: "",
      display_name: "Sumangala Steel  ",
    },
    {
      field_type: "company",
      name: "Sun Metallics And Alloys  ",
      field_id: "COM000913",
      website: "http://www.suntmtbars.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Sun Metallics & Alloys Private Limited.png",
      company_id: "COM000913",
      company_name: "Sun Metallics And Alloys  ",
      industry: "METALS AND MINING",
      display_name: "Sun Metallics And Alloys  ",
    },
    {
      field_type: "company",
      name: "Sun Pharma",
      field_id: "COM000914",
      website: "https://www.sunpharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/RANBAXY LABORATORIES.SUNPHARMA.png",
      company_id: "COM000914",
      company_name: "Sun Pharma",
      display_name: "Sun Pharma",
      sector: "Pharmaceutical",
      page_display_status: false,
      industry: "Pharmaceutical",
    },
    {
      field_type: "company",
      name: "Sundaram Multi Pap ",
      field_id: "COM001309",
      website: "http://www.sundaramgroups.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SUNDARAM MULTI PAP LIMITED.png",
      company_id: "COM001309",
      company_name: "Sundaram Multi Pap ",
      industry: "",
      display_name: "Sundaram Multi Pap ",
    },
    {
      field_type: "company",
      name: "Sundaram Packaging",
      field_id: "COM000916",
      website: "https://www.sundarampackaging.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Sundaram Packaging India Pvt Ltd.png",
      company_id: "COM000916",
      company_name: "Sundaram Packaging",
      industry: "PACKAGING",
      display_name: "Sundaram Packaging",
    },
    {
      field_type: "company",
      name: "Sundram Fasteners ",
      field_id: "COM000915",
      website: "https://www.sundram.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SUNDRAM FASTENERS LIMITED.png",
      company_id: "COM000915",
      company_name: "Sundram Fasteners ",
      industry: "MANUFACTURING",
      display_name: "Sundram Fasteners ",
    },
    {
      field_type: "company",
      name: "Sunil Hitech Engineers ",
      field_id: "COM000917",
      website: "http://www.sunilhitech.com/Index.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Sunil HiTech Engineers Ltd.png",
      company_id: "COM000917",
      company_name: "Sunil Hitech Engineers ",
      industry: "ENGINEERING SERVICES",
      display_name: "Sunil Hitech Engineers ",
    },
    {
      field_type: "company",
      name: "Super Max ",
      field_id: "COM000918",
      website: "http://www.supermaxworld.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SUPER-MAX.png",
      company_id: "COM000918",
      company_name: "Super Max ",
      industry: "FMCG",
      display_name: "Super Max ",
    },
    {
      field_type: "company",
      name: "Supreme Allied Services  ",
      field_id: "COM000919",
      website: "http://www.supremeallied.com/index.html",
      group: "",
      logo: "",
      company_id: "COM000919",
      company_name: "Supreme Allied Services  ",
      industry: "CONSTRUCTION",
      display_name: "Supreme Allied Services  ",
    },
    {
      field_type: "company",
      name: "Supreme Industries ",
      field_id: "COM000920",
      website: "https://www.supreme.co.in/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Supreme Industries limited.png",
      company_id: "COM000920",
      company_name: "Supreme Industries ",
      industry: "PLASTICS",
      display_name: "Supreme Industries ",
    },
    {
      field_type: "company",
      name: "Supreme Nonwoven Industries  ",
      field_id: "COM001310",
      website: "http://www.supremegroup.co.in/",
      group:
        " Nonwovens company and sister concern of Supreme Treon Private Limited",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SUPREME NONWOVEN INDUSTRIES PRIVATE LIMITED.jpg",
      company_id: "COM001310",
      company_name: "Supreme Nonwoven Industries  ",
      industry: "",
      display_name: "Supreme Nonwoven Industries  ",
    },
    {
      field_type: "company",
      name: "Supreme Petrochem ",
      field_id: "COM000921",
      website: "https://www.supremepetrochem.com/default.htm",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Supreme Petrochem Limited.gif",
      company_id: "COM000921",
      company_name: "Supreme Petrochem ",
      industry: "CHEMICAL",
      display_name: "Supreme Petrochem ",
    },
    {
      field_type: "company",
      name: "Suraksha Cement",
      field_id: "COM000922",
      website: "http://www.surakshacement.com/index.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Suraksha Cement.png",
      company_id: "COM000922",
      company_name: "Suraksha Cement",
      industry: "CEMENT",
      display_name: "Suraksha Cement",
    },
    {
      field_type: "company",
      name: "Surya Food And Agro ",
      field_id: "COM000924",
      website: "http://priyagold.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SURYA FOOD & AGRO Limited.png",
      company_id: "COM000924",
      company_name: "Surya Food And Agro ",
      industry: "AGRICULTURAL PRODUCTS",
      display_name: "Surya Food And Agro ",
    },
    {
      field_type: "company",
      name: "Surya Roshni ",
      field_id: "COM000926",
      website: "http://www.surya.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Surya Roshni Limited.png",
      company_id: "COM000926",
      company_name: "Surya Roshni ",
      industry: "ELECTRICALS",
      display_name: "Surya Roshni ",
    },
    {
      field_type: "company",
      name: "Suven Life Sciences ",
      field_id: "COM001482",
      website: "http://www.suven.com/",
      group: "",
      logo: "",
      company_id: "COM001482",
      company_name: "Suven Life Sciences ",
      industry: "",
      display_name: "Suven Life Sciences ",
    },
    {
      field_type: "company",
      name: "Suzlon Group",
      field_id: "COM000927",
      website: "https://www.suzlon.com/",
      group: "SUZLON GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Suzlon Energy Limited.png",
      company_id: "COM000927",
      company_name: "Suzlon Group",
      industry: "MANUFACTURING",
      display_name: "Suzlon Group",
    },
    {
      field_type: "company",
      name: "Swal Corp ",
      field_id: "COM001483",
      website: "https://www.swal.in/",
      group: "",
      logo: "",
      company_id: "COM001483",
      company_name: "Swal Corp ",
      industry: "",
      display_name: "Swal Corp ",
    },
    {
      field_type: "company",
      name: "Swiss Singapore Overseas Enterprises Pte ",
      field_id: "COM000928",
      website: "https://www.swiss-singapore.com/",
      group: "ADITYA BIRLA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Swiss Singapore Overseas Enterprises Pte Limited.jpg",
      company_id: "COM000928",
      company_name: "Swiss Singapore Overseas Enterprises Pte ",
      industry: "ENGINEERING SERVICES",
      display_name: "Swiss Singapore Overseas Enterprises Pte ",
    },
    {
      field_type: "company",
      name: "Symbiotec Pharma Lab  ",
      field_id: "COM001484",
      website: "http://symbiotec.in/",
      group: "",
      logo: "",
      company_id: "COM001484",
      company_name: "Symbiotec Pharma Lab  ",
      industry: "",
      display_name: "Symbiotec Pharma Lab  ",
    },
    {
      field_type: "company",
      name: "Symed Labs ",
      field_id: "COM001485",
      website: "http://www.symedlabs.com/",
      group: "",
      logo: "",
      company_id: "COM001485",
      company_name: "Symed Labs ",
      industry: "",
      display_name: "Symed Labs ",
    },
    {
      field_type: "company",
      name: "Syncom Formulations ",
      field_id: "COM001486",
      website: "http://www.syncomformulations.com/",
      group: "",
      logo: "",
      company_id: "COM001486",
      company_name: "Syncom Formulations ",
      industry: "",
      display_name: "Syncom Formulations ",
    },
    {
      field_type: "company",
      name: "Synergy Films  ",
      field_id: "COM000929",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Synergy Films.png",
      company_id: "COM000929",
      company_name: "Synergy Films  ",
      industry: "",
      display_name: "Synergy Films  ",
    },
    {
      field_type: "company",
      name: "Syngenta ",
      field_id: "COM000930",
      website: "https://www.syngenta.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Syngenta.png",
      company_id: "COM000930",
      company_name: "Syngenta ",
      industry: "CHEMICAL",
      display_name: "Syngenta ",
    },
    {
      field_type: "company",
      name: "Synokem Pharma ",
      field_id: "COM001311",
      website: "https://www.synokempharma.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/SYNOKEM PHARMACEUTICALS LIMITED.png",
      company_id: "COM001311",
      company_name: "Synokem Pharma ",
      industry: "",
      display_name: "Synokem Pharma ",
    },
    {
      field_type: "company",
      name: "Tagros Chemicals ",
      field_id: "COM001487",
      website: "https://tagros.com/",
      group: "",
      logo: "",
      company_id: "COM001487",
      company_name: "Tagros Chemicals ",
      industry: "",
      display_name: "Tagros Chemicals ",
    },
    {
      field_type: "company",
      name: "Taikisha Engineering  ",
      field_id: "COM001312",
      website: "https://www.taikishaindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TAIKISHA ENGINEERING INDIA PVT LTD.jpg",
      company_id: "COM001312",
      company_name: "Taikisha Engineering  ",
      industry: "",
      display_name: "Taikisha Engineering  ",
    },
    {
      field_type: "company",
      name: "Tamilnadu Cements Corp ",
      field_id: "COM001488",
      website: "http://tancem.com/",
      group: "",
      logo: "",
      company_id: "COM001488",
      company_name: "Tamilnadu Cements Corp ",
      industry: "",
      display_name: "Tamilnadu Cements Corp ",
    },
    {
      field_type: "company",
      name: "Tamrag Green Solutions  ",
      field_id: "COM000932",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000932",
      company_name: "Tamrag Green Solutions  ",
      industry: "",
      display_name: "Tamrag Green Solutions  ",
    },
    {
      field_type: "company",
      name: "Tata Autocomp Gy Batteries  ",
      field_id: "COM000934",
      website: "https://www.tatagreenbattery.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Tata AutoComp GY Batteries Private Limited.png",
      company_id: "COM000934",
      company_name: "Tata Autocomp Gy Batteries  ",
      industry: "",
      display_name: "Tata Autocomp Gy Batteries  ",
    },
    {
      field_type: "company",
      name: "Tata Bluescope Steel  ",
      field_id: "COM000935",
      website: "https://tatabluescopesteel.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Tata BlueScope Steel.png",
      company_id: "COM000935",
      company_name: "Tata Bluescope Steel  ",
      industry: "",
      display_name: "Tata Bluescope Steel  ",
    },
    {
      field_type: "company",
      name: "Tata Chemicals ",
      field_id: "COM000936",
      website: "https://www.tatachemicals.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TATA%20Chemicals.jpg",
      company_id: "COM000936",
      company_name: "Tata Chemicals ",
      industry: "CHEMICAL",
      display_name: "Tata Chemicals ",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Tata Consultancy Services ",
      field_id: "COM001315",
      website: "https://www.tcs.com",
      group: "TATA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TATA CONSULTANCY SERVICES LTD.png",
      company_id: "COM001315",
      company_name: "Tata Consultancy Services ",
      industry: "",
      display_name: "Tata Consultancy Services ",
    },
    {
      field_type: "company",
      name: "TATA CONSUMER",
      field_id: "COM000937",
      website: "https://www.tataconsumer.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/tata%20consumer%20-%20COM000937.png",
      company_id: "COM000937",
      company_name: "TATA CONSUMER",
      industry: "",
      display_name: "TATA CONSUMER",
    },
    {
      field_type: "company",
      name: "Tata Hitachi Construction Machinery Company  ",
      field_id: "COM001314",
      website: "https://www.tatahitachi.co.in/",
      group: "TATA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TATA HITACHI CONSTRUCTION MACHINERY COMPANY PVT LTD.png",
      company_id: "COM001314",
      company_name: "Tata Hitachi Construction Machinery Company  ",
      industry: "",
      display_name: "Tata Hitachi Construction Machinery Company  ",
    },
    {
      field_type: "company",
      name: "Tata International ",
      field_id: "COM001316",
      website: "https://tatainternational.com/",
      group: "TATA GROUP",
      logo: "",
      company_id: "COM001316",
      company_name: "Tata International ",
      industry: "",
      display_name: "Tata International ",
    },
    {
      field_type: "company",
      name: "Tata Metaliks ",
      field_id: "COM001317",
      website: "https://www.tatametaliks.com/",
      group: "TATA GROUP",
      logo: "",
      company_id: "COM001317",
      company_name: "Tata Metaliks ",
      industry: "",
      display_name: "Tata Metaliks ",
    },
    {
      field_type: "company",
      name: "Tata Motors ",
      field_id: "COM000939",
      website: "https://www.tatamotors.com/",
      group: "TATA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Tata Motors.png",
      company_id: "COM000939",
      company_name: "Tata Motors ",
      industry: "AUTOMOBILE",
      display_name: "Tata Motors ",
    },
    {
      field_type: "company",
      name: "Tata Power ",
      field_id: "COM000940",
      website: "https://www.tatapower.com/",
      group: "TATA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Tata Power.png",
      company_id: "COM000940",
      company_name: "Tata Power ",
      industry: "ELECTRICALS",
      display_name: "Tata Power ",
    },
    {
      field_type: "company",
      name: "Tata Projects ",
      field_id: "COM001318",
      website: "https://www.tataprojects.com/",
      group: "TATA GROUP",
      logo: "",
      company_id: "COM001318",
      company_name: "Tata Projects ",
      industry: "",
      display_name: "Tata Projects ",
    },
    {
      field_type: "company",
      name: "Tata Sky ",
      field_id: "COM000941",
      website: "https://www.tatasky.com/wps/portal",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Tata Sky Limited.png",
      company_id: "COM000941",
      company_name: "Tata Sky ",
      display_name: "Tata Sky ",
      sector: "Telecom",
      page_display_status: false,
      industry: "Telecom",
    },
    {
      field_type: "company",
      name: "Tata Sons  ",
      field_id: "COM000938",
      website: "https://www.tata.com/",
      group: "TATA GROUP",
      logo: "",
      company_id: "COM000938",
      company_name: "Tata Sons  ",
      industry: "CONGLOMERATE",
      display_name: "Tata Sons  ",
    },
    {
      field_type: "company",
      name: "Tata Starbucks  ",
      field_id: "COM000942",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000942",
      company_name: "Tata Starbucks  ",
      industry: "FMCG",
      display_name: "Tata Starbucks  ",
    },
    {
      field_type: "company",
      name: "Tata Steel Bsl ",
      field_id: "COM001313",
      website: "http://tatasteelbsl.co.in/home.html",
      group: "TATA GROUP",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TATA STEEL BSL LIMITED.png",
      company_id: "COM001313",
      company_name: "Tata Steel Bsl ",
      industry: "",
      display_name: "Tata Steel Bsl ",
    },
    {
      field_type: "company",
      name: "Tata Steel ",
      field_id: "COM000943",
      website: "https://www.tatasteel.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Tata Steel.png",
      company_id: "COM000943",
      company_name: "Tata Steel ",
      display_name: "Tata Steel ",
      sector: "Steel",
      page_display_status: false,
      industry: "Steel",
    },
    {
      field_type: "company",
      name: "Tata Toyo Radiator",
      field_id: "COM000944",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000944",
      company_name: "Tata Toyo Radiator",
      industry: "MANUFACTURING",
      display_name: "Tata Toyo Radiator",
    },
    {
      field_type: "company",
      name: "Tata Autocomp Hendrickson Suspensions  ",
      field_id: "COM000933",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000933",
      company_name: "Tata Autocomp Hendrickson Suspensions  ",
      industry: "AUTOMOBILE",
      display_name: "Tata Autocomp Hendrickson Suspensions  ",
    },
    {
      field_type: "company",
      name: "TCPL Packaging ",
      field_id: "COM001319",
      website: "https://www.tcpl.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TCPL PACKAGING LTD.png",
      company_id: "COM001319",
      company_name: "TCPL Packaging ",
      industry: "",
      display_name: "TCPL Packaging ",
    },
    {
      field_type: "company",
      name: "Technova Imaging Systems  ",
      field_id: "COM000945",
      website: "https://www.technovaworld.com/Web/Default.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TechNova Imaging Systems Private Limited.png",
      company_id: "COM000945",
      company_name: "Technova Imaging Systems  ",
      industry: "PRINTING AND MINTING",
      display_name: "Technova Imaging Systems  ",
    },
    {
      field_type: "company",
      name: "Tecumseh Products Company Llc",
      field_id: "COM001321",
      website: "http://www.tecumseh.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TECUMSEH PRODUCTS INDIA LTD.jpg",
      company_id: "COM001321",
      company_name: "Tecumseh Products Company Llc",
      display_name: "Tecumseh Products Company Llc",
      sector: "Electricals",
      page_display_status: false,
      industry: "Electricals",
    },
    {
      field_type: "company",
      name: "Temple Packaging  ",
      field_id: "COM001322",
      website: "https://templepackaging.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TEMPLE PACKAGING PRIVATE LIMITED.png",
      company_id: "COM001322",
      company_name: "Temple Packaging  ",
      industry: "",
      display_name: "Temple Packaging  ",
    },
    {
      field_type: "company",
      name: "Tethys Foods And Beverages  ",
      field_id: "COM000946",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000946",
      company_name: "Tethys Foods And Beverages  ",
      industry: "BREWING",
      display_name: "Tethys Foods And Beverages  ",
    },
    {
      field_type: "company",
      name: "Teva Pharmaceutical And Chemical",
      field_id: "COM001489",
      website: "https://www.tevapharm.com/about/",
      group: "TEVA",
      logo: "",
      company_id: "COM001489",
      company_name: "Teva Pharmaceutical And Chemical",
      industry: "",
      display_name: "Teva Pharmaceutical And Chemical",
    },
    {
      field_type: "company",
      name: "Texport Industries  ",
      field_id: "COM000947",
      website: "http://www.texportgarments.com/index.htm",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Texport Industries Private Limited.gif",
      company_id: "COM000947",
      company_name: "Texport Industries  ",
      industry: "FASHION AND CLOTHING",
      display_name: "Texport Industries  ",
    },
    {
      field_type: "company",
      name: "Texport Syndicate India ",
      field_id: "COM000948",
      website: "http://www.texportsyndicate.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TEXPORT Syndicate.gif",
      company_id: "COM000948",
      company_name: "Texport Syndicate India ",
      industry: "TEXTILE",
      display_name: "Texport Syndicate India ",
    },
    {
      field_type: "company",
      name: "The Andhra Petrochemicals ",
      field_id: "COM001490",
      website: "https://www.andhrapetrochemicals.com/",
      group: "",
      logo: "",
      company_id: "COM001490",
      company_name: "The Andhra Petrochemicals ",
      industry: "",
      display_name: "The Andhra Petrochemicals ",
    },
    {
      field_type: "company",
      name: "The Andhra Sugars ",
      field_id: "COM001491",
      website: "https://theandhrasugars.com",
      group: "",
      logo: "",
      company_id: "COM001491",
      company_name: "The Andhra Sugars ",
      industry: "",
      display_name: "The Andhra Sugars ",
    },
    {
      field_type: "company",
      name: "The Anup Engineering ",
      field_id: "COM001492",
      website: "http://www.anupengg.com",
      group: "",
      logo: "",
      company_id: "COM001492",
      company_name: "The Anup Engineering ",
      industry: "",
      display_name: "The Anup Engineering ",
    },
    {
      field_type: "company",
      name: "The Arya Vaidya Pharmacy Cbe ",
      field_id: "COM000949",
      website: "https://www.avpayurveda.com",
      group: "AVP Group",
      logo: "",
      company_id: "COM000949",
      company_name: "The Arya Vaidya Pharmacy Cbe ",
      industry: "",
      display_name: "The Arya Vaidya Pharmacy Cbe ",
    },
    {
      field_type: "company",
      name: "The Coca Cola Company",
      field_id: "COM000183",
      website: "https://www.coca-cola.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/THE COCA-COLA COMPANY.png",
      company_id: "COM000183",
      company_name: "The Coca Cola Company",
      industry: "BREWING",
      display_name: "The Coca Cola Company",
    },
    {
      field_type: "company",
      name: "The Geltec Group",
      field_id: "COM001493",
      website: "http://geltec.in/about-us.html",
      group: "",
      logo: "",
      company_id: "COM001493",
      company_name: "The Geltec Group",
      industry: "",
      display_name: "The Geltec Group",
    },
    {
      field_type: "company",
      name: "Hersheys",
      field_id: "COM000951",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000951",
      company_name: "Hersheys",
      display_name: "Hersheys",
      sector: "FMCG",
      page_display_status: false,
      replaced_data: {
        field_type: "company",
        name: "The Hershey Company",
        field_id: "COM000951",
        website: "https://www.thehersheycompany.com/en_us/home.html",
        group: "",
        logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/THE HERSHEY COMPANY.png",
        company_id: "COM000951",
        company_name: "The Hershey Company",
        display_name: "Hersheys",
        sector: "FMCG",
        page_display_status: true,
      },
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "The Himalaya Drug Company",
      field_id: "COM000952",
      website: "https://www.himalayawellness.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Himalaya Wellness.png",
      company_id: "COM000952",
      company_name: "The Himalaya Drug Company",
      industry: "PHARMACEUTICAL",
      display_name: "The Himalaya Drug Company",
    },
    {
      field_type: "company",
      name: "KCP",
      field_id: "COM001494",
      website: "http://www.kcp.co.in/",
      group: "",
      logo: "",
      company_id: "COM001494",
      company_name: "KCP",
      industry: "",
      display_name: "KCP",
    },
    {
      field_type: "company",
      name: "Ramco Cements ",
      field_id: "COM001495",
      website: "http://www.ramcocements.in/",
      group: "",
      logo: "",
      company_id: "COM001495",
      company_name: "Ramco Cements ",
      industry: "",
      display_name: "Ramco Cements ",
    },
    {
      field_type: "company",
      name: "Sirpur Paper Mills ",
      field_id: "COM001302",
      website: "https://www.jkpaper.com/sirpurpaper/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/THE SIRPUR PAPER MILLS LTD.jpg",
      company_id: "COM001302",
      company_name: "Sirpur Paper Mills ",
      industry: "",
      display_name: "Sirpur Paper Mills ",
    },
    {
      field_type: "company",
      name: "VVF - Vegetable Vitamins Foods",
      field_id: "COM000955",
      website: "http://www.vvfltd.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/THE VEGETABLE VITAMINS FOODS COMPANY Private Limited.gif",
      company_id: "COM000955",
      company_name: "VVF - Vegetable Vitamins Foods",
      industry: "FMCG",
      display_name: "VVF - Vegetable Vitamins Foods",
    },
    {
      field_type: "company",
      name: "The Voith",
      field_id: "COM001039",
      website: "http://voith.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VOITH.png",
      company_id: "COM001039",
      company_name: "The Voith",
      industry: "INDUSTRIAL AUTOMATION",
      display_name: "The Voith",
    },
    {
      field_type: "company",
      name: "The Bombay Dyeing",
      field_id: "COM000956",
      website: "https://bombaydyeing.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Bombay Dyeing.png",
      company_id: "COM000956",
      company_name: "The Bombay Dyeing",
      industry: "TEXTILE",
      display_name: "The Bombay Dyeing",
    },
    {
      field_type: "company",
      name: "Thermax ",
      field_id: "COM000957",
      website: "https://www.thermaxglobal.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Thermax Global.png",
      company_id: "COM000957",
      company_name: "Thermax ",
      industry: "CHEMICAL",
      display_name: "Thermax ",
    },
    {
      field_type: "company",
      name: "Thirumalai Chemicals ",
      field_id: "COM000958",
      website: "http://www.thirumalaichemicals.com/index.html",
      group: "Thirumalai Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Thirumalai Chemicals Limited.png",
      company_id: "COM000958",
      company_name: "Thirumalai Chemicals ",
      industry: "CHEMICAL",
      display_name: "Thirumalai Chemicals ",
    },
    {
      field_type: "company",
      name: "Thomson Press",
      field_id: "COM001324",
      website: "http://www.thomsonpress.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/THOMSON PRESS INDIA LTD.PNG",
      company_id: "COM001324",
      company_name: "Thomson Press",
      industry: "",
      display_name: "Thomson Press",
    },
    {
      field_type: "company",
      name: "Thyrocare Technologies ",
      field_id: "COM001325",
      website: "https://www.thyrocare.com/",
      group: "",
      logo: "",
      company_id: "COM001325",
      company_name: "Thyrocare Technologies ",
      industry: "",
      display_name: "Thyrocare Technologies ",
    },
    {
      field_type: "company",
      name: "Thyssenkrupp",
      field_id: "COM000959",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/thyssenkrupp System Engineering.png",
      company_id: "COM000959",
      company_name: "Thyssenkrupp",
      industry: "ENGINEERING SERVICES",
      display_name: "Thyssenkrupp",
    },
    {
      field_type: "company",
      name: "Ti Cycles Of India",
      field_id: "COM000960",
      website: "http://www.tiindia.com/",
      group: "The Murugappa Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TI Cycles of India.png",
      company_id: "COM000960",
      company_name: "Ti Cycles Of India",
      industry: "MANUFACTURING",
      display_name: "Ti Cycles Of India",
    },
    {
      field_type: "company",
      name: "TIDC India",
      field_id: "COM000961",
      website: "https://www.tidcindia.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TIDC INDIA.jpg",
      company_id: "COM000961",
      company_name: "TIDC India",
      industry: "INDUSTRIAL AUTOMATION",
      display_name: "TIDC India",
    },
    {
      field_type: "company",
      name: "Til Health Care India ",
      field_id: "COM001496",
      website: "http://tilhealthcare.com/",
      group: "",
      logo: "",
      company_id: "COM001496",
      company_name: "Til Health Care India ",
      industry: "",
      display_name: "Til Health Care India ",
    },
    {
      field_type: "company",
      name: "Tirupati Iron Impex  ",
      field_id: "COM000962",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000962",
      company_name: "Tirupati Iron Impex  ",
      industry: "CONGLOMERATE",
      display_name: "Tirupati Iron Impex  ",
    },
    {
      field_type: "company",
      name: "Tirupati Structurals ",
      field_id: "COM001326",
      website: "https://www.tirupatistructurals.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TIRUPATI STRUCTURALS LIMITED.PNG",
      company_id: "COM001326",
      company_name: "Tirupati Structurals ",
      industry: "",
      display_name: "Tirupati Structurals ",
    },
    {
      field_type: "company",
      name: "TM Steels",
      field_id: "COM000963",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TM Steels And Cements.png",
      company_id: "COM000963",
      company_name: "TM Steels",
      industry: "STEEL",
      display_name: "TM Steels",
    },
    {
      field_type: "company",
      name: "TMEIC Industrial Systems India  ",
      field_id: "COM000964",
      website: "https://www.tmeic.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TMEIC.png",
      company_id: "COM000964",
      company_name: "TMEIC Industrial Systems India  ",
      industry: "MANUFACTURING",
      display_name: "TMEIC Industrial Systems India  ",
    },
    {
      field_type: "company",
      name: "Torque Pharma  ",
      field_id: "COM001497",
      website: "https://www.torquepharma.com/",
      group: "",
      logo: "",
      company_id: "COM001497",
      company_name: "Torque Pharma  ",
      industry: "",
      display_name: "Torque Pharma  ",
    },
    {
      field_type: "company",
      name: "Torrent Pharma ",
      field_id: "COM001498",
      website: "http://www.torrentpharma.com/",
      group: "",
      logo: "",
      company_id: "COM001498",
      company_name: "Torrent Pharma ",
      industry: "",
      display_name: "Torrent Pharma ",
    },
    {
      field_type: "company",
      name: "Torsa Machines ",
      field_id: "COM001085",
      website: "http://www.torsa.com",
      group: "",
      logo: "",
      company_id: "COM001085",
      company_name: "Torsa Machines ",
      industry: "",
      display_name: "Torsa Machines ",
    },
    {
      field_type: "company",
      name: "Toshali Cements  ",
      field_id: "COM001499",
      website: "https://www.toshalicement.com/",
      group: "",
      logo: "",
      company_id: "COM001499",
      company_name: "Toshali Cements  ",
      industry: "",
      display_name: "Toshali Cements  ",
    },
    {
      field_type: "company",
      name: "Toshiba India  ",
      field_id: "COM000965",
      website: "https://www.toshiba-india.com/index.aspx",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Toshiba India Private Limited.gif",
      company_id: "COM000965",
      company_name: "Toshiba India  ",
      industry: "ELECTRONICS",
      display_name: "Toshiba India  ",
    },
    {
      field_type: "company",
      name: "Tosoh India  ",
      field_id: "COM000966",
      website: "https://www.tosohindia.com/",
      group: "",
      logo: "",
      company_id: "COM000966",
      company_name: "Tosoh India  ",
      industry: "",
      display_name: "Tosoh India  ",
    },
    {
      field_type: "company",
      name: "Total Oil India  ",
      field_id: "COM000967",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000967",
      company_name: "Total Oil India  ",
      industry: "OIL AND GAS",
      display_name: "Total Oil India  ",
    },
    {
      field_type: "company",
      name: "Toyo Engineering India  ",
      field_id: "COM001327",
      website: "https://www.toyo-eng.com/in/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TOYO ENGINEERING INDIA PVT LTD.gif",
      company_id: "COM001327",
      company_name: "Toyo Engineering India  ",
      industry: "",
      display_name: "Toyo Engineering India  ",
    },
    {
      field_type: "company",
      name: "TPG Wholesale  ",
      field_id: "COM000968",
      website: "https://www.tpgwholesale.co.nz/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TPG Wholesale.jpg",
      company_id: "COM000968",
      company_name: "TPG Wholesale  ",
      industry: "INFRASTRUCTURE",
      display_name: "TPG Wholesale  ",
    },
    {
      field_type: "company",
      name: "TPS Infrastructure ",
      field_id: "COM000969",
      website: "http://www.tpsmfg.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TPS Infrastructure Limited.png",
      company_id: "COM000969",
      company_name: "TPS Infrastructure ",
      industry: "MANUFACTURING",
      display_name: "TPS Infrastructure ",
    },
    {
      field_type: "company",
      name: "TPV Technology ",
      field_id: "COM000970",
      website: "https://www.tpv-tech.com/html/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TPV Technology Limited.png",
      company_id: "COM000970",
      company_name: "TPV Technology ",
      industry: "ELECTRONICS",
      display_name: "TPV Technology ",
    },
    {
      field_type: "company",
      name: "Tractors And Farm Equipment ",
      field_id: "COM000971",
      website: "https://www.tafe.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Tractors and Farm Equipment Limited.png",
      company_id: "COM000971",
      company_name: "Tractors And Farm Equipment ",
      industry: "MANUFACTURING",
      display_name: "Tractors And Farm Equipment ",
    },
    {
      field_type: "company",
      name: "Tractors India  ",
      field_id: "COM001086",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001086",
      company_name: "Tractors India  ",
      industry: "",
      display_name: "Tractors India  ",
    },
    {
      field_type: "company",
      name: "Transafe Services ",
      field_id: "COM000972",
      website: "http://www.transafeservices.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Transafe Services Limited.png",
      company_id: "COM000972",
      company_name: "Transafe Services ",
      industry: "LOGISTICS",
      display_name: "Transafe Services ",
    },
    {
      field_type: "company",
      name: "Transmission Line Products",
      field_id: "COM000973",
      website: "http://www.tlproduct.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Transmission Line Products.jpg",
      company_id: "COM000973",
      company_name: "Transmission Line Products",
      industry: "MANUFACTURING",
      display_name: "Transmission Line Products",
    },
    {
      field_type: "company",
      name: "Transworld Furtichem  ",
      field_id: "COM000974",
      website: "https://www.transfurt.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Transworld Furtichem Private Limited.png",
      company_id: "COM000974",
      company_name: "Transworld Furtichem  ",
      industry: "CHEMICAL",
      display_name: "Transworld Furtichem  ",
    },
    {
      field_type: "company",
      name: "Travancore Cements ",
      field_id: "COM001500",
      website: "https://www.travcement.com/",
      group: "",
      logo: "",
      company_id: "COM001500",
      company_name: "Travancore Cements ",
      industry: "",
      display_name: "Travancore Cements ",
    },
    {
      field_type: "company",
      name: "Trident ",
      field_id: "COM000976",
      website: "https://www.tridentindia.com/",
      group: "Trident Group",
      logo: "",
      company_id: "COM000976",
      company_name: "Trident ",
      industry: "CONGLOMERATE",
      display_name: "Trident ",
    },
    {
      field_type: "company",
      name: "Trivenkem Agencies",
      field_id: "COM000977",
      website: "http://www.trivenkem.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Trivenkem Agencies.png",
      company_id: "COM000977",
      company_name: "Trivenkem Agencies",
      industry: "CHEMICAL",
      display_name: "Trivenkem Agencies",
    },
    {
      field_type: "company",
      name: "TTK Healthcare ",
      field_id: "COM001328",
      website: "http://www.ttkhealthcare.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TTK HEALTHCARE LIMITEd.gif",
      company_id: "COM001328",
      company_name: "TTK Healthcare ",
      industry: "",
      display_name: "TTK Healthcare ",
    },
    {
      field_type: "company",
      name: "TTK Prestige ",
      field_id: "COM000978",
      website: "http://www.ttkprestige.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/TTK Prestige Limited.jpg",
      company_id: "COM000978",
      company_name: "TTK Prestige ",
      industry: "MANUFACTURING",
      display_name: "TTK Prestige ",
    },
    {
      field_type: "company",
      name: "Tube Products Of India ",
      field_id: "COM000979",
      website: "",
      group: "TI",
      logo: "",
      company_id: "COM000979",
      company_name: "Tube Products Of India ",
      industry: "STEEL",
      display_name: "Tube Products Of India ",
    },
    {
      field_type: "company",
      name: "Ual Industries ",
      field_id: "COM001501",
      website: "http://ualind.com/",
      group: "",
      logo: "",
      company_id: "COM001501",
      company_name: "Ual Industries ",
      industry: "",
      display_name: "Ual Industries ",
    },
    {
      field_type: "company",
      name: "Uflex ",
      field_id: "COM000983",
      website: "https://www.uflexltd.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Uflex Limited.png",
      company_id: "COM000983",
      company_name: "Uflex ",
      industry: "PACKAGING",
      display_name: "Uflex ",
    },
    {
      field_type: "company",
      name: "Ultra M Sand Company",
      field_id: "COM000985",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000985",
      company_name: "Ultra M Sand Company",
      industry: "",
      display_name: "Ultra M Sand Company",
    },
    {
      field_type: "company",
      name: "Ultra Ready Mix Concrete  ",
      field_id: "COM000986",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000986",
      company_name: "Ultra Ready Mix Concrete  ",
      industry: "CONSTRUCTION",
      display_name: "Ultra Ready Mix Concrete  ",
    },
    {
      field_type: "company",
      name: "Ultratech Cement ",
      field_id: "COM000987",
      website: "https://www.ultratechcement.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/UltraTech Cement Limited.png",
      company_id: "COM000987",
      company_name: "Ultratech Cement ",
      display_name: "Ultratech Cement ",
      sector: "Cement",
      page_display_status: false,
      industry: "Cement",
    },
    {
      field_type: "company",
      name: "Unibic Foods  ",
      field_id: "COM000988",
      website: "http://unibicfoods.com/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/unibic%20(1).png",
      company_id: "COM000988",
      company_name: "Unibic Foods  ",
      industry: "FMCG",
      display_name: "Unibic Foods  ",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Unicharm  ",
      field_id: "COM001087",
      website: "http://www.unicharm.co.in/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/UNICHARM CORPORATION.gif",
      company_id: "COM001087",
      company_name: "Unicharm  ",
      industry: "",
      display_name: "Unicharm  ",
    },
    {
      field_type: "company",
      name: "Unichem Labs ",
      field_id: "COM000989",
      website: "https://unichemlabs.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Unichem Laboratories.png",
      company_id: "COM000989",
      company_name: "Unichem Labs ",
      industry: "",
      display_name: "Unichem Labs ",
    },
    {
      field_type: "company",
      name: "Unichem Pharma Usa ",
      field_id: "COM001502",
      website: "http://www.unichemusa.com/",
      group: "",
      logo: "",
      company_id: "COM001502",
      company_name: "Unichem Pharma Usa ",
      industry: "",
      display_name: "Unichem Pharma Usa ",
    },
    {
      field_type: "company",
      name: "Union Steel Holdings ",
      field_id: "COM000991",
      website: "http://www.unionsteel.com.sg/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Union Steel Holdings Limited.jpg",
      company_id: "COM000991",
      company_name: "Union Steel Holdings ",
      industry: "STEEL",
      display_name: "Union Steel Holdings ",
    },
    {
      field_type: "company",
      name: "Unipatch Rubber ",
      field_id: "COM000992",
      website: "http://www.unipatch.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/UNIPATCH RUBBER LIMITED.jpg",
      company_id: "COM000992",
      company_name: "Unipatch Rubber ",
      industry: "MANUFACTURING",
      display_name: "Unipatch Rubber ",
    },
    {
      field_type: "company",
      name: "United Breweries ",
      field_id: "COM000993",
      website: "http://unitedbreweries.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/UNITED BREWERIES GROUP.JPG",
      company_id: "COM000993",
      company_name: "United Breweries ",
      industry: "BREWING",
      display_name: "United Breweries ",
    },
    {
      field_type: "company",
      name: "United Phosphorus ",
      field_id: "COM000994",
      website: "http://www.upleurope.com/aboutus.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/United Phosphorus Ltd.gif",
      company_id: "COM000994",
      company_name: "United Phosphorus ",
      display_name: "United Phosphorus ",
      sector: "Chemical",
      page_display_status: false,
      industry: "Chemical",
    },
    {
      field_type: "company",
      name: "United Spirits ",
      field_id: "COM000995",
      website: "https://www.diageoindia.com/",
      group: "USL Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/United Spirits Limited.png",
      company_id: "COM000995",
      company_name: "United Spirits ",
      industry: "BREWING",
      display_name: "United Spirits ",
    },
    {
      field_type: "company",
      name: "",
      field_id: "COM000996",
      website: "",
      group: "",
      logo: "",
      company_id: "COM000996",
      company_name: "",
      replaced_data: {
        field_type: "company",
        name: "Up Twiga Fiberglass Limited",
        field_id: "COM000996",
        website: "http://www.twigafiber.com",
        group: "",
        logo: "",
        company_id: "COM000996",
        company_name: "Up Twiga Fiberglass Limited",
      },
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "UP Twiga Fiberglass ",
      field_id: "COM000982",
      website: "http://www.twigafiber.com/index.php",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Twiga.png",
      company_id: "COM000982",
      company_name: "UP Twiga Fiberglass ",
      industry: "",
      display_name: "UP Twiga Fiberglass ",
    },
    {
      field_type: "company",
      name: "USG Boral",
      field_id: "COM000998",
      website: "https://www.usgboral.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/USG BORAL.png",
      company_id: "COM000998",
      company_name: "USG Boral",
      industry: "BUILDING MATERIAL",
      display_name: "USG Boral",
    },
    {
      field_type: "company",
      name: "Usha Martin ",
      field_id: "COM000999",
      website: "http://www.ushamartin.com/en/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Usha Martin.gif",
      company_id: "COM000999",
      company_name: "Usha Martin ",
      industry: "MANUFACTURING",
      display_name: "Usha Martin ",
    },
    {
      field_type: "company",
      name: "USL Group",
      field_id: "COM001000",
      website: "https://www.uslgroup.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/USL Group.jpg",
      company_id: "COM001000",
      company_name: "USL Group",
      industry: "BREWING",
      display_name: "USL Group",
    },
    {
      field_type: "company",
      name: "USV  ",
      field_id: "COM001329",
      website: "https://www.usvindia.com/",
      group: "USV & P Inc. USA",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/USV PRIVATE LIMITED.png",
      company_id: "COM001329",
      company_name: "USV  ",
      industry: "",
      display_name: "USV  ",
    },
    {
      field_type: "company",
      name: "Utkarsh India ",
      field_id: "COM001001",
      website: "https://www.utkarshindia.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Utkarsh India.png",
      company_id: "COM001001",
      company_name: "Utkarsh India ",
      industry: "MANUFACTURING",
      display_name: "Utkarsh India ",
    },
    {
      field_type: "company",
      name: "Uttam Galva Steels ",
      field_id: "COM001002",
      website: "https://www.uttamgalva.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Uttam Galva Steels Limited.png",
      company_id: "COM001002",
      company_name: "Uttam Galva Steels ",
      industry: "STEEL",
      display_name: "Uttam Galva Steels ",
    },
    {
      field_type: "company",
      name: "V Guard Industries ",
      field_id: "COM001019",
      website: "https://www.vguard.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/V GUARD INDUSTRIES LIMITED.jpg",
      company_id: "COM001019",
      company_name: "V Guard Industries ",
      industry: "ELECTRICALS",
      display_name: "V Guard Industries ",
    },
    {
      field_type: "company",
      name: "Vacmet India ",
      field_id: "COM001005",
      website: "https://www.vpipl.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Vacmet India.png",
      company_id: "COM001005",
      company_name: "Vacmet India ",
      industry: "PLASTICS",
      display_name: "Vacmet India ",
    },
    {
      field_type: "company",
      name: "Vadilal Group",
      field_id: "COM001006",
      website: "https://vadilalgroup.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Vadilal Group.png",
      company_id: "COM001006",
      company_name: "Vadilal Group",
      display_name: "Vadilal Group",
      sector: "Food Products",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Vaibhav Foods",
      field_id: "COM001007",
      website: "http://www.vaibhavfoods.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Vaibhav Foods.png",
      company_id: "COM001007",
      company_name: "Vaibhav Foods",
      industry: "FMCG",
      display_name: "Vaibhav Foods",
    },
    {
      field_type: "company",
      name: "Valeo India  ",
      field_id: "COM001088",
      website: "https://www.valeo.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VALEO.png",
      company_id: "COM001088",
      company_name: "Valeo India  ",
      industry: "",
      display_name: "Valeo India  ",
    },
    {
      field_type: "company",
      name: "Valvoline Cummins  ",
      field_id: "COM001503",
      website:
        "https://www.cumminsindia.com/companies/valvoline-cummins-pvt-limited",
      group: "",
      logo: "",
      company_id: "COM001503",
      company_name: "Valvoline Cummins  ",
      industry: "",
      display_name: "Valvoline Cummins  ",
    },
    {
      field_type: "company",
      name: "Valvoline",
      field_id: "COM001008",
      website: "https://www.vioc.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Valvoline.png",
      company_id: "COM001008",
      company_name: "Valvoline",
      industry: "OIL AND GAS",
      display_name: "Valvoline",
    },
    {
      field_type: "company",
      name: "Vansh Electricals",
      field_id: "COM001009",
      website: "http://www.vanshelectricals.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Vansh Electricals.png",
      company_id: "COM001009",
      company_name: "Vansh Electricals",
      industry: "ELECTRICALS",
      display_name: "Vansh Electricals",
    },
    {
      field_type: "company",
      name: "Vardhman Group",
      field_id: "COM001010",
      website: "https://www.vardhman.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VARDHMAN GROUP.png",
      company_id: "COM001010",
      company_name: "Vardhman Group",
      industry: "CONGLOMERATE",
      display_name: "Vardhman Group",
    },
    {
      field_type: "company",
      name: "Vardhman Textiles ",
      field_id: "COM000573",
      website: "https://www.vardhman.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VARDHMAN TEXTILES LIMITED.png",
      company_id: "COM000573",
      company_name: "Vardhman Textiles ",
      industry: "TEXTILE",
      display_name: "Vardhman Textiles ",
    },
    {
      field_type: "company",
      name: "Varun Beverages ",
      field_id: "COM001011",
      website: "https://varunpepsi.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Varun Beverages Ltd.png",
      company_id: "COM001011",
      company_name: "Varun Beverages ",
      industry: "BREWING",
      display_name: "Varun Beverages ",
    },
    {
      field_type: "company",
      name: "Varun Motors  ",
      field_id: "COM001330",
      website: "http://www.varunmaruti.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VARUN MOTORS PRIVATE LIMITED.png",
      company_id: "COM001330",
      company_name: "Varun Motors  ",
      industry: "",
      display_name: "Varun Motors  ",
    },
    {
      field_type: "company",
      name: "Vasudha Pharma Chem ",
      field_id: "COM001504",
      website: "https://www.vasudhapharma.com/",
      group: "",
      logo: "",
      company_id: "COM001504",
      company_name: "Vasudha Pharma Chem ",
      industry: "",
      display_name: "Vasudha Pharma Chem ",
    },
    {
      field_type: "company",
      name: "VE Commercial Vehicles ",
      field_id: "COM001013",
      website: "http://www.vecv.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VE Commercial Vehicles Limited.jpg",
      company_id: "COM001013",
      company_name: "VE Commercial Vehicles ",
      industry: "AUTOMOBILE",
      display_name: "VE Commercial Vehicles ",
    },
    {
      field_type: "company",
      name: "Vedanta ",
      field_id: "COM001014",
      website: "https://www.vedantalimited.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Vedanta Limited.jpg",
      company_id: "COM001014",
      company_name: "Vedanta ",
      display_name: "Vedanta ",
      sector: "Metals and Mining",
      page_display_status: false,
      industry: "Metals and Mining",
    },
    {
      field_type: "company",
      name: "Venus Remedies ",
      field_id: "COM001505",
      website: "http://www.venusremedies.com/",
      group: "",
      logo: "",
      company_id: "COM001505",
      company_name: "Venus Remedies ",
      industry: "",
      display_name: "Venus Remedies ",
    },
    {
      field_type: "company",
      name: "Veremente Enterprise  ",
      field_id: "COM001016",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VEREMENTE ENTERPRISE PRIVATE LIMITED.png",
      company_id: "COM001016",
      company_name: "Veremente Enterprise  ",
      industry: "FASHION AND CLOTHING",
      display_name: "Veremente Enterprise  ",
    },
    {
      field_type: "company",
      name: "Vertiv Group Corp",
      field_id: "COM001017",
      website: "https://www.vertiv.com",
      group: "Vertiv Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Vertiv Group.png",
      company_id: "COM001017",
      company_name: "Vertiv Group Corp",
      industry: "ELECTRICALS",
      display_name: "Vertiv Group Corp",
    },
    {
      field_type: "company",
      name: "Vesuvius Plc",
      field_id: "COM001018",
      website: "https://www.vesuvius.com/en/index.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Vesuvius.png",
      company_id: "COM001018",
      company_name: "Vesuvius Plc",
      industry: "ENGINEERING SERVICES",
      display_name: "Vesuvius Plc",
    },
    {
      field_type: "company",
      name: "Vibhava Marketing Corp",
      field_id: "COM001020",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001020",
      company_name: "Vibhava Marketing Corp",
      industry: "MANUFACTURING",
      display_name: "Vibhava Marketing Corp",
    },
    {
      field_type: "company",
      name: "Victrans Engineers",
      field_id: "COM001022",
      website: "https://ieema.org",
      group: "",
      logo: "",
      company_id: "COM001022",
      company_name: "Victrans Engineers",
      industry: "MANUFACTURING",
      display_name: "Victrans Engineers",
    },
    {
      field_type: "company",
      name: "Videocon Group",
      field_id: "COM001023",
      website: "http://www.videoconindustriesltd.com/",
      group: "Videocon Group",
      logo: "",
      company_id: "COM001023",
      company_name: "Videocon Group",
      industry: "CONGLOMERATE",
      display_name: "Videocon Group",
    },
    {
      field_type: "company",
      name: "Vijai Electricals ",
      field_id: "COM001024",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001024",
      company_name: "Vijai Electricals ",
      industry: "ELECTRICALS",
      display_name: "Vijai Electricals ",
    },
    {
      field_type: "company",
      name: "Vijay Shree Nav Nirman Plaster",
      field_id: "COM001025",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001025",
      company_name: "Vijay Shree Nav Nirman Plaster",
      industry: "PAINTS",
      display_name: "Vijay Shree Nav Nirman Plaster",
    },
    {
      field_type: "company",
      name: "Vijayalakshmi Paper Mills",
      field_id: "COM001027",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001027",
      company_name: "Vijayalakshmi Paper Mills",
      industry: "PAPER",
      display_name: "Vijayalakshmi Paper Mills",
    },
    {
      field_type: "company",
      name: "Vikas Enterprises",
      field_id: "COM001028",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VIKAS ENTERPRISES.jpg",
      company_id: "COM001028",
      company_name: "Vikas Enterprises",
      industry: "MANUFACTURING",
      display_name: "Vikas Enterprises",
    },
    {
      field_type: "company",
      name: "Vikram Solar ",
      field_id: "COM001331",
      website: "https://www.vikramsolar.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VIKRAM SOLAR LIMITED.png",
      company_id: "COM001331",
      company_name: "Vikram Solar ",
      industry: "",
      display_name: "Vikram Solar ",
    },
    {
      field_type: "company",
      name: "Vini Cosmetics  ",
      field_id: "COM001029",
      website: "https://www.vccircle.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VCCIRCLE.png",
      company_id: "COM001029",
      company_name: "Vini Cosmetics  ",
      industry: "CHEMICAL",
      display_name: "Vini Cosmetics  ",
    },
    {
      field_type: "company",
      name: "VIP",
      field_id: "COM001030",
      website: "http://www.vipindustries.co.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VIP INDUSTRIES LIMITED.png",
      company_id: "COM001030",
      company_name: "VIP",
      display_name: "VIP",
      sector: "Luggage",
      page_display_status: false,
      industry: "Luggage",
    },
    {
      field_type: "company",
      name: "Viraj Profiles ",
      field_id: "COM001031",
      website: "https://www.viraj.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VIRAJ PROFILES LIMITED.png",
      company_id: "COM001031",
      company_name: "Viraj Profiles ",
      industry: "STEEL",
      display_name: "Viraj Profiles ",
    },
    {
      field_type: "company",
      name: "Virchow Biotech  ",
      field_id: "COM001506",
      website: "http://virchowbiotech.com",
      group: "",
      logo: "",
      company_id: "COM001506",
      company_name: "Virchow Biotech  ",
      industry: "",
      display_name: "Virchow Biotech  ",
    },
    {
      field_type: "company",
      name: "Virchow Labs ",
      field_id: "COM001507",
      website: "http://virchows.com/",
      group: "",
      logo: "",
      company_id: "COM001507",
      company_name: "Virchow Labs ",
      industry: "",
      display_name: "Virchow Labs ",
    },
    {
      field_type: "company",
      name: "Virupaksha Organics",
      field_id: "COM001508",
      website: "https://virupaksha.com/",
      group: "",
      logo: "",
      company_id: "COM001508",
      company_name: "Virupaksha Organics",
      industry: "",
      display_name: "Virupaksha Organics",
    },
    {
      field_type: "company",
      name: "Visa Steels ",
      field_id: "COM001332",
      website: "https://www.visasteel.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VISA STEELS LIMITED.png",
      company_id: "COM001332",
      company_name: "Visa Steels ",
      industry: "",
      display_name: "Visa Steels ",
    },
    {
      field_type: "company",
      name: "Visaka Industries  ",
      field_id: "COM001032",
      website: "https://www.visaka.co/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VISAKA INDUSTRIES PRIVATE LIMITED.png",
      company_id: "COM001032",
      company_name: "Visaka Industries  ",
      industry: "MANUFACTURING",
      display_name: "Visaka Industries  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Vishal Mega Mart  ",
      field_id: "COM001033",
      website: "https://www.myvishal.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VISHAL MEGA MART.png",
      company_id: "COM001033",
      company_name: "Vishal Mega Mart  ",
      industry: "FASHION AND CLOTHING",
      display_name: "Vishal Mega Mart  ",
    },
    {
      field_type: "company",
      name: "Vishal Nirmiti  ",
      field_id: "COM001034",
      website: "http://www.gitagroup.com/",
      group: "Gita Group",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/GITA GROUP.jpg",
      company_id: "COM001034",
      company_name: "Vishal Nirmiti  ",
      industry: "MANUFACTURING",
      display_name: "Vishal Nirmiti  ",
    },
    {
      field_type: "company",
      name: "Vishva Electrotech ",
      field_id: "COM001035",
      website: "https://www.polar-india.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VISHVA ELECTROTECH LIMITED.png",
      company_id: "COM001035",
      company_name: "Vishva Electrotech ",
      industry: "MANUFACTURING",
      display_name: "Vishva Electrotech ",
    },
    {
      field_type: "company",
      name: "Vista Office System  ",
      field_id: "COM001036",
      website: "http://www.vistaofficesystem.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VISTA OFFICE SYSTEMS.png",
      company_id: "COM001036",
      company_name: "Vista Office System  ",
      industry: "",
      display_name: "Vista Office System  ",
    },
    {
      field_type: "company",
      name: "Vivimed Labs ",
      field_id: "COM001037",
      website: "http://www.vivimedlabs.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VIVIMED LABS LIMITED.png",
      company_id: "COM001037",
      company_name: "Vivimed Labs ",
      industry: "CHEMICAL",
      display_name: "Vivimed Labs ",
    },
    {
      field_type: "company",
      name: "Vivo Communication Technology Corp ",
      field_id: "COM001089",
      website: "https://www.vivo.com/in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VIVO COMMUNICATION TECHNOLOGY CORPORATION LIMITED.png",
      company_id: "COM001089",
      company_name: "Vivo Communication Technology Corp ",
      industry: "",
      display_name: "Vivo Communication Technology Corp ",
    },
    {
      field_type: "company",
      name: "Vodafone Idea ",
      field_id: "COM001038",
      website: "https://www.vodafoneidea.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Vodafone Idea Limited.png",
      company_id: "COM001038",
      company_name: "Vodafone Idea ",
      industry: "TELECOM",
      display_name: "Vodafone Idea ",
    },
    {
      field_type: "company",
      name: "Voltas ",
      field_id: "COM001040",
      website: "https://www.voltas.com",
      group: "",
      logo: "",
      company_id: "COM001040",
      company_name: "Voltas ",
      industry: "ELECTRONICS",
      display_name: "Voltas ",
    },
    {
      field_type: "company",
      name: "Volvo",
      field_id: "COM001041",
      website: "https://www.volvoce.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VOLVO.png",
      company_id: "COM001041",
      company_name: "Volvo",
      industry: "MANUFACTURING",
      display_name: "Volvo",
    },
    {
      field_type: "company",
      name: "VRL",
      field_id: "COM001042",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001042",
      company_name: "VRL",
      industry: "CONGLOMERATE",
      display_name: "VRL",
    },
    {
      field_type: "company",
      name: "VST Industries ",
      field_id: "COM001043",
      website: "http://www.vsthyd.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/VST INDUSTRIES LIMITED.png",
      company_id: "COM001043",
      company_name: "VST Industries ",
      industry: "CONGLOMERATE",
      display_name: "VST Industries ",
    },
    {
      field_type: "company",
      name: "VVF",
      field_id: "COM001045",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001045",
      company_name: "VVF",
      display_name: "VVF",
      sector: "FMCG",
      page_display_status: false,
      replaced_data: {
        field_type: "company",
        name: "Vvf Limited",
        field_id: "COM001045",
        website: "",
        group: "",
        logo: "",
        company_id: "COM001045",
        company_name: "Vvf Limited",
        display_name: "VVF",
        sector: "FMCG",
        page_display_status: true,
      },
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "W2E Engineering  ",
      field_id: "COM001046",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001046",
      company_name: "W2E Engineering  ",
      industry: "MANUFACTURING",
      display_name: "W2E Engineering  ",
    },
    {
      field_type: "company",
      name: "Walchandnagar Industries ",
      field_id: "COM001047",
      website: "https://www.walchand.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/WALCHANDNAGAR INDUSTRIES LIMITED.png",
      company_id: "COM001047",
      company_name: "Walchandnagar Industries ",
      industry: "MANUFACTURING",
      display_name: "Walchandnagar Industries ",
    },
    {
      field_type: "company",
      name: "Wardex Pharma  ",
      field_id: "COM001048",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001048",
      company_name: "Wardex Pharma  ",
      industry: "PHARMACEUTICAL",
      display_name: "Wardex Pharma  ",
    },
    {
      field_type: "company",
      name: "Webfil ",
      field_id: "COM001049",
      website: "https://www.webfilindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/WEBFIL LIMITED.gif",
      company_id: "COM001049",
      company_name: "Webfil ",
      industry: "MANUFACTURING",
      display_name: "Webfil ",
    },
    {
      field_type: "company",
      name: "Welspun ",
      field_id: "COM001090",
      website: "http://www.welspunindia.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/WELSPUN.png",
      company_id: "COM001090",
      company_name: "Welspun ",
      industry: "",
      display_name: "Welspun ",
    },
    {
      field_type: "company",
      name: "Western Coalfields ",
      field_id: "COM001050",
      website: "http://www.westerncoal.in/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/WESTERN COALFIELDS LIMITED.png",
      company_id: "COM001050",
      company_name: "Western Coalfields ",
      industry: "METALS AND MINING",
      display_name: "Western Coalfields ",
    },
    {
      field_type: "company",
      name: "Western India Media  ",
      field_id: "COM000358",
      website: "http://www.gujaratguardian.in/Home",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/WESTERN INDIA MEDIA PRIVATE LIMITED.png",
      company_id: "COM000358",
      company_name: "Western India Media  ",
      industry: "GLASS",
      display_name: "Western India Media  ",
    },
    {
      field_type: "company",
      name: "Wheels India ",
      field_id: "COM001051",
      website: "https://www.wheelsindia.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/WHEELS INDIA LIMITED.png",
      company_id: "COM001051",
      company_name: "Wheels India ",
      industry: "AUTOMOBILE",
      display_name: "Wheels India ",
    },
    {
      field_type: "company",
      name: "Whirlpool Corp",
      field_id: "COM001052",
      website: "https://www.whirlpoolcorp.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/WHIRLPOOL CORPORATION.png",
      company_id: "COM001052",
      company_name: "Whirlpool Corp",
      display_name: "Whirlpool Corp",
      sector: "Electronics",
      page_display_status: true,
      industry: "FMCD",
    },
    {
      field_type: "company",
      name: "Wintac ",
      field_id: "COM001509",
      website: "http://www.wintaclimited.com/",
      group: "",
      logo: "",
      company_id: "COM001509",
      company_name: "Wintac ",
      industry: "",
      display_name: "Wintac ",
    },
    {
      field_type: "company",
      name: "Wipro Enterprises  ",
      field_id: "COM001053",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001053",
      company_name: "Wipro Enterprises  ",
      industry: "CONGLOMERATE",
      display_name: "Wipro Enterprises  ",
    },
    {
      field_type: "company",
      name: "Wockhardt ",
      field_id: "COM001054",
      website: "http://www.wockhardt.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/WOCKHARDT.png",
      company_id: "COM001054",
      company_name: "Wockhardt ",
      industry: "",
      display_name: "Wockhardt ",
    },
    {
      field_type: "company",
      name: "Wonder Cement ",
      field_id: "COM001510",
      website: "https://www.wondercement.com/",
      group: "",
      logo: "",
      company_id: "COM001510",
      company_name: "Wonder Cement ",
      industry: "",
      display_name: "Wonder Cement ",
    },
    {
      field_type: "company",
      name: "Xalta Food And Beverages  ",
      field_id: "COM001055",
      website: "",
      group: "",
      logo: "",
      company_id: "COM001055",
      company_name: "Xalta Food And Beverages  ",
      industry: "BREWING",
      display_name: "Xalta Food And Beverages  ",
    },
    {
      field_type: "company",
      name: "XPRO India ",
      field_id: "COM001056",
      website: "http://www.xproindia.com/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/XPRO INDIA LIMITED.jpg",
      company_id: "COM001056",
      company_name: "XPRO India ",
      industry: "PLASTICS",
      display_name: "XPRO India ",
    },
    {
      field_type: "company",
      name: "Y Cook India  ",
      field_id: "COM001057",
      website: "http://www.ycook.in",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Y COOK INDIA PRIVATE LIMITED.png",
      company_id: "COM001057",
      company_name: "Y Cook India  ",
      industry: "FMCG",
      display_name: "Y Cook India  ",
    },
    {
      field_type: "company",
      name: "Yazaki Corp",
      field_id: "COM001058",
      website: "https://www.yazaki-group.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/YAZAKI CORPORATION.gif",
      company_id: "COM001058",
      company_name: "Yazaki Corp",
      industry: "AUTOMOBILE",
      display_name: "Yazaki Corp",
    },
    {
      field_type: "company",
      name: "Yodeva Plastics  ",
      field_id: "COM001059",
      website: "http://www.yodeva.net/",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/YODEVA PLASTICS PRIVATE LIMITED.jpg",
      company_id: "COM001059",
      company_name: "Yodeva Plastics  ",
      industry: "PLASTICS",
      display_name: "Yodeva Plastics  ",
    },
    {
      field_type: "company",
      name: "Yum Brands corporated",
      field_id: "COM001060",
      website: "https://www.yum.com",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/YUM! BRANDS.png",
      company_id: "COM001060",
      company_name: "Yum Brands corporated",
      display_name: "Yum Brands corporated",
      sector: "Food Products",
      page_display_status: false,
      industry: "Retail",
    },
    {
      field_type: "company",
      name: "ZCL Chemicals ",
      field_id: "COM001511",
      website: "http://www.zclchemicals.com/",
      group: "",
      logo: "",
      company_id: "COM001511",
      company_name: "ZCL Chemicals ",
      industry: "",
      display_name: "ZCL Chemicals ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Zuari Cement ",
      field_id: "COM001512",
      website: "http://www.zuaricements.com/",
      group: "",
      logo: "",
      company_id: "COM001512",
      company_name: "Zuari Cement ",
      industry: "",
      display_name: "Zuari Cement ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Zydus Wellness ",
      field_id: "COM001061",
      website: "https://zyduswellness.in/contactus.html",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/ZYDUS WELLNESS LIMITED.jpg",
      company_id: "COM001061",
      company_name: "Zydus Wellness ",
      industry: "HEALTHCARE",
      display_name: "Zydus Wellness ",
    },
    {
      field_type: "company",
      name: "Zygpharma  ",
      field_id: "COM001513",
      website: "http://www.zygpharma.com/",
      group: "",
      logo: "",
      company_id: "COM001513",
      company_name: "Zygpharma  ",
      industry: "",
      display_name: "Zygpharma  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Page Industries ",
      field_id: "COM001514",
      company_name: "Page Industries ",
      company_id: "COM001514",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Page Industries ",
    },
    {
      field_type: "company",
      name: "NCR Corp India  ",
      field_id: "COM001515",
      company_name: "NCR Corp India  ",
      company_id: "COM001515",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "NCR Corp India  ",
    },
    {
      field_type: "company",
      name: "Jubilant FoodWorks ",
      field_id: "COM001516",
      company_name: "Jubilant FoodWorks ",
      company_id: "COM001516",
      group: "",
      logo: "",
      website: "",
      display_name: "Jubilant FoodWorks ",
      sector: "FMCG",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Reliance Life Sciences",
      field_id: "COM001517",
      company_name: "Reliance Life Sciences",
      company_id: "COM001517",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Reliance Life Sciences",
    },
    {
      field_type: "company",
      name: "Diageo India  ",
      field_id: "COM001518",
      company_name: "Diageo India  ",
      company_id: "COM001518",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Diageo India  ",
    },
    {
      field_type: "company",
      name: "FCA India Automobiles  ",
      field_id: "COM001519",
      company_name: "FCA India Automobiles  ",
      company_id: "COM001519",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "FCA India Automobiles  ",
    },
    {
      field_type: "company",
      name: "DP World",
      field_id: "COM001520",
      company_name: "DP World",
      company_id: "COM001520",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "DP World",
    },
    {
      field_type: "company",
      name: "HyFun Foods  ",
      field_id: "COM001521",
      company_name: "HyFun Foods  ",
      company_id: "COM001521",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "HyFun Foods  ",
    },
    {
      field_type: "company",
      name: "Fonterra Future Dairy",
      field_id: "COM001522",
      company_name: "Fonterra Future Dairy",
      company_id: "COM001522",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Fonterra Future Dairy",
    },
    {
      field_type: "company",
      name: "Sapphire Foods India  ",
      field_id: "COM001523",
      company_name: "Sapphire Foods India  ",
      company_id: "COM001523",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Sapphire Foods India  ",
    },
    {
      field_type: "company",
      name: "Red Bull India  ",
      field_id: "COM001524",
      company_name: "Red Bull India  ",
      company_id: "COM001524",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Red Bull India  ",
    },
    {
      field_type: "company",
      name: "GMR Airports ",
      field_id: "COM001525",
      company_name: "GMR Airports ",
      company_id: "COM001525",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "GMR Airports ",
    },
    {
      field_type: "company",
      name: "M&B Engineering ",
      field_id: "COM001526",
      company_name: "M&B Engineering ",
      company_id: "COM001526",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "M&B Engineering ",
    },
    {
      field_type: "company",
      name: "Columbia Asia Hospitals",
      field_id: "COM001527",
      company_name: "Columbia Asia Hospitals",
      company_id: "COM001527",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Columbia Asia Hospitals",
    },
    {
      field_type: "company",
      name: "IBM",
      field_id: "COM001528",
      company_name: "IBM",
      company_id: "COM001528",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "IBM",
    },
    {
      field_type: "company",
      name: "Nokia",
      field_id: "COM001529",
      company_name: "Nokia",
      company_id: "COM001529",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Nokia",
    },
    {
      field_type: "company",
      name: "ThyssenKrupp Elevator",
      field_id: "COM001530",
      company_name: "ThyssenKrupp Elevator",
      company_id: "COM001530",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "ThyssenKrupp Elevator",
    },
    {
      field_type: "company",
      name: "PVR Cinemas  ",
      field_id: "COM001531",
      company_name: "PVR Cinemas  ",
      company_id: "COM001531",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "PVR Cinemas  ",
    },
    {
      field_type: "company",
      name: "Tata Services ",
      field_id: "COM001532",
      company_name: "Tata Services ",
      company_id: "COM001532",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Tata Services ",
    },
    {
      field_type: "company",
      name: "Metropolis Healthcare ",
      field_id: "COM001533",
      company_name: "Metropolis Healthcare ",
      company_id: "COM001533",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Metropolis Healthcare ",
    },
    {
      field_type: "company",
      name: "Thermo Fisher Scientific",
      field_id: "COM001534",
      company_name: "Thermo Fisher Scientific",
      company_id: "COM001534",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Thermo Fisher Scientific",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Dorf Ketal Chemicals",
      field_id: "COM001535",
      company_name: "Dorf Ketal Chemicals",
      company_id: "COM001535",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Dorf Ketal Chemicals",
    },
    {
      field_type: "company",
      name: "Chaayos Sunshine Teahouse  ",
      field_id: "COM001536",
      company_name: "Chaayos Sunshine Teahouse  ",
      company_id: "COM001536",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Chaayos Sunshine Teahouse  ",
    },
    {
      field_type: "company",
      name: "Laxmi Organic Industries ",
      field_id: "COM001537",
      company_name: "Laxmi Organic Industries ",
      company_id: "COM001537",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Laxmi Organic Industries ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Max Healthcare Institute ",
      field_id: "COM001539",
      company_name: "Max Healthcare Institute ",
      company_id: "COM001539",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Max Healthcare Institute ",
    },
    {
      field_type: "company",
      name: "Apcotex Industries ",
      field_id: "COM001540",
      company_name: "Apcotex Industries ",
      company_id: "COM001540",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Apcotex Industries ",
    },
    {
      field_type: "company",
      name: "Crystal Crop Protection ",
      field_id: "COM001541",
      company_name: "Crystal Crop Protection ",
      company_id: "COM001541",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Crystal Crop Protection ",
    },
    {
      field_type: "company",
      name: "Navin Fluorine International ",
      field_id: "COM001542",
      company_name: "Navin Fluorine International ",
      company_id: "COM001542",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Navin Fluorine International ",
    },
    {
      field_type: "company",
      name: "Luxottica Eyewear",
      field_id: "COM001543",
      company_name: "Luxottica Eyewear",
      company_id: "COM001543",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Luxottica Eyewear",
    },
    {
      field_type: "company",
      name: "BigBasket",
      field_id: "COM001544",
      company_name: "BigBasket",
      company_id: "COM001544",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "BigBasket",
    },
    {
      field_type: "company",
      name: "Spencer's Retail ",
      field_id: "COM001545",
      company_name: "Spencer's Retail ",
      company_id: "COM001545",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Spencer's Retail ",
    },
    {
      field_type: "company",
      name: "Dr Lal Pathlabs ",
      field_id: "COM001546",
      company_name: "Dr Lal Pathlabs ",
      company_id: "COM001546",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Dr Lal Pathlabs ",
    },
    {
      field_type: "company",
      name: "Hamdard Labs",
      field_id: "COM001547",
      company_name: "Hamdard Labs",
      company_id: "COM001547",
      group: "",
      logo: "",
      website: "",
      display_name: "Hamdard Labs",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "RPG Life Sciences ",
      field_id: "COM001548",
      company_name: "RPG Life Sciences ",
      company_id: "COM001548",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "RPG Life Sciences ",
    },
    {
      field_type: "company",
      name: "United Biscuits  ",
      field_id: "COM001549",
      company_name: "United Biscuits  ",
      company_id: "COM001549",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "United Biscuits  ",
    },
    {
      field_type: "company",
      name: "Celio Future Fashion ",
      field_id: "COM001550",
      company_name: "Celio Future Fashion ",
      company_id: "COM001550",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Celio Future Fashion ",
    },
    {
      field_type: "company",
      name: "Nayara Energy ",
      field_id: "COM001551",
      company_name: "Nayara Energy ",
      company_id: "COM001551",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Nayara Energy ",
    },
    {
      field_type: "company",
      name: "Hafele   ",
      field_id: "COM001552",
      company_name: "Hafele   ",
      company_id: "COM001552",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Hafele   ",
    },
    {
      field_type: "company",
      name: "Takeda Pharma ",
      field_id: "COM001553",
      company_name: "Takeda Pharma ",
      company_id: "COM001553",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Takeda Pharma ",
    },
    {
      field_type: "company",
      name: "SOCH Apparel",
      field_id: "COM001554",
      company_name: "SOCH Apparel",
      company_id: "COM001554",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "SOCH Apparel",
    },
    {
      field_type: "company",
      name: "Pearl Global Industries ",
      field_id: "COM001555",
      company_name: "Pearl Global Industries ",
      company_id: "COM001555",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Pearl Global Industries ",
    },
    {
      field_type: "company",
      name: "Davidoff",
      field_id: "COM001556",
      company_name: "Davidoff",
      company_id: "COM001556",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Davidoff",
    },
    {
      field_type: "company",
      name: "MORE Retail ",
      field_id: "COM001557",
      company_name: "MORE Retail ",
      company_id: "COM001557",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "MORE Retail ",
    },
    {
      field_type: "company",
      name: "The Belgian Waffel Co Bloombay Enterprises ",
      field_id: "COM001558",
      company_name: "The Belgian Waffel Co Bloombay Enterprises ",
      company_id: "COM001558",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "The Belgian Waffel Co Bloombay Enterprises ",
    },
    {
      field_type: "company",
      name: "Chai Point Mountain Trail Food  ",
      field_id: "COM001559",
      company_name: "Chai Point Mountain Trail Food  ",
      company_id: "COM001559",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Chai Point Mountain Trail Food  ",
    },
    {
      field_type: "company",
      name: "Malabar Gold and Diamonds  ",
      field_id: "COM001560",
      company_name: "Malabar Gold and Diamonds  ",
      company_id: "COM001560",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Malabar Gold and Diamonds  ",
    },
    {
      field_type: "company",
      name: "A Raymond Fasteners  ",
      field_id: "COM001561",
      company_name: "A Raymond Fasteners  ",
      company_id: "COM001561",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "A Raymond Fasteners  ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Apollo Hospitals Enterprises ",
      field_id: "COM001562",
      company_name: "Apollo Hospitals Enterprises ",
      company_id: "COM001562",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Apollo Hospitals Enterprises ",
    },
    {
      field_type: "company",
      name: "NOCIL ",
      field_id: "COM001563",
      company_name: "NOCIL ",
      company_id: "COM001563",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "NOCIL ",
    },
    {
      field_type: "company",
      name: "Lenskart",
      field_id: "COM001564",
      company_name: "Lenskart",
      company_id: "COM001564",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Lenskart",
    },
    {
      field_type: "company",
      name: "Roche Diagnostics  ",
      field_id: "COM001565",
      company_name: "Roche Diagnostics  ",
      company_id: "COM001565",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Roche Diagnostics  ",
    },
    {
      field_type: "company",
      name: "Hetero Drugs ",
      field_id: "COM001566",
      company_name: "Hetero Drugs ",
      company_id: "COM001566",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Hetero Drugs ",
    },
    {
      field_type: "company",
      name: "TORM",
      field_id: "COM001567",
      company_name: "TORM",
      company_id: "COM001567",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "TORM",
    },
    {
      field_type: "company",
      name: "Dai Ichi Karkaria ",
      field_id: "COM001568",
      company_name: "Dai Ichi Karkaria ",
      company_id: "COM001568",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Dai Ichi Karkaria ",
    },
    {
      field_type: "company",
      name: "OmniActive Health Technologies ",
      field_id: "COM001569",
      company_name: "OmniActive Health Technologies ",
      company_id: "COM001569",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "OmniActive Health Technologies ",
    },
    {
      field_type: "company",
      name: "Savita Oil Technologies ",
      field_id: "COM001570",
      company_name: "Savita Oil Technologies ",
      company_id: "COM001570",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Savita Oil Technologies ",
    },
    {
      field_type: "company",
      name: "Gujarat Heavy Chemicals ",
      field_id: "COM001571",
      company_name: "Gujarat Heavy Chemicals ",
      company_id: "COM001571",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Gujarat Heavy Chemicals ",
    },
    {
      field_type: "company",
      name: "Zuventus Healthcare ",
      field_id: "COM001572",
      company_name: "Zuventus Healthcare ",
      company_id: "COM001572",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Zuventus Healthcare ",
    },
    {
      field_type: "company",
      name: "RS Components",
      field_id: "COM001573",
      company_name: "RS Components",
      company_id: "COM001573",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "RS Components",
    },
    {
      field_type: "company",
      name: "Kamaths Ourtimes Ice cream  ",
      field_id: "COM001574",
      company_name: "Kamaths Ourtimes Ice cream  ",
      company_id: "COM001574",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Kamaths Ourtimes Ice cream  ",
    },
    {
      field_type: "company",
      name: "Meinhardt EPCM Group of Companies",
      field_id: "COM001575",
      company_name: "Meinhardt EPCM Group of Companies",
      company_id: "COM001575",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Meinhardt EPCM Group of Companies",
    },
    {
      field_type: "company",
      name: "Koye Pharma  ",
      field_id: "COM001576",
      company_name: "Koye Pharma  ",
      company_id: "COM001576",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Koye Pharma  ",
    },
    {
      field_type: "company",
      name: "Amcor ",
      field_id: "COM001577",
      company_name: "Amcor ",
      company_id: "COM001577",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Amcor ",
      page_display_status: false,
    },
    {
      field_type: "company",
      name: "Natures Basket ",
      field_id: "COM001578",
      company_name: "Natures Basket ",
      company_id: "COM001578",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Natures Basket ",
    },
    {
      field_type: "company",
      name: "Oaknet Healthcare  ",
      field_id: "COM001579",
      company_name: "Oaknet Healthcare  ",
      company_id: "COM001579",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Oaknet Healthcare  ",
    },
    {
      field_type: "company",
      name: "Meril Life Sciences  ",
      field_id: "COM001580",
      company_name: "Meril Life Sciences  ",
      company_id: "COM001580",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Meril Life Sciences  ",
    },
    {
      field_type: "company",
      name: "Future Retail ",
      field_id: "COM001581",
      company_name: "Future Retail ",
      company_id: "COM001581",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Future Retail ",
    },
    {
      field_type: "company",
      name: "SSK Group",
      field_id: "COM001582",
      company_name: "SSK Group",
      company_id: "COM001582",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "SSK Group",
    },
    {
      field_type: "company",
      name: "Solvay Specialities  ",
      field_id: "COM001583",
      company_name: "Solvay Specialities  ",
      company_id: "COM001583",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Solvay Specialities  ",
    },
    {
      field_type: "company",
      name: "LANXESS India  ",
      field_id: "COM001584",
      company_name: "LANXESS India  ",
      company_id: "COM001584",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "LANXESS India  ",
    },
    {
      field_type: "company",
      name: "Wind World India ",
      field_id: "COM001585",
      company_name: "Wind World India ",
      company_id: "COM001585",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Wind World India ",
    },
    {
      field_type: "company",
      name: "Schindler  ",
      field_id: "COM001586",
      company_name: "Schindler  ",
      company_id: "COM001586",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "Schindler  ",
    },
    {
      field_type: "company",
      name: "LT Foods ",
      field_id: "COM001587",
      company_name: "LT Foods ",
      company_id: "COM001587",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/LT%20Foods.png",
      website: "",
      display_name: "LT Foods ",
      sector: "FMCG",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Adani Agri Fresh ",
      field_id: "COM001588",
      company_name: "Adani Agri Fresh ",
      company_id: "COM001588",
      group: "",
      logo: "",
      website: "",
      display_name: "Adani Agri Fresh ",
      sector: "Agricultural Products",
      page_display_status: false,
      industry: "Agricultural Products",
    },
    {
      field_type: "company",
      name: "JK Agri Genetics ",
      field_id: "COM001589",
      company_name: "JK Agri Genetics ",
      company_id: "COM001589",
      group: "",
      logo: "",
      website: "",
      display_name: "JK Agri Genetics ",
      sector: "Agricultural Products",
      page_display_status: false,
      industry: "Agri Inputs",
    },
    {
      field_type: "company",
      name: "Mapro Foods  ",
      field_id: "COM001590",
      company_name: "Mapro Foods  ",
      company_id: "COM001590",
      group: "",
      logo: "",
      website: "",
      display_name: "Mapro Foods  ",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Bagrrys ",
      field_id: "COM001591",
      company_name: "Bagrrys ",
      company_id: "COM001591",
      group: "",
      logo: "",
      website: "",
      display_name: "Bagrrys ",
      sector: "FMCG",
      page_display_status: false,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Godrej Tyson Foods ",
      field_id: "COM001592",
      company_name: "Godrej Tyson Foods ",
      company_id: "COM001592",
      group: "",
      logo: "",
      website: "",
      display_name: "Godrej Tyson Foods ",
      sector: "FMCG",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Pepperfry - Trendsutra Platform Services  ",
      field_id: "COM001593",
      company_name: "Pepperfry - Trendsutra Platform Services  ",
      company_id: "COM001593",
      group: "",
      logo: "",
      website: "",
      display_name: "Pepperfry - Trendsutra Platform Services  ",
      sector: "FMCD",
      page_display_status: false,
      industry: "E Commerce",
    },
    {
      field_type: "company",
      name: "Baskin-Robbins",
      field_id: "COM001594",
      company_name: "Baskin-Robbins",
      company_id: "COM001594",
      group: "",
      logo: "",
      website: "",
      display_name: "Baskin-Robbins",
      sector: "Food Products",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "CCD - Coffee Day Enterprises ",
      field_id: "COM001595",
      company_name: "CCD - Coffee Day Enterprises ",
      company_id: "COM001595",
      group: "",
      logo: "",
      website: "",
      display_name: "CCD - Coffee Day Enterprises ",
      sector: "Service",
      page_display_status: false,
      industry: "Retail",
    },
    {
      field_type: "company",
      name: "Renewsys  ",
      field_id: "COM001596",
      company_name: "Renewsys  ",
      company_id: "COM001596",
      group: "",
      logo: "",
      website: "",
      display_name: "Renewsys  ",
      sector: "Electronics",
      page_display_status: false,
      industry: "Electronics",
    },
    {
      field_type: "company",
      name: "HBL Power Systems ",
      field_id: "COM001597",
      company_name: "HBL Power Systems ",
      company_id: "COM001597",
      group: "",
      logo: "",
      website: "",
      industry: "",
      display_name: "HBL Power Systems ",
    },
    {
      // id: "replace_with_new_document_id",
      field_type: "company",
      name: "Natural Ice Cream",
      field_id: "COM001598",
      company_name: "Natural Ice Cream",
      company_id: "COM001598",
      group: "",
      logo: "",
      website: "",
      display_name: "Whirlpool Corp",
      sector: "Food Products",
      page_display_status: false,
      industry: "Food (Reefer)",
    },
    {
      field_type: "company",
      name: "Drums Food",
      field_id: "COM001633",
      group: "",
      industry: "FMCG",
      domain: "epigamia.com",
      user_id: "epigamia.com",
      company_id: "COM001633",
      transporter_list: [],
      user_list: [],
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Drums%20Food.png",
      website: "https://www.epigamia.com",
      company_name: "DRUMS Food International Pvt Ltd",
      display_name: "Drum Foods",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "Sterlite",
      field_id: "COM001632",
      industry: "MANUFACTURING",
      company_name: "Sterlite Technologies Limited",
      display_name: "Sterlite (STL)",
      group: "Sterlite",
      domain: "stl.tech",
      user_id: "stl.tech",
      company_id: "COM001632",
      account_status: "Verified",
      user_list: [],
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/Sterlite.png",
      website: "https://www.stl.tech/",
      page_display_status: true,
    },
    {
      field_type: "company",
      name: "P&G",
      field_id: "COM000700",
      website: "",
      group: "",
      logo: "https://lorrifilesproduction.blob.core.windows.net/public-container/Company%20Logos/P%26G%20Logo.png",
      company_id: "COM000700",
      company_name: "P&G",
      display_name: "P&G",
      sector: "",
      page_display_status: true,
      industry: "FMCG",
    },
    {
      field_type: "company",
      name: "Enterpriseforce",
      field_id: "COM001635",
      website: "http://enterpriseforce.in/",
      group: "",
      logo: "",
      company_id: "COM001635",
      company_name: "Enterpriseforce",
      display_name: "Enterpriseforce",
      sector: "Logistics",
      page_display_status: true,
      industry: "Logistics",
    },
  ],

  Currency: [
    {
      cc: "AED",
      symbol: "د.إ.",
      name: "UAE dirham",
    },
    {
      cc: "AFN",
      symbol: "؋",
      name: "Afghan afghani",
    },
    {
      cc: "ALL",
      symbol: "L",
      name: "Albanian lek",
    },
    {
      cc: "AMD",
      symbol: "դր",
      name: "Armenian dram",
    },
    {
      cc: "ANG",
      symbol: "ƒ",
      name: "Netherlands Antillean guilder",
    },
    {
      cc: "AOA",
      symbol: "Kz",
      name: "Angolan kwanza",
    },
    {
      cc: "ARS",
      symbol: "$",
      name: "Argentine peso",
    },
    {
      cc: "AUD",
      symbol: "$",
      name: "Australian dollar",
    },
    {
      cc: "AWG",
      symbol: "ƒ",
      name: "Aruban florin",
    },
    {
      cc: "AZN",
      symbol: "₼",
      name: "Azerbaijani manat",
    },
    {
      cc: "BAM",
      symbol: "КМ",
      name: "Bosnia-Herzegovina convertible mark",
    },
    {
      cc: "BBD",
      symbol: "$",
      name: "Barbadian dollar",
    },
    {
      cc: "BDT",
      symbol: "৳",
      name: "Bangladeshi taka",
    },
    {
      cc: "BGN",
      symbol: "лв.",
      name: "Bulgarian lev",
    },
    {
      cc: "BHD",
      symbol: "د.ب.",
      name: "Bahraini dinar",
    },
    {
      cc: "BIF",
      symbol: "FBu",
      name: "Burundian franc",
    },
    {
      cc: "BMD",
      symbol: "$",
      name: "Bermudian dollar",
    },
    {
      cc: "BND",
      symbol: "$",
      name: "Brunei dollar",
    },
    {
      cc: "BOB",
      symbol: "Bs.",
      name: "Bolivian boliviano",
    },
    {
      cc: "BRL",
      symbol: "R$",
      name: "Brazilian real",
    },
    {
      cc: "BSD",
      symbol: "$",
      name: "Bahamian dollar",
    },
    {
      cc: "BTN",
      symbol: "Nu.",
      name: "Bhutanese ngultrum",
    },
    {
      cc: "BWP",
      symbol: "P",
      name: "Botswana pula",
    },
    {
      cc: "BYN",
      symbol: "руб.",
      name: "Belarusian ruble",
    },
    {
      cc: "BZD",
      symbol: "$",
      name: "Belize dollar",
    },
    {
      cc: "CAD",
      symbol: "$",
      name: "Canadian dollar",
    },
    {
      cc: "CDF",
      symbol: "₣",
      name: "Congolese franc",
    },
    {
      cc: "CHF",
      symbol: "₣",
      name: "Swiss franc",
    },
    {
      cc: "CKD",
      symbol: "$",
      name: "Cook Islands dollar",
    },
    {
      cc: "CLP",
      symbol: "$",
      name: "Chilean peso",
    },
    {
      cc: "CNY",
      symbol: "¥元",
      name: "Chinese yuan",
    },
    {
      cc: "COP",
      symbol: "$",
      name: "Colombian peso",
    },
    {
      cc: "CRC",
      symbol: "₡",
      name: "Costa Rican colón",
    },
    {
      cc: "CUC",
      symbol: "$",
      name: "Cuban Convertible peso",
    },
    {
      cc: "CUP",
      symbol: "₱",
      name: "Cuban peso",
    },
    {
      cc: "CVE",
      symbol: "$",
      name: "Cabo Verdean escudo",
    },
    {
      cc: "CZK",
      symbol: "Kč",
      name: "Czech koruna",
    },
    {
      cc: "DJF",
      symbol: "ف.ج.",
      name: "Djiboutian franc",
    },
    {
      cc: "DKK",
      symbol: "kr.",
      name: "Danish krone",
    },
    {
      cc: "DOP",
      symbol: "$",
      name: "Dominican peso",
    },
    {
      cc: "DZD",
      symbol: "د.ج.",
      name: "Algerian dinar",
    },
    {
      cc: "EGP",
      symbol: "ج.م.",
      name: "Egyptian pound",
    },
    {
      cc: "EHP",
      symbol: "Ptas.",
      name: "Sahrawi peseta",
    },
    {
      cc: "ERN",
      symbol: "ناكفا",
      name: "Eritrean nakfa",
    },
    {
      cc: "ETB",
      symbol: "ብር",
      name: "Ethiopian birr",
    },
    {
      cc: "EUR",
      symbol: "€",
      name: " euro",
    },
    {
      cc: "FJD",
      symbol: "$",
      name: "Fijian dollar",
    },
    {
      cc: "FKP",
      symbol: "£",
      name: "Falkland Islands pound",
    },
    {
      cc: "FOK",
      symbol: "kr",
      name: "Faroese króna",
    },
    {
      cc: "GBP",
      symbol: "£",
      name: "Pound Sterling pound",
    },
    {
      cc: "GEL",
      symbol: "₾",
      name: "Georgian lari",
    },
    {
      cc: "GGP",
      symbol: "£",
      name: "Guernsey pound",
    },
    {
      cc: "GHS",
      symbol: "₵",
      name: "Ghanaian cedi",
    },
    {
      cc: "GIP",
      symbol: "£",
      name: "Gibraltar pound",
    },
    {
      cc: "GMD",
      symbol: "D",
      name: "Gambian dalasi",
    },
    {
      cc: "GNF",
      symbol: "FG",
      name: "Guinean franc",
    },
    {
      cc: "GTQ",
      symbol: "$",
      name: "Guatemalan quetzal",
    },
    {
      cc: "GYD",
      symbol: "$",
      name: "Guyanese dollar",
    },
    {
      cc: "HKD",
      symbol: "$",
      name: "Hong Kong dollar",
    },
    {
      cc: "HNL",
      symbol: "L",
      name: "Honduran lempira",
    },
    {
      cc: "HRK",
      symbol: "kn",
      name: "Croatian kuna",
    },
    {
      cc: "HTG",
      symbol: "G",
      name: "Haitian gourde",
    },
    {
      cc: "HUF",
      symbol: "Ft",
      name: "Hungarian forint",
    },
    {
      cc: "IDR",
      symbol: "Rp",
      name: "Indonesian rupiah",
    },
    {
      cc: "ILS",
      symbol: "₪",
      name: "Israeli shekel",
    },
    {
      cc: "IMP",
      symbol: "£",
      name: "Manx pound",
    },
    {
      cc: "INR",
      symbol: "₹",
      name: "Indian rupee",
    },
    {
      cc: "IQD",
      symbol: "د.ع.",
      name: "Iraqi dinar",
    },
    {
      cc: "IRR",
      symbol: "﷼",
      name: "Iranian rial",
    },
    {
      cc: "ISK",
      symbol: "kr",
      name: "Icelandic krona",
    },
    {
      cc: "JEP",
      symbol: "£",
      name: "Jersey pound",
    },
    {
      cc: "JMD",
      symbol: "$",
      name: "Jamaican dollar",
    },
    {
      cc: "JOD",
      symbol: "د.أ.",
      name: "Jordanian dinar",
    },
    {
      cc: "JPY",
      symbol: "¥",
      name: "Japanese yen",
    },
    {
      cc: "KES",
      symbol: "KSh",
      name: "Kenyan shilling",
    },
    {
      cc: "KGS",
      symbol: "с",
      name: "Kyrgyzstani som",
    },
    {
      cc: "KHR",
      symbol: "៛",
      name: "Cambodian riel",
    },
    {
      cc: "KID",
      symbol: "$",
      name: "Kiribati dollar",
    },
    {
      cc: "KMF",
      symbol: "CF",
      name: "Comorian franc",
    },
    {
      cc: "KPW",
      symbol: "₩",
      name: "North Korean won",
    },
    {
      cc: "KRW",
      symbol: "₩",
      name: "South Korean won",
    },
    {
      cc: "KWD",
      symbol: "د.ك.",
      name: "Kuwaiti dinar",
    },
    {
      cc: "KYD",
      symbol: "$",
      name: "Cayman Islands dollar",
    },
    {
      cc: "KZT",
      symbol: "₸",
      name: "Kazakhstani tenge",
    },
    {
      cc: "LAK",
      symbol: "₭",
      name: "Lao kip",
    },
    {
      cc: "LBP",
      symbol: "ل.ل.",
      name: "Lebanese pound",
    },
    {
      cc: "LKR",
      symbol: "රු or ரூ",
      name: "Sri Lankan rupee",
    },
    {
      cc: "LRD",
      symbol: "$",
      name: "Liberian dollar",
    },
    {
      cc: "LSL",
      symbol: "L",
      name: "Lesotho loti",
    },
    {
      cc: "LYD",
      symbol: "ل.د.",
      name: "Libyan dinar",
    },
    {
      cc: "MAD",
      symbol: "د.م.",
      name: "Moroccan dirham",
    },
    {
      cc: "MDL",
      symbol: "L",
      name: "Moldovan leu",
    },
    {
      cc: "MGA",
      symbol: "Ar",
      name: "Malagasy ariary",
    },
    {
      cc: "MKD",
      symbol: "ден",
      name: "Macedonian denar",
    },
    {
      cc: "MMK",
      symbol: "Ks",
      name: "Myanmar kyat",
    },
    {
      cc: "MNT",
      symbol: "₮",
      name: "Mongolian tögrög",
    },
    {
      cc: "MOP",
      symbol: "MOP$",
      name: "Macanese pataca",
    },
    {
      cc: "MRU",
      symbol: "أ.م.",
      name: "Mauritanian ouguiya",
    },
    {
      cc: "MUR",
      symbol: "रु ",
      name: "Mauritian rupee",
    },
    {
      cc: "MVR",
      symbol: ".ރ",
      name: "Maldivian rufiyaa",
    },
    {
      cc: "MWK",
      symbol: "MK",
      name: "Malawian kwacha",
    },
    {
      cc: "MXN",
      symbol: "$",
      name: "Mexican peso",
    },
    {
      cc: "MYR",
      symbol: "RM",
      name: "Malaysian ringgit",
    },
    {
      cc: "MZN",
      symbol: "MT",
      name: "Mozambican metical",
    },
    {
      cc: "NAD",
      symbol: "$",
      name: "Namibian dollar",
    },
    {
      cc: "NGN",
      symbol: "₦",
      name: "Nigerian naira",
    },
    {
      cc: "NIO",
      symbol: "C$",
      name: "Nicaraguan córdoba oro",
    },
    {
      cc: "NOK",
      symbol: "kr",
      name: "Norwegian krone",
    },
    {
      cc: "NPR",
      symbol: "रू",
      name: "Nepalese rupee",
    },
    {
      cc: "NZD",
      symbol: "$",
      name: "New Zealand dollar",
    },
    {
      cc: "OMR",
      symbol: "ر.ع.",
      name: "Omani rial",
    },
    {
      cc: "PAB",
      symbol: "B/.",
      name: "Panamanian balboa",
    },
    {
      cc: "PEN",
      symbol: "S/.",
      name: "Peruvian sol",
    },
    {
      cc: "PGK",
      symbol: "K",
      name: "Papua New Guinean kina",
    },
    {
      cc: "PHP",
      symbol: "₱",
      name: "Philippine peso",
    },
    {
      cc: "PKR",
      symbol: "Rs",
      name: "Pakistani rupee",
    },
    {
      cc: "PLN",
      symbol: "zł",
      name: "Polish zloty",
    },
    {
      cc: "PND",
      symbol: "$",
      name: "Pitcairn Islands dollar",
    },
    {
      cc: "PRB",
      symbol: "р.",
      name: "Transnistrian ruble",
    },
    {
      cc: "PYG",
      symbol: "₲",
      name: "Paraguayan guaraní",
    },
    {
      cc: "QAR",
      symbol: "ر.ق.",
      name: "Qatari riyal",
    },
    {
      cc: "RON",
      symbol: "L",
      name: "Romanian leu",
    },
    {
      cc: "RSD",
      symbol: "дин",
      name: "Serbian dinar",
    },
    {
      cc: "RUB",
      symbol: "₽",
      name: "Russian ruble",
    },
    {
      cc: "RWF",
      symbol: "R₣",
      name: "Rwandan franc",
    },
    {
      cc: "SAR",
      symbol: "ر.س.",
      name: "Saudi riyal",
    },
    {
      cc: "SBD",
      symbol: "$",
      name: "Solomon Islands dollar",
    },
    {
      cc: "SCR",
      symbol: "Rs",
      name: "Seychellois rupee",
    },
    {
      cc: "SDG",
      symbol: "ج.س.",
      name: "Sudanese pound",
    },
    {
      cc: "SEK",
      symbol: "kr",
      name: "Swedish krona",
    },
    {
      cc: "SGD",
      symbol: "$",
      name: "Singapore dollar",
    },
    {
      cc: "SHP",
      symbol: "£",
      name: "Saint Helena pound",
    },
    {
      cc: "SLL",
      symbol: "Le",
      name: "Sierra Leonean leone",
    },
    {
      cc: "SLS",
      symbol: "Sl",
      name: "Somaliland shilling",
    },
    {
      cc: "SOS",
      symbol: "Ssh",
      name: "Somali shilling",
    },
    {
      cc: "SRD",
      symbol: "$",
      name: "Surinamese dollar",
    },
    {
      cc: "SSP",
      symbol: "SS£",
      name: "South Sudanese pound",
    },
    {
      cc: "STN",
      symbol: "Db",
      name: "Sao Tome dobra",
    },
    {
      cc: "SVC",
      symbol: "₡",
      name: "Salvadoran colón",
    },
    {
      cc: "SYP",
      symbol: "ل.س.",
      name: "Syrian pound",
    },
    {
      cc: "SZL",
      symbol: "L",
      name: "Swazi lilangeni",
    },
    {
      cc: "THB",
      symbol: "฿",
      name: "Thai baht",
    },
    {
      cc: "TJS",
      symbol: "SM",
      name: "Tajikistani somoni",
    },
    {
      cc: "TMT",
      symbol: "T",
      name: "Turkmenistan manat",
    },
    {
      cc: "TND",
      symbol: "د.ت.",
      name: "Tunisian dinar",
    },
    {
      cc: "TOP",
      symbol: "PT",
      name: "Tongan pa'anga",
    },
    {
      cc: "TRY",
      symbol: "₺",
      name: "Turkish lira",
    },
    {
      cc: "TTD",
      symbol: "$",
      name: "Trinidad and Tobago dollar",
    },
    {
      cc: "TVD",
      symbol: "$",
      name: "Tuvaluan dollar",
    },
    {
      cc: "TWD",
      symbol: "圓",
      name: "New Taiwan dollar",
    },
    {
      cc: "TZS",
      symbol: "TSh",
      name: "Tanzanian shilling",
    },
    {
      cc: "UAH",
      symbol: "грн",
      name: "Ukrainian hryvnia",
    },
    {
      cc: "UGX",
      symbol: "Sh",
      name: "Ugandan shilling",
    },
    {
      cc: "USD",
      symbol: "$",
      name: "US dollar",
    },
    {
      cc: "UYU",
      symbol: "$",
      name: "Uruguayan peso",
    },
    {
      cc: "UZS",
      symbol: "сум",
      name: "Uzbekistani som",
    },
    {
      cc: "VED",
      symbol: "Bs.",
      name: "Venezuelan bolívar digital",
    },
    {
      cc: "VES",
      symbol: "Bs.F",
      name: "Venezuelan bolívar",
    },
    {
      cc: "VND",
      symbol: "₫",
      name: "Vietnamese dong",
    },
    {
      cc: "VUV",
      symbol: "VT",
      name: "Vanuatu vatu",
    },
    {
      cc: "WST",
      symbol: "ST",
      name: "Samoan tala",
    },
    {
      cc: "XAF",
      symbol: "Fr.",
      name: "Central African CFA franc",
    },
    {
      cc: "XCD",
      symbol: "$",
      name: "East Caribbean dollar",
    },
    {
      cc: "XOF",
      symbol: "₣",
      name: "West African CFA franc",
    },
    {
      cc: "XPF",
      symbol: "₣",
      name: "CFP franc",
    },
    {
      cc: "YER",
      symbol: "ر.ي.",
      name: "Yemeni rial",
    },
    {
      cc: "ZAR",
      symbol: "R",
      name: "South African rand",
    },
    {
      cc: "ZMW",
      symbol: "ZK",
      name: "Zambian kwacha",
    },
    {
      cc: "ZWB",
      symbol: "$",
      name: "RTGS dollar",
    },
    {
      cc: "ZWL",
      symbol: "$",
      name: "Zimbabwean dollar",
    },
    {
      cc: "Abkhazia",
      symbol: "апсар",
      name: "Abkhazian apsar",
    },
    {
      cc: "Artsakh",
      symbol: "դր.",
      name: "Artsakh dram",
    },
  ],

  Boolean: {
    Yes: "yes",
    No: "no",
  },

  FtlLtl: [
    { label: "FTL", value: "FTL" },
    { label: "LTL", value: "LTL" },
    { label: "Warehousing", value: "Warehousing" },
  ],
};

export const closeSlidingPopUp = () => {
  // document.getElementById('sliding-pop-up').style.top = '150%'
  // document.getElementById('contact-us-button').style.bottom = '2%'
};

export const getTransporterRateListLength = (enquiry, transporter_id) => {
  // Find the transporter based on transporter_id
  const transporter = enquiry?.transporter_list?.find(
    (t) => t.transporter_id === transporter_id
  );

  // If transporter is found, return the length of the rate_list, else return 0
  return transporter && transporter?.rate_list ? transporter?.rate_list?.length : 0;
};

export const numberWithCommas = (x) => {
  if (x) {
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // var x=12345678;
    x = x.toString();
    var lastThree = x.substring(x.length - 3);
    var otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== "") lastThree = "," + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
  } else {
    return 0;
  }
};

/**
 * Formats a number according to the Indian numbering system with commas.
 *
 * @param {number|string} x - The number to be formatted.
 * @returns {string} The formatted number with Indian commas.
 */
export const indiannumberwithcommas = (x) => {
  let number = Number(x);

  if (isNaN(number) || !isFinite(number)) {
    return "0";
  }

  if (number === 0) {
    return "0";
  }

  let isNegative = number < 0;
  number = Math.abs(number);

  return (isNegative ? "-" : "") + number.toLocaleString("en-IN");
};

export const isMobile = () => window.innerWidth < 600;


export const Activity = (
  data,
  activityType = "",
  name = "",
  id = "",
  ip = sessionStorage.getItem("ClientIP"),
  number = ""
) => {
  if ((activityType === "Sign-Out" || activityType === "Sign-In") && id !== "") {
    return Axios.post(Urls.log, {
      activity: "Session Logging",
      application: "TPMP",
      accessed_from_device: isMobile() ? "Mobile" : "Desktop",
      ip: ip,
      transporter_name: name,
      transporter_id: id,
      contact_number: number,
      session_log: data,
      activity_type: activityType,
    });
  }
};
export const ActivityAuction = (data, ip) => {
  return Axios.post(Urls.log, {
    activity: "auction_logging",
    start_timestamp_utc: new Date(),
    application: "TPMP",
    accessed_from_device: isMobile() ? "Mobile" : "Desktop",
    ip: ip,
    session_log: data,
  });
};
export const currentRequestTimeStamp = () => new Date().toISOString();

export const ActivityString = {
  GeneralInformation: "General Information page viewed",
  Website: "Website button clicked",
  Edit: "Edit button clicked",
  Save: "Save button clicked",
  SaveNext: "Save and Next button clicked",
  FinancialInformation: "Financial Information edited",
  GeneralInfo: "General Information",
  BusinessInfo: "Business Information",
  OperationsOverview: "Operations Information",
  CustomerDetails: "Customer Details",
  ContractInfo: "Contract Information",
  BusinessInfoPageView: "Business information page viewed",
  AddButton: "Add button clicked",
  SuggestAnEdit: "Suggest an edit button clicked",
  Submit: "Submit button clicked",
  expand: "Expand button clicked",
  ViewEditedDraft: "View edited draft clicked",
  OperationsOverviewPageView: "Operations Overview page viewed",
  CustomerDetailsPageView: "Customer Details page viewed",
  ContractClosurePageView: "Contract Closure Info page viewed",
  CustomerReference: "Customer Reference",
  RemoveButton: "Remove Button Clicked",
  RequestRatingButton: "Request Rating button clicked",
  Header: "Header",
  ShareButtonClicked: "Share Profile button clicked",
  ProfileUrlCopied: "Profile Url copied",
  NotificationButton: "Notification button clicked",
  DhandhaNow: "DhandhaNow",
  DhandhaNowPageView: "DhandhaNow page viewed",
  InterestExpress: "Intrest Expressed Button Clicked",
};
